
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2apnq", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $2d3550a09830cc5e$export$90dcee7ddb8a0c0c);

var $1ybV0 = parcelRequire("1ybV0");
const $2d3550a09830cc5e$var$globalObj = window || $parcel$global;
const $2d3550a09830cc5e$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d3550a09830cc5e$var$failingHealthcheck = (callback)=>callback({
        isSuccess: false
    });
const $2d3550a09830cc5e$export$90dcee7ddb8a0c0c = (healthcheck = $2d3550a09830cc5e$var$defaultHealthcheck)=>{
    const isHealthcheckAllFailEnabled = (0, $1ybV0.ff)('fe.platform.healthcheck.allfail.enabled');
    if (isHealthcheckAllFailEnabled) {
        $2d3550a09830cc5e$var$globalObj.performHealthcheck = $2d3550a09830cc5e$var$failingHealthcheck;
        return;
    }
    $2d3550a09830cc5e$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("nJqTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $92179c776327c014$export$2e2bcd8739ae039);

var $foPCo = parcelRequire("foPCo");

var $icR0y = parcelRequire("icR0y");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92179c776327c014$export$2e2bcd8739ae039 = {
    install: (args)=>{
        // @ts-expect-error - TS2322 - Type '{ flags?: boolean | undefined; navigation?: boolean | undefined; renderNavigation: (() => any) | (() => void); upflow?: boolean | undefined; heartbeat?: boolean | undefined; profileCardNextLegacy?: boolean | undefined; ... 4 more ...; searchDwellTimeComponent?: boolean | undefined; }' is not assignable to type 'GlobalArgs'.
        const argsWithDefaults = {
            renderNavigation: $icR0y.default,
            ...args
        };
        (0, $foPCo.default).install(argsWithDefaults);
    }
};

});
parcelRegister("foPCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3caef8d053fb2a2$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $ieRGA = parcelRequire("ieRGA");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $2aRps = parcelRequire("2aRps");

var $1Fe9v = parcelRequire("1Fe9v");
// eslint-disable-next-line jira/ff/inline-usage
const $d3caef8d053fb2a2$var$isHeartbeatEnabled = ()=>(0, $1ybV0.ff)('jfp.heartbeat_vfp2h', false);

const $d3caef8d053fb2a2$var$renderEngagementMessages = ()=>{
    (parcelRequire("6d078"));
};

const $d3caef8d053fb2a2$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("acYbg"));
};

const $d3caef8d053fb2a2$var$renderHeartbeat = ()=>{
    (parcelRequire("6i2jN"));
};

const $d3caef8d053fb2a2$var$loadUpFlowAPI = ()=>(parcelRequire("6dWs5"));

const $d3caef8d053fb2a2$var$installConnectModules = ()=>(parcelRequire("96h1U"));
const $d3caef8d053fb2a2$var$markSafeForAnalytics = (str)=>str || null;
const $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $6rW04.default)('ajs-search-session-id');
    const containerId = (0, $6rW04.default)('ajs-search-container-id');
    const objectId = (0, $6rW04.default)('ajs-search-object-id');
    const objectType = (0, $6rW04.default)('ajs-search-content-type');
    (0, $ieRGA.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $1Fe9v.default)('search-dwell-time', $d3caef8d053fb2a2$var$markSafeForAnalytics(searchSessionId), {
        containerId: $d3caef8d053fb2a2$var$markSafeForAnalytics(containerId),
        objectId: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectId),
        objectType: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
        actionSubject: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
        source: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType)
    });
};
const $d3caef8d053fb2a2$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $2aRps.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $d3caef8d053fb2a2$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $d3caef8d053fb2a2$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $d3caef8d053fb2a2$var$renderProfileCardNextLegacy();
    if (args.connectModules) $d3caef8d053fb2a2$var$installConnectModules();
    if (args.engagementMessages) $d3caef8d053fb2a2$var$renderEngagementMessages();
    if (args.heartbeat) $d3caef8d053fb2a2$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent();
};
const $d3caef8d053fb2a2$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($d3caef8d053fb2a2$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $d3caef8d053fb2a2$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $d3caef8d053fb2a2$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: $d3caef8d053fb2a2$var$isHeartbeatEnabled(),
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3caef8d053fb2a2$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $d3caef8d053fb2a2$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        };
        $d3caef8d053fb2a2$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))({
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $d3caef8d053fb2a2$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("kFGm5", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $ee7Ev = parcelRequire("ee7Ev");

var $3zPPS = parcelRequire("3zPPS");

var $4bGgA = parcelRequire("4bGgA");

var $i31gq = parcelRequire("i31gq");

var $8BG5F = parcelRequire("8BG5F");

var $224h2 = parcelRequire("224h2");

var $5YL8y = parcelRequire("5YL8y");
/** Used to compose bitmasks for cloning. */ var $f0c87dd638da6507$var$CLONE_DEEP_FLAG = 1, $f0c87dd638da6507$var$CLONE_FLAT_FLAG = 2, $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $f0c87dd638da6507$var$omit = $224h2(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $kJvGp(paths, function(path) {
        path = $4bGgA(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $i31gq(object, $5YL8y(object), result);
    if (isDeep) result = $ee7Ev(result, $f0c87dd638da6507$var$CLONE_DEEP_FLAG | $f0c87dd638da6507$var$CLONE_FLAT_FLAG | $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG, $8BG5F);
    var length = paths.length;
    while(length--)$3zPPS(result, paths[length]);
    return result;
});
module.exports = $f0c87dd638da6507$var$omit;

});
parcelRegister("3zPPS", function(module, exports) {

var $4bGgA = parcelRequire("4bGgA");

var $iTvqy = parcelRequire("iTvqy");

var $2wKO3 = parcelRequire("2wKO3");

var $cNyDu = parcelRequire("cNyDu");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $29acd9759e1173c0$var$baseUnset(object, path) {
    path = $4bGgA(path, object);
    object = $2wKO3(object, path);
    return object == null || delete object[$cNyDu($iTvqy(path))];
}
module.exports = $29acd9759e1173c0$var$baseUnset;

});
parcelRegister("2wKO3", function(module, exports) {

var $dS3e6 = parcelRequire("dS3e6");

var $jADKY = parcelRequire("jADKY");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $1d72e0aabaa913d7$var$parent(object, path) {
    return path.length < 2 ? object : $dS3e6(object, $jADKY(path, 0, -1));
}
module.exports = $1d72e0aabaa913d7$var$parent;

});


parcelRegister("8BG5F", function(module, exports) {

var $jtsd5 = parcelRequire("jtsd5");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $64426db23baa732e$var$customOmitClone(value) {
    return $jtsd5(value) ? undefined : value;
}
module.exports = $64426db23baa732e$var$customOmitClone;

});


parcelRegister("ieRGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $209cb7ee89940e6b$export$2e2bcd8739ae039);

var $78Ywx = parcelRequire("78Ywx");

var $kFGm5 = parcelRequire("kFGm5");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$209cb7ee89940e6b$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("2aRps", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $6ef677b08ff57190$export$b6228dc14c5adf51);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7rh0R = parcelRequire("7rh0R");

var $gUUjF = parcelRequire("gUUjF");

var $49235 = parcelRequire("49235");

var $5L0Jp = parcelRequire("5L0Jp");

var $geFaw = parcelRequire("geFaw");
const $6ef677b08ff57190$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $gUUjF.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $6ef677b08ff57190$var$getContainer = ()=>{
    let container = document.getElementById('flags');
    if (container == null) {
        container = document.createElement('div');
        container.id = 'flags';
        if (document.body) document.body.appendChild(container);
        else $6ef677b08ff57190$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef677b08ff57190$var$Flags = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dThT7")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef677b08ff57190$var$AfterPaintFlags = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("dThT7")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $6ef677b08ff57190$export$b6228dc14c5adf51 = ()=>(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$Flags, null)))), $6ef677b08ff57190$var$getContainer());

});
parcelRegister("49235", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $237d6228af360b7c$export$6f7845cc5e693f16);

var $eUqFw = parcelRequire("eUqFw");

var $3fQGY = parcelRequire("3fQGY");

var $ao0hp = parcelRequire("ao0hp");

var $fb5Sn = parcelRequire("fb5Sn");

var $eX2O4 = parcelRequire("eX2O4");

var $6rW04 = parcelRequire("6rW04");

var $7LFzI = parcelRequire("7LFzI");

var $jvfW6 = parcelRequire("jvfW6");

var $gXEQH = parcelRequire("gXEQH");

var $8WuJm = parcelRequire("8WuJm");

var $ln3W8 = parcelRequire("ln3W8");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $4yYQo = parcelRequire("4yYQo");
const $237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, children);

const $237d6228af360b7c$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("7KGHt"))
    };
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
            messages: state.messages,
            locale: (0, $ao0hp.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yYQo.LoadingPhaseManager), null));
};

});
parcelRegister("eX2O4", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $ac9adb88a32f4483$export$6f49c95a810d59fa);

var $eUqFw = parcelRequire("eUqFw");

var $hUYqC = parcelRequire("hUYqC");
var $1xrmr = parcelRequire("1xrmr");

var $Xah93 = parcelRequire("Xah93");
const $ac9adb88a32f4483$var$useUnmount = (callback)=>(0, $eUqFw.useEffect)(()=>callback, [
        callback
    ]);
const $ac9adb88a32f4483$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $eUqFw.useState)(new (0, $hUYqC.ExperienceTracker)());
    const [cleanupSliSub] = (0, $eUqFw.useState)(()=>experienceTracker.subscribe((0, $Xah93.sliSubscriber)));
    const cleanup = (0, $eUqFw.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $ac9adb88a32f4483$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("Xah93", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $29a12df906341fa5$export$db0b99fe17114899);

var $3FyZ4 = parcelRequire("3FyZ4");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

const $29a12df906341fa5$var$transformApplication = (application)=>{
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $eIp1n.JIRA_CORE:
            return 'jira-core';
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $eIp1n.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $29a12df906341fa5$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            return 'jedi';
        case 0, $6WXNs.STANDARD_EDITION:
            return 'standard';
        case 0, $6WXNs.PREMIUM_EDITION:
            return 'premium';
        case 0, $6WXNs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $29a12df906341fa5$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $29a12df906341fa5$var$transformApplication(application),
            edition: $29a12df906341fa5$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $29a12df906341fa5$var$reportSli = (experienceDescription)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $29a12df906341fa5$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $29a12df906341fa5$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $99e7a4e4cbcb5db0$export$b48b3d1872522384:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});
const $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $99e7a4e4cbcb5db0$export$b48b3d1872522384 = 'taskFail';
const $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("7LFzI", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $deabbabd1db0af3b$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $deabbabd1db0af3b$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});

parcelRegister("jvfW6", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $3b08d5b0f7ce801d$export$7c9538f5f3c365e9);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $3qf87 = parcelRequire("3qf87");
function $3b08d5b0f7ce801d$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eUqFw.useRef)(1);
    const [modals, setModals] = (0, $eUqFw.useState)([]);
    const modalContext = (0, $eUqFw.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qf87.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        }))));
}

});
parcelRegister("3qf87", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $454708699096dc24$export$ab57792b9b6974a6);

var $eUqFw = parcelRequire("eUqFw");
const $454708699096dc24$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("gXEQH", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $d518287b36cbf350$export$c71778b3a4356b04);

var $keguF = parcelRequire("keguF");

var $77Wva = parcelRequire("77Wva");
const $d518287b36cbf350$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $keguF.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $keguF.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $keguF.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $77Wva.getIsProjectAdmin)
    }
});

});
parcelRegister("77Wva", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $6b9122e612958aea$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $6b9122e612958aea$export$d53e6d79d3fa5f31);
let $6b9122e612958aea$var$projectAdmin = null;
const $6b9122e612958aea$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($6b9122e612958aea$var$projectAdmin == null || !$6b9122e612958aea$var$projectAdmin.loading && $6b9122e612958aea$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($6b9122e612958aea$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($6b9122e612958aea$var$projectAdmin.isProjectAdmin);
};
const $6b9122e612958aea$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $6b9122e612958aea$var$projectAdmin = projectAdminState;
};

});


parcelRegister("ln3W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $8b8bb35ae4ffc3ad$export$83fb48644dee72f0);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $amu7D = parcelRequire("amu7D");
function $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.RelayEnvironmentProvider), {
        environment: (0, $amu7D.default)()
    }, children);
}
function $8b8bb35ae4ffc3ad$export$83fb48644dee72f0() {
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("amu7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68576217aea2baf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $cNy9K = parcelRequire("cNy9K");

var $9GSiX = parcelRequire("9GSiX");
let $f68576217aea2baf$var$relayEnvironment;
function $f68576217aea2baf$export$2e2bcd8739ae039() {
    if (!$f68576217aea2baf$var$relayEnvironment) {
        const environmentConfig = (0, $9GSiX.getRelayEnvironmentConfig)();
        $f68576217aea2baf$var$relayEnvironment = new (0, $cNy9K.Environment)(environmentConfig);
    }
    return $f68576217aea2baf$var$relayEnvironment;
}

});
parcelRegister("9GSiX", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $b823b5ac69a7954d$export$a451c85db2d1cda3);

var $9fdRu = parcelRequire("9fdRu");

var $2vvuk = parcelRequire("2vvuk");

var $isMPK = parcelRequire("isMPK");
const $b823b5ac69a7954d$export$a451c85db2d1cda3 = ()=>(0, $isMPK.getDefaultRelayEnvironmentConfig)({
        network: (0, $2vvuk.getNetwork)(),
        log: (0, $9fdRu.default),
        requiredFieldLogger: $9fdRu.requiredFieldLogger
    });

});
parcelRegister("9fdRu", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $c152fc62c06270e5$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $c152fc62c06270e5$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $gZ48R = parcelRequire("gZ48R");

var $fYqUr = parcelRequire("fYqUr");
const $c152fc62c06270e5$var$RELAY_CLIENT_ID = 'AGG';
const $c152fc62c06270e5$var$LOG_NAMESPACE = `relay.${$c152fc62c06270e5$var$RELAY_CLIENT_ID}.error.graphql`;
const $c152fc62c06270e5$var$requests = {};
const $c152fc62c06270e5$var$queries = {};
const $c152fc62c06270e5$var$resources = {};
const $c152fc62c06270e5$var$executes = {};
const $c152fc62c06270e5$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $c152fc62c06270e5$export$1ab8b98d209afe85 = (event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($c152fc62c06270e5$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $c152fc62c06270e5$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $c152fc62c06270e5$export$2e2bcd8739ae039(event) {
    if ((0, $gZ48R.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $c152fc62c06270e5$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                    $c152fc62c06270e5$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $c152fc62c06270e5$var$requests[networkRequestId];
                        delete $c152fc62c06270e5$var$queries[name];
                    }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $c152fc62c06270e5$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $c152fc62c06270e5$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $fYqUr.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $c152fc62c06270e5$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $c152fc62c06270e5$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                        $c152fc62c06270e5$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $c152fc62c06270e5$var$queries[node.name];
                        }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $c152fc62c06270e5$var$resources[event.resourceID];
                    }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $c152fc62c06270e5$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $c152fc62c06270e5$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $c152fc62c06270e5$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $c152fc62c06270e5$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $c152fc62c06270e5$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $c152fc62c06270e5$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("2vvuk", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $4d8ddda0e7507868$export$7de4970ebfd8206d);

var $cNy9K = parcelRequire("cNy9K");

var $c4LxQ = parcelRequire("c4LxQ");

var $4aLdW = parcelRequire("4aLdW");

var $b3wL2 = parcelRequire("b3wL2");
const $4d8ddda0e7507868$export$7de4970ebfd8206d = ()=>{
    if ((0, $b3wL2.isSSR)()) (0, $cNy9K.Network).create((0, $c4LxQ.fetch));
    return (0, $cNy9K.Network).create((0, $c4LxQ.fetch), (0, $4aLdW.subscribe));
};

});
parcelRegister("c4LxQ", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3);

var $ldoFd = parcelRequire("ldoFd");

var $2vzCR = parcelRequire("2vzCR");

var $cNy9K = parcelRequire("cNy9K");

var $XHGTv = parcelRequire("XHGTv");

var $bW292 = parcelRequire("bW292");

var $eTIsH = parcelRequire("eTIsH");

var $fVqUX = parcelRequire("fVqUX");

var $lRmyA = parcelRequire("lRmyA");
var $7byHA = parcelRequire("7byHA");
var $3lpdA = parcelRequire("3lpdA");

var $5zSUY = parcelRequire("5zSUY");

var $15ZJO = parcelRequire("15ZJO");

var $7GiRY = parcelRequire("7GiRY");

var $c7ifG = parcelRequire("c7ifG");

var $j7fph = parcelRequire("j7fph");

var $8tomX = parcelRequire("8tomX");

var $2n6bs = parcelRequire("2n6bs");

var $cmqZo = parcelRequire("cmqZo");

var $5udmX = parcelRequire("5udmX");

var $iuC8B = parcelRequire("iuC8B");

var $ixYrr = parcelRequire("ixYrr");
let $1a035cb2d3f2c948$var$redirecting = false;
const $1a035cb2d3f2c948$var$redirect = ()=>{
    const identity = (0, $bW292.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.href = redirectUrl;
};
// Silence error logs from queries in this list
const $1a035cb2d3f2c948$var$blocklist = [
    'issueAggQuery'
];
const $1a035cb2d3f2c948$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $3lpdA.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $1a035cb2d3f2c948$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
/**
 * Given a set of options, produce a new set of options for consumption which contains
 * a combination of the given set and the default options
 * @param {RequestOptions} options
 * @returns RequestOptions
 */ const $1a035cb2d3f2c948$var$generateOptions = (options = {})=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $5zSUY.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $fVqUX.default),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $7GiRY.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $1a035cb2d3f2c948$var$checkAuthentication = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.mdt-zora.use-heartbeat-singleton_vzod3')) {
        if (!false && !$1a035cb2d3f2c948$var$redirecting) {
            const heartbeatService = (0, $eTIsH.getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $1a035cb2d3f2c948$var$redirect();
                // Set flag to prevent multiple redirects
                $1a035cb2d3f2c948$var$redirecting = true;
            }
        }
    }
};
const $1a035cb2d3f2c948$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $7byHA.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    $1a035cb2d3f2c948$var$checkAuthentication();
    if ($1a035cb2d3f2c948$var$redirecting) // Hang the request if we are redirecting - should be cleared on redirect
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return (0, $cNy9K.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $8tomX.claimEarlyScriptPromise)((0, $8tomX.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $ixYrr.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $cNy9K.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $cmqZo.getAggEndpoint)(request, cacheConfig);
            const body = (0, $cmqZo.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $j7fph.QueryResponseCache).get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $j7fph.QueryResponseCache).delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $3lpdA.retryOnError)(()=>(0, $lRmyA.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $lRmyA.performPostRequest)(endpoint, $1a035cb2d3f2c948$var$generateOptions({
                        body: body
                    })),
                retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $lRmyA.performPostRequestWithRetry)(endpoint, {
                ...$1a035cb2d3f2c948$var$generateOptions({
                    body: body
                }),
                retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $5udmX.addTraceId)(queryName, $1a035cb2d3f2c948$var$getTraceIdFromExtensions(response));
                (0, $2n6bs.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!$1a035cb2d3f2c948$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $15ZJO.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $15ZJO.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $iuC8B.showUnauthenticatedFlag)(queryName);
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $j7fph.QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) (0, $c7ifG.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("lRmyA", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $ec20d578245eedba$export$8e9baed7697e4959);
$parcel$export(module.exports, "applyErrorHandling", () => $ec20d578245eedba$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $ec20d578245eedba$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $ec20d578245eedba$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $ec20d578245eedba$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $ec20d578245eedba$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $ec20d578245eedba$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $ec20d578245eedba$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $ec20d578245eedba$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $ec20d578245eedba$export$a5717cbee13f28b7);

var $fVqUX = parcelRequire("fVqUX");


var $1ybV0 = parcelRequire("1ybV0");

var $gZ48R = parcelRequire("gZ48R");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");

var $3lpdA = parcelRequire("3lpdA");

var $jxATW = parcelRequire("jxATW");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $ec20d578245eedba$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $ec20d578245eedba$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $7byHA.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $ec20d578245eedba$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $ec20d578245eedba$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $ec20d578245eedba$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $ec20d578245eedba$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$handleErrors = (response)=>{
    const traceId = (0, $jxATW.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status || (0, $1ybV0.ff)('issue.details.hard-limits.milestone-1') && (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $ec20d578245eedba$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) {
            if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        } else {
            // eslint-disable-next-line no-lonely-if
            if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, undefined, response);
            else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
        }
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $ec20d578245eedba$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$ec20d578245eedba$export$e174dc943a170ff(fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $gZ48R.default)('platform_fetch_retries')) return executeRequest();
    return (0, $3lpdA.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $ec20d578245eedba$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...(0, $fVqUX.default),
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$putOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$692a4d9808143175 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$postOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$deleteOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$patchOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$659b5ee69e6eb976 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...(0, $fVqUX.default),
        ...options
    });
const $ec20d578245eedba$export$d7b48b2904a5d812 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$putOptions,
        ...options
    });
const $ec20d578245eedba$export$a5717cbee13f28b7 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$postOptions,
        ...options
    });
const $ec20d578245eedba$export$6d01bf1146815b9b = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$deleteOptions,
        ...options
    });
const $ec20d578245eedba$export$560989ee94ad2a20 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$patchOptions,
        ...options
    });

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("3lpdA", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $689a3993c77053c8$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $689a3993c77053c8$export$f859c88bfac2cf2c);
const $689a3993c77053c8$export$81189edc9b923717 = 1;
const $689a3993c77053c8$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $689a3993c77053c8$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $689a3993c77053c8$export$81189edc9b923717 ? $689a3993c77053c8$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});


parcelRegister("15ZJO", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $2d32667fee5bd79d$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $2d32667fee5bd79d$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $2d32667fee5bd79d$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $2d32667fee5bd79d$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $hompL = parcelRequire("hompL");
const $2d32667fee5bd79d$var$errorCollector = new Map();
const $2d32667fee5bd79d$export$da396ad2a542b095 = 120000; // 2min
const $2d32667fee5bd79d$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $2d32667fee5bd79d$var$errorCollector.delete(key);
    }, $2d32667fee5bd79d$export$da396ad2a542b095);
};
const $2d32667fee5bd79d$export$c211170518c6d0f6 = (key = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4())=>{
    $2d32667fee5bd79d$var$errorCollector.set(key, []);
    $2d32667fee5bd79d$var$scheduleCleanup(key);
    return key;
};
const $2d32667fee5bd79d$export$e0491a0d974dadfa = (key)=>{
    const errors = $2d32667fee5bd79d$var$errorCollector.get(key);
    $2d32667fee5bd79d$var$errorCollector.delete(key);
    return errors || [];
};
const $2d32667fee5bd79d$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $2d32667fee5bd79d$var$errorCollector.forEach((value, key)=>{
        $2d32667fee5bd79d$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $2d32667fee5bd79d$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("7GiRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a04fa54516e5a2d1$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a04fa54516e5a2d1$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'virtual-agent-beta',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});

parcelRegister("c7ifG", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $a238ea58a6cce413$export$607b80f5bc6e396d);
const $a238ea58a6cce413$export$607b80f5bc6e396d = new Map();

});

parcelRegister("j7fph", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $12adf5474a181883$export$688bd21be71b9e5d);

var $9LXG4 = parcelRequire("9LXG4");

var $illlw = parcelRequire("illlw");

var $cNy9K = parcelRequire("cNy9K");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");

var $9jJAD = parcelRequire("9jJAD");
function $12adf5474a181883$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $cNy9K.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $12adf5474a181883$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $12adf5474a181883$export$be21c283b097d175 extends (0, $cNy9K.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $12adf5474a181883$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $9jJAD.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $7EhAs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $gUUjF.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $12adf5474a181883$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $12adf5474a181883$export$688bd21be71b9e5d = new $12adf5474a181883$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $12adf5474a181883$export$94e535e06b7ade61 = ()=>$12adf5474a181883$export$688bd21be71b9e5d.serialize();

});
parcelRegister("7EhAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e30f3a9c559ab$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
var $d91e30f3a9c559ab$export$2e2bcd8739ae039 = (0, $7byHA.default);

});

parcelRegister("9jJAD", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $1b0cdf803f3ea26f$export$8431e42d062de453);
class $1b0cdf803f3ea26f$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
        this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("8tomX", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $da6663b8ee5823ed$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $da6663b8ee5823ed$export$828ac0325bce4536);
$parcel$export(module.exports, "earlyFetch", () => $da6663b8ee5823ed$export$5b55058781674413);

var $lLasf = parcelRequire("lLasf");

var $fqqil = parcelRequire("fqqil");

var $cmqZo = parcelRequire("cmqZo");

var $baC3k = parcelRequire("baC3k");
const $da6663b8ee5823ed$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $da6663b8ee5823ed$export$b5fbc1430cbfd6e1 = (value)=>value;
const $da6663b8ee5823ed$export$6d670d323806bb37 = new Map();
const $da6663b8ee5823ed$export$1102c06c7da91223 = (params, variables)=>{
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $da6663b8ee5823ed$export$828ac0325bce4536 = (key)=>{
    const result = $da6663b8ee5823ed$export$6d670d323806bb37.get(key);
    if (result != null) $da6663b8ee5823ed$export$6d670d323806bb37.delete(key);
    return result;
};
const $da6663b8ee5823ed$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$da6663b8ee5823ed$export$6d670d323806bb37.has(key)) $da6663b8ee5823ed$export$6d670d323806bb37.set(key, promise);
};
const $da6663b8ee5823ed$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
    (0, $lLasf.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $cmqZo.getAggEndpoint)(compiledQuery.params);
    const body = (0, $cmqZo.getRequestBody)(compiledQuery.params, variables);
    const capabilityHeader = (0, $fqqil.getEnhancedCapabilityHeader)(capability ?? null);
    $da6663b8ee5823ed$export$e1336d32be02faf4($da6663b8ee5823ed$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $baC3k.getActiveTraceHttpRequestHeaders)(endpoint),
            ...capabilityHeader ? {
                [$da6663b8ee5823ed$var$CAPABILITY_HEADER_NAME]: capabilityHeader
            } : {}
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $lLasf.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("lLasf", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $bbbf8be69ced3a7f$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4);

var $iNkad = parcelRequire("iNkad");
const $bbbf8be69ced3a7f$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER = 'atl-traceid';
const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER) || response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS);

});
parcelRegister("iNkad", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $623bd65186ba0714$export$26e841bcf1aeb894);
/* eslint-disable max-classes-per-file */ class $623bd65186ba0714$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $623bd65186ba0714$export$26e841bcf1aeb894 extends $623bd65186ba0714$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message);
        this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}

});



parcelRegister("iuC8B", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $768eb5f0fcd8b90f$export$758fcc357484571e);

var $k8Qyf = parcelRequire("k8Qyf");

var $3FyZ4 = parcelRequire("3FyZ4");

var $glrJM = parcelRequire("glrJM");
const $768eb5f0fcd8b90f$var$reloadPage = ()=>window.location.reload();
const $768eb5f0fcd8b90f$var$sendAnalyticEvent = (operationName)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $768eb5f0fcd8b90f$export$758fcc357484571e = (operationName)=>{
    (0, $k8Qyf.showFlag)({
        type: 'error',
        title: (0, $glrJM.default).title,
        description: (0, $glrJM.default).description,
        actions: [
            {
                content: (0, $glrJM.default).login,
                onClick: $768eb5f0fcd8b90f$var$reloadPage
            }
        ]
    });
    $768eb5f0fcd8b90f$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("k8Qyf", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $eeec0389d5aa91e2$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $eeec0389d5aa91e2$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $eeec0389d5aa91e2$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $eeec0389d5aa91e2$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $eeec0389d5aa91e2$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $eeec0389d5aa91e2$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $eeec0389d5aa91e2$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $eeec0389d5aa91e2$export$c126d8b307b8ab86);

var $8vPhU = parcelRequire("8vPhU");

var $bbbyK = parcelRequire("bbbyK");

var $lawuT = parcelRequire("lawuT");

var $eo17r = parcelRequire("eo17r");
const $eeec0389d5aa91e2$export$e12b2cc6b75b006b = (0, $bbbyK.default)((0, $lawuT.store).dispatch);
const $eeec0389d5aa91e2$export$900a08a292ad23cd = (0, $8vPhU.default)((0, $lawuT.store).dispatch);
const $eeec0389d5aa91e2$var$dismissFlagById = (id)=>{
    $eeec0389d5aa91e2$export$900a08a292ad23cd((0, $8vPhU.dismissFlag)(id));
};
const $eeec0389d5aa91e2$var$hasFlag = (id)=>Boolean((0, $lawuT.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $eeec0389d5aa91e2$export$dbb055af53fd81a0 = {
    showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
    dismissFlag: $eeec0389d5aa91e2$export$900a08a292ad23cd
};
const $eeec0389d5aa91e2$export$eee61a1aafe3884 = ()=>({
        showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
        dismissFlag: $eeec0389d5aa91e2$var$dismissFlagById,
        hasFlag: $eeec0389d5aa91e2$var$hasFlag
    });
const $eeec0389d5aa91e2$export$dc4f8132c3090b32 = ()=>$eeec0389d5aa91e2$export$dbb055af53fd81a0;
const $eeec0389d5aa91e2$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $eo17r.DISMISS_COMMAND);
const $eeec0389d5aa91e2$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $eeec0389d5aa91e2$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $eeec0389d5aa91e2$export$63ffd7d99470afd4 = (flag)=>!$eeec0389d5aa91e2$export$14b1864d9cf0809f(flag) && !$eeec0389d5aa91e2$export$d84ce5adcee46025(flag) && !$eeec0389d5aa91e2$export$cd5f9f2b991b82d9(flag);
const $eeec0389d5aa91e2$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("8vPhU", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $39af67031ab9f922$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $39af67031ab9f922$export$2e2bcd8739ae039);

var $bSS3k = parcelRequire("bSS3k");

var $eo17r = parcelRequire("eo17r");
const $39af67031ab9f922$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $eo17r.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39af67031ab9f922$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $bSS3k.dismissFlagAction)(action.id));
    };

});
parcelRegister("bSS3k", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $953f8b1833086611$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $953f8b1833086611$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $953f8b1833086611$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $953f8b1833086611$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $953f8b1833086611$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $953f8b1833086611$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $953f8b1833086611$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $953f8b1833086611$export$aad8462122ac592b);
const $953f8b1833086611$export$9d04158a25ce4cd = 'state.SHOW';
const $953f8b1833086611$export$57bf213be019eeb0 = (payload)=>({
        type: $953f8b1833086611$export$9d04158a25ce4cd,
        payload: payload
    });
const $953f8b1833086611$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $953f8b1833086611$export$abf286bbe7073aba = (payload)=>({
        type: $953f8b1833086611$export$b31a07d2e6382678,
        payload: payload
    });
const $953f8b1833086611$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $953f8b1833086611$export$4818b3c52448050d = (payload)=>({
        type: $953f8b1833086611$export$1eb56620df104bf,
        payload: payload
    });
const $953f8b1833086611$export$4a991c87e640ef77 = 'state.RESET';
const $953f8b1833086611$export$aad8462122ac592b = ()=>({
        type: $953f8b1833086611$export$4a991c87e640ef77
    });

});

parcelRegister("eo17r", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $2e7952269e32b2ae$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $2e7952269e32b2ae$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $2e7952269e32b2ae$export$188cdb77b72629d7);
const $2e7952269e32b2ae$export$e705274c5e156b93 = 'DISMISS';
const $2e7952269e32b2ae$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $2e7952269e32b2ae$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("bbbyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7364d7b2414b4fa5$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $bSS3k = parcelRequire("bSS3k");

var $eo17r = parcelRequire("eo17r");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7364d7b2414b4fa5$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $bSS3k.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $bSS3k.show)(newFlag));
        return flagId;
    };

});

parcelRegister("lawuT", function(module, exports) {

$parcel$export(module.exports, "store", () => $58565b45d694aa17$export$6f57813fe9f31bf9);

var $l32oR = parcelRequire("l32oR");
const $58565b45d694aa17$export$6f57813fe9f31bf9 = (0, $l32oR.createStore)();

});
parcelRegister("l32oR", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ecbe96b78b5bbffc$export$f51a9068ac82ea43);

var $8FRHo = parcelRequire("8FRHo");

var $b7i1H = parcelRequire("b7i1H");
const $ecbe96b78b5bbffc$export$f51a9068ac82ea43 = (rootEpic)=>(0, $8FRHo.default)({
        appName: 'flags',
        rootReducer: $b7i1H.default,
        rootEpic: rootEpic
    });

});
parcelRegister("8FRHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb42e111114ce77$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $lfZsG = parcelRequire("lfZsG");

var $czGdf = parcelRequire("czGdf");

var $jQgix = parcelRequire("jQgix");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cb42e111114ce77$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $jQgix.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $lfZsG.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("iFajX"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $bd1K7.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $huRi7.createStore)((0, $MYW4e.enableBatching)(rootReducer), initialState, (0, $czGdf.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $eUqFw.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $huRi7.compose)(...enhancers, (0, $huRi7.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("lfZsG", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $bd927ad8c0ea4245$export$342c99cc1e9bc5c6);
const $bd927ad8c0ea4245$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("czGdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $22794e51b2572269$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$22794e51b2572269$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $huRi7.compose;
};

});

parcelRegister("jQgix", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b4a5dd033617f8$export$2e2bcd8739ae039);
class $a7b4a5dd033617f8$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("b7i1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bd228b38d69c07$export$2e2bcd8739ae039);

var $bwbFz = parcelRequire("bwbFz");

var $hompL = parcelRequire("hompL");

var $bSS3k = parcelRequire("bSS3k");
const $d2bd228b38d69c07$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d2bd228b38d69c07$export$2e2bcd8739ae039 = (state = $d2bd228b38d69c07$var$defaultState, action)=>{
    switch(action.type){
        case 0, $bSS3k.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))([
                    {
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $bSS3k.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $bSS3k.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $bSS3k.RESET:
            return $d2bd228b38d69c07$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("glrJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1963f04f48a97eb6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1963f04f48a97eb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("ixYrr", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $39705662ea381df8$export$726e1df8186bb981);

var $9LXG4 = parcelRequire("9LXG4");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");
const $39705662ea381df8$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $39705662ea381df8$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $7EhAs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $7EhAs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});


parcelRegister("4aLdW", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $ef96f447a7409c6e$export$ec068583843480e7);

var $cNy9K = parcelRequire("cNy9K");

var $guiFP = parcelRequire("guiFP");

var $dIOaC = parcelRequire("dIOaC");
var $lE8MM = parcelRequire("lE8MM");

var $keguF = parcelRequire("keguF");
const $ef96f447a7409c6e$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $cNy9K.Observable).create((sink)=>{
        const client = (0, $dIOaC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.agg?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $keguF.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $guiFP.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("dIOaC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $176ec127fee3e1b6$export$6bb76d6eba7e258c);

var $9RGox = parcelRequire("9RGox");

var $gZ48R = parcelRequire("gZ48R");

var $7GiRY = parcelRequire("7GiRY");


var $eliQU = parcelRequire("eliQU");
let $176ec127fee3e1b6$var$client;
const $176ec127fee3e1b6$export$6bb76d6eba7e258c = ()=>{
    if ((0, $eliQU.isSSR)() || (0, $gZ48R.default)('graphql_subscriptions')) return null;
    if (!$176ec127fee3e1b6$var$client) $176ec127fee3e1b6$var$client = (0, $9RGox.createClient)({
        url: (0, $eliQU.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $12457a63a9fa501a$export$8b012b965402e06a),
        retryAttempts: (0, $12457a63a9fa501a$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $7GiRY.default).join(',')
        }
    });
    return $176ec127fee3e1b6$var$client;
};
const $176ec127fee3e1b6$export$2f0afd443356d36f = ()=>{
    $176ec127fee3e1b6$var$client = null;
};

});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("eliQU", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $dea6d52502362b12$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $dea6d52502362b12$export$29a72e89601dfc59);
const $dea6d52502362b12$export$48d7c418edadb60c = ()=>false ?? false;
const $dea6d52502362b12$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("lE8MM", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $8f86032d91fec6de$export$ece4736473c28965);
const $8f86032d91fec6de$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});


parcelRegister("b3wL2", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $624029006652488f$export$48d7c418edadb60c);
const $624029006652488f$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("4yYQo", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $01b326d4a0314926$export$6e4bfef9e80c7eb0);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");
const $01b326d4a0314926$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $7rh0R.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("7KGHt", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("5L0Jp", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $3e0b01ebb413784c$export$8b4a0fffcddd96f4);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $3e0b01ebb413784c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, children));

});

parcelRegister("geFaw", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $5551fe9c9ab4b7c0$export$5f8d39834fd61797);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $5551fe9c9ab4b7c0$export$5f8d39834fd61797 = ({ children: children })=>{
    // otherwise if the feature flag is enabled/or force opt-in, use React.StrictMode
    return (0, $1ybV0.ff)('jfp.magma.enable-strict-mode') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).StrictMode, null, children) : children;
};

});

parcelRegister("dThT7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("3WeJg")
]).then(()=>parcelRequire('dKe2f'));

});
parcelRegister("d1Cng", function(module, exports) {
"use strict";

function $97b922b3683b5ed5$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("2MVa4")).resolve(id));
}
module.exports = $97b922b3683b5ed5$var$load;

});



parcelRegister("1Fe9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab81d3bccac6ed19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $geFaw = parcelRequire("geFaw");

var $7BDEW = parcelRequire("7BDEW");
const $ab81d3bccac6ed19$var$getPlaceholder = (placeholderId)=>{
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    const div = document.createElement('div');
    div.id = placeholderId;
    if (document.body) document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $ab81d3bccac6ed19$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
        sessionId: sessionId,
        data: data
    })), $ab81d3bccac6ed19$var$getPlaceholder(placeholder));
};
var $ab81d3bccac6ed19$export$2e2bcd8739ae039 = $ab81d3bccac6ed19$var$renderDwellTimeComponent;

});
parcelRegister("7BDEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe7d84710661a6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $hFmdR = parcelRequire("hFmdR");

var $5BRby = parcelRequire("5BRby");


var $5CH2F = parcelRequire("5CH2F");
const $9fe7d84710661a6d$var$defaultSource = 'dwellComponent';
const $9fe7d84710661a6d$var$defaultActionSubject = 'dwellComponent';
const $9fe7d84710661a6d$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)(actionSubject || $9fe7d84710661a6d$var$defaultActionSubject), (0, $hFmdR.AnalyticsSource)(source || $9fe7d84710661a6d$var$defaultSource, (0, $41ea3621645e2acc$export$f636b5b56f1d624a)))((0, $5CH2F.default));
class $9fe7d84710661a6d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $9fe7d84710661a6d$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $9fe7d84710661a6d$var$defaultSource,
            actionSubject: data && data.actionSubject || $9fe7d84710661a6d$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("hFmdR", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $3d95c57ea565c569$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $3d95c57ea565c569$export$ec9f54bd4341ceb);

var $1ngde = parcelRequire("1ngde");
const $3d95c57ea565c569$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $1ngde.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $3d95c57ea565c569$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $1ngde.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5CH2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def25be35218960$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9LCN1 = parcelRequire("9LCN1");

var $eGI9v = parcelRequire("eGI9v");
var $jUhyG = parcelRequire("jUhyG");
class $6def25be35218960$export$1c7ccff61c195c75 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $9LCN1.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.sendDwellEvent = (payload)=>(0, $jUhyG.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $6def25be35218960$export$2e2bcd8739ae039 = (0, $eGI9v.default)('dwellTime', {
    onDwell: 'dwelled'
})($6def25be35218960$export$1c7ccff61c195c75);

});
parcelRegister("eGI9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9208d82098460921$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");
const $9208d82098460921$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9208d82098460921$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $1ngde.default)({
            componentName: componentName
        })((0, $2jDha.default)($9208d82098460921$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $9208d82098460921$export$2e2bcd8739ae039 = $9208d82098460921$var$componentWithAnalytics;

});

parcelRegister("jUhyG", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $5b05bd1f53288b4a$export$13990ad4625571ed);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
const $5b05bd1f53288b4a$var$isNotUndefined = (a)=>a !== undefined;
const $5b05bd1f53288b4a$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $5b05bd1f53288b4a$var$isNotUndefined);
};
const $5b05bd1f53288b4a$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$5b05bd1f53288b4a$var$mapPayload(payload),
        analyticsType: (0, $etqm0.TRACK_EVENT_TYPE)
    }).fire();
};

});
parcelRegister("klunD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0af4980e66497eeb$export$2e2bcd8739ae039);

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0af4980e66497eeb$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};

});





parcelRegister("6d078", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("53zvZ")
]).then(()=>parcelRequire('jqtYH'));

});

parcelRegister("acYbg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fF7Ru")
]).then(()=>parcelRequire('9h92o'));

});

parcelRegister("6i2jN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cBElD").then(()=>parcelRequire('bq09U'));

});

parcelRegister("6dWs5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("iexSq"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("561Jq"),
    $d1Cng("1QYl5"),
    $d1Cng("2Lfdl"),
    $d1Cng("hPzOn"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("8Ny04")
]).then(()=>parcelRequire('gibLG'));

});

parcelRegister("96h1U", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("ihXca")
]).then(()=>parcelRequire('cfAPv'));

});


parcelRegister("icR0y", function(module, exports) {

$parcel$export(module.exports, "renderPageContainer", () => $b057fcf34e6d44a4$export$53746a9158b8b9c8);
$parcel$export(module.exports, "default", () => $b057fcf34e6d44a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7rh0R = parcelRequire("7rh0R");

var $e91YZ = parcelRequire("e91YZ");

var $8R80x = parcelRequire("8R80x");

var $fee69 = parcelRequire("fee69");

var $d16Bc = parcelRequire("d16Bc");

var $6rW04 = parcelRequire("6rW04");
parcelRequire("80E03");

var $keguF = parcelRequire("keguF");

var $geFaw = parcelRequire("geFaw");

var $lB25E = parcelRequire("lB25E");

var $gTSbo = parcelRequire("gTSbo");

var $9DIQe = parcelRequire("9DIQe");

var $4inxB = parcelRequire("4inxB");

var $fGHk2 = parcelRequire("fGHk2");

// Trigger async import asap, no need for RLL as SSR renders without too
const $b057fcf34e6d44a4$var$pageContainerImport = (parcelRequire("awT4s"));

var $7KGHt = parcelRequire("7KGHt");
const $b057fcf34e6d44a4$export$53746a9158b8b9c8 = async ({ App: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'ComponentType<any>'.
App = null, containerId: containerId = 'navigation-app', onLoad: onLoad, pageType: pageType = 'legacy-page' } = {})=>{
    const container = document.getElementById(containerId);
    if (container) {
        const { default: PageContainerV2 } = await $b057fcf34e6d44a4$var$pageContainerImport;
        (0, $7rh0R.default).init({
            mode: 'RENDER',
            crossOrigin: 'anonymous'
        });
        const tenantContext = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        $parcel$global.__NAV_VERSION__ = '3.0.0';
        (0, $d16Bc.initPlatformFeatureFlags)();
        const history = (0, $lB25E.createLegacyHistory)();
        const routes = (0, $4inxB.getRoutes)();
        const matchedRoute = (0, $lB25E.matchRoute)(routes, window.location.pathname, // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        window.location.search, '');
        (0, $keguF.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        const resourceContext = (0, $fGHk2.getSpaRouterContext)({
            tenantContext: tenantContext
        });
        const resourceData = window.SKELETON_NAVIGATION;
        const LegacyRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTSbo.Router), {
                history: history,
                routes: routes,
                resourceContext: resourceContext,
                resourceData: resourceData
            }, children);
        const placeholders = (0, $8R80x.getPlaceholdersFromHTML)();
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PageContainerV2, {
            id: "jira.entry.legacy",
            locale: tenantContext.locale,
            baseUrl: "",
            messages: $7KGHt,
            onLoad: onLoad,
            Router: LegacyRouter,
            routerLinkComponent: (0, $9DIQe.JiraRouterLinkConfiguration),
            pageType: pageType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
            id: "jira.route-app.legacy-bootstrap"
        }, App ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, null) : null)))), container);
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b057fcf34e6d44a4$export$2e2bcd8739ae039 = ()=>{
    const isGlobalSidebarEnabled = (0, $6rW04.default)('ajs-global-sidebar-enabled') === 'true';
    if (!isGlobalSidebarEnabled) return;
    if (document.getElementById('navigation-app')) $b057fcf34e6d44a4$export$53746a9158b8b9c8();
    else document.addEventListener('DOMContentLoaded', ()=>$b057fcf34e6d44a4$export$53746a9158b8b9c8());
};

});
parcelRegister("8R80x", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $c9ae2df088b0cf45$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $c9ae2df088b0cf45$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointPlaceholder", () => $c9ae2df088b0cf45$export$db2828f683d11042);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");
function $c9ae2df088b0cf45$export$9e9f35acc3af3a9a() {
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $c9ae2df088b0cf45$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $eUqFw.createContext)(new Map());
function $c9ae2df088b0cf45$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
    const { root: root } = entryPoint;
    const hasMounted = (0, $eUqFw.useRef)(false);
    const placeholders = (0, $eUqFw.useContext)($c9ae2df088b0cf45$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $eUqFw.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : // eslint-disable-next-line react/no-danger
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name
    }));
    const lastOriginalFallback = (0, $eUqFw.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (hasMounted.current && placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        entryPoint,
        name,
        placeholders,
        setFallback
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onComplete = ()=>{
            if (placeholders.has(name)) placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        };
        const unsubscribe = root.onComplete(onComplete, onComplete);
        return ()=>{
            unsubscribe();
            onComplete();
        };
    }, [
        name,
        placeholders,
        root
    ]);
    (0, $eUqFw.useEffect)(()=>{
        hasMounted.current = true;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-ep-placeholder-id": name
    }, children));
}

});

parcelRegister("d16Bc", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $00f2fa4abeba3937$export$2d291317456ada16);

var $XHGTv = parcelRequire("XHGTv");

var $eI5EY = parcelRequire("eI5EY");

var $8rQuz = parcelRequire("8rQuz");

var $1ybV0 = parcelRequire("1ybV0");
const $00f2fa4abeba3937$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform.design-system-team.enable-new-icons'
];
const $00f2fa4abeba3937$export$2d291317456ada16 = ()=>{
    if ((0, $1ybV0.ff)('fix_jira_ssr_platform_ff_oxim4')) (0, $XHGTv.setBooleanFeatureFlagResolver)((flagKey)=>{
        if ($00f2fa4abeba3937$var$visualRefreshPlatformFlags.includes(flagKey)) return (0, $8rQuz.isVisualRefreshEnabled)();
        return (0, $eI5EY.fg)(flagKey) || (0, $1ybV0.ff)(flagKey);
    });
};

});
parcelRegister("8rQuz", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $867146288cf212f8$export$48345cb467db19b6);

var $eI5EY = parcelRequire("eI5EY");
const $867146288cf212f8$var$DUMMY_CONDITION = true;
const $867146288cf212f8$export$48345cb467db19b6 = ()=>(0, $eI5EY.fg)('visual-refresh') && $867146288cf212f8$var$DUMMY_CONDITION;

});


parcelRegister("80E03", function(module, exports) {

var $WBLbN = parcelRequire("WBLbN");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("kQSGw"));
    const isDevMode = false;
    (0, $WBLbN.defaults).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $WBLbN.defaults).batchUpdates = !false;
    Object.freeze((0, $WBLbN.defaults));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("kQSGw", function(module, exports) {
const $f2e3153aecef516a$var$style = document.createElement('style');
$f2e3153aecef516a$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font-size:.785714em;font-style:inherit;color:var(--ds-text-subtlest,var(--ds-text-subtlest,#6b778c));line-height:1.45455;font-weight:var(--ds-font-weight-bold,700);margin-top:16px;font-weight:400}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($f2e3153aecef516a$var$style);

});


parcelRegister("gTSbo", function(module, exports) {

$parcel$export(module.exports, "Router", () => $cff2cba3bfe91f62$export$55185c17a0fcbe46);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $8W8mY = parcelRequire("8W8mY");
const $cff2cba3bfe91f62$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $8W8mY.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("8W8mY", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $e161d30d7f706347$export$c41e96fd89bc6106);

var $eUqFw = parcelRequire("eUqFw");

var $eoTRo = parcelRequire("eoTRo");

var $amu7D = parcelRequire("amu7D");

var $gd0Sp = parcelRequire("gd0Sp");

var $dW81L = parcelRequire("dW81L");
const $e161d30d7f706347$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $eUqFw.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $dW81L.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $eoTRo.createEntryPointsPlugin)({
            environment: (0, $amu7D.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("eoTRo", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $8908df19809cff0a$export$33586718f82f356f);

var $iWLL0 = parcelRequire("iWLL0");

var $4Wbcp = parcelRequire("4Wbcp");

var $gglAH = parcelRequire("gglAH");

var $kP52E = parcelRequire("kP52E");
const $8908df19809cff0a$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefethed right before being loaded
                if (prefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $4Wbcp.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else entryPointReference = (0, $iWLL0.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: context,
                    ...entryPointParams
                });
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $gglAH.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $4Wbcp.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $iWLL0.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $4Wbcp.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $gglAH.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $kP52E.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        }
    });

});
parcelRegister("4Wbcp", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $7b677faf33f0c24f$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $7b677faf33f0c24f$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $7b677faf33f0c24f$export$5997e70fc4543270);
const $7b677faf33f0c24f$export$37d3126be6549b13 = 10000;
const $7b677faf33f0c24f$export$b65d7ba7fbf150f1 = ()=>$7b677faf33f0c24f$export$37d3126be6549b13 + Date.now();
const $7b677faf33f0c24f$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $7b677faf33f0c24f$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $7b677faf33f0c24f$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("gglAH", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $200515d1f24b1bb9$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $200515d1f24b1bb9$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $200515d1f24b1bb9$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $200515d1f24b1bb9$export$7e18f3e3cbd04326);

var $WBLbN = parcelRequire("WBLbN");
const $200515d1f24b1bb9$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $200515d1f24b1bb9$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $200515d1f24b1bb9$var$actions = {
    setLastLoadedRoute: $200515d1f24b1bb9$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $200515d1f24b1bb9$export$bb3dc9c55f78173e
};
const $200515d1f24b1bb9$var$EntryPointsStore = (0, $WBLbN.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $200515d1f24b1bb9$var$actions,
    name: 'react-resource-router/entry-points'
});
const $200515d1f24b1bb9$export$895238443fc3eae4 = (0, $WBLbN.createHook)($200515d1f24b1bb9$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $200515d1f24b1bb9$export$fe654a734624d17f = ()=>(0, $WBLbN.defaultRegistry).getStore($200515d1f24b1bb9$var$EntryPointsStore);
const $200515d1f24b1bb9$export$b28ecd0e4705f6b7 = ()=>$200515d1f24b1bb9$export$fe654a734624d17f().storeState.getState();
const $200515d1f24b1bb9$export$5763b2305b3056df = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $200515d1f24b1bb9$export$7e18f3e3cbd04326 = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().prefetchingRoute;

});

parcelRegister("kP52E", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $865808bba2ff8fa0$export$944f853f194e5dd5);

var $c7ifG = parcelRequire("c7ifG");
const $865808bba2ff8fa0$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $c7ifG.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $865808bba2ff8fa0$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});


parcelRegister("dW81L", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $9aee4cd38ce58613$export$23ed892c481a96fe);

var $e2YXo = parcelRequire("e2YXo");

var $l0jNy = parcelRequire("l0jNy");
const $9aee4cd38ce58613$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $9aee4cd38ce58613$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
    const nextResources = (0, $l0jNy.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $9aee4cd38ce58613$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
    const nextResources = (0, $l0jNy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $9aee4cd38ce58613$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $e2YXo.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $9aee4cd38ce58613$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $9aee4cd38ce58613$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $9aee4cd38ce58613$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $e2YXo.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
            const nextResources = (0, $l0jNy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $e2YXo.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("l0jNy", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $334bbc6cfe5a6fd8$export$7cbbc763e2f3d65d);

var $8JMlp = parcelRequire("8JMlp");

var $3DChr = parcelRequire("3DChr");
const $334bbc6cfe5a6fd8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $3DChr.routeHasResources)(nextRoute)) return [];
    if ((0, $3DChr.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8JMlp.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8JMlp.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("8JMlp", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $3e60e0806526708a$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $3e60e0806526708a$export$cd7fbe7e979df558);
const $3e60e0806526708a$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $3e60e0806526708a$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$3e60e0806526708a$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("3DChr", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $135cafef8578dfeb$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $135cafef8578dfeb$export$221027ff1aa38f82);
const $135cafef8578dfeb$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $135cafef8578dfeb$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("9DIQe", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $f7d9123ec5eaca80$export$a580704a2f3cfca);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $f7d9123ec5eaca80$export$a580704a2f3cfca = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        ref: ref,
        href: href || '#',
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest
    }, children);
});

});

parcelRegister("4inxB", function(module, exports) {

$parcel$export(module.exports, "getRoutes", () => $3ba63e6117655a46$export$2f7745f2f5ab3897);

var $exb0h = parcelRequire("exb0h");

var $hHrVM = parcelRequire("hHrVM");

var $bCmyq = parcelRequire("bCmyq");

var $lMiJ0 = parcelRequire("lMiJ0");

var $6ILls = parcelRequire("6ILls");

var $fc79W = parcelRequire("fc79W");

var $7C31q = parcelRequire("7C31q");

var $eIO5Y = parcelRequire("eIO5Y");

var $iYEeU = parcelRequire("iYEeU");

var $1xUfI = parcelRequire("1xUfI");

var $8WSCP = parcelRequire("8WSCP");

var $iVzDY = parcelRequire("iVzDY");

var $9t1Bs = parcelRequire("9t1Bs");

var $17XRP = parcelRequire("17XRP");

var $qNMoW = parcelRequire("qNMoW");

var $5fmBg = parcelRequire("5fmBg");

var $gIjnZ = parcelRequire("gIjnZ");

var $1JV9H = parcelRequire("1JV9H");

var $qswpl = parcelRequire("qswpl");

var $4K2n4 = parcelRequire("4K2n4");

var $eLXBs = parcelRequire("eLXBs");

var $LHKQV = parcelRequire("LHKQV");

var $1FmVb = parcelRequire("1FmVb");

var $gAZCg = parcelRequire("gAZCg");

var $5HwSM = parcelRequire("5HwSM");

var $3lAhy = parcelRequire("3lAhy");

var $aMVCY = parcelRequire("aMVCY");

var $1l6lw = parcelRequire("1l6lw");

var $hfhaB = parcelRequire("hfhaB");

var $7WDKx = parcelRequire("7WDKx");

var $4glRX = parcelRequire("4glRX");

var $cUfSr = parcelRequire("cUfSr");

var $1NXii = parcelRequire("1NXii");

var $imUKj = parcelRequire("imUKj");

var $bkOwc = parcelRequire("bkOwc");
var $43CRR = parcelRequire("43CRR");

var $hgTPZ = parcelRequire("hgTPZ");

var $g4Nub = parcelRequire("g4Nub");

var $cHfoX = parcelRequire("cHfoX");

var $l76Vj = parcelRequire("l76Vj");

var $5xWEa = parcelRequire("5xWEa");

var $gIH1C = parcelRequire("gIH1C");

var $iE7ZG = parcelRequire("iE7ZG");

var $1Aau6 = parcelRequire("1Aau6");

var $iVrTt = parcelRequire("iVrTt");

var $2VpKv = parcelRequire("2VpKv");

var $c9ioI = parcelRequire("c9ioI");

var $9xKXn = parcelRequire("9xKXn");

var $c8sjC = parcelRequire("c8sjC");

var $gFF3Y = parcelRequire("gFF3Y");

var $iMiUN = parcelRequire("iMiUN");

var $j2fHk = parcelRequire("j2fHk");

var $dJWjd = parcelRequire("dJWjd");

var $jGH4y = parcelRequire("jGH4y");

var $7FDXH = parcelRequire("7FDXH");

var $7nirz = parcelRequire("7nirz");

var $7QX3x = parcelRequire("7QX3x");

var $iZ26w = parcelRequire("iZ26w");

var $2W2q2 = parcelRequire("2W2q2");

var $l9tXd = parcelRequire("l9tXd");

var $cJJgM = parcelRequire("cJJgM");

var $eB8ua = parcelRequire("eB8ua");

var $dRIVd = parcelRequire("dRIVd");

var $hPp3X = parcelRequire("hPp3X");

var $heAU9 = parcelRequire("heAU9");

var $cIx9g = parcelRequire("cIx9g");

var $7Q4s7 = parcelRequire("7Q4s7");

var $10wJP = parcelRequire("10wJP");

var $baY1v = parcelRequire("baY1v");

var $afFye = parcelRequire("afFye");

var $6I50K = parcelRequire("6I50K");

var $eSPGm = parcelRequire("eSPGm");

var $6cuLl = parcelRequire("6cuLl");

var $6MVKx = parcelRequire("6MVKx");

var $adgc5 = parcelRequire("adgc5");

var $1v7mq = parcelRequire("1v7mq");

var $faeuP = parcelRequire("faeuP");

var $5WBnz = parcelRequire("5WBnz");

var $furTl = parcelRequire("furTl");

var $9BiW1 = parcelRequire("9BiW1");

var $97mkw = parcelRequire("97mkw");

var $v9XgX = parcelRequire("v9XgX");

var $lspYz = parcelRequire("lspYz");

var $LvsCP = parcelRequire("LvsCP");

var $gzOIA = parcelRequire("gzOIA");

var $3Fjff = parcelRequire("3Fjff");

var $jkJhv = parcelRequire("jkJhv");

var $8Zyn4 = parcelRequire("8Zyn4");

var $je2Fi = parcelRequire("je2Fi");

var $jMPjG = parcelRequire("jMPjG");

var $4s7Hu = parcelRequire("4s7Hu");

var $iE4io = parcelRequire("iE4io");

var $hwhdw = parcelRequire("hwhdw");

var $eMbz6 = parcelRequire("eMbz6");

var $91zkM = parcelRequire("91zkM");

var $gVBaq = parcelRequire("gVBaq");

var $ciIlo = parcelRequire("ciIlo");

var $1blIf = parcelRequire("1blIf");

var $2SdI5 = parcelRequire("2SdI5");

var $iBYQH = parcelRequire("iBYQH");

var $iubtQ = parcelRequire("iubtQ");

var $acwwS = parcelRequire("acwwS");

var $aaRBu = parcelRequire("aaRBu");

var $aA2zo = parcelRequire("aA2zo");

var $21PQj = parcelRequire("21PQj");

var $jCLVV = parcelRequire("jCLVV");

var $djSBu = parcelRequire("djSBu");

var $7Wy95 = parcelRequire("7Wy95");

var $dx9b1 = parcelRequire("dx9b1");

var $lkbNT = parcelRequire("lkbNT");

var $eU1h2 = parcelRequire("eU1h2");

var $6FExv = parcelRequire("6FExv");

var $6v0cp = parcelRequire("6v0cp");

var $1QVRV = parcelRequire("1QVRV");

var $21OTx = parcelRequire("21OTx");

var $7e1il = parcelRequire("7e1il");

var $7JniE = parcelRequire("7JniE");

var $fKLft = parcelRequire("fKLft");

var $7GAkN = parcelRequire("7GAkN");

var $871XI = parcelRequire("871XI");

var $17G3z = parcelRequire("17G3z");

var $99kzs = parcelRequire("99kzs");

var $19kmi = parcelRequire("19kmi");

var $2aAoE = parcelRequire("2aAoE");

var $7brDo = parcelRequire("7brDo");

var $6iqEO = parcelRequire("6iqEO");

var $isiO0 = parcelRequire("isiO0");

var $8cvs0 = parcelRequire("8cvs0");

var $aKebc = parcelRequire("aKebc");

var $1L0xa = parcelRequire("1L0xa");

var $3NLRG = parcelRequire("3NLRG");

var $4avaK = parcelRequire("4avaK");

var $2h3lO = parcelRequire("2h3lO");

var $4fquI = parcelRequire("4fquI");

var $2DXVI = parcelRequire("2DXVI");

var $ijvcE = parcelRequire("ijvcE");

var $50RHu = parcelRequire("50RHu");

var $lXIqH = parcelRequire("lXIqH");

var $bPjBv = parcelRequire("bPjBv");

var $hLzqF = parcelRequire("hLzqF");

var $fzE9V = parcelRequire("fzE9V");

var $7KIKV = parcelRequire("7KIKV");

var $jbNtl = parcelRequire("jbNtl");

var $gmZ4K = parcelRequire("gmZ4K");

var $1koE7 = parcelRequire("1koE7");

var $6DgC6 = parcelRequire("6DgC6");

var $8PAza = parcelRequire("8PAza");

var $jfWNm = parcelRequire("jfWNm");

var $cBVsd = parcelRequire("cBVsd");

var $4LAO4 = parcelRequire("4LAO4");

var $dSBp6 = parcelRequire("dSBp6");

var $2Njzs = parcelRequire("2Njzs");

var $4SOuU = parcelRequire("4SOuU");

var $1j0Bt = parcelRequire("1j0Bt");

var $l6Ck7 = parcelRequire("l6Ck7");

var $3YyaO = parcelRequire("3YyaO");

var $bNJbU = parcelRequire("bNJbU");

var $k2nqy = parcelRequire("k2nqy");

var $7vRFW = parcelRequire("7vRFW");

var $1mBGD = parcelRequire("1mBGD");

var $e1Lm3 = parcelRequire("e1Lm3");

var $eh53C = parcelRequire("eh53C");

var $k3GOY = parcelRequire("k3GOY");

var $d7vUv = parcelRequire("d7vUv");

var $2QuGp = parcelRequire("2QuGp");

var $iSe8w = parcelRequire("iSe8w");

var $8Gz9v = parcelRequire("8Gz9v");

var $ksQFL = parcelRequire("ksQFL");

var $2NoVw = parcelRequire("2NoVw");

var $jn1UR = parcelRequire("jn1UR");

var $223x6 = parcelRequire("223x6");

var $jnAuY = parcelRequire("jnAuY");

var $7Wws4 = parcelRequire("7Wws4");

var $hylPE = parcelRequire("hylPE");

var $aIPqS = parcelRequire("aIPqS");

var $5U2vN = parcelRequire("5U2vN");

var $j8GQH = parcelRequire("j8GQH");

var $leBgO = parcelRequire("leBgO");

var $dg8kv = parcelRequire("dg8kv");

var $8rQkD = parcelRequire("8rQkD");

var $atOQk = parcelRequire("atOQk");

var $1Fjfc = parcelRequire("1Fjfc");

var $egQ89 = parcelRequire("egQ89");

var $12Uvs = parcelRequire("12Uvs");

var $4FxfK = parcelRequire("4FxfK");

var $2VVMG = parcelRequire("2VVMG");

var $e3g9n = parcelRequire("e3g9n");

var $8HL4y = parcelRequire("8HL4y");

var $3Cfrh = parcelRequire("3Cfrh");

var $1hpYM = parcelRequire("1hpYM");

var $3cLCI = parcelRequire("3cLCI");

var $3mqtu = parcelRequire("3mqtu");

var $4kGtK = parcelRequire("4kGtK");

var $lzxba = parcelRequire("lzxba");

var $ejqSg = parcelRequire("ejqSg");

var $C0pKf = parcelRequire("C0pKf");

var $9bf2e = parcelRequire("9bf2e");

var $lnL58 = parcelRequire("lnL58");

var $kOwA2 = parcelRequire("kOwA2");

var $hnGKO = parcelRequire("hnGKO");

var $eMyWM = parcelRequire("eMyWM");

var $fwIzJ = parcelRequire("fwIzJ");

var $f6ROO = parcelRequire("f6ROO");

var $bvVvS = parcelRequire("bvVvS");

var $8cNTF = parcelRequire("8cNTF");

var $9lIwg = parcelRequire("9lIwg");

var $hvKIU = parcelRequire("hvKIU");

var $9NqLg = parcelRequire("9NqLg");

var $8nnEW = parcelRequire("8nnEW");

var $1knqj = parcelRequire("1knqj");

var $70v59 = parcelRequire("70v59");

var $4EwNb = parcelRequire("4EwNb");

var $b4PHH = parcelRequire("b4PHH");

var $f6hR4 = parcelRequire("f6hR4");

var $lJ4T7 = parcelRequire("lJ4T7");

var $bX7PX = parcelRequire("bX7PX");

var $19Ry0 = parcelRequire("19Ry0");

var $axsmw = parcelRequire("axsmw");

var $klGsW = parcelRequire("klGsW");

var $bo5BL = parcelRequire("bo5BL");

var $2WzSD = parcelRequire("2WzSD");

var $8ouYC = parcelRequire("8ouYC");

var $eZ0Ne = parcelRequire("eZ0Ne");

var $hScXQ = parcelRequire("hScXQ");

var $dwp5N = parcelRequire("dwp5N");

var $jKTLS = parcelRequire("jKTLS");

var $bpapD = parcelRequire("bpapD");

var $dyqXz = parcelRequire("dyqXz");

var $aXK8E = parcelRequire("aXK8E");

var $dqn9u = parcelRequire("dqn9u");

var $iyauW = parcelRequire("iyauW");

var $04owV = parcelRequire("04owV");

var $9p0FM = parcelRequire("9p0FM");

var $gcyh1 = parcelRequire("gcyh1");

var $2NNzt = parcelRequire("2NNzt");

var $iWHQ4 = parcelRequire("iWHQ4");

var $19aSV = parcelRequire("19aSV");
/*
    These routes are only used when the SPA route didn't hit in backend,
    and it rendered navigation-skeleton bundle not jira-spa bundle. This means these route are not used in SPA.
    Please delete these routes if your legacy page is not used anymore.
 */ const $3ba63e6117655a46$var$getRawRoutes = ()=>[
        (0, $e3g9n.legacyJsdGettingStartedRouteEntry),
        (0, $2VVMG.legacyJsdCustomersRouteEntry),
        (0, $3Cfrh.legacyJsdKnowledgeRouteEntry),
        (0, $3cLCI.legacyJsdQueuesManageRouteEntry),
        (0, $1hpYM.legacyJsdQueuesRouteEntry),
        (0, $3mqtu.legacyJsdReportsCustomRouteEntry),
        (0, $4kGtK.legacyJsdReportsRouteEntry),
        (0, $ejqSg.legacyJsdSettingsLanguageRouteEntry),
        (0, $C0pKf.legacyJsdSettingsLanguagePagesRouteEntry),
        (0, $8HL4y.legacyJsdJiraAutomationRouteEntry),
        (0, $9bf2e.legacyJsdWidgetsRouteEntry),
        (0, $lzxba.legacyJsdSettingsFallbackRouteEntry),
        (0, $1xUfI.legacyCustomReportRouteEntry),
        (0, $fc79W.legacyBacklogRouteEntry),
        (0, $7C31q.legacyBoardRouteEntry),
        (0, $7C31q.legacyBoard1RouteEntry),
        (0, $6ILls.legacyAllReportsRouteEntry),
        (0, $1NXii.globalIssueNavigatorRouteEntry),
        (0, $1NXii.globalIssueNavigatorBrowseRouteEntry),
        (0, $1NXii.globalIssueNavigatorRedirectRouteEntry),
        (0, $4FxfK.legacyIssueRouteEntry),
        (0, $kOwA2.legacyPinRouteEntry),
        (0, $f6ROO.legacyProjectReleasesRouteEntry),
        (0, $8cNTF.legacyProjectReleasesNoteRouteEntry),
        (0, $bvVvS.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $fwIzJ.legacyProjectReleasesBambooRouteEntry),
        (0, $dwp5N.legacyReportsAverageAgeRouteEntry),
        (0, $bpapD.legacyReportsCreatedVsResolvedRouteEntry),
        (0, $aXK8E.legacyReportsPieRouteEntry),
        (0, $dqn9u.legacyReportsRecentlyCreatedRouteEntry),
        (0, $iyauW.legacyReportsResolutionTimeRouteEntry),
        (0, $04owV.legacyReportsSingleLevelGroupByRouteEntry),
        (0, $9p0FM.legacyReportsTimeSinceRouteEntry),
        (0, $gcyh1.legacyReportsTimeTrackingReportRouteEntry),
        (0, $dyqXz.legacyReportsDeveloperWorkloadRouteEntry),
        (0, $2NNzt.legacyReportsVersionWorkloadRouteEntry),
        (0, $iWHQ4.legacyReportsWorkloadPieRouteEntry),
        (0, $jKTLS.legacyReportsConfigRouteEntry),
        (0, $iYEeU.legacyConnectProjectRouteEntry),
        (0, $bo5BL.legacyProjectSettingsPeopleRouteEntry),
        (0, $eZ0Ne.legacyProjectSettingsSummaryRouteEntry),
        (0, $19Ry0.legacyProjectSettingsIssueTypesRouteEntry),
        (0, $19Ry0.legacyProjectSettingsIssueTypesAssociateRouteEntry),
        (0, $lJ4T7.legacyProjectSettingsIssueLayoutRouteEntry),
        (0, $hScXQ.legacyProjectSettingsWorkflowsRouteEntry),
        (0, $hScXQ.legacyProjectSettingsWorkflowsAssociateRouteEntry),
        (0, $8ouYC.legacyProjectSettingsScreensRouteEntry),
        (0, $8ouYC.legacyProjectSettingsScreensAssociateRouteEntry),
        (0, $f6hR4.legacyProjectSettingsFieldsRouteEntry),
        (0, $f6hR4.legacyProjectSettingsFieldsAssociateRouteEntry),
        (0, $klGsW.legacyProjectSettingsOpsgenieRouteEntry),
        (0, $2WzSD.legacyProjectSettingsPermissionsRouteEntry),
        (0, $bX7PX.legacyProjectSettingsIssueSecurityRouteEntry),
        (0, $bX7PX.legacyProjectSettingsIssueSecurityAssociateRouteEntry),
        (0, $axsmw.legacyProjectSettingsNotificationsRouteEntry),
        (0, $axsmw.legacyProjectSettingsNotificationsAssociateRouteEntry),
        (0, $1knqj.legacyProjectSettingsConfigRouteEntry),
        (0, $b4PHH.legacyProjectSettingsEditRouteEntry),
        (0, $70v59.legacyProjectSettingsDeleteRouteEntry),
        (0, $hvKIU.legacyProjectSettingsCollectorsRouteEntry),
        (0, $9lIwg.legacyProjectSettingsCollectorsAddRouteEntry),
        (0, $9NqLg.legacyProjectSettingsCollectorsHelpRouteEntry),
        (0, $8nnEW.legacyProjectSettingsCollectorsViewRouteEntry),
        (0, $4EwNb.legacyProjectSettingsDevRouteEntry),
        (0, $iVzDY.legacyDashboardsConfigureRouteEntry),
        (0, $17XRP.dashboardsDirectoryRouteEntry),
        (0, $8WSCP.legacyDashboardsAddRouteEntry),
        (0, $qNMoW.legacyDashboardsEditRouteEntry),
        (0, $9t1Bs.legacyDashboardsDeleteRouteEntry),
        (0, $5fmBg.legacyDashboardsRestoreRouteEntry),
        (0, $aMVCY.legacyGinManageRouteEntry),
        (0, $4K2n4.legacyGinBulkeditRouteEntry),
        (0, $qswpl.legacyGinBulkRouteEntry),
        (0, $3lAhy.legacyGinIssueMoveRouteEntry),
        (0, $7WDKx.legacyGinSubtaskActionRouteEntry),
        (0, $LHKQV.legacyGinIssueCloneRouteEntry),
        (0, $eLXBs.legacyGinIssueAssignRouteEntry),
        (0, $gAZCg.legacyGinIssueCreateRouteEntry),
        (0, $1FmVb.legacyGinIssueConvertRouteEntry),
        (0, $5HwSM.legacyGinIssueEditRouteEntry),
        (0, $4glRX.legacyGinWatchersIssueRouteEntry),
        (0, $1JV9H.legacyGinActionRouteEntry),
        (0, $hfhaB.legacyGinSubscriptionsRouteEntry),
        (0, $1l6lw.legacyGinSubscriptionEditRouteEntry),
        (0, $hnGKO.legacyPortfolioPagesRouteEntry),
        (0, $eMyWM.legacyPortfolioTeamRouteEntry),
        (0, $jbNtl.globalSettingsSystemApplicationViewRouteEntry),
        (0, $fzE9V.globalSettingsSystemApplicationAdvancedRouteEntry),
        (0, $7KIKV.globalSettingsSystemApplicationEditRouteEntry),
        (0, $1koE7.globalSettingsSystemAuditingRouteEntry),
        (0, $leBgO.globalSettingsSystemRolesViewRouteEntry),
        (0, $j8GQH.globalSettingsSystemRolesUsageRouteEntry),
        (0, $jnAuY.globalSettingsSystemRolesActorsRouteEntry),
        (0, $7Wws4.globalSettingsSystemRolesActorsGroupsRouteEntry),
        (0, $hylPE.globalSettingsSystemRolesActorsUsersRouteEntry),
        (0, $5U2vN.globalSettingsSystemRolesEditRouteEntry),
        (0, $aIPqS.globalSettingsSystemRolesDeleteRouteEntry),
        (0, $jn1UR.globalSettingsSystemProjectDeleteRouteEntry),
        (0, $2NoVw.globalSettingsSystemProjectAssignSecurityRouteEntry),
        (0, $ksQFL.globalSettingsSystemPermissionsRouteEntry),
        (0, $6DgC6.globalSettingsSystemCollectorsRouteEntry),
        (0, $8PAza.globalSettingsSystemDefaultSettingsRouteEntry),
        (0, $e1Lm3.globalSettingsSystemLookRouteEntry),
        (0, $cBVsd.globalSettingsSystemExportRouteEntry),
        (0, $4LAO4.globalSettingsSystemGlobalPermissionsRouteEntry),
        (0, $3YyaO.globalSettingsSystemImportExternalRouteEntry),
        (0, $bNJbU.globalSettingsSystemImportExternalPagesRouteEntry),
        (0, $l6Ck7.globalSettingsSystemImportCsvRouteEntry),
        (0, $k2nqy.globalSettingsSystemImportJsonRouteEntry),
        (0, $7vRFW.globalSettingsSystemImportTrelloRouteEntry),
        (0, $1j0Bt.globalSettingsSystemImportCloudRouteEntry),
        (0, $4SOuU.globalSettingsSystemImportBulkRouteEntry),
        (0, $cUfSr.globalAutomationRouteEntry),
        (0, $iSe8w.globalSettingsSystemMailSettingsRouteEntry),
        (0, $d7vUv.globalSettingsSystemMailOutgoingRouteEntry),
        (0, $k3GOY.globalSettingsSystemMailDeleteMailHandlerRouteEntry),
        (0, $k3GOY.globalSettingsSystemMailIncomingRouteEntry),
        (0, $eh53C.globalSettingsSystemMailAddRouteEntry),
        (0, $8Gz9v.globalSettingsSystemMailVerifyRouteEntry),
        (0, $2QuGp.globalSettingsSystemMailSendRouteEntry),
        (0, $2Njzs.globalSettingsSystemHelperPermissionRouteEntry),
        (0, $dSBp6.globalSettingsSystemHelperNotificationRouteEntry),
        (0, $atOQk.globalSettingsSystemSharedFiltersRouteEntry),
        (0, $8rQkD.globalSettingsSystemSharedDashboardsRouteEntry),
        (0, $gmZ4K.globalSettingsSystemAttachmentsRouteEntry),
        (0, $jfWNm.globalSettingsSystemEventsRouteEntry),
        (0, $jfWNm.globalSettingsSystemEventsAddRouteEntry),
        (0, $jfWNm.globalSettingsSystemEventsDeleteRouteEntry),
        (0, $jfWNm.globalSettingsSystemEventsEditRouteEntry),
        (0, $1Fjfc.globalSettingsSystemUserInterfaceDashboardEditRouteEntry),
        (0, $egQ89.globalSettingsSystemUserInterfacePreferencesRouteEntry),
        (0, $12Uvs.globalSettingsSystemWebhooksRouteEntry),
        (0, $dg8kv.globalSettingsSystemServicesRouteEntry),
        (0, $1mBGD.globalSettingsSystemLexorankRouteEntry),
        (0, $aKebc.globalSettingsProductsAccessRouteEntry),
        (0, $50RHu.globalSettingsProductsSoftwareConfigRouteEntry),
        (0, $1L0xa.globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry),
        (0, $2DXVI.globalSettingsProductsSdconfigRouteEntry),
        (0, $ijvcE.globalSettingsProductsSdmailRouteEntry),
        (0, $3NLRG.globalSettingsProductsApplinksRouteEntry),
        (0, $2h3lO.globalSettingsProductsDvcsRouteEntry),
        (0, $4avaK.globalSettingsProductsDvcsBitbucketRouteEntry),
        (0, $4fquI.globalSettingsProductsJsdStatusRouteEntry),
        (0, $hLzqF.globalSettingsProjectsCategoriesViewRouteEntry),
        (0, $bPjBv.globalSettingsProjectsCategoriesEditRouteEntry),
        (0, $lXIqH.globalSettingsProjectsCategoriesDeleteRouteEntry),
        (0, $1QVRV.globalSettingsIssuesTypesEditRouteEntry),
        (0, $6v0cp.globalSettingsIssuesTypesDeleteRouteEntry),
        (0, $21OTx.globalSettingsIssuesTypesMigrateRouteEntry),
        (0, $7brDo.globalSettingsIssuesTypesTranslationsRouteEntry),
        (0, $7GAkN.globalSettingsIssuesTypesSchemesOptionRouteEntry),
        (0, $7e1il.globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry),
        (0, $7JniE.globalSettingsIssuesTypesSchemesAssociateRouteEntry),
        (0, $fKLft.globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry),
        (0, $l76Vj.globalSettingsIssueSubtasksRouteEntry),
        (0, $lkbNT.globalSettingsIssuesSubtasksDisableRouteEntry),
        (0, $eU1h2.globalSettingsIssuesSubtasksEditRouteEntry),
        (0, $6FExv.globalSettingsIssuesSubtasksTranlationsRouteEntry),
        (0, $19aSV.workflowDesignerRouteEntry),
        (0, $gIH1C.globalSettingsIssueWorkflowRouteEntry),
        (0, $6iqEO.globalSettingsIssuesWorkflowTransitionRouteEntry),
        (0, $6iqEO.globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry),
        (0, $isiO0.globalSettingsIssuesWorkflowsImportRouteEntry),
        (0, $iE7ZG.globalSettingsIssueWorkflowSchemesRouteEntry),
        (0, $8cvs0.globalSettingsIssuesWorkflowsSchemesEditRouteEntry),
        (0, $eB8ua.globalSettingsIssuesFieldViewRouteEntry),
        (0, $gFF3Y.globalSettingsIssuesFieldAddRouteEntry),
        (0, $j2fHk.globalSettingsIssuesFieldConfigureRouteEntry),
        (0, $iMiUN.globalSettingsIssuesFieldConfigureEditRouteEntry),
        (0, $7FDXH.globalSettingsIssuesFieldEditRouteEntry),
        (0, $dJWjd.globalSettingsIssuesFieldCopyRouteEntry),
        (0, $jGH4y.globalSettingsIssuesFieldDeleteRouteEntry),
        (0, $7nirz.globalSettingsIssuesFieldSchemesAddRouteEntry),
        (0, $7QX3x.globalSettingsIssuesFieldSchemesConfigureRouteEntry),
        (0, $l9tXd.globalSettingsIssuesFieldSchemesEditRouteEntry),
        (0, $cJJgM.globalSettingsIssuesFieldSchemesEditItemRouteEntry),
        (0, $iZ26w.globalSettingsIssuesFieldSchemesCopyRouteEntry),
        (0, $2W2q2.globalSettingsIssuesFieldSchemesDeleteRouteEntry),
        (0, $871XI.globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry),
        (0, $2aAoE.globalSettingsIssuesTypesScreenSchemesEntityRouteEntry),
        (0, $19kmi.globalSettingsIssuesTypesScreenSchemesEditRouteEntry),
        (0, $17G3z.globalSettingsIssuesTypesScreenSchemesCopyRouteEntry),
        (0, $99kzs.globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry),
        (0, $hgTPZ.globalSettingsCustomFieldsRouteEntry),
        (0, $iVrTt.globalSettingsIssuesCustomFieldsConfigRouteEntry),
        (0, $c9ioI.globalSettingsIssuesCustomFieldsEditRouteEntry),
        (0, $c8sjC.globalSettingsIssuesCustomFieldsTranslateRouteEntry),
        (0, $2VpKv.globalSettingsIssuesCustomFieldsDeleteRouteEntry),
        (0, $9xKXn.globalSettingsIssuesCustomFieldsManageRouteEntry),
        (0, $1Aau6.globalSettingsIssuesCustomFieldsAssociateRouteEntry),
        (0, $cHfoX.globalSettingsFieldLayoutsRouteEntry),
        (0, $dRIVd.globalSettingsIssuesFieldlayoutsConfigRouteEntry),
        (0, $eSPGm.globalSettingsIssuesFieldviewRouteEntry),
        (0, $hPp3X.globalSettingsIssuesFieldlayoutsCopyRouteEntry),
        (0, $cIx9g.globalSettingsIssuesFieldlayoutsEditRouteEntry),
        (0, $heAU9.globalSettingsIssuesFieldlayoutsDeleteRouteEntry),
        (0, $g4Nub.globalSettingsFieldLayoutSchemesRouteEntry),
        (0, $7Q4s7.globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry),
        (0, $6I50K.globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry),
        (0, $10wJP.globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry),
        (0, $afFye.globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry),
        (0, $baY1v.globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry),
        (0, $5xWEa.globalSettingsIssueTimeTrackingRouteEntry),
        (0, $6MVKx.globalSettingsIssuesLinkTypesRouteEntry),
        (0, $6MVKx.globalSettingsIssuesLinkTypesActivateRouteEntry),
        (0, $6MVKx.globalSettingsIssuesLinkTypesDeactivateRouteEntry),
        (0, $1v7mq.globalSettingsIssuesLinktypesEditRouteEntry),
        (0, $adgc5.globalSettingsIssuesLinktypesDeleteRouteEntry),
        (0, $7Wy95.globalSettingsIssuesStatusesRouteEntry),
        (0, $dx9b1.globalSettingsIssuesStatusesTranslationsRouteEntry),
        (0, $1blIf.globalSettingsIssuesResolutionsRouteEntry),
        (0, $2SdI5.globalSettingsIssuesResolutionsTranslationsRouteEntry),
        (0, $91zkM.globalSettingsIssuesResolutionsDefaultRouteEntry),
        (0, $ciIlo.globalSettingsIssuesResolutionsEditRouteEntry),
        (0, $gVBaq.globalSettingsIssuesResolutionsDeleteRouteEntry),
        (0, $hwhdw.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $eMbz6.globalSettingsIssuesPrioritiesTranslationsRouteEntry),
        (0, $6cuLl.globalSettingsIssuesGeneralTranslationsRouteEntry),
        (0, $iE4io.globalSettingsIssuesPrioritiesEditRouteEntry),
        (0, $4s7Hu.globalSettingsIssuesPrioritiesDeleteRouteEntry),
        (0, $jMPjG.globalSettingsIssuesPrioritiesDefaultRouteEntry),
        (0, $djSBu.globalSettingsIssuesSecuritySchemesRouteEntry),
        (0, $iBYQH.globalSettingsIssuesSecurityEditRouteEntry),
        (0, $iubtQ.globalSettingsIssuesSecurityLevelAddRouteEntry),
        (0, $aaRBu.globalSettingsIssuesSecurityLevelEditRouteEntry),
        (0, $acwwS.globalSettingsIssuesSecurityLevelDeleteRouteEntry),
        (0, $aA2zo.globalSettingsIssuesSecuritySchemesAddRouteEntry),
        (0, $jCLVV.globalSettingsIssuesSecuritySchemesEditRouteEntry),
        (0, $21PQj.globalSettingsIssuesSecuritySchemesDeleteRouteEntry),
        (0, $lspYz.globalSettingsIssuesNotificationViewRouteEntry),
        (0, $9BiW1.globalSettingsIssuesNotificationSchemeAddRouteEntry),
        (0, $v9XgX.globalSettingsIssuesNotificationSchemeEditRouteEntry),
        (0, $97mkw.globalSettingsIssuesNotificationSchemeDeleteRouteEntry),
        (0, $faeuP.globalSettingsIssuesNotificationAddRouteEntry),
        (0, $furTl.globalSettingsIssuesNotificationEditRouteEntry),
        (0, $5WBnz.globalSettingsIssuesNotificationDeleteRouteEntry),
        (0, $8Zyn4.globalSettingsIssuesPermissionsSchemesRouteEntry),
        (0, $gzOIA.globalSettingsIssuesPermissionsSchemesAddRouteEntry),
        (0, $LvsCP.globalSettingsIssuesPermissionsEditRouteEntry),
        (0, $jkJhv.globalSettingsIssuesPermissionsSchemesEditRouteEntry),
        (0, $je2Fi.globalSettingsIssuesPermissionsSchemesProjectRouteEntry),
        (0, $3Fjff.globalSettingsIssuesPermissionsSchemesDeleteRouteEntry),
        (0, $lMiJ0.addonsEmceePublicRouteEntry),
        (0, $bkOwc.emceeAppRouteEntry),
        (0, $43CRR.manageAppsRouteEntry),
        (0, $imUKj.globalSettingsAddonsOauthRouteEntry),
        (0, $223x6.globalSettingsSystemProjectSelectRouteEntry),
        (0, $lnL58.legacyPersonalSettingsAccessTokensRouteEntry),
        (0, $eIO5Y.legacyConnectGeneralRouteEntry),
        (0, $gIjnZ.legacyFallbackRouteEntry)
    ];
const $3ba63e6117655a46$export$dd1385a42388b11b = ()=>$3ba63e6117655a46$var$getRawRoutes().filter(({ path: path })=>path) // Required for static routes webpack plugin due to dynamic paths
    .map(({ group: group, name: name, path: path, query: query, preloadOptions: preloadOptions, meta: meta })=>({
            group: group,
            name: name,
            path: path,
            query: query,
            preloadOptions: preloadOptions,
            meta: meta
        }));
const $3ba63e6117655a46$export$2f7745f2f5ab3897 = ()=>{
    const routes = $3ba63e6117655a46$var$getRawRoutes().map((route)=>({
            ...route,
            group: (0, $exb0h.ROUTE_GROUPS_LEGACY),
            component: route.component || (0, $bCmyq.LegacyPage),
            resources: [
                ...new Set([
                    ...(0, $hHrVM.getNavigationResources)(),
                    ...route.resources ? route.resources : []
                ])
            ]
        }));
    return routes;
};

});
parcelRegister("exb0h", function(module, exports) {

$parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", () => $67f07001968fe110$export$1ba937db1fe6ef01);
$parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", () => $67f07001968fe110$export$bbf08d4d25df5504);
$parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", () => $67f07001968fe110$export$e3e759b7f50aaee1);
$parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", () => $67f07001968fe110$export$89337611b52bc9a3);
$parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", () => $67f07001968fe110$export$3d7937b12eb9e5d5);
$parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", () => $67f07001968fe110$export$7a3d181d86fce9e6);
$parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", () => $67f07001968fe110$export$7a22726acd7d6021);
$parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", () => $67f07001968fe110$export$f3f4a9f53ba00861);
$parcel$export(module.exports, "ROUTE_GROUPS_EOC", () => $67f07001968fe110$export$112d69653b2f1d8b);
$parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", () => $67f07001968fe110$export$74e0426b66571086);
$parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", () => $67f07001968fe110$export$c2e20e142c95c1ce);
$parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", () => $67f07001968fe110$export$f8cea29bebf098c);
$parcel$export(module.exports, "ROUTE_GROUPS_HOME", () => $67f07001968fe110$export$5801ef8dfc9a2f70);
$parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", () => $67f07001968fe110$export$7246838143f848f3);
$parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$54f96702980a2f87);
$parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", () => $67f07001968fe110$export$5566db8fbd042fc4);
$parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", () => $67f07001968fe110$export$656d0cc2c67b2708);
$parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", () => $67f07001968fe110$export$bfdbcebc4c81b043);
$parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", () => $67f07001968fe110$export$82021d71ad19e227);
$parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", () => $67f07001968fe110$export$6f266218a6973848);
$parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", () => $67f07001968fe110$export$a846fcaeeea8e0ff);
$parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", () => $67f07001968fe110$export$6c87a9dff4e7a2de);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", () => $67f07001968fe110$export$ab79970dcfac06a1);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", () => $67f07001968fe110$export$d1a70f80bb22f18a);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", () => $67f07001968fe110$export$bd925e9fcb6ce37f);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", () => $67f07001968fe110$export$86509a1baabd62ee);
$parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", () => $67f07001968fe110$export$98823ed9eedfc756);
$parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", () => $67f07001968fe110$export$da8d13fe1ccd5c09);
$parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", () => $67f07001968fe110$export$78fb2f6176b7c6b8);
$parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", () => $67f07001968fe110$export$26efaec7a7a8b361);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", () => $67f07001968fe110$export$88041353cc69458d);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", () => $67f07001968fe110$export$f88d57dcb03ba452);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", () => $67f07001968fe110$export$e8aa63af071c2da9);
$parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", () => $67f07001968fe110$export$b114d0da2ebcff6c);
$parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", () => $67f07001968fe110$export$29cc94b8cea5c920);
$parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", () => $67f07001968fe110$export$4d1b45005cdcfb39);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", () => $67f07001968fe110$export$a42ea04fdf53eeaf);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", () => $67f07001968fe110$export$ca4c5f5b3e2daa18);
$parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", () => $67f07001968fe110$export$d58a5411a2ac6260);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", () => $67f07001968fe110$export$ec333dd1d6a8b38);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", () => $67f07001968fe110$export$ed495fbad44791af);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", () => $67f07001968fe110$export$5281552f8109b7c0);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", () => $67f07001968fe110$export$6e8473713ed4557a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", () => $67f07001968fe110$export$cbdd5c24d69b2cb1);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", () => $67f07001968fe110$export$e7f012f402be01ea);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", () => $67f07001968fe110$export$b34d3882b42d660d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", () => $67f07001968fe110$export$ed869c60c6a56182);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", () => $67f07001968fe110$export$5013269f29c75b37);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", () => $67f07001968fe110$export$fc8b48319e993d43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", () => $67f07001968fe110$export$d6e60a2059f028d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", () => $67f07001968fe110$export$3d589aae17a00bc9);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", () => $67f07001968fe110$export$bd92ef03b23dd672);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", () => $67f07001968fe110$export$fa7fc44c718fc850);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", () => $67f07001968fe110$export$1dffaf831e01e2b4);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", () => $67f07001968fe110$export$5f8187412dd60f35);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", () => $67f07001968fe110$export$3d2c1c04d18f6c43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", () => $67f07001968fe110$export$cd22a5d8f560a1d8);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", () => $67f07001968fe110$export$cad1b1aa5ce26bbc);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", () => $67f07001968fe110$export$ee073463b4144367);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", () => $67f07001968fe110$export$ea034943499772ea);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", () => $67f07001968fe110$export$19bc888bcf37d22d);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", () => $67f07001968fe110$export$e0746183e11767fb);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", () => $67f07001968fe110$export$3e2d215ce157adc8);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", () => $67f07001968fe110$export$8a8485bb05daf40b);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$a2799b01de5bb62);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", () => $67f07001968fe110$export$2d4f89c4b1ee3640);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", () => $67f07001968fe110$export$75609d3416c31f79);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$79793dc26e0b7b1a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", () => $67f07001968fe110$export$2eda7466fbfdef43);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", () => $67f07001968fe110$export$417297669917ee1a);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", () => $67f07001968fe110$export$8c79f3309ac0737);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", () => $67f07001968fe110$export$ef71a22e7befd35c);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", () => $67f07001968fe110$export$62ba1e294f5007c1);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", () => $67f07001968fe110$export$a4315324546ecc89);
$parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", () => $67f07001968fe110$export$a653cf6d478b3df1);
$parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", () => $67f07001968fe110$export$b0f268fe53a03e98);
$parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", () => $67f07001968fe110$export$f4160b48e4ab8f39);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", () => $67f07001968fe110$export$608f359cf8b08d2e);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", () => $67f07001968fe110$export$8bfbf790fe89f8d3);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", () => $67f07001968fe110$export$d7011d1ed949f970);
$parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", () => $67f07001968fe110$export$bd2506db44585db6);
$parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", () => $67f07001968fe110$export$200fa5ad16f8c112);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", () => $67f07001968fe110$export$a296bb962bea95b5);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", () => $67f07001968fe110$export$b9960c143c0414eb);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", () => $67f07001968fe110$export$411171d2fcaefaea);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", () => $67f07001968fe110$export$ee104ed514f63003);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", () => $67f07001968fe110$export$9233f9ddcecd3062);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", () => $67f07001968fe110$export$b3240ec044a6c70f);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", () => $67f07001968fe110$export$2463c779e12367e3);
$parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", () => $67f07001968fe110$export$dd3e5187eae2abe9);
$parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", () => $67f07001968fe110$export$38ca7e07048a5bfd);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERTS", () => $67f07001968fe110$export$a9044bbb0247378d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_DETAIL", () => $67f07001968fe110$export$ae7376e552380ac0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", () => $67f07001968fe110$export$48749e87cc44a5a5);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", () => $67f07001968fe110$export$21c230ef79df9e9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", () => $67f07001968fe110$export$d2d813dd057a8352);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", () => $67f07001968fe110$export$54ed2374d14a7e88);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", () => $67f07001968fe110$export$58368fe796f5ecb4);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", () => $67f07001968fe110$export$bbb4032f8f259109);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", () => $67f07001968fe110$export$5b17b30c2dd69cf2);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", () => $67f07001968fe110$export$d18d0b9a9e85e59c);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", () => $67f07001968fe110$export$5126a481501fc518);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", () => $67f07001968fe110$export$40e720d8c26e6804);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", () => $67f07001968fe110$export$dc8ac1f7e9373a32);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", () => $67f07001968fe110$export$8ca3e3f0326ba27f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", () => $67f07001968fe110$export$9cd1c70eda5cae15);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", () => $67f07001968fe110$export$99f769b27f537a72);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", () => $67f07001968fe110$export$5c5fe79d3f9ec214);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", () => $67f07001968fe110$export$901b974cf0954c88);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", () => $67f07001968fe110$export$b2dd23a345bd5cb3);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", () => $67f07001968fe110$export$8ae7cbc0a73f9351);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", () => $67f07001968fe110$export$8057ebe7fb7f7f8d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", () => $67f07001968fe110$export$a22387b9744e62e3);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", () => $67f07001968fe110$export$f6fefa9d2e5bbda1);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", () => $67f07001968fe110$export$e6de4aa6c719d2b);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", () => $67f07001968fe110$export$1800d32171b754a6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", () => $67f07001968fe110$export$d22a153bfcbaaaa0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", () => $67f07001968fe110$export$a9a41c76994b6ae9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", () => $67f07001968fe110$export$5bd6f2569c3cfd5c);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", () => $67f07001968fe110$export$dc70eff53ff26c70);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", () => $67f07001968fe110$export$1fe2ca96b360df19);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", () => $67f07001968fe110$export$1ff01e77517a80b0);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", () => $67f07001968fe110$export$de3f8f3198f8213a);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", () => $67f07001968fe110$export$b2cb569d360db382);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_SETTINGS", () => $67f07001968fe110$export$c4531cbbea51b6a1);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", () => $67f07001968fe110$export$da985e953465731f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", () => $67f07001968fe110$export$b7eee2afd0a5c6b9);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", () => $67f07001968fe110$export$9b6c84986db47d98);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", () => $67f07001968fe110$export$89276f76fdd700d6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", () => $67f07001968fe110$export$ea64769f19da8c95);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", () => $67f07001968fe110$export$4a584839d9a9eb6f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", () => $67f07001968fe110$export$27d27c817eeb97cc);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", () => $67f07001968fe110$export$9f533c13cfb48a8f);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", () => $67f07001968fe110$export$6889e571e5aa6ba6);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", () => $67f07001968fe110$export$bdd811277711c53d);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", () => $67f07001968fe110$export$c7b51c0e8ad6f77a);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", () => $67f07001968fe110$export$a348fc7f3b4cfe34);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", () => $67f07001968fe110$export$a4eff769c94da831);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", () => $67f07001968fe110$export$7c928ca9c9822772);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", () => $67f07001968fe110$export$b48311a8f24f4b63);
$parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", () => $67f07001968fe110$export$20649eac204f7661);
$parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", () => $67f07001968fe110$export$62170875a111d729);
$parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", () => $67f07001968fe110$export$2928f3d69e7ac609);
$parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", () => $67f07001968fe110$export$259e18cafd820487);
$parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", () => $67f07001968fe110$export$4b8f333757e638a4);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", () => $67f07001968fe110$export$ac4f65a14002f892);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", () => $67f07001968fe110$export$c73ddc4b44ccb359);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", () => $67f07001968fe110$export$7ad826b482229119);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", () => $67f07001968fe110$export$3df864df9b639033);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", () => $67f07001968fe110$export$7d67bf4077ebe18d);
$parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", () => $67f07001968fe110$export$5ff797dfd5df551f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", () => $67f07001968fe110$export$8a66ba1da5efa2c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$eadf5aff28def565);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", () => $67f07001968fe110$export$8f9c045e8fd449b7);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", () => $67f07001968fe110$export$1bf439327974644b);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", () => $67f07001968fe110$export$e2a9d163770d0d46);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", () => $67f07001968fe110$export$21b497c57bcd299a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", () => $67f07001968fe110$export$8d4d1f7df6e5d4e4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", () => $67f07001968fe110$export$df5ca261227a6052);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", () => $67f07001968fe110$export$9f2f4303259b8508);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", () => $67f07001968fe110$export$7fd53fe07eecc273);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", () => $67f07001968fe110$export$c8e9ba2b5bc9dab2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", () => $67f07001968fe110$export$e05a6c9e9b9b0c48);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", () => $67f07001968fe110$export$7a337a2687b5d5e3);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", () => $67f07001968fe110$export$a41998c1a3572e41);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", () => $67f07001968fe110$export$2c9fe9e6005a9c36);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", () => $67f07001968fe110$export$5d8d82ff1de3586e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", () => $67f07001968fe110$export$8a0ed100d885c17c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", () => $67f07001968fe110$export$1c7041445acf79e8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", () => $67f07001968fe110$export$e4712523d95125f6);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", () => $67f07001968fe110$export$7401274ad357ff94);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", () => $67f07001968fe110$export$6984b21077857555);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", () => $67f07001968fe110$export$5a2dae98f768aedf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", () => $67f07001968fe110$export$5eef1c6eb1388ac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", () => $67f07001968fe110$export$69bcf2c26d45e030);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", () => $67f07001968fe110$export$ba1417cf5de80f81);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", () => $67f07001968fe110$export$fdcfcb2e2eb16afd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", () => $67f07001968fe110$export$5d3e6bffd6b5abfe);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", () => $67f07001968fe110$export$5c676bbb7e3aae9e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", () => $67f07001968fe110$export$8bb013ced097489a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", () => $67f07001968fe110$export$e384ae6a87fadedd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", () => $67f07001968fe110$export$8f55a911c4bd95bf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", () => $67f07001968fe110$export$d7b98892cb31fba5);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", () => $67f07001968fe110$export$8be4b203f526b2cd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", () => $67f07001968fe110$export$df09947903c514c4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", () => $67f07001968fe110$export$cf4a57a81e0bfbca);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", () => $67f07001968fe110$export$bc64365bbb09c05e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", () => $67f07001968fe110$export$5b12571311ebe766);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", () => $67f07001968fe110$export$56dc46fe1de63994);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", () => $67f07001968fe110$export$65af0e5a36d4b4e9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", () => $67f07001968fe110$export$dec448f9d2e50c90);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", () => $67f07001968fe110$export$9ff4144e1dcf9fa4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", () => $67f07001968fe110$export$8aab6fb9a62dda95);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", () => $67f07001968fe110$export$9f804a2650117f51);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", () => $67f07001968fe110$export$7dd4b916600f670);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", () => $67f07001968fe110$export$c1b40a8a70c0aafa);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", () => $67f07001968fe110$export$ff10d812380db045);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", () => $67f07001968fe110$export$8deeffdf8dfed878);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", () => $67f07001968fe110$export$561687f2fa9b9cc9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", () => $67f07001968fe110$export$691d30818c14141c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", () => $67f07001968fe110$export$8fa58495105f8fb0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", () => $67f07001968fe110$export$8304c57494d82ffd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", () => $67f07001968fe110$export$353609deec72a2ba);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", () => $67f07001968fe110$export$1cb56e4c132ac8fd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", () => $67f07001968fe110$export$5fe3eec0a6bda09);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", () => $67f07001968fe110$export$12b56880d6fb7ac7);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", () => $67f07001968fe110$export$9986e8be82998857);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", () => $67f07001968fe110$export$3280ec16231916af);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", () => $67f07001968fe110$export$54885d105d1e2b37);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", () => $67f07001968fe110$export$f34d87c870f3bf43);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", () => $67f07001968fe110$export$4108ebf71e36e461);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", () => $67f07001968fe110$export$d42ec33a6e69686e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", () => $67f07001968fe110$export$8d2cfabd01e2feaa);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", () => $67f07001968fe110$export$d0fe3726dffeca80);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", () => $67f07001968fe110$export$b4aa4b2b8fb7267a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", () => $67f07001968fe110$export$3743711165f5dd4f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", () => $67f07001968fe110$export$5df6f81deab9567c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", () => $67f07001968fe110$export$b3db2a2ee8a9a8e4);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", () => $67f07001968fe110$export$d5fc8cd4b3fd2b84);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", () => $67f07001968fe110$export$a03360d8b616ef34);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", () => $67f07001968fe110$export$336e54edc189df7f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", () => $67f07001968fe110$export$53572e9a81205523);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", () => $67f07001968fe110$export$b71f2ef452117a2a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", () => $67f07001968fe110$export$f79745fee583cd62);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", () => $67f07001968fe110$export$2281663e19f399c1);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", () => $67f07001968fe110$export$38c52d8c5e5dad29);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", () => $67f07001968fe110$export$10babc3f11b4e6e2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", () => $67f07001968fe110$export$adf2f51c41b4e22a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", () => $67f07001968fe110$export$11b217754d4c7d24);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", () => $67f07001968fe110$export$3414f0d81f1c11d);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", () => $67f07001968fe110$export$5574c73a9a5878ca);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", () => $67f07001968fe110$export$cb2626c385b72992);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", () => $67f07001968fe110$export$fa7aa7cabc3ec459);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", () => $67f07001968fe110$export$8b0450672651ef67);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", () => $67f07001968fe110$export$ef510a15f840e437);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", () => $67f07001968fe110$export$bc159fa4984a907f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", () => $67f07001968fe110$export$47bfbce13af95d24);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", () => $67f07001968fe110$export$c8cb78e94cd3f83c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", () => $67f07001968fe110$export$4496279df22177be);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", () => $67f07001968fe110$export$afdfef5d17c56988);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", () => $67f07001968fe110$export$ac9b4b1136300033);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", () => $67f07001968fe110$export$4aa31dc2a6d4f2ee);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", () => $67f07001968fe110$export$c56f5509b93eba68);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", () => $67f07001968fe110$export$dd9462e97e11637a);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", () => $67f07001968fe110$export$11f8c53e10f63cfb);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", () => $67f07001968fe110$export$758ad3ad6916c9f6);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", () => $67f07001968fe110$export$9d65a754315eb617);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", () => $67f07001968fe110$export$564b665f6ca740dd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", () => $67f07001968fe110$export$256fc89c38c1b9e9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", () => $67f07001968fe110$export$ddeae77164bfac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", () => $67f07001968fe110$export$fa2b355372963545);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", () => $67f07001968fe110$export$45511e437e54fa02);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", () => $67f07001968fe110$export$ad76895f03f27a7c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", () => $67f07001968fe110$export$1c291d65a59b1636);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", () => $67f07001968fe110$export$d9bb14d665bfeea5);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", () => $67f07001968fe110$export$8b44cb3da7b8f857);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", () => $67f07001968fe110$export$9ca6a09e1518d3bb);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", () => $67f07001968fe110$export$4c211b3188348679);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", () => $67f07001968fe110$export$24757bb1837e33af);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", () => $67f07001968fe110$export$95b5d0bd29a3a076);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", () => $67f07001968fe110$export$d55d4330b58683da);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", () => $67f07001968fe110$export$f4d5833f0b40a26b);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", () => $67f07001968fe110$export$c78577545f514ca8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", () => $67f07001968fe110$export$253eb3db7152d010);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", () => $67f07001968fe110$export$16b4392a63a3eacf);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", () => $67f07001968fe110$export$b2d5a7bc804ed9c9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", () => $67f07001968fe110$export$f870832f94ca5009);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", () => $67f07001968fe110$export$8b3a1b2e8e954dc2);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", () => $67f07001968fe110$export$15603150075c3d64);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", () => $67f07001968fe110$export$92536fe760c41862);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", () => $67f07001968fe110$export$3f4d05032349dae0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", () => $67f07001968fe110$export$8ff94a2e5f98315f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", () => $67f07001968fe110$export$c906c6946fef5d99);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", () => $67f07001968fe110$export$a1916b723e186494);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", () => $67f07001968fe110$export$5070b4c974017f28);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", () => $67f07001968fe110$export$bee7f9f93cb74124);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", () => $67f07001968fe110$export$efe4008073ab3b69);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", () => $67f07001968fe110$export$9e40228f1c62d4d9);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", () => $67f07001968fe110$export$223f8094878fea34);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", () => $67f07001968fe110$export$2f589c572415c043);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", () => $67f07001968fe110$export$8cc394a1f5ca4ac0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", () => $67f07001968fe110$export$a11311cd333dae90);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", () => $67f07001968fe110$export$2b2f159267202dcc);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", () => $67f07001968fe110$export$c5a6874288d2e609);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", () => $67f07001968fe110$export$55dd30b027c838fe);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", () => $67f07001968fe110$export$aee9c7dbf672403c);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", () => $67f07001968fe110$export$75f2fbd33e76028e);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", () => $67f07001968fe110$export$ca57c3dfefb2c826);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", () => $67f07001968fe110$export$8f2e6f133c022a59);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", () => $67f07001968fe110$export$bcd741cf5a35ece8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", () => $67f07001968fe110$export$bfd8ab4625d5c275);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", () => $67f07001968fe110$export$750a33c4058af733);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", () => $67f07001968fe110$export$1b66c7594340363f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", () => $67f07001968fe110$export$fe2fa966509db649);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", () => $67f07001968fe110$export$373b97e8d136f558);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", () => $67f07001968fe110$export$64909bb6f2181592);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", () => $67f07001968fe110$export$53d6ade2eaa2ae84);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", () => $67f07001968fe110$export$e49d7a1ddf301d09);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", () => $67f07001968fe110$export$9469cfde1d14fcac);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", () => $67f07001968fe110$export$be2e231547dca6dd);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", () => $67f07001968fe110$export$ad6f28bbfe57d0a0);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", () => $67f07001968fe110$export$2fb73d5c1c0e7186);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", () => $67f07001968fe110$export$46b4f43d6ece38fc);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", () => $67f07001968fe110$export$49d1c20d84d46735);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", () => $67f07001968fe110$export$265062715b11a1ef);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", () => $67f07001968fe110$export$e9f5eae9444c9b46);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", () => $67f07001968fe110$export$e19bf9459d6eba56);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", () => $67f07001968fe110$export$40097704c31872d8);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", () => $67f07001968fe110$export$dcdf0405aa7e2078);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", () => $67f07001968fe110$export$fb75113636566d39);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", () => $67f07001968fe110$export$e27baa0c7747e67f);
$parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", () => $67f07001968fe110$export$40d189100899f572);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", () => $67f07001968fe110$export$341933b279728599);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", () => $67f07001968fe110$export$ae4b815061537207);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", () => $67f07001968fe110$export$5cd0dd5a6be6aa2b);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", () => $67f07001968fe110$export$bee46016693b19dc);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES", () => $67f07001968fe110$export$c39a25878c902e0a);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS", () => $67f07001968fe110$export$6eaa6ce8101f6468);
$parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", () => $67f07001968fe110$export$2e90ab5aa3463c0d);
$parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", () => $67f07001968fe110$export$d70320ae3b4d9e43);
$parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", () => $67f07001968fe110$export$b2b57cde1fa39bf5);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE", () => $67f07001968fe110$export$e8e3b3a04b70a016);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", () => $67f07001968fe110$export$1a3116351e4f3550);
$parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", () => $67f07001968fe110$export$6e2629d41c380b47);
$parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", () => $67f07001968fe110$export$ced38e55e6d33a4e);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", () => $67f07001968fe110$export$d61d16755cb40ff3);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", () => $67f07001968fe110$export$bb6392f1b2e80781);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", () => $67f07001968fe110$export$6fd25e722e91a0d8);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", () => $67f07001968fe110$export$18f32f825e7a5a6f);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", () => $67f07001968fe110$export$b17f22f274f4cd5e);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", () => $67f07001968fe110$export$285854ec33f7cc);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", () => $67f07001968fe110$export$77cf9c44bbdaa05b);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", () => $67f07001968fe110$export$d6f1b92110a16f2a);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", () => $67f07001968fe110$export$fea47b97c6086336);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", () => $67f07001968fe110$export$264d0a2b60d052cd);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", () => $67f07001968fe110$export$991ba0c465b48539);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", () => $67f07001968fe110$export$904b472d57dee40d);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", () => $67f07001968fe110$export$bbe98dfa7f6a1e4a);
$parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", () => $67f07001968fe110$export$8cfdaccf43a32440);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", () => $67f07001968fe110$export$37bd400c00057d64);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", () => $67f07001968fe110$export$eb66bd587b5f093d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", () => $67f07001968fe110$export$521baa72494c2a67);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", () => $67f07001968fe110$export$ca255c93be51d5bc);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", () => $67f07001968fe110$export$51e45f736a60769b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", () => $67f07001968fe110$export$e64c3c8f45d7eb28);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", () => $67f07001968fe110$export$5475ba822739444a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", () => $67f07001968fe110$export$8483f5c57513e386);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", () => $67f07001968fe110$export$93c4d1960660bdb3);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", () => $67f07001968fe110$export$a5421dcc88027406);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", () => $67f07001968fe110$export$81d5ef2e5cb06446);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", () => $67f07001968fe110$export$77f5621cd10b53c5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", () => $67f07001968fe110$export$41008c2b014795bf);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", () => $67f07001968fe110$export$3001841111579cf2);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", () => $67f07001968fe110$export$28dc2fac9c08502e);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", () => $67f07001968fe110$export$4487dfcd6dce7088);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", () => $67f07001968fe110$export$c344587fa7092e8c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", () => $67f07001968fe110$export$3fbd487079a23c0f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", () => $67f07001968fe110$export$d6822df31c37b21a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", () => $67f07001968fe110$export$d39bcac6fced7707);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", () => $67f07001968fe110$export$da975f212e8a3e43);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", () => $67f07001968fe110$export$6e6feddeb62a0825);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", () => $67f07001968fe110$export$d7df906c2ffbeab4);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", () => $67f07001968fe110$export$c71836085985a7d3);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", () => $67f07001968fe110$export$a17a19a9de903839);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", () => $67f07001968fe110$export$e66c1e847a52ebb5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", () => $67f07001968fe110$export$f0254c80025ed0fc);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", () => $67f07001968fe110$export$1d4a64220d5b474d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", () => $67f07001968fe110$export$8af215d394bc18c1);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", () => $67f07001968fe110$export$b6b536a795b08b39);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", () => $67f07001968fe110$export$59cde094247fca1a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", () => $67f07001968fe110$export$d27bf19e22921164);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", () => $67f07001968fe110$export$3467807847c0a87d);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$1996eeee6a067f1c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", () => $67f07001968fe110$export$ec7cb9394e8994c9);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", () => $67f07001968fe110$export$f01730982626c4af);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", () => $67f07001968fe110$export$9d1758ddc1563e90);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", () => $67f07001968fe110$export$ecff223feb9d08be);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", () => $67f07001968fe110$export$487bc26cddb34312);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", () => $67f07001968fe110$export$118290072826cd87);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", () => $67f07001968fe110$export$e5994b7b1acebe82);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", () => $67f07001968fe110$export$84b0e53f785e02cf);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", () => $67f07001968fe110$export$d58992a667105ce8);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", () => $67f07001968fe110$export$bb1cea2d23743f65);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", () => $67f07001968fe110$export$76dac5f55ab3705e);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", () => $67f07001968fe110$export$a7c4adb03bc6e997);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", () => $67f07001968fe110$export$2dc565d0b2334780);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", () => $67f07001968fe110$export$28687a1181a7676f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", () => $67f07001968fe110$export$2e74a7026073fa54);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", () => $67f07001968fe110$export$58fdfc78d176c564);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", () => $67f07001968fe110$export$cb8548f16119b181);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", () => $67f07001968fe110$export$66e3f6af203a567f);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", () => $67f07001968fe110$export$658e7e21f1c7b69b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", () => $67f07001968fe110$export$1fa628a4527d424c);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", () => $67f07001968fe110$export$c2989c5c00f9f64b);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", () => $67f07001968fe110$export$2d21e5416485b195);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", () => $67f07001968fe110$export$e514491aa85dd54a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", () => $67f07001968fe110$export$d9662297242bfcb5);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", () => $67f07001968fe110$export$2a53516b15393945);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", () => $67f07001968fe110$export$62e00190aa938a43);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", () => $67f07001968fe110$export$22a3924a6eab79ab);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", () => $67f07001968fe110$export$677cf3d89d18bb74);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", () => $67f07001968fe110$export$7eef86163449ad98);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", () => $67f07001968fe110$export$8f56061e1403fa5a);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", () => $67f07001968fe110$export$adeb429de8df1e02);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", () => $67f07001968fe110$export$931d6222073b5708);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", () => $67f07001968fe110$export$2106f1ac8ba807e1);
$parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", () => $67f07001968fe110$export$36678521a86f620b);
$parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", () => $67f07001968fe110$export$55248356780fc584);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", () => $67f07001968fe110$export$cd84c5a333c8d16a);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", () => $67f07001968fe110$export$624af6f61b05f55);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", () => $67f07001968fe110$export$2ed9525182145b82);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", () => $67f07001968fe110$export$7fb2b42fc4e7df8b);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", () => $67f07001968fe110$export$fa962db82ae571b2);
$parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", () => $67f07001968fe110$export$e145bf76b1aef705);
$parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", () => $67f07001968fe110$export$8febbfb647e4c8b9);
$parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", () => $67f07001968fe110$export$4b34f3d336f4ccd2);
$parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", () => $67f07001968fe110$export$a979a5c1f5e3631c);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", () => $67f07001968fe110$export$ffcbf91dfadffd0);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", () => $67f07001968fe110$export$1807a39cc63b856c);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", () => $67f07001968fe110$export$2be8d3c6fedd5276);
$parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", () => $67f07001968fe110$export$6268da7263eb670d);
$parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", () => $67f07001968fe110$export$93bd4a896a0fc581);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", () => $67f07001968fe110$export$2b9b1bfb538ab810);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", () => $67f07001968fe110$export$d1217085321b2648);
$parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LOGS", () => $67f07001968fe110$export$e5dc3f48a0b19ea1);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", () => $67f07001968fe110$export$39624171b7c8a10a);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", () => $67f07001968fe110$export$1654cd6813e90e6b);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", () => $67f07001968fe110$export$33059cd02df2febd);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", () => $67f07001968fe110$export$1d746ff2bc48ceb4);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", () => $67f07001968fe110$export$145c578104a45fd2);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", () => $67f07001968fe110$export$a51df1bc877c58e5);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", () => $67f07001968fe110$export$45208fff8de46880);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", () => $67f07001968fe110$export$c710a35d40378fa5);
$parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", () => $67f07001968fe110$export$15d6b93ff5273ce3);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", () => $67f07001968fe110$export$e26f2863c7ccd504);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", () => $67f07001968fe110$export$496da9aa0fe819ff);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", () => $67f07001968fe110$export$f7bbc23b5f8e2d3b);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", () => $67f07001968fe110$export$53ce69fb34f6d286);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", () => $67f07001968fe110$export$b6e861786143eb1b);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", () => $67f07001968fe110$export$f7e3d3b413c017e1);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", () => $67f07001968fe110$export$b84d34b8175abde5);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", () => $67f07001968fe110$export$50e4e3e5231fb74f);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", () => $67f07001968fe110$export$39d913ae557ba8f3);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", () => $67f07001968fe110$export$a2d9bcceac584c93);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", () => $67f07001968fe110$export$eb2e5f1608ec8b32);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", () => $67f07001968fe110$export$9ac90b948c53bf58);
$parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", () => $67f07001968fe110$export$bb5665894498893f);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS", () => $67f07001968fe110$export$fc61479fdfdd263a);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK", () => $67f07001968fe110$export$5ae82b891e42770e);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE", () => $67f07001968fe110$export$8dcc46e162f2235b);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", () => $67f07001968fe110$export$a934caa57ac0ac0b);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", () => $67f07001968fe110$export$25a4e6c77f91c259);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", () => $67f07001968fe110$export$2a9a9bab313fd713);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", () => $67f07001968fe110$export$82ad2da638fc34d8);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", () => $67f07001968fe110$export$ff67cffdbd881a41);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", () => $67f07001968fe110$export$c41c7d73df3fc08c);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS", () => $67f07001968fe110$export$65f234e4799edddc);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK", () => $67f07001968fe110$export$215ea4e7405fa88c);
$parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE", () => $67f07001968fe110$export$927b1972180d9cc4);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", () => $67f07001968fe110$export$ff1365ce4d652337);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", () => $67f07001968fe110$export$79b30013cbfdee04);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", () => $67f07001968fe110$export$33c2dcc7c7abc45e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", () => $67f07001968fe110$export$a6ef20aa08a533b1);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", () => $67f07001968fe110$export$5908e15483da8a45);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", () => $67f07001968fe110$export$a3812f6f4e60d897);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$3c8c119f40a061a9);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", () => $67f07001968fe110$export$47e034646abefdb2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", () => $67f07001968fe110$export$f36f4cf8b17f250f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", () => $67f07001968fe110$export$1fde4a6e7df24a97);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", () => $67f07001968fe110$export$69335bf8b709edc7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", () => $67f07001968fe110$export$946b472f7559a889);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", () => $67f07001968fe110$export$373fdf6888021ed0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", () => $67f07001968fe110$export$d6a5f13a3d30923c);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", () => $67f07001968fe110$export$adfff93b0b015409);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", () => $67f07001968fe110$export$404de4ddea701cff);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", () => $67f07001968fe110$export$596e1f6f6f4997b2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", () => $67f07001968fe110$export$8da0e4cdbdd0cd0b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$d610a17dff3a01fa);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", () => $67f07001968fe110$export$284db5107f3db516);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", () => $67f07001968fe110$export$fbce46826eefc586);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", () => $67f07001968fe110$export$c86b29c76317ac6f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", () => $67f07001968fe110$export$3160b86e1b5dc391);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", () => $67f07001968fe110$export$690c0080c930fca);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", () => $67f07001968fe110$export$171ba8c33c05c4ef);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", () => $67f07001968fe110$export$e2f2c23286c3255c);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", () => $67f07001968fe110$export$5a262d40e10207a1);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$ab790cb87175797e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", () => $67f07001968fe110$export$db780b39656c673a);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", () => $67f07001968fe110$export$a77cb4dafc511d3);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", () => $67f07001968fe110$export$253fd82874264ee4);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", () => $67f07001968fe110$export$eaf9ab4ec0c25813);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", () => $67f07001968fe110$export$574bcdf6b73fcf1f);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", () => $67f07001968fe110$export$a14853dfff8da872);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CLASSIC_CUSTOMER_NOTIFICATIONS", () => $67f07001968fe110$export$923d56d5ae77c67e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", () => $67f07001968fe110$export$d416059b17fe7d4e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", () => $67f07001968fe110$export$688de32d31fc70f5);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", () => $67f07001968fe110$export$13d770f8814d480a);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", () => $67f07001968fe110$export$3a628f9376166ffb);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", () => $67f07001968fe110$export$649dafa225625f30);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", () => $67f07001968fe110$export$dbfe76dd37018b2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$20db7bb9d1bd8b38);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", () => $67f07001968fe110$export$fc6b949fd2bc782d);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", () => $67f07001968fe110$export$c940f866ac7760a0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", () => $67f07001968fe110$export$184d4979f6f9fe7e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", () => $67f07001968fe110$export$959f50de166cc45e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", () => $67f07001968fe110$export$b13b8c8bb4e30a75);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", () => $67f07001968fe110$export$40d6fc2b9a4f09d2);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", () => $67f07001968fe110$export$cc1af211e3feda50);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", () => $67f07001968fe110$export$3873539001f5aed7);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", () => $67f07001968fe110$export$89fcbafce559080b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", () => $67f07001968fe110$export$c3f05da9e4e13249);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", () => $67f07001968fe110$export$619694ab37142384);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", () => $67f07001968fe110$export$cb89b516b9cf418b);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", () => $67f07001968fe110$export$50680f54e95bb859);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", () => $67f07001968fe110$export$194c2b4da7e38757);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", () => $67f07001968fe110$export$962d838817f090f8);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", () => $67f07001968fe110$export$eacbdb340a470309);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", () => $67f07001968fe110$export$6a7782d87a21425d);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", () => $67f07001968fe110$export$c2f56336162e799e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", () => $67f07001968fe110$export$ba419378ad70624e);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", () => $67f07001968fe110$export$62f38c589a73d386);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", () => $67f07001968fe110$export$90900ebfa6f48861);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", () => $67f07001968fe110$export$93ff02c205edd1a8);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", () => $67f07001968fe110$export$db7f5d93be70ee30);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", () => $67f07001968fe110$export$432229516b7f82da);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", () => $67f07001968fe110$export$8f554d4ef9f084c0);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", () => $67f07001968fe110$export$6b2b99b0055772a3);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", () => $67f07001968fe110$export$83c7a51057be6264);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", () => $67f07001968fe110$export$46706d786aab3829);
$parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", () => $67f07001968fe110$export$b690025ef7e3cf6c);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", () => $67f07001968fe110$export$ea48cc6bf1183d11);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", () => $67f07001968fe110$export$930e4881302bbd54);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", () => $67f07001968fe110$export$375801b708576466);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", () => $67f07001968fe110$export$5b1e8463bd590143);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", () => $67f07001968fe110$export$1606662a398a24be);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", () => $67f07001968fe110$export$c5b19a37e49ceb28);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", () => $67f07001968fe110$export$c46680afe70295f3);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", () => $67f07001968fe110$export$831fc7eba98b58c9);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", () => $67f07001968fe110$export$4061c0c586f3b7c8);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", () => $67f07001968fe110$export$99e0abd8ba1de289);
$parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", () => $67f07001968fe110$export$cd96a6a0cc4831ab);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", () => $67f07001968fe110$export$db1b3d2fee80859);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", () => $67f07001968fe110$export$fb4e3ee7e7c21e9f);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", () => $67f07001968fe110$export$8c8f03e75b6708ac);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP", () => $67f07001968fe110$export$2e93790099768be5);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", () => $67f07001968fe110$export$3c3d8caf61c9aa0c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", () => $67f07001968fe110$export$9bde4a0b155f2972);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", () => $67f07001968fe110$export$a52f5ffbbe135078);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", () => $67f07001968fe110$export$e6773bf0fbccdb9c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", () => $67f07001968fe110$export$8e3dd8487a7b65bd);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", () => $67f07001968fe110$export$258b44fcc29a5961);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", () => $67f07001968fe110$export$ea1146ebce07be6d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", () => $67f07001968fe110$export$53731240ce2d3b76);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", () => $67f07001968fe110$export$956eb40834ddee22);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", () => $67f07001968fe110$export$9057470ebf41169);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", () => $67f07001968fe110$export$3e7c6a54a9d2267a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", () => $67f07001968fe110$export$c3e2697b35a149c4);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", () => $67f07001968fe110$export$288c7dd61dd0c291);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", () => $67f07001968fe110$export$37161a981d69c891);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", () => $67f07001968fe110$export$cfe61aa92a4d585d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", () => $67f07001968fe110$export$9ed512ab4c81669c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", () => $67f07001968fe110$export$37a9bdd8513f462d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", () => $67f07001968fe110$export$f01162415f3a2ee3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", () => $67f07001968fe110$export$860dd13b1e836ed8);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", () => $67f07001968fe110$export$5eaf1dce55090ff3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", () => $67f07001968fe110$export$1fe309e7cdbd1c1);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", () => $67f07001968fe110$export$fcd9750494ff0236);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", () => $67f07001968fe110$export$ad856b38e93b93b2);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", () => $67f07001968fe110$export$a833209ca71d2e56);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", () => $67f07001968fe110$export$829d1776460a6ad3);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", () => $67f07001968fe110$export$d30ab2da08d8b7b9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", () => $67f07001968fe110$export$3c71889849aeaa08);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", () => $67f07001968fe110$export$354bf2df81f6ffb0);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", () => $67f07001968fe110$export$f8880b461acd270d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", () => $67f07001968fe110$export$876055c0ede2f8df);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", () => $67f07001968fe110$export$bf493c66e34711c8);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", () => $67f07001968fe110$export$212f6e2c7c2a53bb);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", () => $67f07001968fe110$export$7c28c6e8d8a6545);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", () => $67f07001968fe110$export$8d55b6ef2cd92f8c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", () => $67f07001968fe110$export$f7fbe9a4717b7a50);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", () => $67f07001968fe110$export$8c800f176d079d28);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", () => $67f07001968fe110$export$1c5fbcbfc0923176);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", () => $67f07001968fe110$export$59644e5d8d69a016);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", () => $67f07001968fe110$export$c7074ebe0ca83f98);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", () => $67f07001968fe110$export$2b4737953287a354);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", () => $67f07001968fe110$export$e7a8d6d534c5e2fe);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", () => $67f07001968fe110$export$5dcba309e2bfa88b);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", () => $67f07001968fe110$export$2d961b0101f8733e);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", () => $67f07001968fe110$export$195fe2558f1a8591);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", () => $67f07001968fe110$export$1b3cf68be370a45b);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", () => $67f07001968fe110$export$45c35381e5da2232);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", () => $67f07001968fe110$export$d479ba53b9bf65a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", () => $67f07001968fe110$export$ccd12890649c59cc);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", () => $67f07001968fe110$export$8c84064031188e80);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", () => $67f07001968fe110$export$46c6fef035fbe8ba);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", () => $67f07001968fe110$export$6fb23ec5a12d5c24);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", () => $67f07001968fe110$export$156b2dfbd87d576f);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", () => $67f07001968fe110$export$6961f1ed0407cb26);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", () => $67f07001968fe110$export$ba284efd679bf637);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", () => $67f07001968fe110$export$e48a3df597407767);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", () => $67f07001968fe110$export$c73718d4a6efea1d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", () => $67f07001968fe110$export$ed454783ba1bacb9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", () => $67f07001968fe110$export$48f6285d4729ca9d);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", () => $67f07001968fe110$export$8066418cead2d2ef);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", () => $67f07001968fe110$export$b3db7857ac710a89);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", () => $67f07001968fe110$export$d574810e3edad044);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", () => $67f07001968fe110$export$be4b2ffade787316);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", () => $67f07001968fe110$export$3caf79b5f4be02d7);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", () => $67f07001968fe110$export$29bc361328055683);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", () => $67f07001968fe110$export$a4a5a333fe874d97);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", () => $67f07001968fe110$export$2193b681ac1ae132);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", () => $67f07001968fe110$export$f1bfd5b3918619a9);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", () => $67f07001968fe110$export$a4c4f7898d6b914a);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", () => $67f07001968fe110$export$6cffae90b9277bb);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", () => $67f07001968fe110$export$17e76ebd53424ed5);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", () => $67f07001968fe110$export$b1329dc26a81a277);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", () => $67f07001968fe110$export$e1cba0bfe330f5c);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", () => $67f07001968fe110$export$8e68c55c334de101);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", () => $67f07001968fe110$export$5cb7cfba189a0240);
$parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", () => $67f07001968fe110$export$d28aab4a6d6f1d0d);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", () => $67f07001968fe110$export$1cf56e2d6c4edb35);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", () => $67f07001968fe110$export$27c1770584d7e3fe);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", () => $67f07001968fe110$export$22e0ebdea08537f7);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", () => $67f07001968fe110$export$4db732436e4edfaf);
$parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", () => $67f07001968fe110$export$e832418dbed0717e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", () => $67f07001968fe110$export$ee09be798f0e4471);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", () => $67f07001968fe110$export$653bf90ae3578f21);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", () => $67f07001968fe110$export$9da4125a0c62444d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", () => $67f07001968fe110$export$fbcc0fd9b402bb12);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", () => $67f07001968fe110$export$e74fe5bd41e23fbd);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", () => $67f07001968fe110$export$1a93e63ddbe4aa06);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", () => $67f07001968fe110$export$3b6dbbe49882589d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", () => $67f07001968fe110$export$eb01394789016fd4);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", () => $67f07001968fe110$export$f17f4523583fa8e5);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", () => $67f07001968fe110$export$eaa4d6eec75a6778);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", () => $67f07001968fe110$export$dcc96e4abbdc0d39);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", () => $67f07001968fe110$export$9eaf39ba5a56c72a);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", () => $67f07001968fe110$export$495be3320b67814a);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", () => $67f07001968fe110$export$25752eb5bb5e3d32);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", () => $67f07001968fe110$export$f116716aedb35e10);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", () => $67f07001968fe110$export$36fffb6b49d9f31d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", () => $67f07001968fe110$export$a6d07be4ff318f84);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", () => $67f07001968fe110$export$a9a43f1114df1ad9);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", () => $67f07001968fe110$export$3a4c7a521a900b4d);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", () => $67f07001968fe110$export$9dcf51a9040a4fd6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", () => $67f07001968fe110$export$a74f9f6bd0d4fb26);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", () => $67f07001968fe110$export$f8cb86acf6b74661);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", () => $67f07001968fe110$export$2d3d850c64058bfb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", () => $67f07001968fe110$export$af6b51164f66908b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", () => $67f07001968fe110$export$12efc96fc9c9fb34);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORMS", () => $67f07001968fe110$export$a2ebabe0077b0970);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORMS_CLASSIC", () => $67f07001968fe110$export$590d764d6cf087ac);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", () => $67f07001968fe110$export$b8045610416fa8ca);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", () => $67f07001968fe110$export$8e80136ad13099e3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", () => $67f07001968fe110$export$b5fe44c0bc324494);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", () => $67f07001968fe110$export$7a4f52d9060a20d2);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", () => $67f07001968fe110$export$d6a9e4695952522e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", () => $67f07001968fe110$export$deab88d0814c564b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", () => $67f07001968fe110$export$906faff110f898ef);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", () => $67f07001968fe110$export$ab3f2a34a3b0db87);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", () => $67f07001968fe110$export$4ed84a2011fdc400);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", () => $67f07001968fe110$export$f7b286b39bf6051b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", () => $67f07001968fe110$export$6c4337c0332c8c7f);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", () => $67f07001968fe110$export$3805e4f07dca7584);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", () => $67f07001968fe110$export$f77254983320e888);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", () => $67f07001968fe110$export$2e784832f1c6bb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", () => $67f07001968fe110$export$9e53cdb1ac02195c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", () => $67f07001968fe110$export$7a821e22be2c2f14);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", () => $67f07001968fe110$export$e7423156dba31a7c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", () => $67f07001968fe110$export$cba7e383b2409c7b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", () => $67f07001968fe110$export$d5378fb71d5242c0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", () => $67f07001968fe110$export$4b16b72c72da8833);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", () => $67f07001968fe110$export$10114d78cefb1f53);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", () => $67f07001968fe110$export$92fe23ed30100817);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", () => $67f07001968fe110$export$e824495554c83069);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", () => $67f07001968fe110$export$8df2e9efdd625a44);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", () => $67f07001968fe110$export$aeb4d3006e298033);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", () => $67f07001968fe110$export$e15d3c40985c4b53);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", () => $67f07001968fe110$export$1d8c84454fd2d571);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", () => $67f07001968fe110$export$db61a12efb59745c);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", () => $67f07001968fe110$export$2da67fb5bd6bc2ee);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", () => $67f07001968fe110$export$182e0167fd960de6);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", () => $67f07001968fe110$export$2d9e2484ee02e7da);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", () => $67f07001968fe110$export$ea23f150f64e8a4e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", () => $67f07001968fe110$export$116338bd93f78ad0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PRESENTATION_TOOLKIT_REPORT", () => $67f07001968fe110$export$7a4b4b66d7637fbb);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", () => $67f07001968fe110$export$d75d93e5d44182cc);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", () => $67f07001968fe110$export$cc3027ae3767801);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", () => $67f07001968fe110$export$3492ce83b8884e0e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", () => $67f07001968fe110$export$b4798b7e62733393);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", () => $67f07001968fe110$export$388685c701d6e0d3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", () => $67f07001968fe110$export$5ff4d2d4257ea2b0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", () => $67f07001968fe110$export$fa83895c1eac55e7);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", () => $67f07001968fe110$export$5c82bb95a06a1846);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", () => $67f07001968fe110$export$c725b9c7e11dd69e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", () => $67f07001968fe110$export$90594f89c675ba05);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", () => $67f07001968fe110$export$ae0d999dd2bdd59b);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS", () => $67f07001968fe110$export$43bbf6935a91d277);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC", () => $67f07001968fe110$export$92e23977438282b2);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", () => $67f07001968fe110$export$296115eb5b7129d3);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", () => $67f07001968fe110$export$17574f41c3925d64);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", () => $67f07001968fe110$export$955692fbfe35fc16);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", () => $67f07001968fe110$export$30af3a767b8ad2d8);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", () => $67f07001968fe110$export$f47d664298c2c2f0);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", () => $67f07001968fe110$export$1714b5ad9b672bc7);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", () => $67f07001968fe110$export$c9634bf15518a3a1);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", () => $67f07001968fe110$export$3b5eb3ea8cbeeed);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", () => $67f07001968fe110$export$c29d90ae9a4b648e);
$parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", () => $67f07001968fe110$export$8f2717a951373c25);
$parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", () => $67f07001968fe110$export$831acb5098f5706d);
$parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", () => $67f07001968fe110$export$d218cda46c433fe1);
$parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", () => $67f07001968fe110$export$61147168ac2833f9);
$parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", () => $67f07001968fe110$export$9fe0117c0fd486a8);
$parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", () => $67f07001968fe110$export$a49474778d15635d);
$parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", () => $67f07001968fe110$export$af3296e54e7fb362);
$parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", () => $67f07001968fe110$export$281f2e01ee9e4977);
/**
 * SPA ROUTES
 *
 * This should contain only 3 things:
 *
 *  1. ROUTE_GROUPS - strings that represent the FULL route-group name (not a substring of the actual route-group name).
 *  2. ROUTE_NAMES - strings that represent the FULL route name (not a substring of the actual route name).
 *  3. The types for 1 & 2.
 *
 * This file is used in the following unit tests:
 *  - jira/src/packages/navigation-apps/sidebar-nav4/context/src/common/utils/routeToSelectedPath.test.tsx
 *
 * Therefore, any changes to this file is highly-likely to break the unit test(s).
 * If that happens, DON'T PANIC.
 * There will usually be a simple solution to fix the test(s).
 * The failing test-suite will have suggestions on how to fix the breaking-test(s).
 */ const $67f07001968fe110$export$1ba937db1fe6ef01 = 'archive-issues';
const $67f07001968fe110$export$3fd002e197e83a30 = 'arj-settings';
const $67f07001968fe110$export$bbf08d4d25df5504 = 'classic-business';
const $67f07001968fe110$export$e3e759b7f50aaee1 = 'classic-software';
const $67f07001968fe110$export$89337611b52bc9a3 = 'components';
const $67f07001968fe110$export$3d7937b12eb9e5d5 = 'connect';
const $67f07001968fe110$export$7a3d181d86fce9e6 = 'dashboard';
const $67f07001968fe110$export$294c878a3842c859 = 'dashboards';
const $67f07001968fe110$export$7a22726acd7d6021 = 'devops';
const $67f07001968fe110$export$f3f4a9f53ba00861 = 'directories';
const $67f07001968fe110$export$112d69653b2f1d8b = 'eoc';
const $67f07001968fe110$export$74e0426b66571086 = 'errors';
const $67f07001968fe110$export$c2e20e142c95c1ce = 'global-settings';
const $67f07001968fe110$export$f8cea29bebf098c = 'helpcenter-settings';
const $67f07001968fe110$export$5801ef8dfc9a2f70 = 'home';
const $67f07001968fe110$export$7246838143f848f3 = 'issue';
const $67f07001968fe110$export$54f96702980a2f87 = 'issue-navigator';
const $67f07001968fe110$export$5566db8fbd042fc4 = 'legacy';
const $67f07001968fe110$export$20344ad17b5fca86 = 'legacy-jsd-settings';
const $67f07001968fe110$export$656d0cc2c67b2708 = 'marketplace';
const $67f07001968fe110$export$bfdbcebc4c81b043 = 'people-profiles';
const $67f07001968fe110$export$82021d71ad19e227 = 'personal-settings';
const $67f07001968fe110$export$6f266218a6973848 = 'plan-settings';
const $67f07001968fe110$export$a846fcaeeea8e0ff = 'polaris';
const $67f07001968fe110$export$6c87a9dff4e7a2de = 'proforma';
const $67f07001968fe110$export$ab79970dcfac06a1 = 'project-settings-classic';
const $67f07001968fe110$export$d1a70f80bb22f18a = 'project-settings-core';
const $67f07001968fe110$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
const $67f07001968fe110$export$86509a1baabd62ee = 'project-settings-software';
const $67f07001968fe110$export$98823ed9eedfc756 = 'project-settings-software-boards';
const $67f07001968fe110$export$da8d13fe1ccd5c09 = 'redirects';
const $67f07001968fe110$export$78fb2f6176b7c6b8 = 'servicedesk';
const $67f07001968fe110$export$d4a2a2e87da2135a = 'services';
const $67f07001968fe110$export$26efaec7a7a8b361 = 'software';
const $67f07001968fe110$export$db781fb68c08f7e2 = 'versions';
const $67f07001968fe110$export$88041353cc69458d = 'archived-issues-directory';
const $67f07001968fe110$export$f88d57dcb03ba452 = 'archived-plans-directory';
const $67f07001968fe110$export$e8aa63af071c2da9 = 'archived-projects-directory';
const $67f07001968fe110$export$b114d0da2ebcff6c = 'archived-project-direct-link';
const $67f07001968fe110$export$29cc94b8cea5c920 = 'boards-directory';
const $67f07001968fe110$export$4d1b45005cdcfb39 = 'browse-project-redirect';
const $67f07001968fe110$export$a42ea04fdf53eeaf = 'next-gen-business-board';
const $67f07001968fe110$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
const $67f07001968fe110$export$d58a5411a2ac6260 = 'next-gen-business-reports';
const $67f07001968fe110$export$ec333dd1d6a8b38 = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-calendar`;
const $67f07001968fe110$export$ed495fbad44791af = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-redirect`;
const $67f07001968fe110$export$5281552f8109b7c0 = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-summary`;
const $67f07001968fe110$export$6e8473713ed4557a = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-timeline`;
const $67f07001968fe110$export$cbdd5c24d69b2cb1 = `${$67f07001968fe110$export$bbf08d4d25df5504}-approvals`;
const $67f07001968fe110$export$e7f012f402be01ea = `${$67f07001968fe110$export$bbf08d4d25df5504}-attachments`;
const $67f07001968fe110$export$b34d3882b42d660d = `${$67f07001968fe110$export$bbf08d4d25df5504}-board`;
const $67f07001968fe110$export$ed869c60c6a56182 = `${$67f07001968fe110$export$bbf08d4d25df5504}-board-embed`;
const $67f07001968fe110$export$5013269f29c75b37 = `${$67f07001968fe110$export$bbf08d4d25df5504}-calendar`;
const $67f07001968fe110$export$fc8b48319e993d43 = `${$67f07001968fe110$export$bbf08d4d25df5504}-calendar-embed`;
const $67f07001968fe110$export$40903feb5b038923 = `${$67f07001968fe110$export$bbf08d4d25df5504}-files`;
const $67f07001968fe110$export$d6e60a2059f028d = `${$67f07001968fe110$export$bbf08d4d25df5504}-form`;
const $67f07001968fe110$export$3d589aae17a00bc9 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-builder`;
const $67f07001968fe110$export$bd92ef03b23dd672 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-submit`;
const $67f07001968fe110$export$fa7fc44c718fc850 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-submit-embed`;
const $67f07001968fe110$export$1dffaf831e01e2b4 = `${$67f07001968fe110$export$bbf08d4d25df5504}-list`;
const $67f07001968fe110$export$5f8187412dd60f35 = `${$67f07001968fe110$export$bbf08d4d25df5504}-list-embed`;
const $67f07001968fe110$export$3d2c1c04d18f6c43 = `${$67f07001968fe110$export$bbf08d4d25df5504}-sample-onboarding`;
const $67f07001968fe110$export$cd22a5d8f560a1d8 = `${$67f07001968fe110$export$bbf08d4d25df5504}-shortcut`;
const $67f07001968fe110$export$cad1b1aa5ce26bbc = `${$67f07001968fe110$export$bbf08d4d25df5504}-summary`;
const $67f07001968fe110$export$ee073463b4144367 = `${$67f07001968fe110$export$bbf08d4d25df5504}-summary-embed`;
const $67f07001968fe110$export$ea034943499772ea = `${$67f07001968fe110$export$bbf08d4d25df5504}-timeline`;
const $67f07001968fe110$export$19bc888bcf37d22d = `${$67f07001968fe110$export$bbf08d4d25df5504}-timeline-embed`;
const $67f07001968fe110$export$e0746183e11767fb = `${$67f07001968fe110$export$bbf08d4d25df5504}-redirect`;
const $67f07001968fe110$export$3e2d215ce157adc8 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-code`;
const $67f07001968fe110$export$8a8485bb05daf40b = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-project-forms`;
const $67f07001968fe110$export$a2799b01de5bb62 = `${$67f07001968fe110$export$ab79970dcfac06a1}-data-classifications`;
const $67f07001968fe110$export$1bc2b66dcb07293a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-details`;
const $67f07001968fe110$export$2d4f89c4b1ee3640 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-features`;
const $67f07001968fe110$export$75609d3416c31f79 = `${$67f07001968fe110$export$ab79970dcfac06a1}-issue-layout`;
const $67f07001968fe110$export$79793dc26e0b7b1a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications-notification-email`;
const $67f07001968fe110$export$2eda7466fbfdef43 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-link-opsgenie`;
const $67f07001968fe110$export$417297669917ee1a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-details`;
const $67f07001968fe110$export$8c79f3309ac0737 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications`;
const $67f07001968fe110$export$ef71a22e7befd35c = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications-issue-logs`;
const $67f07001968fe110$export$62ba1e294f5007c1 = `${$67f07001968fe110$export$86509a1baabd62ee}-proforma-edit-forms`;
const $67f07001968fe110$export$a4315324546ecc89 = `${$67f07001968fe110$export$86509a1baabd62ee}-proforma-project-forms`;
const $67f07001968fe110$export$a653cf6d478b3df1 = `${$67f07001968fe110$export$86509a1baabd62ee}-toolchain-company-managed`;
const $67f07001968fe110$export$b0f268fe53a03e98 = 'compass-product-settings';
const $67f07001968fe110$export$f4160b48e4ab8f39 = 'confluence-product-settings';
const $67f07001968fe110$export$608f359cf8b08d2e = 'connect-general';
const $67f07001968fe110$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
const $67f07001968fe110$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
const $67f07001968fe110$export$bd2506db44585db6 = 'connect-project';
const $67f07001968fe110$export$200fa5ad16f8c112 = 'create-project';
const $67f07001968fe110$export$21702f145fe1bbb0 = 'customer-service-accounts';
const $67f07001968fe110$export$a296bb962bea95b5 = 'dashboard';
const $67f07001968fe110$export$b9960c143c0414eb = 'dashboards-directory';
const $67f07001968fe110$export$411171d2fcaefaea = 'dashboards-directory-secure';
const $67f07001968fe110$export$ee104ed514f63003 = 'dashboard-edit';
const $67f07001968fe110$export$9233f9ddcecd3062 = 'dashboard-selected';
const $67f07001968fe110$export$b3240ec044a6c70f = 'dashboard-view';
const $67f07001968fe110$export$2463c779e12367e3 = 'dashboard-view-embed';
const $67f07001968fe110$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
const $67f07001968fe110$export$38ca7e07048a5bfd = 'devops-connected-project';
const $67f07001968fe110$export$a9044bbb0247378d = 'eoc-alerts';
const $67f07001968fe110$export$ae7376e552380ac0 = 'eoc-alert-detail';
const $67f07001968fe110$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
const $67f07001968fe110$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
const $67f07001968fe110$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
const $67f07001968fe110$export$54ed2374d14a7e88 = 'eoc-api-key-management';
const $67f07001968fe110$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
const $67f07001968fe110$export$bbb4032f8f259109 = 'eoc-automations';
const $67f07001968fe110$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
const $67f07001968fe110$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
const $67f07001968fe110$export$5126a481501fc518 = 'eoc-global-alert-detail';
const $67f07001968fe110$export$40e720d8c26e6804 = 'eoc-global-group-detail';
const $67f07001968fe110$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
const $67f07001968fe110$export$8ca3e3f0326ba27f = 'eoc-global-reports';
const $67f07001968fe110$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
const $67f07001968fe110$export$99f769b27f537a72 = 'eoc-incoming-call';
const $67f07001968fe110$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
const $67f07001968fe110$export$901b974cf0954c88 = 'eoc-integrations';
const $67f07001968fe110$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
const $67f07001968fe110$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
const $67f07001968fe110$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
const $67f07001968fe110$export$a22387b9744e62e3 = 'eoc-integration-log';
const $67f07001968fe110$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
const $67f07001968fe110$export$e6de4aa6c719d2b = 'eoc-on-call';
const $67f07001968fe110$export$1800d32171b754a6 = 'eoc-overview';
const $67f07001968fe110$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
const $67f07001968fe110$export$a9a41c76994b6ae9 = 'eoc-permissions';
const $67f07001968fe110$export$5bd6f2569c3cfd5c = 'eoc-policies';
const $67f07001968fe110$export$dc70eff53ff26c70 = 'eoc-reports';
const $67f07001968fe110$export$1fe2ca96b360df19 = 'eoc-reports-team';
const $67f07001968fe110$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
const $67f07001968fe110$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
const $67f07001968fe110$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
const $67f07001968fe110$export$c4531cbbea51b6a1 = 'eoc-settings';
const $67f07001968fe110$export$da985e953465731f = 'eoc-team-alerts';
const $67f07001968fe110$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
const $67f07001968fe110$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
const $67f07001968fe110$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
const $67f07001968fe110$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
const $67f07001968fe110$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
const $67f07001968fe110$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
const $67f07001968fe110$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
const $67f07001968fe110$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
const $67f07001968fe110$export$bdd811277711c53d = 'eoc-team-integration-create';
const $67f07001968fe110$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
const $67f07001968fe110$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
const $67f07001968fe110$export$a4eff769c94da831 = 'eoc-team-integration-log';
const $67f07001968fe110$export$7c928ca9c9822772 = 'eoc-team-policies';
const $67f07001968fe110$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
const $67f07001968fe110$export$20649eac204f7661 = 'eoc-who-is-on-call';
const $67f07001968fe110$export$62170875a111d729 = 'errors-not-found';
const $67f07001968fe110$export$2928f3d69e7ac609 = 'external-import';
const $67f07001968fe110$export$259e18cafd820487 = 'filters-directory';
const $67f07001968fe110$export$4b8f333757e638a4 = 'filters-directory-secure';
const $67f07001968fe110$export$ac4f65a14002f892 = 'forge-spa-admin';
const $67f07001968fe110$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
const $67f07001968fe110$export$7ad826b482229119 = 'forge-spa-field-context-config';
const $67f07001968fe110$export$3df864df9b639033 = 'forge-spa-global';
const $67f07001968fe110$export$7d67bf4077ebe18d = 'forge-spa-project';
const $67f07001968fe110$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
const $67f07001968fe110$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
const $67f07001968fe110$export$eadf5aff28def565 = 'global-issue-navigator';
const $67f07001968fe110$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
const $67f07001968fe110$export$1bf439327974644b = 'global-mail-settings';
const $67f07001968fe110$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
const $67f07001968fe110$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
const $67f07001968fe110$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
const $67f07001968fe110$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
const $67f07001968fe110$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
const $67f07001968fe110$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
const $67f07001968fe110$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
const $67f07001968fe110$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
const $67f07001968fe110$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
const $67f07001968fe110$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
const $67f07001968fe110$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
const $67f07001968fe110$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
const $67f07001968fe110$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
const $67f07001968fe110$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
const $67f07001968fe110$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
const $67f07001968fe110$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
const $67f07001968fe110$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
const $67f07001968fe110$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
const $67f07001968fe110$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
const $67f07001968fe110$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
const $67f07001968fe110$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
const $67f07001968fe110$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
const $67f07001968fe110$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
const $67f07001968fe110$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
const $67f07001968fe110$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
const $67f07001968fe110$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
const $67f07001968fe110$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
const $67f07001968fe110$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
const $67f07001968fe110$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
const $67f07001968fe110$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
const $67f07001968fe110$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
const $67f07001968fe110$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
const $67f07001968fe110$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
const $67f07001968fe110$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
const $67f07001968fe110$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
const $67f07001968fe110$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
const $67f07001968fe110$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
const $67f07001968fe110$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
const $67f07001968fe110$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
const $67f07001968fe110$export$7dd4b916600f670 = 'global-settings-issues-priorities';
const $67f07001968fe110$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
const $67f07001968fe110$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
const $67f07001968fe110$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
const $67f07001968fe110$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
const $67f07001968fe110$export$691d30818c14141c = 'global-settings-issues-resolutions';
const $67f07001968fe110$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
const $67f07001968fe110$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
const $67f07001968fe110$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
const $67f07001968fe110$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
const $67f07001968fe110$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
const $67f07001968fe110$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
const $67f07001968fe110$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
const $67f07001968fe110$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
const $67f07001968fe110$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
const $67f07001968fe110$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
const $67f07001968fe110$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
const $67f07001968fe110$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
const $67f07001968fe110$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
const $67f07001968fe110$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
const $67f07001968fe110$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
const $67f07001968fe110$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
const $67f07001968fe110$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
const $67f07001968fe110$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
const $67f07001968fe110$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
const $67f07001968fe110$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
const $67f07001968fe110$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
const $67f07001968fe110$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
const $67f07001968fe110$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
const $67f07001968fe110$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
const $67f07001968fe110$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
const $67f07001968fe110$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
const $67f07001968fe110$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
const $67f07001968fe110$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
const $67f07001968fe110$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
const $67f07001968fe110$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
const $67f07001968fe110$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
const $67f07001968fe110$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
const $67f07001968fe110$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
const $67f07001968fe110$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
const $67f07001968fe110$export$ef510a15f840e437 = 'global-settings-issues-types-view';
const $67f07001968fe110$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
const $67f07001968fe110$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
const $67f07001968fe110$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
const $67f07001968fe110$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
const $67f07001968fe110$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
const $67f07001968fe110$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
const $67f07001968fe110$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
const $67f07001968fe110$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
const $67f07001968fe110$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
const $67f07001968fe110$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
const $67f07001968fe110$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
const $67f07001968fe110$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
const $67f07001968fe110$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
const $67f07001968fe110$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
const $67f07001968fe110$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
const $67f07001968fe110$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
const $67f07001968fe110$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
const $67f07001968fe110$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
const $67f07001968fe110$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
const $67f07001968fe110$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
const $67f07001968fe110$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
const $67f07001968fe110$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
const $67f07001968fe110$export$4c211b3188348679 = 'global-settings-performance-custom-field';
const $67f07001968fe110$export$24757bb1837e33af = 'global-settings-performance-issue';
const $67f07001968fe110$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
const $67f07001968fe110$export$d55d4330b58683da = 'global-settings-performance-overview';
const $67f07001968fe110$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
const $67f07001968fe110$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
const $67f07001968fe110$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
const $67f07001968fe110$export$16b4392a63a3eacf = 'global-settings-products-applinks';
const $67f07001968fe110$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
const $67f07001968fe110$export$f870832f94ca5009 = 'global-settings-products-sdmail';
const $67f07001968fe110$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
const $67f07001968fe110$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
const $67f07001968fe110$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
const $67f07001968fe110$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
const $67f07001968fe110$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
const $67f07001968fe110$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
const $67f07001968fe110$export$a1916b723e186494 = 'global-settings-system-helper-permission';
const $67f07001968fe110$export$5070b4c974017f28 = 'global-settings-system-attachments';
const $67f07001968fe110$export$bee7f9f93cb74124 = 'global-settings-system-events';
const $67f07001968fe110$export$efe4008073ab3b69 = 'global-settings-system-events-add';
const $67f07001968fe110$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
const $67f07001968fe110$export$223f8094878fea34 = 'global-settings-system-events-edit';
const $67f07001968fe110$export$2f589c572415c043 = 'global-settings-system-lexorank';
const $67f07001968fe110$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
const $67f07001968fe110$export$a11311cd333dae90 = 'global-settings-system-webhooks';
const $67f07001968fe110$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
const $67f07001968fe110$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
const $67f07001968fe110$export$55dd30b027c838fe = 'global-settings-system-application-edit';
const $67f07001968fe110$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
const $67f07001968fe110$export$75f2fbd33e76028e = 'global-settings-system-export';
const $67f07001968fe110$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
const $67f07001968fe110$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
const $67f07001968fe110$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
const $67f07001968fe110$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
const $67f07001968fe110$export$750a33c4058af733 = 'global-settings-system-import-trello';
const $67f07001968fe110$export$1b66c7594340363f = 'global-settings-system-collectors';
const $67f07001968fe110$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
const $67f07001968fe110$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
const $67f07001968fe110$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
const $67f07001968fe110$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
const $67f07001968fe110$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
const $67f07001968fe110$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
const $67f07001968fe110$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
const $67f07001968fe110$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
const $67f07001968fe110$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
const $67f07001968fe110$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
const $67f07001968fe110$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
const $67f07001968fe110$export$265062715b11a1ef = 'global-settings-system-roles-usage';
const $67f07001968fe110$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
const $67f07001968fe110$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
const $67f07001968fe110$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
const $67f07001968fe110$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
const $67f07001968fe110$export$fb75113636566d39 = 'global-settings-system-look';
const $67f07001968fe110$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
const $67f07001968fe110$export$40d189100899f572 = 'global-settings-system-default-settings';
const $67f07001968fe110$export$341933b279728599 = $67f07001968fe110$export$f8cea29bebf098c;
const $67f07001968fe110$export$ae4b815061537207 = `${$67f07001968fe110$export$f8cea29bebf098c}-customer-notifications`;
const $67f07001968fe110$export$5cd0dd5a6be6aa2b = `${$67f07001968fe110$export$f8cea29bebf098c}-email`;
const $67f07001968fe110$export$bee46016693b19dc = `${$67f07001968fe110$export$f8cea29bebf098c}-kb`;
const $67f07001968fe110$export$c39a25878c902e0a = `${$67f07001968fe110$export$f8cea29bebf098c}-unassigned-ticket-types-config`;
const $67f07001968fe110$export$6eaa6ce8101f6468 = `${$67f07001968fe110$export$f8cea29bebf098c}-unassigned-ticket-type-fields`;
const $67f07001968fe110$export$2e90ab5aa3463c0d = `${$67f07001968fe110$export$f8cea29bebf098c}-web-portal`;
const $67f07001968fe110$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
const $67f07001968fe110$export$b2b57cde1fa39bf5 = 'home-redirect';
const $67f07001968fe110$export$e8e3b3a04b70a016 = 'issue';
const $67f07001968fe110$export$1a3116351e4f3550 = 'issue-create-embed';
const $67f07001968fe110$export$6e2629d41c380b47 = 'issue-embed';
const $67f07001968fe110$export$ced38e55e6d33a4e = 'jira-search';
const $67f07001968fe110$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
const $67f07001968fe110$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
const $67f07001968fe110$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
const $67f07001968fe110$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
const $67f07001968fe110$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
const $67f07001968fe110$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
const $67f07001968fe110$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
const $67f07001968fe110$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
const $67f07001968fe110$export$fea47b97c6086336 = 'knowledge-hub-drafts';
const $67f07001968fe110$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
const $67f07001968fe110$export$991ba0c465b48539 = 'knowledge-hub-landing';
const $67f07001968fe110$export$904b472d57dee40d = 'knowledge-hub-search';
const $67f07001968fe110$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
const $67f07001968fe110$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
const $67f07001968fe110$export$37bd400c00057d64 = 'legacy-all-reports';
const $67f07001968fe110$export$eb66bd587b5f093d = 'legacy-backlog';
const $67f07001968fe110$export$521baa72494c2a67 = 'legacy-board';
const $67f07001968fe110$export$ca255c93be51d5bc = 'legacy-connect-general';
const $67f07001968fe110$export$51e45f736a60769b = 'legacy-connect-project';
const $67f07001968fe110$export$2da88c0583f7fff0 = 'legacy-core-reports';
const $67f07001968fe110$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
const $67f07001968fe110$export$5475ba822739444a = 'legacy-fallback';
const $67f07001968fe110$export$8483f5c57513e386 = 'legacy-gin';
const $67f07001968fe110$export$93c4d1960660bdb3 = 'legacy-gin-issue';
const $67f07001968fe110$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
const $67f07001968fe110$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
const $67f07001968fe110$export$bf4001a5c23bef67 = 'legacy-issue';
const $67f07001968fe110$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
const $67f07001968fe110$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
const $67f07001968fe110$export$41008c2b014795bf = 'legacy-jsd-getting-started';
const $67f07001968fe110$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
const $67f07001968fe110$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
const $67f07001968fe110$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
const $67f07001968fe110$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
const $67f07001968fe110$export$3fbd487079a23c0f = 'legacy-jsd-reports';
const $67f07001968fe110$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
const $67f07001968fe110$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
const $67f07001968fe110$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
const $67f07001968fe110$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
const $67f07001968fe110$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
const $67f07001968fe110$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
const $67f07001968fe110$export$c71836085985a7d3 = 'legacy-pin';
const $67f07001968fe110$export$a17a19a9de903839 = 'legacy-project-releases';
const $67f07001968fe110$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
const $67f07001968fe110$export$f0254c80025ed0fc = 'legacy-project-releases-note';
const $67f07001968fe110$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
const $67f07001968fe110$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
const $67f07001968fe110$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
const $67f07001968fe110$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
const $67f07001968fe110$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
const $67f07001968fe110$export$3467807847c0a87d = 'legacy-project-settings-config';
const $67f07001968fe110$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
const $67f07001968fe110$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
const $67f07001968fe110$export$f01730982626c4af = 'legacy-project-settings-dev';
const $67f07001968fe110$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
const $67f07001968fe110$export$ecff223feb9d08be = 'legacy-project-settings-fields';
const $67f07001968fe110$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
const $67f07001968fe110$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
const $67f07001968fe110$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
const $67f07001968fe110$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
const $67f07001968fe110$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
const $67f07001968fe110$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
const $67f07001968fe110$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
const $67f07001968fe110$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
const $67f07001968fe110$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
const $67f07001968fe110$export$28687a1181a7676f = 'legacy-project-settings-people';
const $67f07001968fe110$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
const $67f07001968fe110$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
const $67f07001968fe110$export$cb8548f16119b181 = 'legacy-project-settings-screens';
const $67f07001968fe110$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
const $67f07001968fe110$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
const $67f07001968fe110$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
const $67f07001968fe110$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
const $67f07001968fe110$export$2d21e5416485b195 = 'legacy-redirect';
const $67f07001968fe110$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
const $67f07001968fe110$export$d9662297242bfcb5 = 'legacy-reports-configure';
const $67f07001968fe110$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
const $67f07001968fe110$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
const $67f07001968fe110$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
const $67f07001968fe110$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
const $67f07001968fe110$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
const $67f07001968fe110$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
const $67f07001968fe110$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
const $67f07001968fe110$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
const $67f07001968fe110$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
const $67f07001968fe110$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
const $67f07001968fe110$export$55248356780fc584 = 'login-embed';
const $67f07001968fe110$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
const $67f07001968fe110$export$624af6f61b05f55 = 'addons-emcee-public';
const $67f07001968fe110$export$2ed9525182145b82 = 'marketplace-app-requests';
const $67f07001968fe110$export$7fb2b42fc4e7df8b = 'marketplace-index';
const $67f07001968fe110$export$fa962db82ae571b2 = 'global-settings-addons-upm';
const $67f07001968fe110$export$e145bf76b1aef705 = 'marketplace-promotions';
const $67f07001968fe110$export$8febbfb647e4c8b9 = 'notification-logs';
const $67f07001968fe110$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
const $67f07001968fe110$export$a979a5c1f5e3631c = 'people-index';
const $67f07001968fe110$export$ffcbf91dfadffd0 = 'personal-settings';
const $67f07001968fe110$export$1807a39cc63b856c = 'personal-settings-general';
const $67f07001968fe110$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
const $67f07001968fe110$export$6268da7263eb670d = 'personal-settings-ops-notifications';
const $67f07001968fe110$export$93bd4a896a0fc581 = 'plans-directory';
const $67f07001968fe110$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
const $67f07001968fe110$export$d1217085321b2648 = 'project-settings-playbooks-list';
const $67f07001968fe110$export$e5dc3f48a0b19ea1 = 'project-settings-playbooks-logs';
const $67f07001968fe110$export$39624171b7c8a10a = 'polaris-collections';
const $67f07001968fe110$export$1654cd6813e90e6b = 'polaris-ideas';
const $67f07001968fe110$export$33059cd02df2febd = 'polaris-insights';
const $67f07001968fe110$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
const $67f07001968fe110$export$145c578104a45fd2 = 'polaris-plays';
const $67f07001968fe110$export$a51df1bc877c58e5 = 'polaris-rooms';
const $67f07001968fe110$export$45208fff8de46880 = 'polaris-settings-access';
const $67f07001968fe110$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
const $67f07001968fe110$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
const $67f07001968fe110$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
const $67f07001968fe110$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
const $67f07001968fe110$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
const $67f07001968fe110$export$53ce69fb34f6d286 = 'products-jsm-configuration';
const $67f07001968fe110$export$b6e861786143eb1b = 'products-jsm-customer-access';
const $67f07001968fe110$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
const $67f07001968fe110$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
const $67f07001968fe110$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
const $67f07001968fe110$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
const $67f07001968fe110$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
const $67f07001968fe110$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
const $67f07001968fe110$export$9ac90b948c53bf58 = 'products-jsw-configuration';
const $67f07001968fe110$export$bb5665894498893f = 'products-jsw-storage-management';
const $67f07001968fe110$export$fc61479fdfdd263a = 'classic-business-proforma-export';
const $67f07001968fe110$export$5ae82b891e42770e = 'servicedesk-proforma-export';
const $67f07001968fe110$export$8dcc46e162f2235b = 'software-proforma-export';
const $67f07001968fe110$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
const $67f07001968fe110$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
const $67f07001968fe110$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
const $67f07001968fe110$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
const $67f07001968fe110$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
const $67f07001968fe110$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
const $67f07001968fe110$export$65f234e4799edddc = 'classic-business-proforma-issue-forms-general';
const $67f07001968fe110$export$215ea4e7405fa88c = 'servicedesk-proforma-issue-forms-general';
const $67f07001968fe110$export$927b1972180d9cc4 = 'software-proforma-issue-forms-general';
const $67f07001968fe110$export$ff1365ce4d652337 = 'projects-directory';
const $67f07001968fe110$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
const $67f07001968fe110$export$33c2dcc7c7abc45e = 'projects-directory-manage';
const $67f07001968fe110$export$a6ef20aa08a533b1 = 'projects-redirect';
const $67f07001968fe110$export$5908e15483da8a45 = 'project-components';
const $67f07001968fe110$export$a3812f6f4e60d897 = 'project-directory-redirect';
const $67f07001968fe110$export$3c8c119f40a061a9 = 'issue-navigator';
const $67f07001968fe110$export$47e034646abefdb2 = 'issue-navigator-classic';
const $67f07001968fe110$export$f36f4cf8b17f250f = 'issue-navigator-core';
const $67f07001968fe110$export$1fde4a6e7df24a97 = 'project-pages';
const $67f07001968fe110$export$69335bf8b709edc7 = 'project-settings-automation';
const $67f07001968fe110$export$946b472f7559a889 = 'project-settings-components';
const $67f07001968fe110$export$373fdf6888021ed0 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-access`;
const $67f07001968fe110$export$d6a5f13a3d30923c = `${$67f07001968fe110$export$d1a70f80bb22f18a}-access-redirect`;
const $67f07001968fe110$export$adfff93b0b015409 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-approvals`;
const $67f07001968fe110$export$404de4ddea701cff = `${$67f07001968fe110$export$d1a70f80bb22f18a}-apps`;
const $67f07001968fe110$export$596e1f6f6f4997b2 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-apps-fields`;
const $67f07001968fe110$export$8da0e4cdbdd0cd0b = `${$67f07001968fe110$export$d1a70f80bb22f18a}-automation`;
const $67f07001968fe110$export$d610a17dff3a01fa = `${$67f07001968fe110$export$d1a70f80bb22f18a}-data-classifications`;
const $67f07001968fe110$export$284db5107f3db516 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-redirect`;
const $67f07001968fe110$export$fbce46826eefc586 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-details`;
const $67f07001968fe110$export$c86b29c76317ac6f = `${$67f07001968fe110$export$d1a70f80bb22f18a}-fields`;
const $67f07001968fe110$export$3160b86e1b5dc391 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-forge-apps`;
const $67f07001968fe110$export$690c0080c930fca = `${$67f07001968fe110$export$d1a70f80bb22f18a}-issuetypes`;
const $67f07001968fe110$export$171ba8c33c05c4ef = `${$67f07001968fe110$export$d1a70f80bb22f18a}-issuetypes-workflow`;
const $67f07001968fe110$export$e2f2c23286c3255c = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications`;
const $67f07001968fe110$export$5a262d40e10207a1 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications-issue-logs`;
const $67f07001968fe110$export$ab790cb87175797e = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications-notification-email`;
const $67f07001968fe110$export$db780b39656c673a = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
const $67f07001968fe110$export$a77cb4dafc511d3 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-project-forms`;
const $67f07001968fe110$export$253fd82874264ee4 = `${$67f07001968fe110$export$86509a1baabd62ee}-forge-apps`;
const $67f07001968fe110$export$eaf9ab4ec0c25813 = `${$67f07001968fe110$export$86509a1baabd62ee}-apps-forge`;
const $67f07001968fe110$export$574bcdf6b73fcf1f = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-apps-fields`;
const $67f07001968fe110$export$a14853dfff8da872 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-chat`;
const $67f07001968fe110$export$923d56d5ae77c67e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-customer-notifications-classic`;
const $67f07001968fe110$export$d416059b17fe7d4e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-email`;
const $67f07001968fe110$export$688de32d31fc70f5 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-details`;
const $67f07001968fe110$export$13d770f8814d480a = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-forge-apps`;
const $67f07001968fe110$export$3a628f9376166ffb = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
const $67f07001968fe110$export$649dafa225625f30 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
const $67f07001968fe110$export$dbfe76dd37018b2 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notifications`;
const $67f07001968fe110$export$20db7bb9d1bd8b38 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notifications-notification-email`;
const $67f07001968fe110$export$fc6b949fd2bc782d = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-portal-settings`;
const $67f07001968fe110$export$c940f866ac7760a0 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-ticket-types-config`;
const $67f07001968fe110$export$184d4979f6f9fe7e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-ticket-type-fields`;
const $67f07001968fe110$export$959f50de166cc45e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
const $67f07001968fe110$export$b13b8c8bb4e30a75 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
const $67f07001968fe110$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
const $67f07001968fe110$export$cc1af211e3feda50 = `${$67f07001968fe110$export$86509a1baabd62ee}-apps-fields`;
const $67f07001968fe110$export$3873539001f5aed7 = 'project-settings-software-automation';
const $67f07001968fe110$export$89fcbafce559080b = 'project-settings-software-boards-card';
const $67f07001968fe110$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
const $67f07001968fe110$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
const $67f07001968fe110$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
const $67f07001968fe110$export$50680f54e95bb859 = 'project-settings-software-boards-features';
const $67f07001968fe110$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
const $67f07001968fe110$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
const $67f07001968fe110$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
const $67f07001968fe110$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
const $67f07001968fe110$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
const $67f07001968fe110$export$ba419378ad70624e = 'project-settings-software-data-classifications';
const $67f07001968fe110$export$62f38c589a73d386 = 'project-settings-software-details';
const $67f07001968fe110$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
const $67f07001968fe110$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
const $67f07001968fe110$export$db7f5d93be70ee30 = `${$67f07001968fe110$export$86509a1baabd62ee}-notifications`;
const $67f07001968fe110$export$432229516b7f82da = `${$67f07001968fe110$export$86509a1baabd62ee}-notifications-issue-logs`;
const $67f07001968fe110$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
const $67f07001968fe110$export$6b2b99b0055772a3 = `${$67f07001968fe110$export$86509a1baabd62ee}-link-opsgenie`;
const $67f07001968fe110$export$83c7a51057be6264 = `${$67f07001968fe110$export$86509a1baabd62ee}-toolchain-team-managed`;
const $67f07001968fe110$export$46706d786aab3829 = 'project-settings-versions';
const $67f07001968fe110$export$b690025ef7e3cf6c = 'project-versions';
const $67f07001968fe110$export$ea48cc6bf1183d11 = 'rapidboard';
const $67f07001968fe110$export$930e4881302bbd54 = 'rapidboard-backlog';
const $67f07001968fe110$export$375801b708576466 = 'rapidboard-backlog-embed';
const $67f07001968fe110$export$5b1e8463bd590143 = 'rapidboard-board';
const $67f07001968fe110$export$1606662a398a24be = 'rapidboard-board-embed';
const $67f07001968fe110$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
const $67f07001968fe110$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
const $67f07001968fe110$export$c46680afe70295f3 = 'rapidboard-report';
const $67f07001968fe110$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
const $67f07001968fe110$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
const $67f07001968fe110$export$99e0abd8ba1de289 = 'rapidboard-user-board';
const $67f07001968fe110$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
const $67f07001968fe110$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
const $67f07001968fe110$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
const $67f07001968fe110$export$8c8f03e75b6708ac = 'servicedesk-calendar';
const $67f07001968fe110$export$2e93790099768be5 = 'servicedesk-calendar-eap';
const $67f07001968fe110$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
const $67f07001968fe110$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
const $67f07001968fe110$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
const $67f07001968fe110$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
const $67f07001968fe110$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
const $67f07001968fe110$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
const $67f07001968fe110$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
const $67f07001968fe110$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
const $67f07001968fe110$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
const $67f07001968fe110$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
const $67f07001968fe110$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
const $67f07001968fe110$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
const $67f07001968fe110$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
const $67f07001968fe110$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
const $67f07001968fe110$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
const $67f07001968fe110$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
const $67f07001968fe110$export$37a9bdd8513f462d = 'servicedesk-connect-project';
const $67f07001968fe110$export$f01162415f3a2ee3 = 'servicedesk-create-project';
const $67f07001968fe110$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
const $67f07001968fe110$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
const $67f07001968fe110$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
const $67f07001968fe110$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
const $67f07001968fe110$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
const $67f07001968fe110$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
const $67f07001968fe110$export$829d1776460a6ad3 = 'servicedesk-incidents';
const $67f07001968fe110$export$d30ab2da08d8b7b9 = 'servicedesk-index';
const $67f07001968fe110$export$3c71889849aeaa08 = 'servicedesk-issue';
const $67f07001968fe110$export$354bf2df81f6ffb0 = 'servicedesk-issues';
const $67f07001968fe110$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
const $67f07001968fe110$export$876055c0ede2f8df = 'servicedesk-automation';
const $67f07001968fe110$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
const $67f07001968fe110$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
const $67f07001968fe110$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
const $67f07001968fe110$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
const $67f07001968fe110$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
const $67f07001968fe110$export$8c800f176d079d28 = 'servicedesk-organization-details';
const $67f07001968fe110$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
const $67f07001968fe110$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
const $67f07001968fe110$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
const $67f07001968fe110$export$2b4737953287a354 = 'servicedesk-practice-issue';
const $67f07001968fe110$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
const $67f07001968fe110$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
const $67f07001968fe110$export$2d961b0101f8733e = 'servicedesk-practice-new';
const $67f07001968fe110$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
const $67f07001968fe110$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
const $67f07001968fe110$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
const $67f07001968fe110$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
const $67f07001968fe110$export$ccd12890649c59cc = 'servicedesk-queues-issue';
const $67f07001968fe110$export$8c84064031188e80 = 'servicedesk-queues-landing';
const $67f07001968fe110$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
const $67f07001968fe110$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
const $67f07001968fe110$export$156b2dfbd87d576f = 'servicedesk-redirect';
const $67f07001968fe110$export$6961f1ed0407cb26 = 'servicedesk-reports';
const $67f07001968fe110$export$ba284efd679bf637 = 'servicedesk-reports-custom';
const $67f07001968fe110$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
const $67f07001968fe110$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
const $67f07001968fe110$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
const $67f07001968fe110$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
const $67f07001968fe110$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
const $67f07001968fe110$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
const $67f07001968fe110$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
const $67f07001968fe110$export$be4b2ffade787316 = 'servicedesk-reports-summary';
const $67f07001968fe110$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
const $67f07001968fe110$export$29bc361328055683 = 'servicedesk-reports-workload';
const $67f07001968fe110$export$a4a5a333fe874d97 = 'servicedesk-services';
const $67f07001968fe110$export$2193b681ac1ae132 = 'servicedesk-services-new';
const $67f07001968fe110$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
const $67f07001968fe110$export$a4c4f7898d6b914a = 'servicedesk-service-details';
const $67f07001968fe110$export$6cffae90b9277bb = 'servicedesk-service-details-new';
const $67f07001968fe110$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
const $67f07001968fe110$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
const $67f07001968fe110$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
const $67f07001968fe110$export$8e68c55c334de101 = 'servicedesk-sla-settings';
const $67f07001968fe110$export$5cb7cfba189a0240 = 'service-hub-services';
const $67f07001968fe110$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
const $67f07001968fe110$export$1cf56e2d6c4edb35 = 'global-automation';
const $67f07001968fe110$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
const $67f07001968fe110$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
const $67f07001968fe110$export$4db732436e4edfaf = 'recommendations';
const $67f07001968fe110$export$e832418dbed0717e = 'view-custom-fields';
const $67f07001968fe110$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
const $67f07001968fe110$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
const $67f07001968fe110$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
const $67f07001968fe110$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
const $67f07001968fe110$export$e74fe5bd41e23fbd = `${$67f07001968fe110$export$3fd002e197e83a30}-dependencies`;
const $67f07001968fe110$export$1a93e63ddbe4aa06 = `${$67f07001968fe110$export$3fd002e197e83a30}-dependencies-redirect`;
const $67f07001968fe110$export$3b6dbbe49882589d = `${$67f07001968fe110$export$3fd002e197e83a30}-financial-year`;
const $67f07001968fe110$export$eb01394789016fd4 = `${$67f07001968fe110$export$3fd002e197e83a30}-loading-limits`;
const $67f07001968fe110$export$f17f4523583fa8e5 = `${$67f07001968fe110$export$3fd002e197e83a30}-loading-limits-redirect`;
const $67f07001968fe110$export$eaa4d6eec75a6778 = `${$67f07001968fe110$export$3fd002e197e83a30}-permissions`;
const $67f07001968fe110$export$dcc96e4abbdc0d39 = `${$67f07001968fe110$export$3fd002e197e83a30}-permissions-redirect`;
const $67f07001968fe110$export$9eaf39ba5a56c72a = 'software-backlog';
const $67f07001968fe110$export$495be3320b67814a = 'software-backlog-embed';
const $67f07001968fe110$export$25752eb5bb5e3d32 = 'software-boards';
const $67f07001968fe110$export$f116716aedb35e10 = 'software-boards-embed';
const $67f07001968fe110$export$36fffb6b49d9f31d = 'software-calendar';
const $67f07001968fe110$export$a6d07be4ff318f84 = 'software-calendar-classic';
const $67f07001968fe110$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
const $67f07001968fe110$export$3a4c7a521a900b4d = 'software-calendar-embed';
const $67f07001968fe110$export$9dcf51a9040a4fd6 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
const $67f07001968fe110$export$a74f9f6bd0d4fb26 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
const $67f07001968fe110$export$f8cb86acf6b74661 = 'software-code';
const $67f07001968fe110$export$2d3d850c64058bfb = 'software-code-classic';
const $67f07001968fe110$export$af6b51164f66908b = 'software-deployments';
const $67f07001968fe110$export$12efc96fc9c9fb34 = 'software-deployments-classic';
const $67f07001968fe110$export$a2ebabe0077b0970 = 'software-forms';
const $67f07001968fe110$export$590d764d6cf087ac = 'software-forms-classic';
const $67f07001968fe110$export$b8045610416fa8ca = 'software-goals';
const $67f07001968fe110$export$8e80136ad13099e3 = 'software-goals-classic';
const $67f07001968fe110$export$b5fe44c0bc324494 = 'software-incidents';
const $67f07001968fe110$export$7a4f52d9060a20d2 = 'software-incidents-classic';
const $67f07001968fe110$export$d6a9e4695952522e = 'software-issue-navigator';
const $67f07001968fe110$export$deab88d0814c564b = 'software-list';
const $67f07001968fe110$export$906faff110f898ef = 'software-list-classic';
const $67f07001968fe110$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
const $67f07001968fe110$export$4ed84a2011fdc400 = 'software-list-embed';
const $67f07001968fe110$export$f7b286b39bf6051b = 'software-nextgen-redirect';
const $67f07001968fe110$export$6c4337c0332c8c7f = 'software-onboarding';
const $67f07001968fe110$export$3805e4f07dca7584 = 'software-periscope';
const $67f07001968fe110$export$f77254983320e888 = 'software-periscope-classic';
const $67f07001968fe110$export$2e784832f1c6bb = 'software-plan-calendar';
const $67f07001968fe110$export$9e53cdb1ac02195c = 'software-plan-dependencies';
const $67f07001968fe110$export$7a821e22be2c2f14 = 'software-plan-increment';
const $67f07001968fe110$export$e7423156dba31a7c = 'software-plan-increments';
const $67f07001968fe110$export$cba7e383b2409c7b = 'software-plan-releases';
const $67f07001968fe110$export$d5378fb71d5242c0 = `${$67f07001968fe110$export$6f266218a6973848}-auto-scheduler`;
const $67f07001968fe110$export$4b16b72c72da8833 = `${$67f07001968fe110$export$6f266218a6973848}-custom-fields`;
const $67f07001968fe110$export$10114d78cefb1f53 = `${$67f07001968fe110$export$6f266218a6973848}-exclusion-rules`;
const $67f07001968fe110$export$92fe23ed30100817 = `${$67f07001968fe110$export$6f266218a6973848}-find-your-issue`;
const $67f07001968fe110$export$e824495554c83069 = `${$67f07001968fe110$export$6f266218a6973848}-issue-sources`;
const $67f07001968fe110$export$8df2e9efdd625a44 = `${$67f07001968fe110$export$6f266218a6973848}-permissions`;
const $67f07001968fe110$export$aeb4d3006e298033 = `${$67f07001968fe110$export$6f266218a6973848}-plan-info`;
const $67f07001968fe110$export$e15d3c40985c4b53 = `${$67f07001968fe110$export$6f266218a6973848}-program-boards`;
const $67f07001968fe110$export$1d8c84454fd2d571 = `${$67f07001968fe110$export$6f266218a6973848}-removed-issues`;
const $67f07001968fe110$export$db61a12efb59745c = `${$67f07001968fe110$export$6f266218a6973848}-saved-views`;
const $67f07001968fe110$export$2da67fb5bd6bc2ee = `${$67f07001968fe110$export$6f266218a6973848}-scenarios`;
const $67f07001968fe110$export$182e0167fd960de6 = `${$67f07001968fe110$export$6f266218a6973848}-scheduling`;
const $67f07001968fe110$export$2d9e2484ee02e7da = 'software-plan-summary';
const $67f07001968fe110$export$ea23f150f64e8a4e = 'software-plan-teams';
const $67f07001968fe110$export$116338bd93f78ad0 = 'software-plan-timeline';
const $67f07001968fe110$export$7a4b4b66d7637fbb = 'software-presentation-toolkit-report';
const $67f07001968fe110$export$d75d93e5d44182cc = 'software-release-notes';
const $67f07001968fe110$export$cc3027ae3767801 = 'software-reports';
const $67f07001968fe110$export$3492ce83b8884e0e = 'software-reports-burndown';
const $67f07001968fe110$export$b4798b7e62733393 = 'software-reports-burnup';
const $67f07001968fe110$export$388685c701d6e0d3 = 'software-reports-control';
const $67f07001968fe110$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
const $67f07001968fe110$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
const $67f07001968fe110$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
const $67f07001968fe110$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
const $67f07001968fe110$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
const $67f07001968fe110$export$ae0d999dd2bdd59b = 'software-reports-velocity';
const $67f07001968fe110$export$43bbf6935a91d277 = 'software-requests';
const $67f07001968fe110$export$92e23977438282b2 = 'software-requests-classic';
const $67f07001968fe110$export$296115eb5b7129d3 = 'software-roadmap';
const $67f07001968fe110$export$17574f41c3925d64 = 'software-roadmap-classic';
const $67f07001968fe110$export$955692fbfe35fc16 = 'software-roadmap-redirect';
const $67f07001968fe110$export$30af3a767b8ad2d8 = 'software-security';
const $67f07001968fe110$export$f47d664298c2c2f0 = 'software-security-classic';
const $67f07001968fe110$export$1714b5ad9b672bc7 = 'software-timeline';
const $67f07001968fe110$export$c9634bf15518a3a1 = 'software-timeline-classic';
const $67f07001968fe110$export$3b5eb3ea8cbeeed = 'software-version-detail';
const $67f07001968fe110$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
const $67f07001968fe110$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
const $67f07001968fe110$export$831acb5098f5706d = 'system-configuration-general';
const $67f07001968fe110$export$d218cda46c433fe1 = 'system-dashboard-edit';
const $67f07001968fe110$export$61147168ac2833f9 = 'trashed-plan-direct-link';
const $67f07001968fe110$export$9fe0117c0fd486a8 = 'trash-plans-directory';
const $67f07001968fe110$export$a49474778d15635d = 'trash-projects-directory';
const $67f07001968fe110$export$af3296e54e7fb362 = 'user-segmentation';
const $67f07001968fe110$export$281f2e01ee9e4977 = 'your-work';

});

parcelRegister("hHrVM", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $c6a3d716ac1fee91$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $c6a3d716ac1fee91$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $c6a3d716ac1fee91$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarProjectResource", () => $c6a3d716ac1fee91$export$c4cf7264f95bae78);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $c6a3d716ac1fee91$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $c6a3d716ac1fee91$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $c6a3d716ac1fee91$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $a5Lgz = parcelRequire("a5Lgz");

var $1ybV0 = parcelRequire("1ybV0");

var $l90Gp = parcelRequire("l90Gp");
var $7zhpa = parcelRequire("7zhpa");
var $4MmfV = parcelRequire("4MmfV");
var $I0t4m = parcelRequire("I0t4m");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");
var $eJCK9 = parcelRequire("eJCK9");
var $6OTFM = parcelRequire("6OTFM");

var $7JTqr = parcelRequire("7JTqr");

var $hawmT = parcelRequire("hawmT");

var $8mP0X = parcelRequire("8mP0X");

var $8yXY1 = parcelRequire("8yXY1");

var $cpkr0 = parcelRequire("cpkr0");

var $hlO97 = parcelRequire("hlO97");

var $dAKwA = parcelRequire("dAKwA");

var $jlBE2 = parcelRequire("jlBE2");

var $ellXt = parcelRequire("ellXt");

var $8Osbm = parcelRequire("8Osbm");

var $h0Ytu = parcelRequire("h0Ytu");

var $6XOSh = parcelRequire("6XOSh");

var $jD3pk = parcelRequire("jD3pk");

var $l6RYU = parcelRequire("l6RYU");

var $9CFDS = parcelRequire("9CFDS");

var $1NIhY = parcelRequire("1NIhY");

var $gF5SK = parcelRequire("gF5SK");

var $fKYF0 = parcelRequire("fKYF0");

var $ixwgj = parcelRequire("ixwgj");

var $grsJA = parcelRequire("grsJA");

var $3vlQh = parcelRequire("3vlQh");

var $3MEW8 = parcelRequire("3MEW8");

var $4uxD3 = parcelRequire("4uxD3");

var $jwzNs = parcelRequire("jwzNs");
const $c6a3d716ac1fee91$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ]);
const $c6a3d716ac1fee91$var$isModernIssueTransitionSettingEnabled = ()=>{
    const variation = $c6a3d716ac1fee91$var$getNewIssueTransitionExperienceInJiraLabsVariation();
    return variation !== 'OFF';
};
const $c6a3d716ac1fee91$var$OFF = 'Off';
const $c6a3d716ac1fee91$var$EAP = 'EAP';
const $c6a3d716ac1fee91$var$GA = 'GA';
const $c6a3d716ac1fee91$var$getPlanSidebarNavigationJiraLabsVariation = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('com.atlassian.rm.jpo.sidebar-navigation-jira-labs-variations', $c6a3d716ac1fee91$var$OFF, [
        $c6a3d716ac1fee91$var$OFF,
        $c6a3d716ac1fee91$var$EAP,
        $c6a3d716ac1fee91$var$GA
    ]);
const $c6a3d716ac1fee91$var$isPlanSidebarNavigationEnabled = ()=>{
    const variation = $c6a3d716ac1fee91$var$getPlanSidebarNavigationJiraLabsVariation();
    return variation === $c6a3d716ac1fee91$var$EAP || variation === $c6a3d716ac1fee91$var$GA;
};
const $c6a3d716ac1fee91$var$conditionalGicOptInStatusResource = (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create'), (0, $ellXt.gicOptInStatusResources));
const $c6a3d716ac1fee91$var$conditionalPlanNavigationSidebarOptInStatusResource = (0, $jwzNs.resourceWithCondition)($c6a3d716ac1fee91$var$isPlanSidebarNavigationEnabled, (0, $8mP0X.planSidebarNavigationOptInStatusResources));
const $c6a3d716ac1fee91$var$conditionalIssueTransitionOptInStatusResource = (0, $jwzNs.resourceWithCondition)($c6a3d716ac1fee91$var$isModernIssueTransitionSettingEnabled, (0, $6XOSh.issueTransitionOptInStatusResource));
const $c6a3d716ac1fee91$var$conditionalGicSmartFieldsOptoutResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr'), (0, $jlBE2.gicSmartFieldsFeatureResource));
const $c6a3d716ac1fee91$var$conditionalConsentBannerUserPreferencesResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2'), (0, $8yXY1.consentBannerUserPreferencesResource));
const $c6a3d716ac1fee91$var$conditionalIncomingMailServerExpiryStatusResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w'), (0, $8Osbm.incomingMailServerExpiryStatusResource));
const $c6a3d716ac1fee91$export$e1afa08027b1e44b = ()=>[
        $c6a3d716ac1fee91$var$conditionalIssueTransitionOptInStatusResource,
        (0, $h0Ytu.issueTransitionChangeboardingPreferencesResource)
    ];
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $c6a3d716ac1fee91$var$dedupableConditionalResources = [
    (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $hlO97.consolidationUserStateResource)),
    (0, $jwzNs.resourceWithCondition2)((0, $7JTqr.getWillShowNav4), (0, $7zhpa.sidebarNav4Resource)),
    (0, $jwzNs.resourceWithCondition2)((0, $7JTqr.getWillShowNav4), (0, $7zhpa.sidebarNav4UiStateResource))
];
const $c6a3d716ac1fee91$export$75cffd1aaecf4a2c = ()=>[
        (0, $1NIhY.navigationUiStateResource),
        (0, $hawmT.navigationPlansVisibilityResource),
        (0, $4uxD3.userHomepageResource),
        $c6a3d716ac1fee91$var$conditionalGicOptInStatusResource,
        (0, $a5Lgz.announcementBannerSettingsV4Resource),
        $c6a3d716ac1fee91$var$conditionalConsentBannerUserPreferencesResource,
        ...$c6a3d716ac1fee91$var$dedupableConditionalResources,
        (0, $jD3pk.organizationIdResource),
        (0, $3MEW8.themePreferenceResource),
        ...$c6a3d716ac1fee91$export$e1afa08027b1e44b(),
        $c6a3d716ac1fee91$var$conditionalPlanNavigationSidebarOptInStatusResource,
        (0, $fKYF0.persistentIssueCreateModalViewResource),
        $c6a3d716ac1fee91$var$conditionalGicSmartFieldsOptoutResource,
        $c6a3d716ac1fee91$var$conditionalIncomingMailServerExpiryStatusResource,
        (0, $grsJA.rovoEntitlementResource)
    ];
const $c6a3d716ac1fee91$export$c57dc1ea7f76f91f = ()=>[
        (0, $4MmfV.staticJSWUserBoardSidebarNavigationResource)
    ];
const $c6a3d716ac1fee91$export$c4cf7264f95bae78 = ()=>[
        (0, $3vlQh.incidentExperimentTraitResource),
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource),
        (0, $6OTFM.staticSoftwareProjectHorizontalNavResource)
    ];
const $c6a3d716ac1fee91$export$af2259a87f79645d = ()=>[
        (0, $jwzNs.resourceWithCondition2)($c6a3d716ac1fee91$var$isPlanSidebarNavigationEnabled, (0, $I0t4m.staticPlanSidebarNavigationResource))
    ];
const $c6a3d716ac1fee91$export$a103e99ad51f7bc3 = ()=>[
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('eoc-api-key-management-feature-jira_8ox4z'), (0, $cpkr0.checkApiKeyManagementKeysResource)())
    ];
const $c6a3d716ac1fee91$export$808691f5a412afa3 = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $l6RYU.navigationSidebarAutomationLegacyEnabledResource),
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $l90Gp.forgeProjectSettingsModuleResource),
        (0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("a5Lgz", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $7a3ce10da4ecebac$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $7a3ce10da4ecebac$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $jF6Sk = parcelRequire("jF6Sk");
var $iXfYO = parcelRequire("iXfYO");
var $6abiR = parcelRequire("6abiR");
const $7a3ce10da4ecebac$export$2a421cd16fa9a95a = (0, $6xFTe.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $jF6Sk.get)(),
            (0, $6abiR.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $7a3ce10da4ecebac$export$8fbe7f8de07afffd = (0, $6xFTe.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $iXfYO.get)(),
            (0, $6abiR.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $7a3ce10da4ecebac$export$43d4950a3e443fd3 = ()=>(0, $h5RgW.useResource)($7a3ce10da4ecebac$export$2a421cd16fa9a95a);
const $7a3ce10da4ecebac$export$6fb72f4a0c177494 = ()=>(0, $h5RgW.useResource)($7a3ce10da4ecebac$export$8fbe7f8de07afffd);

});
parcelRegister("jF6Sk", function(module, exports) {

$parcel$export(module.exports, "get", () => $baaff1b2e6f1885b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $baaff1b2e6f1885b$export$adaa4cf7ef1b65be);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $baaff1b2e6f1885b$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $lRmyA.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $baaff1b2e6f1885b$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $lRmyA.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $6015420733166380$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $6015420733166380$export$5e0c0e8c940630f8 = 'private';
const $6015420733166380$export$1d5a5b6462188eb3 = 'public';


parcelRegister("iXfYO", function(module, exports) {

$parcel$export(module.exports, "get", () => $58a9dca49db86568$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $58a9dca49db86568$export$adaa4cf7ef1b65be);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $58a9dca49db86568$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $lRmyA.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $guiFP.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $58a9dca49db86568$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $lRmyA.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("6abiR", function(module, exports) {

$parcel$export(module.exports, "get", () => $5e6a63cc908ec028$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $5e6a63cc908ec028$export$adaa4cf7ef1b65be);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

const $5e6a63cc908ec028$var$key = 'announcementBannerDismissedLast';
const $5e6a63cc908ec028$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $48bs8.getUserProperty)(accoundId, $5e6a63cc908ec028$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $5e6a63cc908ec028$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $48bs8.setUserProperties)(accoundId, $5e6a63cc908ec028$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
parcelRegister("48bs8", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $016bb9e2a17179ab$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $016bb9e2a17179ab$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $016bb9e2a17179ab$export$b3126db2ef6e34ed);

var $axhXb = parcelRequire("axhXb");

var $7EhAs = parcelRequire("7EhAs");
const $016bb9e2a17179ab$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $016bb9e2a17179ab$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(accountId, propertyKey), {
        ...(0, $axhXb.default),
        method: 'PUT',
        body: data
    });
const $016bb9e2a17179ab$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(accountId, propertyKey), (0, $axhXb.default)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $7EhAs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);

});
parcelRegister("axhXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1543ae6d5c00264$export$2e2bcd8739ae039);
const $d1543ae6d5c00264$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
var $d1543ae6d5c00264$export$2e2bcd8739ae039 = $d1543ae6d5c00264$var$defaultOptions;

});




parcelRegister("l90Gp", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $a5dfafe975dbf279$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $a5dfafe975dbf279$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $a5dfafe975dbf279$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $a5dfafe975dbf279$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $a5dfafe975dbf279$export$97b0827022fdafe3);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $a5dfafe975dbf279$export$e6be2f0ca0849869);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $a5dfafe975dbf279$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $a5dfafe975dbf279$export$dcc98f4b36ce9223);

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $8hg3R = parcelRequire("8hg3R");

var $fSEqj = parcelRequire("fSEqj");
const $a5dfafe975dbf279$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $8hg3R.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $a5dfafe975dbf279$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const { match: params } = route;
        const dataClassification = $a5dfafe975dbf279$export$eb46cc3d7c1a6649(params, moduleName);
        // isNonJSDModule variable to be removed with arken-1053-jira-forge-extension-changes-for-aegis_aws9x FF cleanup. It's been added to keep JSD and non-JSD modules
        // independent during rollout/rollback of the FFs
        const isNonJSDModule = moduleName !== (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE);
        let contextIds;
        if (isNonJSDModule && (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x')) contextIds = typeof createContextIds === 'function' && createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined;
        else if (!isNonJSDModule) contextIds = typeof createContextIds === 'function' && createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined;
        return (0, $fSEqj.fetchForgeModule)({
            cloudId: cloudId,
            moduleName: moduleName,
            dataClassification: dataClassification,
            shouldReturnANExtensions: shouldReturnANExtensions,
            contextIds: contextIds
        });
    };
const $a5dfafe975dbf279$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ];
const $a5dfafe975dbf279$export$b9489d8c5c5e3626 = (0, $6xFTe.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.ADMIN_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$72db683c2914a65e = (0, $6xFTe.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$7a928d209faf75f = (0, $6xFTe.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$e81e11bbc3239153 = ()=>(0, $h5RgW.useResource)($a5dfafe975dbf279$export$7a928d209faf75f);
const $a5dfafe975dbf279$export$97b0827022fdafe3 = (0, $6xFTe.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.GLOBAL_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$e6be2f0ca0849869 = (0, $6xFTe.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $hsX10.default)(cloudId, [
            (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)
        ], null, undefined, (0, $2Rqjr.SOURCE_NAVIGATION), (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') && $a5dfafe975dbf279$var$createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        .then((modules)=>modules.extensions.jiraCustomFieldType),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$ebf5369e4dcfad00 = (0, $6xFTe.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$dcc98f4b36ce9223 = ()=>[
        $a5dfafe975dbf279$export$b9489d8c5c5e3626
    ];

});
parcelRegister("2Rqjr", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $24e2ca1817bcdc8d$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $24e2ca1817bcdc8d$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $24e2ca1817bcdc8d$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $24e2ca1817bcdc8d$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $24e2ca1817bcdc8d$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $24e2ca1817bcdc8d$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $24e2ca1817bcdc8d$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $24e2ca1817bcdc8d$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $24e2ca1817bcdc8d$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $24e2ca1817bcdc8d$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $24e2ca1817bcdc8d$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $24e2ca1817bcdc8d$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $24e2ca1817bcdc8d$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $24e2ca1817bcdc8d$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $24e2ca1817bcdc8d$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $24e2ca1817bcdc8d$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $24e2ca1817bcdc8d$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $24e2ca1817bcdc8d$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $24e2ca1817bcdc8d$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $24e2ca1817bcdc8d$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $24e2ca1817bcdc8d$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $24e2ca1817bcdc8d$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $24e2ca1817bcdc8d$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $24e2ca1817bcdc8d$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $24e2ca1817bcdc8d$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $24e2ca1817bcdc8d$export$4346e4e240c84319);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $24e2ca1817bcdc8d$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $24e2ca1817bcdc8d$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $24e2ca1817bcdc8d$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $24e2ca1817bcdc8d$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$51ab2784839ce348);
const $24e2ca1817bcdc8d$export$9af0088c49bdedb = 'PRODUCTION';
const $24e2ca1817bcdc8d$export$71acbd662c478c42 = 'STAGING';
const $24e2ca1817bcdc8d$export$978072fd3fd149 = 'DEVELOPMENT';
const $24e2ca1817bcdc8d$export$ebc15d9cebfd6063 = 'default';
const $24e2ca1817bcdc8d$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $24e2ca1817bcdc8d$export$259bab989b0129d0 = 'jira:issueGlance';
const $24e2ca1817bcdc8d$export$75f224942f595e13 = 'jira:issueContext';
const $24e2ca1817bcdc8d$export$ba0968f9752844 = 'jira:issuePanel';
const $24e2ca1817bcdc8d$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $24e2ca1817bcdc8d$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $24e2ca1817bcdc8d$export$811b7f067a43b422 = 'jira:uiModifications';
const $24e2ca1817bcdc8d$export$e3887d6bafe8a17 = 'jira:customField';
const $24e2ca1817bcdc8d$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $24e2ca1817bcdc8d$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $24e2ca1817bcdc8d$export$151b03356f566603 = 'jira:projectPage';
const $24e2ca1817bcdc8d$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $24e2ca1817bcdc8d$export$31ac745ab2add7cc = 'jira:globalPage';
const $24e2ca1817bcdc8d$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $24e2ca1817bcdc8d$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $24e2ca1817bcdc8d$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $24e2ca1817bcdc8d$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $24e2ca1817bcdc8d$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $24e2ca1817bcdc8d$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $24e2ca1817bcdc8d$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $24e2ca1817bcdc8d$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7 = [
    $24e2ca1817bcdc8d$export$fcc4a18f46f80f16,
    $24e2ca1817bcdc8d$export$259bab989b0129d0,
    $24e2ca1817bcdc8d$export$75f224942f595e13,
    $24e2ca1817bcdc8d$export$ba0968f9752844,
    $24e2ca1817bcdc8d$export$cc20a5638825fbb0,
    $24e2ca1817bcdc8d$export$9069d4b945c3d532,
    $24e2ca1817bcdc8d$export$811b7f067a43b422,
    $24e2ca1817bcdc8d$export$e3887d6bafe8a17,
    $24e2ca1817bcdc8d$export$7b7866c04a2ad947,
    $24e2ca1817bcdc8d$export$52e4945e96bd2aa0,
    $24e2ca1817bcdc8d$export$151b03356f566603,
    $24e2ca1817bcdc8d$export$ea0d6ac082b0d636,
    $24e2ca1817bcdc8d$export$31ac745ab2add7cc,
    $24e2ca1817bcdc8d$export$353acf28daa75c79,
    $24e2ca1817bcdc8d$export$25627f012b21b0b9,
    $24e2ca1817bcdc8d$export$8af4cb794979f60d,
    $24e2ca1817bcdc8d$export$5592ab836d562168,
    $24e2ca1817bcdc8d$export$842eb4236828ac9,
    $24e2ca1817bcdc8d$export$42d6a8740fd42e58,
    $24e2ca1817bcdc8d$export$a7186e5a73395db4,
    $24e2ca1817bcdc8d$export$8fbcfe84dc845d17
];
const $24e2ca1817bcdc8d$export$2b8aeda236486576 = 'edit';
const $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d = 'view';
const $24e2ca1817bcdc8d$export$b37d58c3ed77c139 = 'create';
const $24e2ca1817bcdc8d$export$ab94dbd1d02ac251 = 'contextConfig';
const $24e2ca1817bcdc8d$export$b6a67a3131c6c48d = 'none';
const $24e2ca1817bcdc8d$export$b75dc2bfd20898fe = 5;
const $24e2ca1817bcdc8d$export$8e96118a698216cb = 'native';
const $24e2ca1817bcdc8d$export$9b72a8e9b92658fb = 'basic';
const $24e2ca1817bcdc8d$export$2d6539e7d0553ae7 = 'blank';
const $24e2ca1817bcdc8d$export$ecbd7135d66cb322 = 'unknownSource';
const $24e2ca1817bcdc8d$export$61d882aa7aba51c = 'global-issue-create';
const $24e2ca1817bcdc8d$export$46cb92762d68a048 = 'issue-view';
const $24e2ca1817bcdc8d$export$fe90e46aea58e30b = 'navigation';
const $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a = 'full-page-app';
const $24e2ca1817bcdc8d$export$eae46a3c13473a8d = 'router';
const $24e2ca1817bcdc8d$export$ac11ee191d09688f = 'legacy';
const $24e2ca1817bcdc8d$export$6d00582aa947900f = 'workflow-list';
const $24e2ca1817bcdc8d$export$4346e4e240c84319 = 'organization-panel';
const $24e2ca1817bcdc8d$export$bf75cf7720bd8fde = 'transition-view';
const $24e2ca1817bcdc8d$export$4b6228758e800433 = 'jira';
const $24e2ca1817bcdc8d$export$70495c8cc141a7a4 = 'jsm';
const $24e2ca1817bcdc8d$export$bc3d408418fdf9d2 = 'cmdb';
const $24e2ca1817bcdc8d$export$a48dade1864725a = {
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$24e2ca1817bcdc8d$export$a48dade1864725a
};
const $24e2ca1817bcdc8d$export$218a328f66b86f7d = ()=>({
        ...$24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $24e2ca1817bcdc8d$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $24e2ca1817bcdc8d$export$df7774a415710cce = 'com.atlassian.forge:';
const $24e2ca1817bcdc8d$export$51ab2784839ce348 = `${$24e2ca1817bcdc8d$export$df7774a415710cce}${$24e2ca1817bcdc8d$export$3193d714ab54ee26}`;

});

parcelRegister("hsX10", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5bab9bca496d0a$export$2e2bcd8739ae039);

var $jh2R9 = parcelRequire("jh2R9");

var $fcWBJ = parcelRequire("fcWBJ");

var $cnRoI = parcelRequire("cnRoI");

var $2vzCR = parcelRequire("2vzCR");

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $eTZsp = parcelRequire("eTZsp");

var $cHWHh = parcelRequire("cHWHh");

var $hRcYT = parcelRequire("hRcYT");

var $ibWQr = parcelRequire("ibWQr");

var $2Rqjr = parcelRequire("2Rqjr");

var $2NB1f = parcelRequire("2NB1f");

var $02sMi = parcelRequire("02sMi");

var $iD9au = parcelRequire("iD9au");

var $c10S5 = parcelRequire("c10S5");

var $dkvex = parcelRequire("dkvex");

var $8ZBIo = parcelRequire("8ZBIo");
const $df5bab9bca496d0a$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(module);
const $df5bab9bca496d0a$export$3361e9be8093ddcc = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $df5bab9bca496d0a$var$moduleToVariableKey(key));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(groupedExtensionsWithMappedKeys, (0, $2Rqjr.getEmptyExtensionsObject)());
};
const $df5bab9bca496d0a$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>$df5bab9bca496d0a$var$moduleToVariableKey(key)), (0, $2Rqjr.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $02sMi.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $df5bab9bca496d0a$var$EXCLUDED_ERROR_TYPES = [
    (0, $eTZsp.FAILED_TO_FETCH),
    (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
];
const $df5bab9bca496d0a$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source)=>{
    if (modules.length === 0) throw new Error('No modules to fetch provided');
    const dataClassificationTags = await (0, $iD9au.getDataClassification)(dataClassification, source);
    const includeConfig = extras?.include || {};
    const query = (0, $8ZBIo.buildForgeQuery)(includeConfig);
    const variables = {
        contextIds: contextIds || [
            `ari:cloud:jira::site/${cloudId}`
        ],
        extensionsFilter: [
            {
                type: 'EXTENSION_TYPE',
                value: modules
            }
        ],
        dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`)
    };
    const { data: data, errors: errors, extensions: extensions } = await (0, $cHWHh.measureExecutionTimeMetrics)(()=>(0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            method: 'POST'
        }));
    const traceId = (0, $dkvex.getTraceIdFromExtensions)({
        extensions: extensions
    });
    if (errors) throw new (0, $c10S5.ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
    if (!data) throw new (0, $c10S5.ForgeFetchError)('No data returned', traceId, errors);
    if (data.extensionContexts.length < 1) throw new (0, $c10S5.ForgeFetchError)('No extensionContext returned', traceId, errors);
    return {
        data: data,
        traceId: traceId
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df5bab9bca496d0a$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, $2Rqjr.SOURCE_UNKNOWN), contextIds)=>{
    try {
        // Just in case something goes very much wrong we don't want to call the XIS
        if (!(0, $2NB1f.canFetchForgeModules)()) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        const { data: data, traceId: traceId } = await $df5bab9bca496d0a$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source);
        if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source, {
            traceId: traceId
        });
        return $df5bab9bca496d0a$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const errorType = (0, $eTZsp.getErrorType)(error);
        const traceId = (0, $dkvex.getTraceIdFromError)(error);
        (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error,
            traceId: traceId
        });
        if ($df5bab9bca496d0a$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        throw error;
    }
};

});
parcelRegister("eTZsp", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $11a471eb077355bb$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $11a471eb077355bb$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $11a471eb077355bb$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $11a471eb077355bb$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $11a471eb077355bb$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $11a471eb077355bb$export$e19f9f08a6d79fd2);

var $7rh0R = parcelRequire("7rh0R");


var $JRB5w = parcelRequire("JRB5w");
const $11a471eb077355bb$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
    GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
};
const $11a471eb077355bb$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $11a471eb077355bb$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $11a471eb077355bb$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $11a471eb077355bb$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $11a471eb077355bb$export$89a175d4190df42e = 'Invoke value functions failed:';
const $11a471eb077355bb$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $11a471eb077355bb$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $7rh0R.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $11a471eb077355bb$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return 'NULL_OR_UNDEFINED';
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $11a471eb077355bb$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $11a471eb077355bb$export$23de3198bfe70090;
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($11a471eb077355bb$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($11a471eb077355bb$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($11a471eb077355bb$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($11a471eb077355bb$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $JRB5w.isClientFetchError)(error)) return $11a471eb077355bb$export$f52aa41ccd776f01;
    return 'OTHER';
};

});

parcelRegister("cHWHh", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $69ad25e8e60753eb$export$a859f6866f4653e0);

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $hRcYT = parcelRequire("hRcYT");

var $d6g7g = parcelRequire("d6g7g");
const $69ad25e8e60753eb$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
    const shouldSendTimeMetric = !(0, $1ybV0.ff)('fetch-forge-modules-sampling_1e415') || Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE);
    if ((0, $eI5EY.fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
    else try {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).stop({
            stopTime: performance.now()
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).cancel();
        throw error;
    }
};

});
parcelRegister("hRcYT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $7ddaf55383536638$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $7ddaf55383536638$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $7ddaf55383536638$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $7ddaf55383536638$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $7ddaf55383536638$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $7ddaf55383536638$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $7ddaf55383536638$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $7ddaf55383536638$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $7ddaf55383536638$export$f892f621fb508154 = 'jiraForgeUi';
const $7ddaf55383536638$export$273f5980517336e2 = 'jiraforgeui';
const $7ddaf55383536638$export$ed63b053e04e26df = 'trigger';
const $7ddaf55383536638$export$725bacc669333eef = 'extension';
const $7ddaf55383536638$export$d920cee73ec094d0 = 10;
const $7ddaf55383536638$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $7ddaf55383536638$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $7ddaf55383536638$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $7ddaf55383536638$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("d6g7g", function(module, exports) {

$parcel$export(module.exports, "forgeModulesFetchTime", () => $2f54a22cce56cf6f$export$cd129f3639657eae);
$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $2f54a22cce56cf6f$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $2f54a22cce56cf6f$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $2f54a22cce56cf6f$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $2f54a22cce56cf6f$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $2f54a22cce56cf6f$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $2f54a22cce56cf6f$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $2f54a22cce56cf6f$export$a318f99472db73c8);

var $lNfG4 = parcelRequire("lNfG4");

var $8uNQc = parcelRequire("8uNQc");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $hRcYT = parcelRequire("hRcYT");
const $2f54a22cce56cf6f$export$cd129f3639657eae = (0, $lNfG4.metrics).custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $2f54a22cce56cf6f$export$c3d8833fbea3e976 = (0, $lNfG4.metrics).concurrent.custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $2f54a22cce56cf6f$export$292f3b557281044f = (0, $lNfG4.metrics).concurrent.custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $2f54a22cce56cf6f$export$89ace7e2bb7d7685 = new (0, $kDfSL.UFOExperience)((0, $hRcYT.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
async function $2f54a22cce56cf6f$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $8uNQc.default).getEntriesByName(startMark).length > 0 || (0, $8uNQc.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $8uNQc.default).mark(startMark);
    const result = await fn();
    (0, $8uNQc.default).mark(endMark);
    return result;
}
const $2f54a22cce56cf6f$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $8uNQc.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $8uNQc.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $8uNQc.default).clearMarks(name);
    });
};
const $2f54a22cce56cf6f$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $2f54a22cce56cf6f$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $lNfG4.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("ibWQr", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2c36a22053951caa$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2c36a22053951caa$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2c36a22053951caa$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2c36a22053951caa$export$b274c658390b491b);

var $TrUS5 = parcelRequire("TrUS5");

var $cYWDh = parcelRequire("cYWDh");
const $2c36a22053951caa$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2c36a22053951caa$export$917d0643b0111a02 = (0, $TrUS5.toEventId)('issueViewInitialization');
const $2c36a22053951caa$export$43e875fd63e64525 = (0, $TrUS5.toEventId)('fetchModulesInitialization');
const $2c36a22053951caa$export$132ca822850e455f = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b274c658390b491b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("TrUS5", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $157b5a46da0774f4$export$75e84ef5a3771f9a);
const $157b5a46da0774f4$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("cYWDh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $6b16192b91ad756a$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $6b16192b91ad756a$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $6b16192b91ad756a$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $6b16192b91ad756a$export$390a62413962e4f0);

var $3FyZ4 = parcelRequire("3FyZ4");

var $hRcYT = parcelRequire("hRcYT");

var $bBGpO = parcelRequire("bBGpO");

var $7ALvE = parcelRequire("7ALvE");

var $29pIG = parcelRequire("29pIG");
const $6b16192b91ad756a$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hRcYT.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $bBGpO.createAttributes)(attributes),
        source: source,
        action: action
    });
const $6b16192b91ad756a$var$getAnalyticsClient = async ()=>(await (0, $3FyZ4.getAnalyticsWebClientPromise)()).getInstance();
const $6b16192b91ad756a$var$sendOperationalEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendOperationalEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendUiEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendUIEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendTrackEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendTrackEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendUiEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendTrackEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $6b16192b91ad756a$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7ALvE.logError)((0, $7ALvE.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $29pIG.isSynthetic)().toString()}, id=${id}, source=${(0, $bBGpO.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("bBGpO", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $c13c8af67eb85442$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $c13c8af67eb85442$export$c7c9603a6b1fd815);

var $7PHyj = parcelRequire("7PHyj");

var $f4SFV = parcelRequire("f4SFV");

var $eTZsp = parcelRequire("eTZsp");

var $29pIG = parcelRequire("29pIG");
const $c13c8af67eb85442$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $c13c8af67eb85442$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $c13c8af67eb85442$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $29pIG.isSynthetic)(),
        isOverridingFragments: (0, $f4SFV.isOverridingFragments)(),
        isSSR: false
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $c13c8af67eb85442$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $c13c8af67eb85442$export$78c6267359db7e73(error);
            attributes.errorType = (0, $eTZsp.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7PHyj)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("f4SFV", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $131b22271a46e6fc$export$1d1321d2b374d697);
const $131b22271a46e6fc$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("29pIG", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $4e7b61ea3e7b237b$export$947749d756ccb0a);

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");
const $4e7b61ea3e7b237b$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('issue.details.forge-ui-synthetic-check');

});


parcelRegister("7ALvE", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $d44e65d0fc9da8f1$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $d44e65d0fc9da8f1$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $d44e65d0fc9da8f1$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $hRcYT = parcelRequire("hRcYT");
const $d44e65d0fc9da8f1$export$e31edcd35abe3bb1 = 'environment-mapping';
const $d44e65d0fc9da8f1$export$d1e4f308040bb0d5 = 'analytics';
const $d44e65d0fc9da8f1$export$36f315a5c6daf40b = 'custom-field-object-type';
const $d44e65d0fc9da8f1$export$6ee8198f29fffdb4 = {
    [$d44e65d0fc9da8f1$export$d1e4f308040bb0d5]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$d44e65d0fc9da8f1$export$e31edcd35abe3bb1]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$d44e65d0fc9da8f1$export$36f315a5c6daf40b]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $d44e65d0fc9da8f1$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($d44e65d0fc9da8f1$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("2NB1f", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $54017b90132e06f5$export$bb3a4a3b8e654c08);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy

var $e91YZ = parcelRequire("e91YZ");
const $54017b90132e06f5$export$bb3a4a3b8e654c08 = ()=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    // There is no anonymous access for now
    return !isAnonymous;
};

});

parcelRegister("02sMi", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $e5793a48e1add67f$export$e0393e97f15a28a5);

var $fUTZC = parcelRequire("fUTZC");

var $2Rqjr = parcelRequire("2Rqjr");
const $e5793a48e1add67f$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $2Rqjr.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("iD9au", function(module, exports) {

$parcel$export(module.exports, "getDataClassification", () => $afc4148764d3af06$export$1635afa94064952c);

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $eTZsp = parcelRequire("eTZsp");

var $ibWQr = parcelRequire("ibWQr");

var $7i1xd = parcelRequire("7i1xd");

var $fvGQu = parcelRequire("fvGQu");
const $afc4148764d3af06$var$handleError = (err, source)=>{
    const errorMessage = err instanceof Error ? err.message : String(err);
    const error = Error(`Data classification request failed: ${errorMessage}`);
    const errorType = (0, $eTZsp.getErrorType)(error);
    // prevent fetching extensions in case of no access
    if (errorType === (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)) throw error;
    (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
        isSSR: false,
        errorType: errorType,
        error: error
    });
    // otherwise, optimistically fetch the extensions
    return [];
};
async function $afc4148764d3af06$var$getDataClassificationIssue(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $fvGQu.DataClassificationTagsCache).get(`${(0, $fvGQu.issueKeyPrefix)}-${props.issueKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $fvGQu.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
            (0, $fvGQu.DataClassificationTagsCache).set(`${(0, $fvGQu.issueKeyPrefix)}-${props.issueKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $afc4148764d3af06$var$handleError(err, source);
    }
}
async function $afc4148764d3af06$var$getDataClassificationProject(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $fvGQu.DataClassificationTagsCache).get(`${(0, $fvGQu.projectKeyPrefix)}-${props.projectIdOrKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $fvGQu.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
            (0, $fvGQu.DataClassificationTagsCache).set(`${(0, $fvGQu.projectKeyPrefix)}-${props.projectIdOrKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $afc4148764d3af06$var$handleError(err, source);
    }
}
const $afc4148764d3af06$export$1635afa94064952c = async (props, source)=>{
    if (props !== null) {
        if ((0, $7i1xd.hasPrefetchedData)(props)) return props.tags;
        if ((0, $7i1xd.hasProjectIdOrKey)(props)) {
            const tags = await $afc4148764d3af06$var$getDataClassificationProject(props, source);
            return tags;
        }
        if ((0, $7i1xd.hasIssueKey)(props)) {
            const tags = await $afc4148764d3af06$var$getDataClassificationIssue(props, source);
            return tags;
        }
    }
    return [];
};

});
parcelRegister("7i1xd", function(module, exports) {

$parcel$export(module.exports, "hasPrefetchedData", () => $f4d16f0e4c0cff8e$export$c19d255b92c7c2da);
$parcel$export(module.exports, "hasProjectIdOrKey", () => $f4d16f0e4c0cff8e$export$494434246e5dea0d);
$parcel$export(module.exports, "hasIssueKey", () => $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b);

var $1c8hB = parcelRequire("1c8hB");
const $f4d16f0e4c0cff8e$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(props.tags);
const $f4d16f0e4c0cff8e$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
const $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;

});

parcelRegister("fvGQu", function(module, exports) {

$parcel$export(module.exports, "TTL", () => $e29cae659811c7d2$export$6ebb1381174e92a7);
$parcel$export(module.exports, "issueKeyPrefix", () => $e29cae659811c7d2$export$a040db2850f159b0);
$parcel$export(module.exports, "projectKeyPrefix", () => $e29cae659811c7d2$export$df256a06d24ff906);
$parcel$export(module.exports, "DataClassificationTagsCache", () => $e29cae659811c7d2$export$b7adc37405b5ff0d);
const $e29cae659811c7d2$export$6ebb1381174e92a7 = 60000;
const $e29cae659811c7d2$export$a040db2850f159b0 = 'issue';
const $e29cae659811c7d2$export$df256a06d24ff906 = 'project';
const $e29cae659811c7d2$export$b7adc37405b5ff0d = new Map();

});


parcelRegister("c10S5", function(module, exports) {

$parcel$export(module.exports, "ForgeFetchError", () => $be007d6d4af22f2a$export$2e3b53e53bafa);
class $be007d6d4af22f2a$export$2e3b53e53bafa extends Error {
    constructor(message, traceId, errors){
        super(message);
        this.name = $be007d6d4af22f2a$export$2e3b53e53bafa.name;
        this.traceId = traceId;
        this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $be007d6d4af22f2a$export$2e3b53e53bafa);
    }
}

});

parcelRegister("dkvex", function(module, exports) {

$parcel$export(module.exports, "getTraceIdFromExtensions", () => $de55799bed033deb$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getTraceIdFromError", () => $de55799bed033deb$export$9955d05ba83067ba);

var $7byHA = parcelRequire("7byHA");

var $c10S5 = parcelRequire("c10S5");
const $de55799bed033deb$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    const traceId = extensions?.gateway?.request_id;
    if (traceId && typeof traceId === 'string') return traceId;
    return undefined;
};
const $de55799bed033deb$export$9955d05ba83067ba = (error)=>{
    if (error instanceof (0, $c10S5.ForgeFetchError) || error instanceof (0, $7byHA.default)) return error.traceId;
    return undefined;
};

});

parcelRegister("8ZBIo", function(module, exports) {

$parcel$export(module.exports, "buildForgeQuery", () => $a2e306a4af3081df$export$497b2dc04db7bd76);

var $1ybV0 = parcelRequire("1ybV0");
const $a2e306a4af3081df$export$497b2dc04db7bd76 = (include)=>{
    const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
    const scopesField = include.scopes === true ? 'scopes' : '';
    const capabilitySetField = (0, $1ybV0.ff)('platform.forge-ui.license-capability-set') ? 'capabilitySet' : '';
    const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
		    ${capabilitySetField}
    }`;
    return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
};

});


parcelRegister("8hg3R", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $07950346cbbaf790$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $07950346cbbaf790$export$b87af5b274141bd6);

var $9zYls = parcelRequire("9zYls");
const $07950346cbbaf790$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $07950346cbbaf790$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});
parcelRegister("9zYls", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyId", () => $5d8459da4a60e5c9$export$1f7213d0f9054f06);
const $5d8459da4a60e5c9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
    const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("fSEqj", function(module, exports) {

$parcel$export(module.exports, "fetchForgeModule", () => $8729e3f9c8f23451$export$e1683e15cedb5f17);

var $jh2R9 = parcelRequire("jh2R9");

var $h1xZf = parcelRequire("h1xZf");

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $6vrw7 = parcelRequire("6vrw7");

var $4MOAS = parcelRequire("4MOAS");
const $8729e3f9c8f23451$var$dataClassificatedModulesConfig = {
    names: new Set(),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    request: Promise.resolve({})
};
const $8729e3f9c8f23451$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds })=>{
    $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names.add(moduleName);
    // simulate next tick so other resources could register their modules to fetch
    await new Promise((resolve)=>setTimeout(resolve, 0));
    const moduleNamesToFetch = Array.from($8729e3f9c8f23451$var$dataClassificatedModulesConfig.names);
    let extensions = [];
    let accessNarrowedExtensions = [];
    // If the fetch is not already handled
    if (moduleNamesToFetch.length > 0) {
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names = new Set();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request = (0, $hsX10.default)((0, $6vrw7.toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, $2Rqjr.SOURCE_FULL_PAGE_APP), contextIds).then((extensionsMap)=>extensionsMap);
    }
    const result = await $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request;
    extensions = result.extensions[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(moduleName)];
    if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(moduleName)];
    const getExtensionsFilter = (fullPageModuleName)=>{
        switch(fullPageModuleName){
            case 0, $2Rqjr.ADMIN_PAGE_MODULE:
                return 0, $4MOAS.adminPageFilter;
            default:
                // filtered, as we allow only one extension per module
                return 0, $4MOAS.uniqueExtensionsFilter;
        }
    };
    return {
        extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title)),
        accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title))
    };
};

});
parcelRegister("h1xZf", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1);

var $gUUjF = parcelRequire("gUUjF");
const $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $gUUjF.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("4MOAS", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $7eebe06f4aced941$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $7eebe06f4aced941$export$1eefd1d9cde49fd5);

var $lyOYo = parcelRequire("lyOYo");

var $70ON1 = parcelRequire("70ON1");
const $7eebe06f4aced941$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $7eebe06f4aced941$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const adminExtensions = extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("70ON1", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $46692d02f47d8a1d$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $46692d02f47d8a1d$export$a92b17288693d366);
const $46692d02f47d8a1d$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $46692d02f47d8a1d$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});




parcelRegister("7zhpa", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $57db5858a67a5074$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $57db5858a67a5074$export$a46129bd512544d7);

var $20jcc = parcelRequire("20jcc");

var $4ursw = parcelRequire("4ursw");

var $i8H41 = parcelRequire("i8H41");

var $2Kryv = parcelRequire("2Kryv");

var $buJlM = parcelRequire("buJlM");

var $buJlM = parcelRequire("buJlM");

var $hkmE9 = parcelRequire("hkmE9");

var $bckG1 = parcelRequire("bckG1");
const $57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $57db5858a67a5074$export$7648dc6f76f4f83d = (0, $buJlM.createRelayResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const initialSelectedPath = (0, $i8H41.getInitialSelectedPath)(routerContext);
        // console.log('Route name', routerContext.route.name);
        return {
            parameters: (0, $hkmE9.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $2Kryv.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_APPS)),
                isDashboardsExpanded: (0, $2Kryv.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_DASHBOARDS)),
                isFiltersExpanded: (0, $2Kryv.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $20jcc.isPlanRoute)(routerContext),
                isProjectsExpanded: (0, $2Kryv.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $2Kryv.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_OPERATIONS))
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $57db5858a67a5074$export$a46129bd512544d7 = (0, $buJlM.createRelayResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $bckG1.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("20jcc", function(module, exports) {

$parcel$export(module.exports, "useIsPlanUrl", () => $3d824212db695c8f$export$c892a721bc19437f);
$parcel$export(module.exports, "isPlanRoute", () => $3d824212db695c8f$export$a7cfc620f2f80f6);

var $lB25E = parcelRequire("lB25E");
function $3d824212db695c8f$export$c892a721bc19437f() {
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const [planId] = (0, $lB25E.usePathParam)('planId');
    return $3d824212db695c8f$var$isPlanUrl(location.pathname, planId);
}
function $3d824212db695c8f$export$a7cfc620f2f80f6(routerContext) {
    const { match: match } = routerContext;
    const planId = match.params.planId;
    return $3d824212db695c8f$var$isPlanUrl(match.path, planId);
}
function $3d824212db695c8f$var$isPlanUrl(path, planId) {
    if (planId) return true;
    // TODO: Support other miscellaneous plan urls, such as reports
    return Boolean(path === '/jira/plans');
}

});

parcelRegister("4ursw", function(module, exports) {

$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $520542fb506bd92b$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $520542fb506bd92b$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $520542fb506bd92b$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $520542fb506bd92b$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $520542fb506bd92b$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $520542fb506bd92b$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $520542fb506bd92b$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $520542fb506bd92b$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $520542fb506bd92b$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $520542fb506bd92b$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $520542fb506bd92b$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $520542fb506bd92b$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $520542fb506bd92b$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $520542fb506bd92b$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $520542fb506bd92b$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $520542fb506bd92b$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $520542fb506bd92b$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECT_JSM_CHANGES", () => $520542fb506bd92b$export$f9acefb690d6e79b);
$parcel$export(module.exports, "MENU_ID_PROJECT_JSM_DIR", () => $520542fb506bd92b$export$e682260eda678e61);
$parcel$export(module.exports, "MENU_ID_PROJECT_JSM_INCIDENTS", () => $520542fb506bd92b$export$fef15e6f1ed7626a);
$parcel$export(module.exports, "MENU_ID_PROJECT_JSM_PROBLEMS", () => $520542fb506bd92b$export$89d221dab5405087);
$parcel$export(module.exports, "MENU_ID_PROJECT_JSM_SERVICE_REQUESTS", () => $520542fb506bd92b$export$96f8a4078a2c98f2);
$parcel$export(module.exports, "MENU_ID_PROJECT_JSM_POST_INCIDENT", () => $520542fb506bd92b$export$5661df61abba7d91);
$parcel$export(module.exports, "MENU_ID_PROJECT_QUEUES", () => $520542fb506bd92b$export$3bec67273a78f6cb);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $520542fb506bd92b$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $520542fb506bd92b$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $520542fb506bd92b$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $520542fb506bd92b$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $520542fb506bd92b$export$80dc576e446bdb6b);
// These IDs are used with the user-customisable navigation service.
const $520542fb506bd92b$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams'
};
const $520542fb506bd92b$export$103ff18fe29ee1b = {
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_JSM_DIR_ORGS: (projectKey)=>`proj-${projectKey}-dir-org`,
    PROJECT_JSM_DIR_CUSTOMERS: (projectKey)=>`proj-${projectKey}-dir-cust`,
    PROJECT_JSM_DIR_PRODUCTS: (projectKey)=>`proj-${projectKey}-dir-prod`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $520542fb506bd92b$export$441cd608ea3204f4 = $520542fb506bd92b$export$7838b734e4cd5e8d.APPS;
const $520542fb506bd92b$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $520542fb506bd92b$export$75c65bfc98b3a6e1 = $520542fb506bd92b$export$7838b734e4cd5e8d.ASSETS;
const $520542fb506bd92b$export$dd009509c2dabb5e = $520542fb506bd92b$export$7838b734e4cd5e8d.DASHBOARDS;
const $520542fb506bd92b$export$d3da0455b4200fb2 = 'dash-view';
const $520542fb506bd92b$export$b9dd2b5309d19763 = 'dash-view-starred';
const $520542fb506bd92b$export$3d81af172a8e3c57 = $520542fb506bd92b$export$7838b734e4cd5e8d.FILTERS;
const $520542fb506bd92b$export$1e2599eaf0039a97 = 'filt-search';
const $520542fb506bd92b$export$53d274d993c9d5b5 = 'filt-view-all';
const $520542fb506bd92b$export$7661ea763be69cfa = 'filt-view-starred';
const $520542fb506bd92b$export$ef89639b7d9c162a = $520542fb506bd92b$export$7838b734e4cd5e8d.OPERATIONS;
const $520542fb506bd92b$export$3bd12c092f8db11b = $520542fb506bd92b$export$7838b734e4cd5e8d.OVERVIEWS;
const $520542fb506bd92b$export$f2533da33c749933 = $520542fb506bd92b$export$7838b734e4cd5e8d.PLANS;
const $520542fb506bd92b$export$8468c5b6648f4f1f = 'plan-view-all';
const $520542fb506bd92b$export$fed17b4c0866b97d = 'proj-app';
const $520542fb506bd92b$export$f9acefb690d6e79b = 'proj-jsm-chng';
const $520542fb506bd92b$export$e682260eda678e61 = 'proj-dir';
const $520542fb506bd92b$export$fef15e6f1ed7626a = 'proj-jsm-inci';
const $520542fb506bd92b$export$89d221dab5405087 = 'proj-jsm-prob';
const $520542fb506bd92b$export$96f8a4078a2c98f2 = 'proj-jsm-sr';
const $520542fb506bd92b$export$5661df61abba7d91 = 'proj-jsm-pir';
const $520542fb506bd92b$export$3bec67273a78f6cb = 'proj-queu';
const $520542fb506bd92b$export$9c5278bd360a285 = $520542fb506bd92b$export$7838b734e4cd5e8d.PROJECTS;
const $520542fb506bd92b$export$85389c606bb641dd = 'proj-view-all';
const $520542fb506bd92b$export$4a1974b63c858e9c = 'proj-view-starred';
const $520542fb506bd92b$export$d4f6fcf571f9c50 = $520542fb506bd92b$export$7838b734e4cd5e8d.TEAMS;
const $520542fb506bd92b$export$80dc576e446bdb6b = 'yrwk';

});

parcelRegister("i8H41", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $e180fca36617e2fa$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use
 * this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To workaround THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $6l6Xk = parcelRequire("6l6Xk");

var $8SNie = parcelRequire("8SNie");
const $e180fca36617e2fa$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))((0, $8SNie.routeToSelectedPath));

});
parcelRegister("8SNie", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $e0a788123df7170a$export$a92474c098a1fd13);

var $dVFze = parcelRequire("dVFze");

var $7l6Vc = parcelRequire("7l6Vc");

var $l9iHq = parcelRequire("l9iHq");

var $kQKHc = parcelRequire("kQKHc");

var $6QMa1 = parcelRequire("6QMa1");

var $3RDtj = parcelRequire("3RDtj");

var $1403f = parcelRequire("1403f");

var $aukag = parcelRequire("aukag");

var $dbLx9 = parcelRequire("dbLx9");
function $e0a788123df7170a$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $3RDtj.topLevelConverter).routes.has(routeName)) return (0, $3RDtj.topLevelConverter).convert(routeContext);
    if ((0, $dVFze.appsConverter).routes.has(routeName)) return (0, $dVFze.appsConverter).convert(routeContext);
    if ((0, $7l6Vc.assetsConverter).routes.has(routeName)) return (0, $7l6Vc.assetsConverter).convert(routeContext);
    if ((0, $l9iHq.dashboardsConverter).routes.has(routeName)) return (0, $l9iHq.dashboardsConverter).convert(routeContext);
    if ((0, $kQKHc.filtersConverter).routes.has(routeName)) return (0, $kQKHc.filtersConverter).convert(routeContext);
    if ((0, $6QMa1.operationsConverter).routes.has(routeName)) return (0, $6QMa1.operationsConverter).convert(routeContext);
    if ((0, $1403f.overviewsConverter).routes.has(routeName)) return (0, $1403f.overviewsConverter).convert(routeContext);
    if ((0, $1403f.overviewsConverter).routes.has(routeName)) return (0, $1403f.overviewsConverter).convert(routeContext);
    if ((0, $aukag.plansConverter).routes.has(routeName)) return (0, $aukag.plansConverter).convert(routeContext);
    if ((0, $dbLx9.projectsConverter).routes.has(routeName)) return (0, $dbLx9.projectsConverter).convert(routeContext);
    return [];
}

});
parcelRegister("dVFze", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $52271f2e4d1a0e26$export$d017a63045c88c47);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
// TODO: verify these routes
const $52271f2e4d1a0e26$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID),
    (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
    (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT)
];
const $52271f2e4d1a0e26$var$CERTAIN_APPS_SECTION_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL),
    (0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX)
];
const $52271f2e4d1a0e26$export$66b32f6f30eb4b4 = new Set([
    ...$52271f2e4d1a0e26$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$52271f2e4d1a0e26$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $52271f2e4d1a0e26$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_APPS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX:
            path.push((0, $4ursw.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL:
        case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID:
        case 0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
            path.push((0, $4ursw.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT:
        case 0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $4ursw.MENU_ID_PROJECTS),
                    (0, $4ursw.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $4ursw.MENU_ID_PROJECTS),
                    (0, $4ursw.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $52271f2e4d1a0e26$export$d017a63045c88c47 = {
    routes: $52271f2e4d1a0e26$export$66b32f6f30eb4b4,
    convert: $52271f2e4d1a0e26$var$convert
};

});

parcelRegister("7l6Vc", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $530acac62a39df2a$export$6cfeba0849032a84);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $530acac62a39df2a$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
    // TODO: sort this out when we come to asset routes:
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
]);
function $530acac62a39df2a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    // const { match, query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_ASSETS)
    ];
    routeName;
    return path;
}
const $530acac62a39df2a$export$6cfeba0849032a84 = {
    routes: $530acac62a39df2a$var$routes,
    convert: $530acac62a39df2a$var$convert
};

});

parcelRegister("l9iHq", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $685c450fca71b492$export$6468819b4be328b1);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $685c450fca71b492$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_DASHBOARD_EDIT),
    (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW),
    (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD)
]);
function $685c450fca71b492$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_DASHBOARDS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY:
            path.push((0, $4ursw.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD:
            query.dashboardId && path.push((0, $4ursw.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $4ursw.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $4ursw.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $685c450fca71b492$export$6468819b4be328b1 = {
    routes: $685c450fca71b492$var$routes,
    convert: $685c450fca71b492$var$convert
};

});

parcelRegister("kQKHc", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $c8fd53ebbba77799$export$6e91331b5debb7c8);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $c8fd53ebbba77799$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_ISSUE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_GIN),
    (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_ISSUE),
    (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
]);
function $c8fd53ebbba77799$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_FILTERS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY:
            path.push((0, $4ursw.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_ISSUE:
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $4ursw.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $4ursw.MENU_ID_PROJECTS),
                        (0, $4ursw.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $4ursw.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $4ursw.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $c8fd53ebbba77799$export$6e91331b5debb7c8 = {
    routes: $c8fd53ebbba77799$var$routes,
    convert: $c8fd53ebbba77799$var$convert
};

});

parcelRegister("6QMa1", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $7e2ffeb83ffcdee6$export$7fc92455d5020e1);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $7e2ffeb83ffcdee6$var$routes = new Set([
    // TODO: Confirm all of these routes are relevant:
    (0, $exb0h.ROUTE_NAMES_EOC_ALERTS),
    (0, $exb0h.ROUTE_NAMES_EOC_ALERT_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING),
    (0, $exb0h.ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE),
    (0, $exb0h.ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_API_KEY_MANAGEMENT),
    (0, $exb0h.ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES),
    (0, $exb0h.ROUTE_NAMES_EOC_AUTOMATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_CUSTOM_ROLES),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERTS),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE),
    (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORTS),
    (0, $exb0h.ROUTE_NAMES_EOC_HEARTBEATS),
    (0, $exb0h.ROUTE_NAMES_EOC_INCOMING_CALL),
    (0, $exb0h.ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_CREATE),
    (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_LIST),
    (0, $exb0h.ROUTE_NAMES_EOC_INTEGRATION_LOG),
    (0, $exb0h.ROUTE_NAMES_EOC_MAINTENANCE),
    (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL),
    (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW),
    (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
    (0, $exb0h.ROUTE_NAMES_EOC_PERMISSIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_POLICIES),
    (0, $exb0h.ROUTE_NAMES_EOC_REPORTS),
    (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_TEAM),
    (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
    (0, $exb0h.ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_SETTINGS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERTS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
    (0, $exb0h.ROUTE_NAMES_EOC_TEAM_POLICIES),
    (0, $exb0h.ROUTE_NAMES_EOC_UNLOCK_OPERATIONS),
    (0, $exb0h.ROUTE_NAMES_EOC_WHO_IS_ON_CALL)
]);
function $7e2ffeb83ffcdee6$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $4ursw.MENU_ID_OPERATIONS)
    ];
    routeName;
    return path;
}
const $7e2ffeb83ffcdee6$export$7fc92455d5020e1 = {
    routes: $7e2ffeb83ffcdee6$var$routes,
    convert: $7e2ffeb83ffcdee6$var$convert
};

});

parcelRegister("3RDtj", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $128ec34ead4ecce4$export$a33f2d74a674bf8a);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $128ec34ead4ecce4$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
    // ROUTE_NAMES_HOME_ONBOARDING_REDIRECT,
    // ROUTE_NAMES_HOME_REDIRECT
    (0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX)
]);
function $128ec34ead4ecce4$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_YOUR_WORK:
            path.push((0, $4ursw.MENU_ID_YOUR_WORK));
            break;
        case 0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX:
            path.push((0, $4ursw.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $128ec34ead4ecce4$export$a33f2d74a674bf8a = {
    routes: $128ec34ead4ecce4$var$routes,
    convert: $128ec34ead4ecce4$var$convert
};

});

parcelRegister("1403f", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $cba3eebaac019d4e$export$5469f6c6536ca9c5);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $cba3eebaac019d4e$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
]);
function $cba3eebaac019d4e$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_OVERVIEWS)
    ];
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $4ursw.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $cba3eebaac019d4e$export$5469f6c6536ca9c5 = {
    routes: $cba3eebaac019d4e$var$routes,
    convert: $cba3eebaac019d4e$var$convert
};

});

parcelRegister("aukag", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $a6f7a8f2d7e72d03$export$3bde637b58016d1);

var $exb0h = parcelRequire("exb0h");

var $4ursw = parcelRequire("4ursw");
const $a6f7a8f2d7e72d03$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK),
    (0, $exb0h.ROUTE_NAMES_TRASH_PLANS_DIRECTORY)
]);
function $a6f7a8f2d7e72d03$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    // const { match, query } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_PLANS)
    ];
    routeName, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY;
    path.push((0, $4ursw.MENU_ID_PLANS_VIEW_ALL));
    return path;
}
const $a6f7a8f2d7e72d03$export$3bde637b58016d1 = {
    routes: $a6f7a8f2d7e72d03$var$routes,
    convert: $a6f7a8f2d7e72d03$var$convert
};

});

parcelRegister("dbLx9", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $068cb2e0ae192cf5$export$c41b724886e5872b);

var $exb0h = parcelRequire("exb0h");

var $f1lMr = parcelRequire("f1lMr");

var $4ursw = parcelRequire("4ursw");
const $068cb2e0ae192cf5$var$routes = new Set([
    (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    (0, $exb0h.ROUTE_NAMES_LEGACY_ALL_REPORTS),
    (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
    // Apps
    (0, $exb0h.ROUTE_NAMES_FORGE_PROJECT),
    (0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
    // JPD
    (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS),
    (0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING),
    // JSW
    (0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORMS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORMS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    // JSM
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
    (0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
    // JWM
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT)
]);
function $068cb2e0ae192cf5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $4ursw.MENU_ID_PROJECTS)
    ];
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING:
            break;
        case 0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY:
            path.push((0, $4ursw.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 0, $exb0h.ROUTE_NAMES_FORGE_PROJECT:
        case 0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $4ursw.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $4ursw.ENTITY_ID).APP(appId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
        case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS:
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $4ursw.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $4ursw.MENU_ID_PROJECT_JSM_DIR));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_JSM_DIR_CUSTOMERS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $4ursw.MENU_ID_PROJECT_JSM_DIR));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_JSM_DIR_PRODUCTS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $4ursw.MENU_ID_PROJECT_JSM_DIR));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_JSM_DIR_ORGS(projectKey));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                switch(practiceType){
                    case 0, $f1lMr.SHORT_FORM_CHANGES:
                        path.push((0, $4ursw.MENU_ID_PROJECT_JSM_CHANGES));
                        break;
                    case 0, $f1lMr.SHORT_FORM_INCIDENTS:
                        path.push((0, $4ursw.MENU_ID_PROJECT_JSM_INCIDENTS));
                        break;
                    case 0, $f1lMr.SHORT_FORM_PROBLEMS:
                        path.push((0, $4ursw.MENU_ID_PROJECT_JSM_PROBLEMS));
                        break;
                    case 0, $f1lMr.SHORT_FORM_SERVICE_REQUEST:
                        path.push((0, $4ursw.MENU_ID_PROJECT_JSM_SERVICE_REQUESTS));
                        break;
                    case 0, $f1lMr.SHORT_FORM_POST_INCIDENT_REVIEWS:
                        path.push((0, $4ursw.MENU_ID_PROJECT_JSM_POST_INCIDENT));
                        break;
                    default:
                        break;
                }
                queueId && path.push((0, $4ursw.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $4ursw.MENU_ID_PROJECT_QUEUES));
                queueId && path.push((0, $4ursw.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $4ursw.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $4ursw.ENTITY_ID).FORM(formId));
            }
    }
    return path;
}
const $068cb2e0ae192cf5$export$c41b724886e5872b = {
    routes: $068cb2e0ae192cf5$var$routes,
    convert: $068cb2e0ae192cf5$var$convert
};

});
parcelRegister("f1lMr", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $d4363a603a2b1168$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $d4363a603a2b1168$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $d4363a603a2b1168$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $d4363a603a2b1168$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $d4363a603a2b1168$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $d4363a603a2b1168$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $d4363a603a2b1168$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $d4363a603a2b1168$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $d4363a603a2b1168$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $d4363a603a2b1168$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $d4363a603a2b1168$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $d4363a603a2b1168$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $d4363a603a2b1168$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $d4363a603a2b1168$export$b78213db77524b5b);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $d4363a603a2b1168$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $d4363a603a2b1168$export$45ba5f49e9509c4d);

var $edAb7 = parcelRequire("edAb7");
const $d4363a603a2b1168$export$8598196f74460271 = 'change-management';
const $d4363a603a2b1168$export$a50b49a533b5f7bc = 'incident-management';
const $d4363a603a2b1168$export$ceba70db1edb1def = 'problem-management';
const $d4363a603a2b1168$export$3d1cda9bd50505e8 = 'service-request';
const $d4363a603a2b1168$export$6ebf7b6bf1c580f = 'post-incident-review';
const $d4363a603a2b1168$export$81e62964cc725098 = 'developer-escalation';
const $d4363a603a2b1168$export$a613d808168c7b25 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f,
    $d4363a603a2b1168$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $d4363a603a2b1168$export$a2b1f8f055150f02 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $d4363a603a2b1168$export$485b1216c42d8d4 = 'no-category';
const $d4363a603a2b1168$export$f929a394dd190451 = 'no-category-new';
const $d4363a603a2b1168$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $d4363a603a2b1168$export$a50185c8e9fb007e = 'changes';
const $d4363a603a2b1168$export$a54a30a3c3cce634 = 'incidents';
const $d4363a603a2b1168$export$354f3a4c6ac0c903 = 'problems';
const $d4363a603a2b1168$export$335d3ac0c367f03f = 'service-requests';
const $d4363a603a2b1168$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $d4363a603a2b1168$export$cb41b99ca54e6bd = 'developer-escalations';
const $d4363a603a2b1168$export$f1b813cd23817ade = [
    $d4363a603a2b1168$export$a50185c8e9fb007e,
    $d4363a603a2b1168$export$a54a30a3c3cce634,
    $d4363a603a2b1168$export$354f3a4c6ac0c903,
    $d4363a603a2b1168$export$335d3ac0c367f03f,
    $d4363a603a2b1168$export$7ffd7f2c2ae96b6f,
    $d4363a603a2b1168$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $d4363a603a2b1168$export$6c24c440228eac9c = 'Changes';
const $d4363a603a2b1168$export$5b65d27ec2d28d18 = 'Incidents';
const $d4363a603a2b1168$export$51618dc8334072b = 'Problems';
const $d4363a603a2b1168$export$a34586940ac9c374 = 'Service requests';
const $d4363a603a2b1168$export$5497b62b513b7853 = 'Post-incident reviews';
const $d4363a603a2b1168$export$3f757c5e00588ffd = 'Developer escalation';
const $d4363a603a2b1168$export$b78213db77524b5b = {
    [$d4363a603a2b1168$export$8598196f74460271]: $d4363a603a2b1168$export$6c24c440228eac9c,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: $d4363a603a2b1168$export$5b65d27ec2d28d18,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: $d4363a603a2b1168$export$51618dc8334072b,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: $d4363a603a2b1168$export$a34586940ac9c374,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: $d4363a603a2b1168$export$5497b62b513b7853,
    [$d4363a603a2b1168$export$81e62964cc725098]: $d4363a603a2b1168$export$3f757c5e00588ffd
};
const $d4363a603a2b1168$export$fbf0dfd01228e38d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queues,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$45ba5f49e9509c4d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queuesLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};

});
parcelRegister("edAb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $716d4f665940f429$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $716d4f665940f429$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});





parcelRegister("2Kryv", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $02bda2a8432b1d07$export$cdcd6885320eec31);

var $hZ5um = parcelRequire("hZ5um");
function $02bda2a8432b1d07$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $hZ5um.isMenuIdList)(menuId) ? (0, $hZ5um.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("hZ5um", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $0aa74a7539989c0c$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $0aa74a7539989c0c$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $0aa74a7539989c0c$export$d8e017f58178e379);
const $0aa74a7539989c0c$var$MENU_ID_DELIM = '   '; // Three spaces
function $0aa74a7539989c0c$export$253323efd0c41e72(menuIds) {
    return menuIds.join($0aa74a7539989c0c$var$MENU_ID_DELIM);
}
function $0aa74a7539989c0c$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($0aa74a7539989c0c$var$MENU_ID_DELIM) !== -1;
}
function $0aa74a7539989c0c$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($0aa74a7539989c0c$var$MENU_ID_DELIM);
}

});


parcelRegister("buJlM", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $485f6c69495cf127$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $485f6c69495cf127$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $485f6c69495cf127$export$42ca7b248c7aaee);

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $6iz4v = parcelRequire("6iz4v");

var $eI5EY = parcelRequire("eI5EY");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $c7ifG = parcelRequire("c7ifG");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $5udmX = parcelRequire("5udmX");
const $485f6c69495cf127$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $485f6c69495cf127$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6iz4v.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // We either have a sync query or an async one from loadParameters. Never neither
    // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const query = parameters ?? await loadParameters?.();
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), query, variables || {}, options));
    if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
    if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6iz4v.setMark)(endMark);
        (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $485f6c69495cf127$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6iz4v.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6iz4v.setMark)(endMark);
            (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6iz4v.setMark)(endMark);
        (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $485f6c69495cf127$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $6xFTe.createResource)({
        type: `${$485f6c69495cf127$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $cNy9K.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            if ((0, $eI5EY.fg)('blu-3813-improve-ssr-hydration-of-relay')) return $485f6c69495cf127$var$getDataNew({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
            return $485f6c69495cf127$var$getDataOld({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                loadParameters: loadParameters,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $485f6c69495cf127$export$1cc887c62079ea32 = $485f6c69495cf127$var$createRelayResourceImpl;
const $485f6c69495cf127$export$bbe949b85c06f763 = $485f6c69495cf127$var$createRelayResourceImpl;
const $485f6c69495cf127$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $h5RgW.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("hkmE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ac2903ab7cc20b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09b8f4753e427dc1055d03a890369538>>
 * @relayHash 4251d10df6e4c6722afca79bd5e9c259
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb34a0d21b845c88b8570713d80232e0adbc24ff146b3e16a49cf6a5b8ecb586
const $85ac2903ab7cc20b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isDashboardsExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v13 = {
        "kind": "ScalarField",
        "name": "url"
    }, v14 = {
        "order": "DESC"
    }, v15 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v16 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v19 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v20 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v22 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v23 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "typeKey"
                                        }
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "navigationMetadata",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "boardId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSimpleBoard"
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "JiraSoftwareProjectNavigationMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "queueId"
                                        }
                                    ],
                                    "type": "JiraServiceManagementProjectNavigationMetadata"
                                }
                            ]
                        },
                        {
                            "alias": "editProjectConfig",
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v20 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        v21 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectTypeName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webUrl"
                        },
                        {
                            "alias": "editPermission",
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v20 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        v22 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "args": v19 /*: any*/ ,
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": v20 /*: any*/ ,
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "softwareBoardCount"
                        }
                    ],
                    "type": "JiraProject"
                },
                v18 /*: any*/ 
            ]
        }
    ], v24 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v25 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v7 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v28 = {
        "kind": "ScalarField",
        "name": "title"
    }, v29 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v7 /*: any*/ 
        ]
    }, v30 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v28 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v29 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v18 /*: any*/ 
            ]
        }
    ], v31 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v10 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        v28 /*: any*/ ,
                        v29 /*: any*/ 
                    ],
                    "type": "JiraDashboard"
                },
                v18 /*: any*/ 
            ]
        }
    ], v32 = [
        v7 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenuItems"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v13 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteProjects",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "PROJECT"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentProjects",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PROJECT"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v25 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isDashboardsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "dashboardFavourites",
                                    "args": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v14 /*: any*/ ,
                                                "type": "DASHBOARD"
                                            }
                                        },
                                        v15 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "dashboardRecents",
                                    "args": [
                                        v8 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "DASHBOARD"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v31 /*: any*/ 
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb34a0d21b845c88b8570713d80232e0adbc24ff146b3e16a49cf6a5b8ecb586",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$85ac2903ab7cc20b$var$node.hash = "301906cf56b46d61420af572d827d1a7";
var $85ac2903ab7cc20b$export$2e2bcd8739ae039 = $85ac2903ab7cc20b$var$node;

});

parcelRegister("bckG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $135252e9d486cd82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6397372677267ea3c070486a779d6ada>>
 * @relayHash a62980e6f93cb5f2ad31fdebd70c38b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8
const $135252e9d486cd82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v2 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "jira.navigationUIState.leftSidebarWidth"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$135252e9d486cd82$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
var $135252e9d486cd82$export$2e2bcd8739ae039 = $135252e9d486cd82$var$node;

});


parcelRegister("4MmfV", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $ca35414721fafc7a$export$5839dd8142de842e);

var $gUUjF = parcelRequire("gUUjF");

var $6xFTe = parcelRequire("6xFTe");

var $ElVpH = parcelRequire("ElVpH");

var $9SjeY = parcelRequire("9SjeY");
const $ca35414721fafc7a$export$5839dd8142de842e = (0, $6xFTe.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $9SjeY.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("ElVpH", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $478ce79be34a38cd$export$557c2f222778cea6);
const $478ce79be34a38cd$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("9SjeY", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $7d7ff3f2c7ca5c69$export$306fb49fca60b34);

var $lRmyA = parcelRequire("lRmyA");
const $7d7ff3f2c7ca5c69$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("I0t4m", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $481e4ad580b3240b$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $kZ7vG = parcelRequire("kZ7vG");
const $481e4ad580b3240b$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $481e4ad580b3240b$export$e7e6c1b9d8d5ea7 = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$481e4ad580b3240b$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $kZ7vG.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("kZ7vG", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $ffd9df53dda0b988$export$a49729698cfc5310);

var $lRmyA = parcelRequire("lRmyA");
const $ffd9df53dda0b988$var$requestSideBarInfo = (planId, scenarioId)=>(0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $ffd9df53dda0b988$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $ffd9df53dda0b988$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("iivTa", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$2d5a704ae6f6b050);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $a5660a56dfe8a855$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $a5660a56dfe8a855$export$e4bf33528101348c = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$a5660a56dfe8a855$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $a5660a56dfe8a855$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $a5660a56dfe8a855$export$2d5a704ae6f6b050 = ()=>(0, $h5RgW.useResource)($a5660a56dfe8a855$export$e4bf33528101348c);

});
parcelRegister("76v64", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $c603d0485f5d33bd$export$b15f9f5cf6db359e);

var $lRmyA = parcelRequire("lRmyA");
const $c603d0485f5d33bd$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("cbmC6", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $9d72696b0f8eb1a8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$9d72696b0f8eb1a8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9d72696b0f8eb1a8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});

});

parcelRegister("kXWpU", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $4181ab9f0d3720b7$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $4181ab9f0d3720b7$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $4181ab9f0d3720b7$export$b692cfadccf4e047);

var $exb0h = parcelRequire("exb0h");

var $kdp9J = parcelRequire("kdp9J");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $ElVpH = parcelRequire("ElVpH");
var $9zYls = parcelRequire("9zYls");

var $LWmvk = parcelRequire("LWmvk");
const $4181ab9f0d3720b7$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $kdp9J.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    return (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $4181ab9f0d3720b7$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $4181ab9f0d3720b7$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $4181ab9f0d3720b7$export$f2dfc0f7b2d92691 = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    getKey: ({ match: match, query: query, route: { name: name } })=>$4181ab9f0d3720b7$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        const scopeIdentifier = $4181ab9f0d3720b7$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $LWmvk.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $4181ab9f0d3720b7$export$b692cfadccf4e047 = ()=>(0, $h5RgW.useResource)($4181ab9f0d3720b7$export$f2dfc0f7b2d92691);

});
parcelRegister("kdp9J", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $004bd39330a8812e$export$68278f7cf66944f9);

const $004bd39330a8812e$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $718a877cd35f74b2$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $718a877cd35f74b2$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $718a877cd35f74b2$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $718a877cd35f74b2$export$b5a308a17bc991f3 = 'projectKey';
const $718a877cd35f74b2$export$929d50f83189406c = 'boardId';
const $718a877cd35f74b2$export$da6f46390e1a426f = 'projectId';


parcelRegister("LWmvk", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $586cfcaef75ec717$export$8a51470472777e11);

var $lRmyA = parcelRequire("lRmyA");
const $586cfcaef75ec717$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("eJCK9", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $9e1e6b174c3d84b9$export$4847c29b4786b3b4);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $iVoS5 = parcelRequire("iVoS5");
const $9e1e6b174c3d84b9$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9e1e6b174c3d84b9$export$4847c29b4786b3b4 = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$9e1e6b174c3d84b9$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9e1e6b174c3d84b9$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $iVoS5.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("iVoS5", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $72b9eb1ede36e333$export$49d696bf2525d700);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $72b9eb1ede36e333$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $2OdyW.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("6OTFM", function(module, exports) {

$parcel$export(module.exports, "staticSoftwareProjectHorizontalNavResource", () => $e315884b683b3230$export$c5680a2101ae5345);

var $jDNSq = parcelRequire("jDNSq");

var $8npnf = parcelRequire("8npnf");

var $kdp9J = parcelRequire("kdp9J");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $com8B = parcelRequire("com8B");

var $buJlM = parcelRequire("buJlM");

var $djXuz = parcelRequire("djXuz");

var $ElVpH = parcelRequire("ElVpH");
var $9zYls = parcelRequire("9zYls");
var $jwzNs = parcelRequire("jwzNs");
const $e315884b683b3230$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    let scope;
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    if (isTMPBoardRoute) // TMP software projects always use projectKey even on board routes because they only have one board
    scope = (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId
    });
    else scope = (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
    const boardAri = scope.identifierType === 'boardId' ? (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: tenantContext.cloudId,
        boardId: String(match.params.boardId)
    }).toString() : null;
    const projectAri = projectId ? (0, $8npnf.JiraProjectAri).create({
        siteId: tenantContext.cloudId,
        projectId: String(projectId)
    }).toString() : '';
    const containerNavigationInput = boardAri || projectAri ? {
        scopeId: String(boardAri || projectAri)
    } : {
        projectKeyQuery: {
            cloudId: tenantContext.cloudId,
            projectKey: projectKey
        }
    };
    return {
        parameters: (0, $djXuz.default),
        variables: {
            cloudId: tenantContext.cloudId,
            projectKey: projectKey,
            projectAri: projectAri,
            boardId: boardAri,
            containerNavigationInput: containerNavigationInput,
            first: (0, $com8B.NAVIGATION_ITEMS_PAGE_SIZE),
            useContainerNavigation: (0, $eI5EY.fg)('custom_project_navigation_m2'),
            useProjectKey: Boolean(projectKey),
            useProjectAri: Boolean(projectAri)
        },
        options: {
            fetchPolicy: 'store-and-network'
        }
    };
};
const $e315884b683b3230$export$c5680a2101ae5345 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav'), (0, $buJlM.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_PROJECT_QUERY',
    getQuery: $e315884b683b3230$export$71eec30d9db46a56
}));

});
parcelRegister("com8B", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $992003ad8c7a0558$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $992003ad8c7a0558$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $992003ad8c7a0558$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_ANGLE", () => $992003ad8c7a0558$export$29911ec08ab2ca2d);
$parcel$export(module.exports, "TAB_GAP", () => $992003ad8c7a0558$export$b61e6f89a9db76de);
$parcel$export(module.exports, "MAX_MORE_TAB_COUNT", () => $992003ad8c7a0558$export$7fd2e391116c6ef5);
$parcel$export(module.exports, "MORE_TRIGGER_ID", () => $992003ad8c7a0558$export$e1633e494d305bfb);


var $b79zs = parcelRequire("b79zs");

var $9uAlc = parcelRequire("9uAlc");
const $992003ad8c7a0558$export$4653cda61a4943d6 = 75;
const $992003ad8c7a0558$export$d1b9ea3245b6a5de = 2;
const $992003ad8c7a0558$export$d07bba395c9390f1 = 36;
const $992003ad8c7a0558$export$29911ec08ab2ca2d = 5;
const $992003ad8c7a0558$export$b61e6f89a9db76de = 12;
const $992003ad8c7a0558$export$7fd2e391116c6ef5 = 9;
const $992003ad8c7a0558$export$e1633e494d305bfb = 'MORE';

});
parcelRegister("b79zs", function(module, exports) {

$parcel$export(module.exports, "getRouteForViewType", () => $0ab701c4882c193f$export$354a3334a0b30da2);
const $0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL = '/jira/core/projects';
const $0ab701c4882c193f$export$354a3334a0b30da2 = (projectKey, itemTypeKey)=>{
    switch(itemTypeKey){
        case 'SUMMARY':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/summary`;
        case 'BOARD':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/board`;
        case 'LIST':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/list`;
        case 'TIMELINE':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/timeline`;
        case 'CALENDAR':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/calendar`;
        case 'FORMS':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/form`;
        case 'APPROVALS':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/approvals`;
        case 'ATTACHMENTS':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/attachments`;
        case 'PAGES':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/pages`;
        case 'ISSUES':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/issues`;
        case 'REPORTS':
            return `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
        case 'COMPONENTS':
            return `${$0ab701c4882c193f$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/components`;
        default:
            return undefined;
    }
};

});

parcelRegister("9uAlc", function(module, exports) {

$parcel$export(module.exports, "TabsConfigurationProvider", () => $b89e3da0f3f7b5d3$export$1bce62184976ada3);
$parcel$export(module.exports, "useTabConfiguration", () => $b89e3da0f3f7b5d3$export$e5ac2ee76dd2d5a5);
$parcel$export(module.exports, "useTabsConfiguration", () => $b89e3da0f3f7b5d3$export$997db1b8d6ce9f71);

var $eUqFw = parcelRequire("eUqFw");
const $b89e3da0f3f7b5d3$var$TabsConfigurationContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $b89e3da0f3f7b5d3$export$1bce62184976ada3 = ({ tabsConfiguration: tabsConfiguration, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b89e3da0f3f7b5d3$var$TabsConfigurationContext.Provider, {
        value: tabsConfiguration
    }, children);
const $b89e3da0f3f7b5d3$export$e5ac2ee76dd2d5a5 = (typeKey)=>{
    const tabsConfiguration = (0, $eUqFw.useContext)($b89e3da0f3f7b5d3$var$TabsConfigurationContext);
    if (!tabsConfiguration) throw new Error('useTabsConfiguration must be used within a TabConfigurationProvider');
    if (!typeKey || !(typeKey in tabsConfiguration)) return null;
    return tabsConfiguration[typeKey];
};
const $b89e3da0f3f7b5d3$export$997db1b8d6ce9f71 = ()=>{
    const tabsConfiguration = (0, $eUqFw.useContext)($b89e3da0f3f7b5d3$var$TabsConfigurationContext);
    if (!tabsConfiguration) throw new Error('useTabsConfiguration must be used within a TabConfigurationProvider');
    return tabsConfiguration;
};

});


parcelRegister("djXuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d6cbbebfbb8fd5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a917e42196cc7babc7ca30f1d3104e3>>
 * @relayHash d4b6959e642f60149dd224903a51e42d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b200b0149d1b350296ee8fc578490153d3cb53e45efcbdd206f171b4c6786d31
const $70d6cbbebfbb8fd5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useContainerNavigation"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectAri"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v11 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectKey"
        }
    ], v12 = [
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabList_TabList_tabsFragment"
        }
    ], v13 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "containerNavigationInput"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v15 = [
        v10 /*: any*/ 
    ], v16 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v17 = [
        {
            "kind": "FragmentSpread",
            "name": "projectBoardHeader_horizontalNavHeader"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabList_TabList_projectFragment"
        }
    ], v18 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "label"
    }, v22 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v24 = {
        "kind": "ScalarField",
        "name": "url"
    }, v25 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v26 = [
        {
            "concreteType": "JiraNavigationItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isDefault"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "typeKey"
                        },
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraNavigationItem"
                        },
                        v21 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canRemove"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canSetAsDefault"
                        },
                        v22 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraAppSection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": true,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "envLabel"
                                }
                            ],
                            "type": "JiraAppNavigationItem"
                        }
                    ]
                }
            ]
        }
    ], v27 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v28 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v29 = [
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectTypeName"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "alias": "editPermission",
            "args": v27 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v28 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        v22 /*: any*/ ,
        {
            "alias": "canEditProjectConfig",
            "args": v27 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v28 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v28 /*: any*/ ,
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
                v19 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "boardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSimpleBoard"
                        },
                        v20 /*: any*/ 
                    ],
                    "type": "JiraSoftwareProjectNavigationMetadata"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "jiraSoftwareNavigationItems",
                                            "plural": false,
                                            "selections": v12 /*: any*/ 
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraSoftwareNavigationItems"
                                    }
                                ]
                            },
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v13 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitTabList_TabList_containerFragment"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitAddTab_AddTab"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v14 /*: any*/ ,
                                                    {
                                                        "args": v15 /*: any*/ ,
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": v12 /*: any*/ 
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": v17 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "condition": "useProjectAri",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "alias": "projectDataById",
                                                "args": v18 /*: any*/ ,
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "jiraProject",
                                                "plural": false,
                                                "selections": v17 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "jiraSoftwareNavigationItems",
                                    "plural": false,
                                    "selections": v26 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v13 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                {
                                                    "args": v15 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v29 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "useProjectAri",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "projectDataById",
                                            "args": v18 /*: any*/ ,
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "jiraProject",
                                            "plural": false,
                                            "selections": v29 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b200b0149d1b350296ee8fc578490153d3cb53e45efcbdd206f171b4c6786d31",
            "metadata": {},
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70d6cbbebfbb8fd5$var$node.hash = "bf77e8c96ff302d165517a93e4b8b372";
var $70d6cbbebfbb8fd5$export$2e2bcd8739ae039 = $70d6cbbebfbb8fd5$var$node;

});

parcelRegister("jwzNs", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $55f07a7915bec73f$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $55f07a7915bec73f$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $55f07a7915bec73f$export$5284559c6d2f1a7b);

var $6qExu = parcelRequire("6qExu");
const $55f07a7915bec73f$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $6qExu.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        }
    };
const $55f07a7915bec73f$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $55f07a7915bec73f$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $55f07a7915bec73f$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $55f07a7915bec73f$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("6qExu", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $d6fba9243db8a331$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $d6fba9243db8a331$export$5664a170ac5a9781);
const $d6fba9243db8a331$export$eb37f5d331ea4de4 = 'NOOP';
const $d6fba9243db8a331$export$5664a170ac5a9781 = 5000;

});



parcelRegister("7JTqr", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4", () => $dc1b3996866994bc$export$f1ce4aa22fe8768a);

var $eI5EY = parcelRequire("eI5EY");

var $exP3y = parcelRequire("exP3y");

var $5lmZv = parcelRequire("5lmZv");
const $dc1b3996866994bc$export$f1ce4aa22fe8768a = ()=>(0, $eI5EY.fg)('jira_nav4') && ((0, $exP3y.getWillShowNav4ForDogfooding)() || (0, $5lmZv.getWillShowNav4ForEap)());

});
parcelRegister("exP3y", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForDogfooding", () => $82eed044de9be38a$export$9ca0d92d31816d4f);

var $eI5EY = parcelRequire("eI5EY");

var $bfAKe = parcelRequire("bfAKe");

var $gWBBV = parcelRequire("gWBBV");
const $82eed044de9be38a$export$9ca0d92d31816d4f = ()=>{
    if (!(0, $eI5EY.fg)('jira_nav4_dogfooding')) return false;
    const phase1 = (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1');
    const phase2 = (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2');
    const phase3 = !(phase1 || phase2);
    return phase3 || phase2 && !(0, $bfAKe.getIsNav4UserOptOut)() || phase1 && !(0, $bfAKe.getIsNav4UserOptOut)() && !(0, $gWBBV.getIsRouteExcludedForDogfoodingPhase1)();
};

});
parcelRegister("bfAKe", function(module, exports) {

$parcel$export(module.exports, "getMetaBoolean", () => $aaf90bd4ad3ea95d$export$9683360b0ae70629);
$parcel$export(module.exports, "getIsNav4UserOptOut", () => $aaf90bd4ad3ea95d$export$3fbfe0fdf05e0f9f);

var $jqvCZ = parcelRequire("jqvCZ");

var $6rW04 = parcelRequire("6rW04");

var $5X9iw = parcelRequire("5X9iw");
const $aaf90bd4ad3ea95d$export$9683360b0ae70629 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((name)=>(0, $6rW04.default)(`ajs-${name}`) === 'true');
const $aaf90bd4ad3ea95d$export$7d046765d192af80 = ()=>$aaf90bd4ad3ea95d$export$9683360b0ae70629((0, $5X9iw.IS_ADMIN));
const $aaf90bd4ad3ea95d$export$ba89637357392be6 = ()=>$aaf90bd4ad3ea95d$export$9683360b0ae70629((0, $5X9iw.IS_NAV4_USER_OPT_IN));
const $aaf90bd4ad3ea95d$export$3fbfe0fdf05e0f9f = ()=>$aaf90bd4ad3ea95d$export$9683360b0ae70629((0, $5X9iw.IS_NAV4_USER_OPT_OUT));

});
parcelRegister("5X9iw", function(module, exports) {

$parcel$export(module.exports, "IS_ADMIN", () => $f137fe3e234ef511$export$4261d5d429e288ec);
$parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", () => $f137fe3e234ef511$export$153ded4d539b820d);
$parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", () => $f137fe3e234ef511$export$9c962957701a4fe8);
$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $f137fe3e234ef511$export$3b602cac1f385c06);
$parcel$export(module.exports, "getLatestNav4Stage", () => $f137fe3e234ef511$export$b25aebc11fc18552);
const $f137fe3e234ef511$export$4261d5d429e288ec = 'is-admin';
const $f137fe3e234ef511$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $f137fe3e234ef511$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
const $f137fe3e234ef511$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $f137fe3e234ef511$export$9cd4b8dc5f7153b8 = {
    NONE: 'none',
    DOGFOODING: 'dogfooding',
    EAP: 'eap',
    BETA: 'beta',
    GA: 'ga'
};
const $f137fe3e234ef511$export$b25aebc11fc18552 = ()=>$f137fe3e234ef511$export$9cd4b8dc5f7153b8.DOGFOODING;

});


parcelRegister("gWBBV", function(module, exports) {

$parcel$export(module.exports, "getIsRouteExcludedForDogfoodingPhase1", () => $cc10597c510e7cbe$export$f0abfe25b95778e3);

var $1ybV0 = parcelRequire("1ybV0");
const $cc10597c510e7cbe$export$f0abfe25b95778e3 = ()=>{
    if (false) return false;
    const pathname = $cc10597c510e7cbe$var$getPathname();
    if (!(0, $1ybV0.ff)('polaris.sidebar-v4') && (pathname.includes('/jira/polaris/') || pathname.includes('/secure/JiraProductDiscoveryEmbedded') || pathname.includes('/jira/discovery/'))) return true;
    return false;
};
const $cc10597c510e7cbe$var$getPathname = ()=>window.location.pathname;

});


parcelRegister("5lmZv", function(module, exports) {

$parcel$export(module.exports, "getWillShowNav4ForEap", () => $1766c676b326be23$export$393f53ae320de085);

var $eI5EY = parcelRequire("eI5EY");

var $bfAKe = parcelRequire("bfAKe");
const $1766c676b326be23$export$393f53ae320de085 = ()=>(0, $eI5EY.fg)('jira_nav4_eap') && !(0, $bfAKe.getIsNav4UserOptOut)();

});


parcelRegister("hawmT", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $a93019de4376d1a2$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $a93019de4376d1a2$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $a93019de4376d1a2$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $a93019de4376d1a2$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $a93019de4376d1a2$export$54805a2120a31ad0);

var $gUUjF = parcelRequire("gUUjF");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");

const $a93019de4376d1a2$export$fa475a9581133779 = (0, $6xFTe.createResource)({
    type: (0, $b5f6b10e2be29709$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $2OdyW.default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $b5f6b10e2be29709$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $a93019de4376d1a2$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    if (isVisible && jswEdition === (0, $6WXNs.FREE_EDITION)) {
        const shouldHidePlans = (0, $79xbN.expVal)('hide_plans_tab_for_jira_free', 'shouldHidePlansTab', false);
        return [
            !shouldHidePlans
        ];
    }
    return [
        isVisible
    ];
};
const $a93019de4376d1a2$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $a93019de4376d1a2$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $a93019de4376d1a2$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
parcelRegister("79xbN", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $2783c762502a41a6$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $2783c762502a41a6$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $2783c762502a41a6$export$677f9fa2e1ae6fec);

var $8tM2T = parcelRequire("8tM2T");

var $9bn72 = parcelRequire("9bn72");

var $fbE19 = parcelRequire("fbE19");
function $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $8tM2T.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $fbE19.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $2783c762502a41a6$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    return $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
class $2783c762502a41a6$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $fbE19.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $2783c762502a41a6$var$cache = new Map();
function $2783c762502a41a6$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $2783c762502a41a6$var$cache.get(experimentName);
    if (instance == null) {
        // Handle vendorless scripts use of gates
        (0, $9bn72.UNSAFE_initIfNeeded)();
        const config = (0, $8tM2T.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $8tM2T.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $2783c762502a41a6$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $2783c762502a41a6$var$cache.set(experimentName, instance);
    }
    return instance;
}

});

parcelRegister("ab6rA", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $75e408c194026ea5$export$92ed15881fc090d7);

var $gd0Sp = parcelRequire("gd0Sp");
const $75e408c194026ea5$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

const $b5f6b10e2be29709$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $b5f6b10e2be29709$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("8mP0X", function(module, exports) {

$parcel$export(module.exports, "planSidebarNavigationOptInStatusResources", () => $25d62fa85243192d$export$80a694316ccf7408);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");

const $25d62fa85243192d$export$80a694316ccf7408 = (0, $6xFTe.createResource)({
    type: (0, $af778776d0774f93$export$469e0f3dfa0992d7),
    getKey: ()=>'plan_sidebar_navigation_optin_status',
    getData: async ()=>{
        let planSidebarNavigationOptInStatus = null;
        try {
            planSidebarNavigationOptInStatus = await (0, $lRmyA.performGetRequest)('/rest/api/3/mypreferences?key=arj-navigation-sidebar');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // Error 404 is acceptable as on the first call the key does not exist in the user profile
            if (e.statusCode === 404) return {
                planSidebarNavigationOptInStatus: {
                    isEnabled: false
                }
            };
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.detectPlanSidebarNavigationVisibility', 'getDetectPlanSidebarNavigationVisibility', e);
        }
        return {
            planSidebarNavigationOptInStatus: planSidebarNavigationOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $af778776d0774f93$export$469e0f3dfa0992d7 = 'RESOURCE_TYPE_PLAN_SIDEBAR_NAVIGATION_OPTIN_STATUS';


parcelRegister("8yXY1", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $9d378f53ff5588a3$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $9d378f53ff5588a3$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $f8OZU = parcelRequire("f8OZU");

var $aqZcy = parcelRequire("aqZcy");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

const $9d378f53ff5588a3$export$785c22104b6f2285 = (0, $6xFTe.createResource)({
    type: (0, $915023b8afa83aa8$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $915023b8afa83aa8$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $aqZcy.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $aqZcy.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if ((0, $eI5EY.fg)('jfp-magma-browser-storage-bump-3')) {
            if (consentToken) return {
                consentToken: consentToken,
                fallbackConsentToken: fallbackConsentToken
            };
        } else {
            const currentLocale = (0, $aqZcy.getCookie)((0, $f8OZU.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
            if (consentToken && currentLocale) return {
                consentToken: consentToken,
                currentLocale: currentLocale,
                fallbackConsentToken: fallbackConsentToken
            };
        }
        const data = await (0, $lRmyA.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $9d378f53ff5588a3$export$5bc7e83e85567fb4 = ()=>(0, $h5RgW.useResource)($9d378f53ff5588a3$export$785c22104b6f2285);

});
parcelRegister("f8OZU", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $9d814338104eeebb$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $9d814338104eeebb$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $9d814338104eeebb$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", () => $9d814338104eeebb$export$f57af01b64fc97b8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $9d814338104eeebb$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $9d814338104eeebb$export$37073d560ecebada);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $9d814338104eeebb$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $9d814338104eeebb$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $9d814338104eeebb$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $9d814338104eeebb$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $9d814338104eeebb$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $9d814338104eeebb$export$31deaeaebce525bb);

var $epRiJ = parcelRequire("epRiJ");
const $9d814338104eeebb$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $9d814338104eeebb$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $9d814338104eeebb$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $9d814338104eeebb$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $9d814338104eeebb$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $9d814338104eeebb$export$37073d560ecebada = 'atl-testing-consents';
const $9d814338104eeebb$export$b28b5d760fe14a21 = {
    [(0, $epRiJ.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $epRiJ.PreferenceCategory).Functional]: true,
    [(0, $epRiJ.PreferenceCategory).Marketing]: true,
    [(0, $epRiJ.PreferenceCategory).Analytics]: true,
    [(0, $epRiJ.PreferenceCategory).Unknown]: true
};
const $9d814338104eeebb$export$4a12f9e99971760a = {
    [(0, $epRiJ.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $epRiJ.PreferenceCategory).Functional]: false,
    [(0, $epRiJ.PreferenceCategory).Marketing]: false,
    [(0, $epRiJ.PreferenceCategory).Analytics]: false,
    [(0, $epRiJ.PreferenceCategory).Unknown]: false
};
const $9d814338104eeebb$export$f0fd1d13ec1d48f2 = {
    ...$9d814338104eeebb$export$4a12f9e99971760a,
    [(0, $epRiJ.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $epRiJ.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $epRiJ.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $9d814338104eeebb$export$f95182b7aa141c57 = '001';
const $9d814338104eeebb$export$1f25427b34f9c405 = '002';
const $9d814338104eeebb$export$31deaeaebce525bb = '003';

});
parcelRegister("epRiJ", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $8b442acf8aa2778c$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $8b442acf8aa2778c$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $8b442acf8aa2778c$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $8b442acf8aa2778c$export$5d6594a0bba4ab8a);
var $8b442acf8aa2778c$export$ba064dbfe4bb66d7;
(function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
})($8b442acf8aa2778c$export$ba064dbfe4bb66d7 || ($8b442acf8aa2778c$export$ba064dbfe4bb66d7 = {}));
var $8b442acf8aa2778c$export$cdef20bac194f235;
(function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
})($8b442acf8aa2778c$export$cdef20bac194f235 || ($8b442acf8aa2778c$export$cdef20bac194f235 = {}));
var $8b442acf8aa2778c$export$fac80ad19b60e313;
(function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
})($8b442acf8aa2778c$export$fac80ad19b60e313 || ($8b442acf8aa2778c$export$fac80ad19b60e313 = {}));
var $8b442acf8aa2778c$export$5d6594a0bba4ab8a;
(function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
})($8b442acf8aa2778c$export$5d6594a0bba4ab8a || ($8b442acf8aa2778c$export$5d6594a0bba4ab8a = {}));

});


parcelRegister("aqZcy", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $5345d14aecffdbc4$export$4be65e66cfa2648a);

var $b4VDn = parcelRequire("b4VDn");
function $5345d14aecffdbc4$export$4be65e66cfa2648a(key) {
    return key ? (0, $b4VDn.getCookie)(key) : (0, $b4VDn.getCookie)();
}

});
parcelRegister("b4VDn", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $6abf82c1c8dfcc08$export$4be65e66cfa2648a);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $6lAvk = parcelRequire("6lAvk");
function $6abf82c1c8dfcc08$export$4be65e66cfa2648a(key) {
    try {
        if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) (0, $1J3ZG.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get();
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});
parcelRegister("1J3ZG", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $ead04f6d271b7556$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $ead04f6d271b7556$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $ead04f6d271b7556$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $ead04f6d271b7556$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $ead04f6d271b7556$export$1ba525b8a711eaac);

var $dNAsL = parcelRequire("dNAsL");
var $1C9jQ = parcelRequire("1C9jQ");

var $XHGTv = parcelRequire("XHGTv");

var $4uLct = parcelRequire("4uLct");

var $6lAvk = parcelRequire("6lAvk");

var $48ifh = parcelRequire("48ifh");

var $6kCIk = parcelRequire("6kCIk");
const $ead04f6d271b7556$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $1C9jQ.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $1C9jQ.envType).DEV;
    return (0, $1C9jQ.envType).PROD;
};
const $ead04f6d271b7556$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $ead04f6d271b7556$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $ead04f6d271b7556$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $ead04f6d271b7556$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $ead04f6d271b7556$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $ead04f6d271b7556$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $ead04f6d271b7556$export$fce3dd735e04d566();
    return {
        featureFlagOn: (0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls'),
        packageName: $48ifh.packageName,
        packageVersion: $48ifh.packageVersion,
        domain: domain,
        product: (0, $4uLct.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $ead04f6d271b7556$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $4uLct.getBscGlobalState)().analyticsEnabled) instance = new (0, $dNAsL.default)({
                env: $ead04f6d271b7556$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $6lAvk.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $4uLct.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $ead04f6d271b7556$export$5bfe55348e7aebc1(properties) {
    (0, $6kCIk.withAnalyticsEventSampling)(properties.action, ()=>$ead04f6d271b7556$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $ead04f6d271b7556$var$decorateEventAttributes(properties.attributes)
        }));
}
function $ead04f6d271b7556$export$1aecf263098db667(properties) {
    $ead04f6d271b7556$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $ead04f6d271b7556$var$decorateEventAttributes(properties.attributes)
    });
}
function $ead04f6d271b7556$export$22a3b1671f38a193(properties) {
    $ead04f6d271b7556$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $ead04f6d271b7556$var$decorateEventAttributes(properties.attributes)
    });
}
function $ead04f6d271b7556$export$1ba525b8a711eaac(properties) {
    $ead04f6d271b7556$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $ead04f6d271b7556$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("4uLct", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $428483159295c9a1$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $428483159295c9a1$export$882c4530c58781d8);
let $428483159295c9a1$var$localAnalyticsEnabled;
let $428483159295c9a1$var$localProduct;
const $428483159295c9a1$export$3b78a1ea01f5ec28 = ()=>{
    if ($428483159295c9a1$var$localAnalyticsEnabled == null) $428483159295c9a1$var$localAnalyticsEnabled = true;
    return {
        analyticsEnabled: $428483159295c9a1$var$localAnalyticsEnabled,
        product: $428483159295c9a1$var$localProduct
    };
};
const $428483159295c9a1$export$882c4530c58781d8 = ({ analyticsEnabled: analyticsEnabled = true, product: product = 'NONE' } = {})=>{
    $428483159295c9a1$var$localAnalyticsEnabled = analyticsEnabled;
    $428483159295c9a1$var$localProduct = product;
};
const $428483159295c9a1$export$ac7c2edd09656c05 = ()=>{
    $428483159295c9a1$var$localAnalyticsEnabled = undefined;
    $428483159295c9a1$var$localProduct = undefined;
};

});

parcelRegister("6lAvk", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $2b88c5d995edc6ec$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $1J3ZG = parcelRequire("1J3ZG");
const $2b88c5d995edc6ec$var$LOG_PREFIX = '[browser-storage-controls]';
class $2b88c5d995edc6ec$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$2b88c5d995edc6ec$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$2b88c5d995edc6ec$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $1J3ZG.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$2b88c5d995edc6ec$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});

parcelRegister("48ifh", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $6ea6e06639a9f9c7$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $6ea6e06639a9f9c7$export$91546b032799aa40);
const $6ea6e06639a9f9c7$export$9345d7360ffe0722 = "platform-pkg";
const $6ea6e06639a9f9c7$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("6kCIk", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $530d1d0bbf2f842b$export$67b6e87f323cb6ad);

var $kzWh4 = parcelRequire("kzWh4");

var $3J72S = parcelRequire("3J72S");

var $038zE = parcelRequire("038zE");
const $530d1d0bbf2f842b$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $530d1d0bbf2f842b$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $530d1d0bbf2f842b$var$loadSamplingConfig() {
    if ((0, $kzWh4.cache).cachedSamplingConfig) return (0, $kzWh4.cache).cachedSamplingConfig;
    if ((0, $3J72S.isSSR)()) return undefined;
    const controlsData = await (0, $038zE.loadStorageControlsData)();
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $kzWh4.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $530d1d0bbf2f842b$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($530d1d0bbf2f842b$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $530d1d0bbf2f842b$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $530d1d0bbf2f842b$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $530d1d0bbf2f842b$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $530d1d0bbf2f842b$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $530d1d0bbf2f842b$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $530d1d0bbf2f842b$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $530d1d0bbf2f842b$export$b286f5e8716d11ad(analyticsEventKey);
    $530d1d0bbf2f842b$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("kzWh4", function(module, exports) {

$parcel$export(module.exports, "cache", () => $c7353d58202261e7$export$69a3209f1a06c04d);

var $fIBqz = parcelRequire("fIBqz");
const $c7353d58202261e7$export$69a3209f1a06c04d = new (0, $fIBqz.CachedSamplingConfig)();

});
parcelRegister("fIBqz", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $c119cf06dc139e7e$export$b886edaf6623554a);
class $c119cf06dc139e7e$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("3J72S", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $ebee5e84767dc0e2$export$48d7c418edadb60c);

var $dNAsL = parcelRequire("dNAsL");

var $XHGTv = parcelRequire("XHGTv");

var $6lAvk = parcelRequire("6lAvk");
const $ebee5e84767dc0e2$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $XHGTv.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $dNAsL.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $6lAvk.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $6lAvk.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $dNAsL.default)) (0, $6lAvk.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("038zE", function(module, exports) {

$parcel$export(module.exports, "loadStorageControlsData", () => $affe817fa27c9a8e$export$4dbb842f063ffea4);

var $6lAvk = parcelRequire("6lAvk");
const $affe817fa27c9a8e$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
/**
 * Cache variable for storing categorized cookies cache
 */ let $affe817fa27c9a8e$var$localResponseCache;
/**
 * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
 *
 * Allows for many invocations to happen simultaneously, and for only one fetch to go out
 */ let $affe817fa27c9a8e$var$localResponsePromiseCache;
/**
 * Cache variable for storing the promise returned from the response object's json method
 *
 * Ensures we don't invoke response.json multiple times
 */ let $affe817fa27c9a8e$var$localResponseJsonPromiseCache;
const $affe817fa27c9a8e$export$19bc72f5ccd901a6 = ()=>{
    $affe817fa27c9a8e$var$localResponseCache = undefined;
    $affe817fa27c9a8e$var$localResponsePromiseCache = undefined;
    $affe817fa27c9a8e$var$localResponseJsonPromiseCache = undefined;
};
/**
 * Unpacks the response promise from the categories CDN
 *
 * errors if that request was unsuccessful, returns the categories data otherwise
 *
 */ const $affe817fa27c9a8e$var$handleCategoriesResponse = async (responsePromise)=>{
    if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
    const response = await responsePromise;
    if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
    // Checks if we've already fired the response.json() promise
    $affe817fa27c9a8e$var$localResponseJsonPromiseCache = $affe817fa27c9a8e$var$localResponseJsonPromiseCache || response?.json();
    return $affe817fa27c9a8e$var$localResponseJsonPromiseCache;
};
const $affe817fa27c9a8e$export$4dbb842f063ffea4 = async ()=>{
    if ($affe817fa27c9a8e$var$localResponseCache) return $affe817fa27c9a8e$var$localResponseCache;
    else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
    try {
        if (!$affe817fa27c9a8e$var$localResponsePromiseCache) // invoke CDN and cache the promise
        $affe817fa27c9a8e$var$localResponsePromiseCache = fetch($affe817fa27c9a8e$export$ab0619f627170401);
        // unpack response
        $affe817fa27c9a8e$var$localResponseCache = await $affe817fa27c9a8e$var$handleCategoriesResponse($affe817fa27c9a8e$var$localResponsePromiseCache);
        return $affe817fa27c9a8e$var$localResponseCache;
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'loadStorageControlsError',
            message: e.message || ''
        });
        $affe817fa27c9a8e$export$19bc72f5ccd901a6();
    }
};

});





const $915023b8afa83aa8$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $915023b8afa83aa8$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("cpkr0", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $0913ae43ba61e45d$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $kRdYM = parcelRequire("kRdYM");

var $jf8p7 = parcelRequire("jf8p7");

var $bKxX9 = parcelRequire("bKxX9");

var $6xFTe = parcelRequire("6xFTe");


const $0913ae43ba61e45d$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!(0, $bKxX9.ff)('eoc-api-key-management-feature-jira_8ox4z') || !isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $kRdYM.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $0913ae43ba61e45d$export$b16eaa5246afc9b6 = ()=>(0, $6xFTe.createResource)({
        type: (0, $be0f36e5e3d53287$export$5879151f0d972f18),
        getKey: ()=>'check-api-key-management-keys',
        getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const tenantInfo = await dependencies[0, $02315c431173f662$export$25ee35b01de9d734]?.promise;
            const isTransitioning = (0, $jf8p7.checkIsTransitioning)(tenantInfo);
            return $0913ae43ba61e45d$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
        },
        maxAge: Infinity,
        isBrowserOnly: true,
        depends: [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]
    });

});
parcelRegister("kRdYM", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $7775a32a91a5ec92$export$212b9c60150b5a0a);

var $XHGTv = parcelRequire("XHGTv");

var $7JEKn = parcelRequire("7JEKn");

var $fYqUr = parcelRequire("fYqUr");

var $3lxlO = parcelRequire("3lxlO");
const $7775a32a91a5ec92$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') input = (0, $3lxlO.withPrefix)(input, init);
    else input = {
        ...input,
        url: (0, $3lxlO.withPrefix)(input.url, init)
    };
    const errorTransformer = init?.errorTransformer ?? (0, $3lxlO.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $7JEKn.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $7JEKn.HTTPError)(response);
        if ((0, $XHGTv.getBooleanFF)('platform.send-eoc-fetch-metrics-to-performance-portal_1u3l0')) {
            const sanitizedUrl = (0, $3lxlO.sanitizeUrlString)((0, $3lxlO.getRequestUrl)(input));
            (0, $fYqUr.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now());
        }
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $7JEKn.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("7JEKn", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $d68e2f12e365276a$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $d68e2f12e365276a$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $d68e2f12e365276a$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $d68e2f12e365276a$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $d68e2f12e365276a$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $d68e2f12e365276a$export$4f52fcea95c8f97d);

var $bSKtU = parcelRequire("bSKtU");
class $d68e2f12e365276a$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!');
        this.name = name;
        this.cause = cause;
    }
}
class $d68e2f12e365276a$export$aa9d629c530f62a7 extends $d68e2f12e365276a$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $bSKtU.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $d68e2f12e365276a$export$c30b5b02747d791c extends $d68e2f12e365276a$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response);
        this.cause = cause;
        this.data = data;
        this.message = message;
        this.message = message;
        this.name = (0, $bSKtU.ERROR_NAMES).StreamedHTTPError;
    }
}
const $d68e2f12e365276a$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $d68e2f12e365276a$export$aa9d629c530f62a7 || [
        (0, $bSKtU.ERROR_NAMES).HTTPError,
        (0, $bSKtU.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $d68e2f12e365276a$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $d68e2f12e365276a$export$bae979e68e4dc802 || [
        (0, $bSKtU.ERROR_NAMES).NetworkError,
        (0, $bSKtU.ERROR_NAMES).HTTPError,
        (0, $bSKtU.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $d68e2f12e365276a$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $d68e2f12e365276a$export$c30b5b02747d791c || candidate?.name === (0, $bSKtU.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("bSKtU", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $2ded0429e5da1da0$export$daceac3b97803ce1);
var $2ded0429e5da1da0$export$daceac3b97803ce1;
(function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
})($2ded0429e5da1da0$export$daceac3b97803ce1 || ($2ded0429e5da1da0$export$daceac3b97803ce1 = {}));

});


parcelRegister("3lxlO", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $757b9ebe01720e4f$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $757b9ebe01720e4f$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $757b9ebe01720e4f$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $757b9ebe01720e4f$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $757b9ebe01720e4f$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $757b9ebe01720e4f$export$ceb09b958e605eff);

var $8ji9h = parcelRequire("8ji9h");

var $7JEKn = parcelRequire("7JEKn");

let $757b9ebe01720e4f$var$metaCloudId;
let $757b9ebe01720e4f$var$isJSMAvailable = true;
function $757b9ebe01720e4f$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $8ji9h.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($757b9ebe01720e4f$var$metaCloudId) return $757b9ebe01720e4f$var$metaCloudId;
    if ($757b9ebe01720e4f$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $757b9ebe01720e4f$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $757b9ebe01720e4f$var$isJSMAvailable = !!$757b9ebe01720e4f$var$metaCloudId;
    }
    return $757b9ebe01720e4f$var$metaCloudId;
}
function $757b9ebe01720e4f$export$5a75f4aeb58ba80f(id) {
    $757b9ebe01720e4f$var$metaCloudId = id;
}
function $757b9ebe01720e4f$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $757b9ebe01720e4f$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $875484804ad28aca$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $757b9ebe01720e4f$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $757b9ebe01720e4f$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $7JEKn.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $757b9ebe01720e4f$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $757b9ebe01720e4f$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $7JEKn.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $757b9ebe01720e4f$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $757b9ebe01720e4f$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $757b9ebe01720e4f$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("8ji9h", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $a0acbe87ddc44949$export$6acf61af03e62db);
const $a0acbe87ddc44949$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $875484804ad28aca$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("jf8p7", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $77654e10ad778a08$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $77654e10ad778a08$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $77654e10ad778a08$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $77654e10ad778a08$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $77654e10ad778a08$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $77654e10ad778a08$export$cd227238525e8d57);

var $lPDOE = parcelRequire("lPDOE");

const $77654e10ad778a08$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED;
};
const $77654e10ad778a08$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONING;
};
const $77654e10ad778a08$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).CONSOLIDATED;
};
const $77654e10ad778a08$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONED;
};
const $77654e10ad778a08$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1);
};
const $77654e10ad778a08$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$a101f3562b5f0742));
};

});
parcelRegister("lPDOE", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $1d60cf44e0c38c08$export$9ef498b0a11fd37d);
const $1d60cf44e0c38c08$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $9e5329fbcc13ca2e$export$650f6934db1290c1 = 'cohort3';
const $9e5329fbcc13ca2e$export$a101f3562b5f0742 = 'cohort3.5';


const $02315c431173f662$export$25ee35b01de9d734 = 'EOC_TENANT';

const $be0f36e5e3d53287$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("hlO97", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $df22f4299975551a$export$4b870505c49999ef);

var $guiFP = parcelRequire("guiFP");

var $6xFTe = parcelRequire("6xFTe");

var $e70K7 = parcelRequire("e70K7");

var $9EQcI = parcelRequire("9EQcI");
const $df22f4299975551a$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $df22f4299975551a$export$4b870505c49999ef = (0, $6xFTe.createResource)({
    type: $df22f4299975551a$var$RESOURCE_KEY,
    getKey: ()=>$df22f4299975551a$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $e70K7.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("e70K7", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $f1438afaaf09dc03$export$df7594d56c9ebe57);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $9EQcI = parcelRequire("9EQcI");
const $f1438afaaf09dc03$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $9EQcI.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $48bs8.getUserProperty)(accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $guiFP.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $7byHA.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $7byHA.default) && error.statusCode === 404) return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("9EQcI", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $ede4833892459008$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $ede4833892459008$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $ede4833892459008$export$23da4710c3a29eae);
const $ede4833892459008$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $ede4833892459008$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $ede4833892459008$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("dAKwA", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $kRdYM = parcelRequire("kRdYM");

var $1ybV0 = parcelRequire("1ybV0");

var $6xFTe = parcelRequire("6xFTe");

var $lPDOE = parcelRequire("lPDOE");

const $59d64f3d4fc6187b$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
    let url = '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED
            });
        });
        return promise;
    }
    if (false) promise = (0, $kRdYM.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': 'og-apigw-atlassian-gw'
        }
    });
    else promise = (0, $kRdYM.eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
    if ((0, $1ybV0.ff)('eoc-tenant-info-hook_dq6ke')) return promise;
    return promise.then((response)=>response.consolidationState);
};
const $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $6xFTe.createResource)({
        type: (0, $02315c431173f662$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$59d64f3d4fc6187b$export$de6c19ae237c1eb9(cloudId, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });

});

parcelRegister("jlBE2", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $4ec33ba6cfdbce95$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $4ec33ba6cfdbce95$export$3870b1ff1b155c73);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $cm5m0 = parcelRequire("cm5m0");

const $4ec33ba6cfdbce95$export$ee94bb1f59b07e35 = (0, $6xFTe.createResource)({
    type: (0, $af92d8ab297d74d2$export$6f0555de4f60e84e),
    getKey: ()=>(0, $af92d8ab297d74d2$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $cm5m0.userPreferenceAPI).get((0, $af92d8ab297d74d2$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $af92d8ab297d74d2$export$b8b9d90f9e5bd72b),
                    teamName: 'deliveroo'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false
        };
    },
    maxAge: Number.MAX_VALUE
});
const $4ec33ba6cfdbce95$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $h5RgW.useResource)($4ec33ba6cfdbce95$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const dismissReadMore = (0, $eUqFw.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        dismissReadMore: dismissReadMore,
        loading: loading
    };
};

});
parcelRegister("cm5m0", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $65cd88220f00e257$export$4f7929ca6b50a436);


var $lRmyA = parcelRequire("lRmyA");
const $65cd88220f00e257$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $65cd88220f00e257$var$get = async (key)=>{
    try {
        const result = await (0, $lRmyA.performGetRequest)($65cd88220f00e257$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $65cd88220f00e257$var$set = (key, value)=>(0, $lRmyA.performPutRequest)($65cd88220f00e257$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $65cd88220f00e257$var$remove = (key)=>(0, $lRmyA.performDeleteRequest)($65cd88220f00e257$var$url(key));
const $65cd88220f00e257$export$4f7929ca6b50a436 = {
    get: $65cd88220f00e257$var$get,
    set: $65cd88220f00e257$var$set,
    remove: $65cd88220f00e257$var$remove
};

});

const $af92d8ab297d74d2$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $af92d8ab297d74d2$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $af92d8ab297d74d2$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $af92d8ab297d74d2$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("ellXt", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $d1ab65e118ce0b83$export$14c89b6b6a261524);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");

const $d1ab65e118ce0b83$export$14c89b6b6a261524 = (0, $6xFTe.createResource)({
    type: (0, $937f75d7d64d5d05$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $lRmyA.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $937f75d7d64d5d05$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("8Osbm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $c9c7ef93c34099a4$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $c9c7ef93c34099a4$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $c9c7ef93c34099a4$export$283aa034b7d4e2a0);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

const $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $lRmyA.performGetRequest)((0, $6a195a4b7e83469e$export$5bf8eb915287f5f4));
const $c9c7ef93c34099a4$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $c9c7ef93c34099a4$export$369caf52ed1ad2b1 = (0, $6xFTe.createResource)({
    type: (0, $6a195a4b7e83469e$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $6a195a4b7e83469e$export$f2f2f265ccc09f82),
    getData: async ()=>{
        if (!(0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w')) return {
            incomingMailServerExpiryStatus: {
                ...$c9c7ef93c34099a4$export$32d9db53927095d3,
                showBanner: false
            }
        };
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $c9c7ef93c34099a4$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $c9c7ef93c34099a4$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $h5RgW.useResource)($c9c7ef93c34099a4$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eUqFw.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $c9c7ef93c34099a4$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $6a195a4b7e83469e$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $6a195a4b7e83469e$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $6a195a4b7e83469e$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("h0Ytu", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $a8290ca1941fd80d$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $a8290ca1941fd80d$export$e21c345b2538e96e);

var $eUqFw = parcelRequire("eUqFw");

var $6G5mG = parcelRequire("6G5mG");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $058mG = parcelRequire("058mG");
const $a8290ca1941fd80d$export$1b6468a6eb7d9b09 = (0, $6xFTe.createResource)({
    type: (0, $058mG.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = (0, $058mG.USER_SEEN_CARDINALITY_UNKNOWN);
        try {
            const apiResult = await (0, $lRmyA.performGetRequest)((0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $guiFP.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) return {
                numberOfTimesUserHasSeenChangeboarding: 0
            };
            (0, $guiFP.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount
        };
    }
});
const $a8290ca1941fd80d$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $h5RgW.useResource)($a8290ca1941fd80d$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $eUqFw.useState)(()=>{
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $058mG.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            await (0, $lRmyA.performPutRequest)((0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify({
                    value: updates
                })
            });
            setResponseStatusPut('success');
            update(()=>({
                    numberOfTimesUserHasSeenChangeboarding: updates
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("058mG", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $0ce11008f44b5e39$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $0ce11008f44b5e39$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $0ce11008f44b5e39$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $0ce11008f44b5e39$export$91880069e7e73b18);
const $0ce11008f44b5e39$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $0ce11008f44b5e39$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $0ce11008f44b5e39$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $0ce11008f44b5e39$export$91880069e7e73b18 = -1;

});


parcelRegister("6XOSh", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $839ddb0b122518f6$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $839ddb0b122518f6$export$bc11d4816053db5c);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


var $ZKxj9 = parcelRequire("ZKxj9");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState = async ()=>(0, $lRmyA.performGetRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca));
const $839ddb0b122518f6$export$5fbcf4d7a6d9c477 = (0, $6xFTe.createResource)({
    type: (0, $62811791007d8b59$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $62811791007d8b59$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc') || (0, $dfBCt.isFedRamp)();
        const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $ZKxj9.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $lRmyA.performPutRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $839ddb0b122518f6$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $h5RgW.useResource)($839ddb0b122518f6$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eUqFw.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $ZKxj9.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $62811791007d8b59$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $62811791007d8b59$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $62811791007d8b59$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $62811791007d8b59$export$880a78695d76498e = 8;

parcelRegister("ZKxj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $99072b8c90c9105d$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");
const $99072b8c90c9105d$var$FF_POSSIBLE_VALUES = [
    'OFF',
    'BY_DEFAULT_USER_OPT_IN',
    'BY_DEFAULT_USER_OPT_OUT'
];
const $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc') || (0, $dfBCt.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    const isExplicitlyUseTurnedOff = (0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $99072b8c90c9105d$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
    return isExplicitlyUseTurnedOff ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $99072b8c90c9105d$export$2e2bcd8739ae039 = $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("l6RYU", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $694329614259616a$export$fa191d7d71460a98);

var $e91YZ = parcelRequire("e91YZ");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");

const $694329614259616a$export$fa191d7d71460a98 = (0, $6xFTe.createResource)({
    type: (0, $05abdcb8189088ad$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $05abdcb8189088ad$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("9CFDS", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $979e04dcc1e8ef35$export$44e7ad3c66a3f25f);

var $6xFTe = parcelRequire("6xFTe");

var $hdKL9 = parcelRequire("hdKL9");
var $9zYls = parcelRequire("9zYls");

const $979e04dcc1e8ef35$export$44e7ad3c66a3f25f = (0, $6xFTe.createResource)({
    type: (0, $892a51daa0b1294e$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $hdKL9.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("hdKL9", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $7f8c4b071371acc8$export$d1d13c4b972a22f1);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $7f8c4b071371acc8$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $7f8c4b071371acc8$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("9sh4S"));
        if (!fetchProtobuf) (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $7f8c4b071371acc8$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
};
const $7f8c4b071371acc8$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $7f8c4b071371acc8$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $2OdyW.default)(sidebarUrl);
};

});
parcelRegister("9sh4S", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ioYkw").then(()=>parcelRequire('bHKJS'));

});


const $892a51daa0b1294e$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("1NIhY", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $f81bf6691f07ea3e$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $5iWql = parcelRequire("5iWql");

var $6xFTe = parcelRequire("6xFTe");

var $jCGD5 = parcelRequire("jCGD5");

const $f81bf6691f07ea3e$var$getNavigationUiStateMemoized = (0, $5iWql.default)((atlassianAccountId)=>(0, $jCGD5.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $f81bf6691f07ea3e$export$14c178691841b423 = (0, $6xFTe.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$f81bf6691f07ea3e$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("jCGD5", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $db77001cbd8f906b$export$29999268b070c9bd);

var $48bs8 = parcelRequire("48bs8");


var $lTttU = parcelRequire("lTttU");
const $db77001cbd8f906b$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $lTttU.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $48bs8.getUserProperty)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $lTttU.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $75b7df28d47cff7a$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $75b7df28d47cff7a$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("lTttU", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $4239519c11764e08$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $4239519c11764e08$export$ec13c725e067146a);

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

const $4239519c11764e08$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
};
const $4239519c11764e08$var$queryLocalStorageSync = ()=>{
    const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
    const item = localStorage.getItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $75b7df28d47cff7a$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $4239519c11764e08$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $4239519c11764e08$var$queryLocalStorageSync();
        resolve(item);
    });
const $4239519c11764e08$export$ec13c725e067146a = (data)=>{
    const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
    localStorage.setItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("gF5SK", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $43a0964905230dcb$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $43a0964905230dcb$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $43a0964905230dcb$export$3b09097f2a423abd);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


const $43a0964905230dcb$export$babbf5bfbc4d268c = (0, $6xFTe.createResource)({
    type: (0, $bf1b1f026fde1439$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("jEcQ4")),
    maxAge: Number.MAX_VALUE
});
const $43a0964905230dcb$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $43a0964905230dcb$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $43a0964905230dcb$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $43a0964905230dcb$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $h5RgW.useResource)($43a0964905230dcb$export$babbf5bfbc4d268c);

});
const $bf1b1f026fde1439$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("jEcQ4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4VHyJ").then(()=>parcelRequire('e1dkv'));

});


parcelRegister("fKYF0", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $9179d1c8af5062b2$export$266a039a005e8314);

var $6xFTe = parcelRequire("6xFTe");


const $9179d1c8af5062b2$export$266a039a005e8314 = (0, $6xFTe.createResource)({
    type: (0, $9cf0ecd2babadcc5$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("75Uv8")),
    maxAge: Number.MAX_VALUE
});

});
const $9cf0ecd2babadcc5$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $9cf0ecd2babadcc5$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $9cf0ecd2babadcc5$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("75Uv8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8V0MZ").then(()=>parcelRequire('9HgCP'));

});


parcelRegister("ixwgj", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $97b06b2828b1be93$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $97b06b2828b1be93$export$d75816e37af81473);

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");


const $97b06b2828b1be93$var$getDataLoader = ()=>(parcelRequire("8FY9p"));
const $97b06b2828b1be93$export$27ad0d75c619be68 = (0, $6xFTe.createResource)({
    type: (0, $e9754370217fd66e$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $97b06b2828b1be93$var$getDataLoader,
    maxAge: 1800000
});
const $97b06b2828b1be93$export$d75816e37af81473 = $97b06b2828b1be93$export$27ad0d75c619be68;

});
const $e9754370217fd66e$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("8FY9p", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cLVTX").then(()=>parcelRequire('6oUEv'));

});


parcelRegister("grsJA", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $75c646b84cc2b8ad$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $75c646b84cc2b8ad$export$b9cee3799212b85a);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $jwzNs = parcelRequire("jwzNs");

const $75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $75c646b84cc2b8ad$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $3fb9e0f992806b04$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null
    };
};
const $75c646b84cc2b8ad$export$a0974cf24d16bc5d = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jira.frontend.enable-rovo-entitlement-resource-router'), (0, $6xFTe.createResource)({
    type: $75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$75c646b84cc2b8ad$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
}));
const $75c646b84cc2b8ad$export$b9cee3799212b85a = ()=>(0, $h5RgW.useResource)($75c646b84cc2b8ad$export$a0974cf24d16bc5d);

});
const $3fb9e0f992806b04$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;


parcelRegister("3vlQh", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $51abc3777a1ecce4$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $51abc3777a1ecce4$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $51abc3777a1ecce4$export$31c6945718067be3);

var $6xFTe = parcelRequire("6xFTe");


const $51abc3777a1ecce4$export$b2b94ce8ba590cc8 = (0, $6xFTe.createResource)({
    type: (0, $8c440df88740d3a4$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("1RW2T"))
});

const $51abc3777a1ecce4$export$e81d7afef87ae597 = (0, $6xFTe.createResource)({
    type: (0, $8c440df88740d3a4$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("jiByF"))
});

const $51abc3777a1ecce4$export$31c6945718067be3 = (0, $6xFTe.createResource)({
    type: (0, $8c440df88740d3a4$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("bKVfu")),
    maxAge: Number.MAX_SAFE_INTEGER
});

});
const $8c440df88740d3a4$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $8c440df88740d3a4$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $8c440df88740d3a4$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("1RW2T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("a5Zg4").then(()=>parcelRequire('dJRnz'));

});

parcelRegister("jiByF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kb1Sj").then(()=>parcelRequire('gZWJg'));

});

parcelRegister("bKVfu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8856W").then(()=>parcelRequire('8XkTQ'));

});


parcelRegister("3MEW8", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $aa9979c4bb771fd9$export$3416635c8aeb5bab);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


var $YWIXh = parcelRequire("YWIXh");

const $aa9979c4bb771fd9$var$getDataLoader = ()=>(parcelRequire("6OpTH"));
const $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0 = (0, $6xFTe.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $aa9979c4bb771fd9$var$getDataLoader,
    maxAge: 300000
});
const $aa9979c4bb771fd9$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $h5RgW.useResource)($aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eUqFw.useCallback)((current, next)=>{
        const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea),
            actionSubject: (0, $6f1b3f4a1b1409cf$export$9e2cc65718a61846)
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eUqFw.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $YWIXh.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $6f1b3f4a1b1409cf$export$9e2cc65718a61846 = 'themePreference';
const $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("YWIXh", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $31ba3788a5049b63$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $31ba3788a5049b63$export$2f7a12048d96237);

var $eM3G3 = parcelRequire("eM3G3");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

const $31ba3788a5049b63$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $cm5m0.userPreferenceAPI).set((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $31ba3788a5049b63$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $cm5m0.userPreferenceAPI).get((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $eM3G3.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $eM3G3.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("eM3G3", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $65da877bf2b17a02$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $65da877bf2b17a02$export$2faeed762aac6741);
const $65da877bf2b17a02$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $65da877bf2b17a02$export$2faeed762aac6741 = 'light';

});


parcelRegister("6OpTH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8mnLk")
]).then(()=>parcelRequire('foRwS'));

});


parcelRegister("4uxD3", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $08039d73d4df766b$export$16320dd0d1e6c145);

var $lRmyA = parcelRequire("lRmyA");

var $6xFTe = parcelRequire("6xFTe");

const $08039d73d4df766b$export$16320dd0d1e6c145 = (0, $6xFTe.createResource)({
    type: (0, $1af1518206a530c1$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
        const { homepagePreference: homepagePreference } = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $1af1518206a530c1$export$2026a6db44b15de7 = 'USER_HOMEPAGE';



parcelRegister("bCmyq", function(module, exports) {

$parcel$export(module.exports, "LegacyPage", () => $61eea69f8de6ca0a$export$273311ee2c946a58);

var $eUqFw = parcelRequire("eUqFw");

var $k1v3Y = parcelRequire("k1v3Y");
const $61eea69f8de6ca0a$export$273311ee2c946a58 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k1v3Y.default), {
        match: props.match,
        action: props.action,
        route: props.route,
        isSpa: false
    }));
var $61eea69f8de6ca0a$export$2e2bcd8739ae039 = $61eea69f8de6ca0a$export$273311ee2c946a58;

});
parcelRegister("k1v3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1060a9721c3b7f46$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $exb0h = parcelRequire("exb0h");

var $lcJyp = parcelRequire("lcJyp");

var $3oscM = parcelRequire("3oscM");

var $cVz42 = parcelRequire("cVz42");
// eslint-disable-next-line jira/react/no-class-components
class $1060a9721c3b7f46$var$SpaStateResetPage extends (0, $eUqFw.Component) {
    shouldComponentUpdate(nextProps) {
        const cleanMatch = (0, $3oscM.getApdexMatchObject)(this.props.match, this.props.route);
        const cleanNextMatch = (0, $3oscM.getApdexMatchObject)(nextProps.match, nextProps.route);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(cleanMatch, cleanNextMatch);
    }
    render() {
        const { action: action, match: match, route: route, isSpa: isSpa } = this.props;
        const shouldNotUpdate = action === 'REPLACE' && (!isSpa || route.name === (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR));
        return /* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { resetCurrentPage: resetCurrentPage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVz42.default), {
                // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type '() => Action<State, void, void | Promise<void>>'.
                resetCurrentPage: shouldNotUpdate ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : resetCurrentPage,
                match: (0, $3oscM.getApdexMatchObject)(match, route),
                route: route
            }));
    }
}
var $1060a9721c3b7f46$export$2e2bcd8739ae039 = $1060a9721c3b7f46$var$SpaStateResetPage;

});
parcelRegister("lcJyp", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $847fac6342ee5df8$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $847fac6342ee5df8$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $847fac6342ee5df8$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $847fac6342ee5df8$export$b134752525935b78);

var $WBLbN = parcelRequire("WBLbN");

var $cfLkw = parcelRequire("cfLkw");
const $847fac6342ee5df8$export$fd52daf2a3c1ec68 = (0, $WBLbN.createSubscriber)((0, $cfLkw.default));
const $847fac6342ee5df8$export$3dfa91988c213fbc = (0, $WBLbN.createSubscriber)((0, $cfLkw.default), {
    selector: null
});
const $847fac6342ee5df8$export$a57865516f6345d1 = (0, $WBLbN.createHook)((0, $cfLkw.default));
const $847fac6342ee5df8$export$b134752525935b78 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: null
});

});
parcelRegister("cfLkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e76bb655f4dbc8c$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $WBLbN = parcelRequire("WBLbN");

var $a2pDC = parcelRequire("a2pDC");
const $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $7e76bb655f4dbc8c$var$store = (0, $WBLbN.createStore)({
    name: 'spa-state',
    initialState: $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a,
    actions: $a2pDC
});
var $7e76bb655f4dbc8c$export$2e2bcd8739ae039 = $7e76bb655f4dbc8c$var$store;

});
parcelRegister("a2pDC", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("gKuw7")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("gKuw7")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("gKuw7")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("gKuw7")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("gKuw7")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("gKuw7")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("gKuw7")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("gKuw7")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("gKuw7")).setResourceMetrics);

var $gKuw7 = parcelRequire("gKuw7");

});
parcelRegister("gKuw7", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $1354b0144a8be88b$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $1354b0144a8be88b$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $1354b0144a8be88b$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $1354b0144a8be88b$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $1354b0144a8be88b$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $1354b0144a8be88b$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $1354b0144a8be88b$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $1354b0144a8be88b$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $1354b0144a8be88b$export$8ad155d489dcf34d);

var $hompL = parcelRequire("hompL");

var $acbV3 = parcelRequire("acbV3");

var $1ybV0 = parcelRequire("1ybV0");

var $keguF = parcelRequire("keguF");

var $4nnPJ = parcelRequire("4nnPJ");

var $ULuRM = parcelRequire("ULuRM");
const $1354b0144a8be88b$export$7bd623b29ec8e1eb = 10000;
const $1354b0144a8be88b$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $acbV3.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $ULuRM.default)(nextRouteUfoName, nextRouteName);
        if ((0, $1ybV0.ff)('uip.ufo')) {
            (0, $4nnPJ.GlobalPageLoadExperience).abort({
                force: true
            });
            (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        }
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $1354b0144a8be88b$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $1354b0144a8be88b$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $1354b0144a8be88b$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId));
            }, $1354b0144a8be88b$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $keguF.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$9d528722f2ff2999(appId, startTime));
    };
const $1354b0144a8be88b$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$6a25429a42d30f9a(appId, endTime));
    };
const $1354b0144a8be88b$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




parcelRegister("3oscM", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $c71ed4be82b11f4e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $c71ed4be82b11f4e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $c71ed4be82b11f4e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $c71ed4be82b11f4e$export$9f3e656a7f6a3adc);

var $exb0h = parcelRequire("exb0h");
const $c71ed4be82b11f4e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [
                (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
            ];
            resetDone = true;
            break;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $c71ed4be82b11f4e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $c71ed4be82b11f4e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
            // use search to navigate to board
            if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $c71ed4be82b11f4e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $c71ed4be82b11f4e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 0, $exb0h.ROUTE_NAMES_ISSUE:
        case 0, $exb0h.ROUTE_NAMES_ISSUE_EMBED:
        case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
        case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
        case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
        case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("cVz42", function(module, exports) {

$parcel$export(module.exports, "default", () => $1533feaa3c496d01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $3oscM = parcelRequire("3oscM");
class $1533feaa3c496d01$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.resetDone = true;
        this.rapidBoardPaths = [];
        const [paths] = (0, $3oscM.calcRapidBoardResetState)(this.rapidBoardPaths, this.props.route.name, !!this.props.match.query.useStoredSettings);
        this.rapidBoardPaths = paths;
    }
    shouldComponentUpdate(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props.match, nextProps.match)) {
            // RapidboardPaths is being persisted here.
            // resetDone boolean is calculated in the util function.
            const [paths, resetBoolean] = (0, $3oscM.calcRapidBoardResetState)(this.rapidBoardPaths, nextProps.route.name, !!nextProps.match.query.useStoredSettings);
            this.rapidBoardPaths = paths;
            this.resetDone = resetBoolean;
        }
        return true;
    }
    componentDidUpdate() {
        if (!this.resetDone) {
            if (!__SPA__) {
                this.resetDone = true;
                return;
            }
            this.props.resetCurrentPage();
            this.resetDone = true;
        }
    }
    render() {
        return null;
    }
}

});



parcelRegister("lMiJ0", function(module, exports) {

$parcel$export(module.exports, "addonsEmceePublicRouteEntry", () => $6a35d5ee6f83429c$export$7922e0b87a833c8e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $dpViY = parcelRequire("dpViY");
const $6a35d5ee6f83429c$export$7922e0b87a833c8e = (0, $bMm60.createEntry)((0, $dpViY.addonsEmceePublicRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)()
    ]
});

});
parcelRegister("efFTI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $f4bfbc079ef4e42a$export$e6aef6083548e882);

var $dVvIP = parcelRequire("dVvIP");

var $isbb2 = parcelRequire("isbb2");
const $f4bfbc079ef4e42a$export$e6aef6083548e882 = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout));

});
parcelRegister("dVvIP", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $d3e020a4d042f679$export$929cb72e7acb7fd9);

var $isbb2 = parcelRequire("isbb2");
const $d3e020a4d042f679$var$rightSidebars = ()=>[];
const $d3e020a4d042f679$export$929cb72e7acb7fd9 = (0, $isbb2.createLayout)({
    rightSidebars: $d3e020a4d042f679$var$rightSidebars()
});

});
parcelRegister("isbb2", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $7465cd989816140c$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $7465cd989816140c$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $7465cd989816140c$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $7465cd989816140c$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $7465cd989816140c$export$e97a7da67a5b8ce4);

var $eUqFw = parcelRequire("eUqFw");

var $cPEpP = parcelRequire("cPEpP");

var $gGtKh = parcelRequire("gGtKh");

var $jiReJ = parcelRequire("jiReJ");
const $7465cd989816140c$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $7465cd989816140c$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $7465cd989816140c$export$6e5538615c060df7(displayName) ?? $7465cd989816140c$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null)));
    });
const $7465cd989816140c$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $7465cd989816140c$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $7465cd989816140c$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $7465cd989816140c$export$3dd437ade36ede40(layout);
};
const $7465cd989816140c$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $7465cd989816140c$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $7465cd989816140c$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $7465cd989816140c$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $7465cd989816140c$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $cPEpP.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
    };
    const name = $7465cd989816140c$export$6e5538615c060df7(Component.displayName) ?? $7465cd989816140c$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $7465cd989816140c$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("cPEpP", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $681442ce6e3ade0b$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");

var $eWsAG = parcelRequire("eWsAG");

var $2futN = parcelRequire("2futN");
const $681442ce6e3ade0b$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarNavigation)(customContext);
    const project = (0, $eUqFw.useMemo)(()=>data && (0, $eWsAG.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eWsAG", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $994f1ddfe6829bdc$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $994f1ddfe6829bdc$export$9df5fa0a366163d2);

var $7ZZxN = parcelRequire("7ZZxN");
const $994f1ddfe6829bdc$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC;
const $994f1ddfe6829bdc$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $994f1ddfe6829bdc$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey
    });
const $994f1ddfe6829bdc$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("2futN", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $e6824b09c7b48982$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $e6824b09c7b48982$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $e6824b09c7b48982$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $e6824b09c7b48982$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $e6824b09c7b48982$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $e6824b09c7b48982$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $e6824b09c7b48982$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $e6824b09c7b48982$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $e6824b09c7b48982$export$d63d92edebe543d9);

var $eUqFw = parcelRequire("eUqFw");

var $7wRIc = parcelRequire("7wRIc");
var $kKeF6 = parcelRequire("kKeF6");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");

var $iZJHG = parcelRequire("iZJHG");

var $h5RgW = parcelRequire("h5RgW");

var $cLNfQ = parcelRequire("cLNfQ");
const $e6824b09c7b48982$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $kXWpU.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $eUqFw.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $cLNfQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $e6824b09c7b48982$export$2bed15cd7d167db5 = ()=>(0, $h5RgW.useResource)((0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$a9d05fc2c1d94895 = ()=>(0, $h5RgW.useResource)((0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$d48e3c3556894533 = ()=>(0, $h5RgW.useResource)((0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$24a781cd863077aa = ()=>(0, $h5RgW.useResource)((0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("7wRIc", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $1da568058e8dfab8$export$fab84295e18e9246);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $1da568058e8dfab8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $1da568058e8dfab8$export$fab84295e18e9246 = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$1da568058e8dfab8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $1da568058e8dfab8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("kKeF6", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5a0ad956b22e7be5$export$b662f3f877add30d);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $5a0ad956b22e7be5$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5a0ad956b22e7be5$export$b662f3f877add30d = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5a0ad956b22e7be5$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5a0ad956b22e7be5$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("iZJHG", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $8cce526bdc89f636$export$61dad767cf446185);

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $lB25E = parcelRequire("lB25E");
var $h5RgW = parcelRequire("h5RgW");

var $dUsMe = parcelRequire("dUsMe");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $8cce526bdc89f636$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
/**
 * Reusable hook, to pass *custom context* to the React router resource
 */ const $8cce526bdc89f636$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
    let useResourceArgCustomContext;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
            routerContext: (0, $lB25E.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const resourceResponse = (0, $h5RgW.useResource)(resource, useResourceArgCustomContext);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $dUsMe.useInitFetchResource)(resourceResponse, !customRouterContext);
    return resourceResponse;
};
/**
 * Allows for router resources to be to be fetched on a route that doesn't include the required router params. A custom router context can be passed to the resource to fetch the data.
 * The resource will be automatically fetched via `refresh()` when the component mounts, unless disabled via `options.autoFetch = false`. If you don't need this behaviour, use `useResource` instead.
 */ function $8cce526bdc89f636$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $lB25E.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $h5RgW.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $dUsMe.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}
const $8cce526bdc89f636$export$61dad767cf446185 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('fix_useinitresource_data_bug'), $8cce526bdc89f636$var$useResourceWithCustomRouterContextWithOptions, $8cce526bdc89f636$var$useResourceWithCustomRouterContextOld);

});
parcelRegister("8LJqN", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $96fc75653c9b207d$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $96fc75653c9b207d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("dUsMe", function(module, exports) {

$parcel$export(module.exports, "useInitFetchResource", () => $e60431eaa4374b0b$export$5b98692301d8680);
$parcel$export(module.exports, "usePrefetchableResource", () => $e60431eaa4374b0b$export$99f17ace416cfe75);

var $eUqFw = parcelRequire("eUqFw");
const $e60431eaa4374b0b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
    (0, $eUqFw.useEffect)(()=>{
        if (skipInitFetch) return;
        if (!data && !loading && !error && refresh) refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh,
        ...rest
    };
};
function $e60431eaa4374b0b$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("cLNfQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $1154a45446083a64$export$780174995da89d60);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kXWpU = parcelRequire("kXWpU");

var $kXWpU = parcelRequire("kXWpU");

var $lB25E = parcelRequire("lB25E");
var $h5RgW = parcelRequire("h5RgW");
const $1154a45446083a64$export$90dbde7e33e6e21 = ()=>null;
const $1154a45446083a64$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $lB25E.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $1154a45446083a64$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $h5RgW.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $lB25E.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $1154a45446083a64$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $h5RgW.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$780174995da89d60 = (latestNavInfo)=>{
    const [{ match: match, query: query, route: { name: name } }] = (0, $lB25E.useRouter)();
    const isOnBoardBasedRoute = (0, $kXWpU.getIdentifier)(name, match, query)?.identifierType === 'boardId';
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $1154a45446083a64$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $1154a45446083a64$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eUqFw.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});



parcelRegister("jiReJ", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $b330a57b19ee3016$export$c5db53e93ba35c0f);
const $b330a57b19ee3016$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});




parcelRegister("7vTKl", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $d4390c4ef90a66f3$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $d4390c4ef90a66f3$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $d4390c4ef90a66f3$export$adf978edbdfaf080);
const $d4390c4ef90a66f3$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $d4390c4ef90a66f3$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $d4390c4ef90a66f3$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS'
};

});

parcelRegister("hUM03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1b194caac4ce1a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("k6BwM")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar, null)));
$ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $ea1b194caac4ce1a$export$2e2bcd8739ae039 = $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar;

});
parcelRegister("av9ef", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $f6954eb5e712c16f$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $f6954eb5e712c16f$export$edbd543f308bbef5);
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");
const $f6954eb5e712c16f$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $f6954eb5e712c16f$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});
parcelRegister("8fxTv", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $0e0908bb9731ec35$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $0e0908bb9731ec35$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $0e0908bb9731ec35$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $0e0908bb9731ec35$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopSSRPerformanceMark", () => $0e0908bb9731ec35$export$2c4a101f2cde4fc2);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $0e0908bb9731ec35$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $0e0908bb9731ec35$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarSSRPerformanceMark", () => $0e0908bb9731ec35$export$14f711a2cb6a655a);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $0e0908bb9731ec35$export$a018e347341b3640);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => (parcelRequire("7webZ")).NAVIGATION_SIDEBAR_SEGMENT_NAME);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => (parcelRequire("7webZ")).NAVIGATION_TOP_MARKS);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => (parcelRequire("7webZ")).NAVIGATION_SIDEBAR_MARKS);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $lNfG4 = parcelRequire("lNfG4");

var $keguF = parcelRequire("keguF");

var $inC6u = parcelRequire("inC6u");

var $7webZ = parcelRequire("7webZ");
const $0e0908bb9731ec35$var$createTopNavPageSegment = ()=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $0e0908bb9731ec35$export$8df02628d98cae7e = {
    ADDONS: (0, $lNfG4.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $0e0908bb9731ec35$var$createSidebarPageSegment = ()=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $0e0908bb9731ec35$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createTopNavPageSegment,
        [(0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $0e0908bb9731ec35$export$906025848d54198d = (segmentKey = (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eUqFw.useRef)(false);
    const segment = (0, $eUqFw.useRef)($0e0908bb9731ec35$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eUqFw.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $inC6u.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $0e0908bb9731ec35$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    (0, $eUqFw.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $0e0908bb9731ec35$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>navSegment.markSSR(metricKey), []);
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: tmpSsrMetricKey
    }) : null;
};
const $0e0908bb9731ec35$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    (0, $eUqFw.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $keguF.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $0e0908bb9731ec35$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$2c4a101f2cde4fc2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$14f711a2cb6a655a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("inC6u", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $eba039e5967c438d$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $eba039e5967c438d$export$345f21b0287f67e5);

var $eUqFw = parcelRequire("eUqFw");

var $aeTOI = parcelRequire("aeTOI");

var $illlw = parcelRequire("illlw");

var $9I5Lq = parcelRequire("9I5Lq");

var $WBLbN = parcelRequire("WBLbN");

const $eba039e5967c438d$var$initialState = {
    start: undefined,
    traces: {}
};
let $eba039e5967c438d$var$currentTraces = {};
const $eba039e5967c438d$export$2365ecd8218e21c7 = ()=>$eba039e5967c438d$var$currentTraces;
const $eba039e5967c438d$export$5c757eaa1990d0d7 = (key)=>{
    if ($eba039e5967c438d$var$currentTraces[key]) return;
    $eba039e5967c438d$var$currentTraces[key] = {
        startTime: (0, $9I5Lq.performance).now()
    };
};
const $eba039e5967c438d$export$16854dc18f8d976 = (key)=>{
    if (!$eba039e5967c438d$var$currentTraces[key] || $eba039e5967c438d$var$currentTraces[key].duration != null) return;
    $eba039e5967c438d$var$currentTraces[key].duration = (0, $9I5Lq.performance).now() - $eba039e5967c438d$var$currentTraces[key].startTime;
};
const $eba039e5967c438d$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $eba039e5967c438d$var$currentTraces = Object.assign($eba039e5967c438d$var$currentTraces, getState().traces);
        }
};
const $eba039e5967c438d$var$Store = (0, $WBLbN.createStore)({
    name: 'jira-render-tracer',
    initialState: $eba039e5967c438d$var$initialState,
    actions: $eba039e5967c438d$var$actions
});
const $eba039e5967c438d$var$RenderTracerActions = (0, $WBLbN.createSubscriber)($eba039e5967c438d$var$Store, {
    selector: null
});
const $eba039e5967c438d$export$719a95758870be58 = (0, $WBLbN.createHook)($eba039e5967c438d$var$Store, {
    selector: null
});
const $eba039e5967c438d$var$RenderTracerContainerBase = (0, $WBLbN.createContainer)($eba039e5967c438d$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $9I5Lq.performance).now()
                    }
                }
            });
        }
});
const $eba039e5967c438d$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $eba039e5967c438d$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $9I5Lq.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $9I5Lq.performance).now());
        return null;
    });
const $eba039e5967c438d$export$cba8addc8743389c = (appName = 'unknown', traces = $eba039e5967c438d$var$currentTraces)=>({
        [(0, $98d270000c5bb498$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $eba039e5967c438d$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $98d270000c5bb498$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("9I5Lq", function(module, exports) {

$parcel$export(module.exports, "performance", () => $cb19fd4c8632f94b$export$f2d2284f5fec51f8);
const $cb19fd4c8632f94b$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $cb19fd4c8632f94b$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $cb19fd4c8632f94b$var$now();
    }
    now() {
        if (false) return $cb19fd4c8632f94b$var$now() - this.startAt;
        return $cb19fd4c8632f94b$var$now();
    }
    constructor(){
        this.startAt = $cb19fd4c8632f94b$var$now();
    }
}
const $cb19fd4c8632f94b$export$f2d2284f5fec51f8 = new $cb19fd4c8632f94b$export$9a0dbed22cbf63be();

});

const $98d270000c5bb498$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';


parcelRegister("7webZ", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $ba1c37c8f1f8f79b$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $ba1c37c8f1f8f79b$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21);
const $ba1c37c8f1f8f79b$export$6635720e40ea7a7a = 'navigation.top';
const $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $ba1c37c8f1f8f79b$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});



parcelRegister("9RvDp", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $a0579ef23379c6d1$export$1edc778464f08256);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");

var $gGtKh = parcelRequire("gGtKh");

var $4C6RK = parcelRequire("4C6RK");

var $u0mbR = parcelRequire("u0mbR");

var $7Fu43 = parcelRequire("7Fu43");
const $a0579ef23379c6d1$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $u0mbR.useSidebarFail)();
    const onSuccess = (0, $u0mbR.useSidebarSuccess)();
    const onError = (0, $eUqFw.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("4C6RK", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $5b97a95fb0135b37$export$62853c5766dad0c4);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $keguF = parcelRequire("keguF");

var $gq8Ge = parcelRequire("gq8Ge");
const $5b97a95fb0135b37$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $keguF.getUserLocation)();
    const extraEventData = (0, $eUqFw.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eUqFw.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gq8Ge.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("gq8Ge", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $ca78cb141c4c2211$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $iH6c1 = parcelRequire("iH6c1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4EIGo = parcelRequire("4EIGo");

var $gnvfi = parcelRequire("gnvfi");
const $ca78cb141c4c2211$var$styles = {
    wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $ca78cb141c4c2211$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $ca78cb141c4c2211$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4EIGo))),
        className: (0, $7JEyt.default)([
            $ca78cb141c4c2211$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $gnvfi.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $gnvfi.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", {
        className: (0, $7JEyt.default)([
            $ca78cb141c4c2211$var$styles.error
        ])
    }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
};

});
parcelRegister("4EIGo", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("gnvfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $525f5b24291fe557$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $525f5b24291fe557$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("u0mbR", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b1949a81125e9848$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b1949a81125e9848$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1949a81125e9848$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1949a81125e9848$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1949a81125e9848$export$ddb17534fdfb7dc6);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");

var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $jmt32 = parcelRequire("jmt32");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $3O0Td = parcelRequire("3O0Td");

var $bgNoL = parcelRequire("bgNoL");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1949a81125e9848$var$useSidebarId } = (0, $jmt32.createValueController)('sidebar-id');
const $b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1949a81125e9848$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $lB25E.useRouter)();
    const pageId = (0, $3O0Td.usePageId)();
    const startRef = (0, $eUqFw.useRef)(Date.now());
    const onStartExperience = (0, $bDhRl.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eUqFw.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1949a81125e9848$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1949a81125e9848$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1949a81125e9848$var$useSidebarId();
    const route = (0, $10fdS.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eUqFw.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eUqFw.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1949a81125e9848$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE)
    });
    return (0, $eUqFw.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1949a81125e9848$export$ddb17534fdfb7dc6 = ()=>(0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("4qhD6", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $2f159cb06c119de7$export$606da7704d8eaf06);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $JRB5w = parcelRequire("JRB5w");

var $gtrMw = parcelRequire("gtrMw");
const $2f159cb06c119de7$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $7rh0R.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $JRB5w.isClientFetchError)(error)) return;
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("gtrMw", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $b35642cd91fe7353$export$be8ec22ac9208049);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");
const $b35642cd91fe7353$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("bDhRl", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $61606509e9879b1e$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $61606509e9879b1e$export$f20b867e738a222c);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $61606509e9879b1e$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eUqFw.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eUqFw.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $61606509e9879b1e$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $61606509e9879b1e$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eUqFw.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});
parcelRegister("10fdS", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $ddc2f4c28203b504$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $ddc2f4c28203b504$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $ddc2f4c28203b504$export$1e5fb68306bd0b92);

var $lB25E = parcelRequire("lB25E");

var $keguF = parcelRequire("keguF");
const $ddc2f4c28203b504$export$c4b7ea2942f2d0e = (0, $lB25E.createRouterSelector)((state)=>state.route);
const $ddc2f4c28203b504$export$d69a946e2d0a1c12 = (0, $lB25E.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $ddc2f4c28203b504$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $ddc2f4c28203b504$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $lB25E.useRouter)();
    return (0, $keguF.getPreviousRouterState)();
};

});


parcelRegister("fDZ6r", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $62a77bba99475ca2$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $62a77bba99475ca2$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT = {};
const $62a77bba99475ca2$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const self = (0, $eUqFw.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eUqFw.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};
const $62a77bba99475ca2$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $62a77bba99475ca2$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("jmt32", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93);

var $WBLbN = parcelRequire("WBLbN");
const $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $WBLbN.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $WBLbN.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $WBLbN.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("3O0Td", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $8b00509e9968a84b$export$3434ba5eadb360dc);

var $WBLbN = parcelRequire("WBLbN");

var $cfLkw = parcelRequire("cfLkw");
const $8b00509e9968a84b$var$useSweetStatePageId = (0, $WBLbN.createHook)((0, $cfLkw.default), {
    selector: (state)=>state.currentPage.uuid
});
const $8b00509e9968a84b$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $8b00509e9968a84b$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("bgNoL", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $425fbadb5891ec48$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $425fbadb5891ec48$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $425fbadb5891ec48$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $425fbadb5891ec48$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $425fbadb5891ec48$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $425fbadb5891ec48$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $425fbadb5891ec48$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $425fbadb5891ec48$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $425fbadb5891ec48$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $425fbadb5891ec48$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $425fbadb5891ec48$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $425fbadb5891ec48$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $425fbadb5891ec48$export$f57650e6e7be03dc);
const $425fbadb5891ec48$export$399c7e6858236b4 = 'source.code.link';
const $425fbadb5891ec48$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $425fbadb5891ec48$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $425fbadb5891ec48$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $425fbadb5891ec48$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $425fbadb5891ec48$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $425fbadb5891ec48$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $425fbadb5891ec48$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $425fbadb5891ec48$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $425fbadb5891ec48$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $425fbadb5891ec48$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $425fbadb5891ec48$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $425fbadb5891ec48$export$dde074e512e80dff = 'global-create-spotlight';
const $425fbadb5891ec48$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $425fbadb5891ec48$export$83016cff6318a5dd = Object.freeze({
    CODE_TAB: 'CODE_TAB',
    ONCALL_TAB: 'ONCALL_TAB',
    PAGES_TAB: 'PAGES_TAB'
});
const $425fbadb5891ec48$export$f371b4c263b142af = {
    [$425fbadb5891ec48$export$83016cff6318a5dd.CODE_TAB]: 'code',
    [$425fbadb5891ec48$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
    [$425fbadb5891ec48$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
};
const $425fbadb5891ec48$export$b66c40cadee12a0b = 'project/agility/index';
const $425fbadb5891ec48$export$6f454e69bce3a691 = 'project/business/index';
const $425fbadb5891ec48$export$3a0f7f7a8a0b306b = 'project/ops/index';
const $425fbadb5891ec48$export$1346c9aa3cbb477d = 'project/software/index';
const $425fbadb5891ec48$export$4598dd67943205cf = 'project/software/issues';
const $425fbadb5891ec48$export$8f36e85c5afae5 = 'project/software/reports';
const $425fbadb5891ec48$export$8151e5564c0016a1 = 'attachments';
const $425fbadb5891ec48$export$4acd0d06a25e56b5 = 'eventtypes';
const $425fbadb5891ec48$export$211ab01804585e09 = 'webhooks-admin';
const $425fbadb5891ec48$export$294b9ab8545a9f36 = 'services';
const $425fbadb5891ec48$export$665efe695022359b = 'greenhopper-lexorank-manage';
const $425fbadb5891ec48$export$47fbefc73055eb9d = 'admin-helper-admin-section';
const $425fbadb5891ec48$export$76e6bd729450de52 = 'advanced_section';
const $425fbadb5891ec48$export$ac928a90c0d3daa8 = 'collectors';
const $425fbadb5891ec48$export$309ac0136b7d5dfa = 'dark_features';
const $425fbadb5891ec48$export$998f1706a6ca29b = 'general_configuration';
const $425fbadb5891ec48$export$e9af81a594543847 = 'import_export_section';
const $425fbadb5891ec48$export$bbf19cc23216c6b = 'mail_section';
const $425fbadb5891ec48$export$693dd06b18660b78 = 'security_section';
const $425fbadb5891ec48$export$c6d1221ea0bce75e = 'shared_section';
const $425fbadb5891ec48$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
const $425fbadb5891ec48$export$af156d8e27fc5458 = 'user_interface';
const $425fbadb5891ec48$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $425fbadb5891ec48$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
];

});


parcelRegister("7Fu43", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $64b74158f6952660$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $84CBi = parcelRequire("84CBi");
const $64b74158f6952660$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64b74158f6952660$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tem _1yt4s5g3",
            __cmplp.className
        ])
    });
});
const $64b74158f6952660$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7eyVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1046e4bd7e18e79$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c1046e4bd7e18e79$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        overrides: {
            HeadingItem: {
                cssFn: (0, $jvM56.sectionHeaderSpacingStyles)
            }
        }
    });
});
var $c1046e4bd7e18e79$export$2e2bcd8739ae039 = $c1046e4bd7e18e79$var$Section;

});
parcelRegister("jvM56", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $451539d16e759684$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $451539d16e759684$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $451539d16e759684$export$a5c27bed78cfecb9);

const $451539d16e759684$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $451539d16e759684$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`
    }
};
const $451539d16e759684$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    }
};
const $451539d16e759684$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $451539d16e759684$var$defaultStyles,
        ...!isDisabled && isSelected && $451539d16e759684$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $451539d16e759684$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("gLn5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a96e6894a019ef04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $a96e6894a019ef04$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        cssFn: ()=>({
                ...(0, $jvM56.sectionHeaderSpacingStyles)(),
                // This doubles up & to get a higher specificity as well as to not overwite the base styles.
                '&&::before': {
                    height: '1.5rem',
                    marginRight: "var(--ds-space-200, 16px)",
                    width: '1.5rem'
                }
            }),
        ...props
    });
};
var $a96e6894a019ef04$export$2e2bcd8739ae039 = $a96e6894a019ef04$var$SkeletonItem;

});



parcelRegister("k6BwM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("iyqJ7")
]).then(()=>parcelRequire('60IuX'));

});


parcelRegister("bMm60", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $ed0b59c4afa4514b$export$344b9c9ab5e66c9a);
const $ed0b59c4afa4514b$export$344b9c9ab5e66c9a = (baseRoute, opts)=>Object.assign(baseRoute, opts);

});

parcelRegister("dpViY", function(module, exports) {

$parcel$export(module.exports, "addonsEmceePublicRoute", () => $2b0a0c0576982dfa$export$9f7bcf70c66ebed0);

var $exb0h = parcelRequire("exb0h");
const $2b0a0c0576982dfa$export$9f7bcf70c66ebed0 = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC),
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover'
};

});


parcelRegister("6ILls", function(module, exports) {

$parcel$export(module.exports, "legacyAllReportsRouteEntry", () => $f06dce1f95f42672$export$b8ab848c3f170ed4);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $aup9J = parcelRequire("aup9J");

var $aTgp4 = parcelRequire("aTgp4");
const $f06dce1f95f42672$export$b8ab848c3f170ed4 = (0, $bMm60.createEntry)((0, $aup9J.legacyAllReportsRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $aTgp4.getReportsCommonResource)()
    ]
});

});
parcelRegister("d1szd", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $4949b32bbf913e83$export$85dad8e9886563f6);

var $iZnNg = parcelRequire("iZnNg");

var $isbb2 = parcelRequire("isbb2");

var $csLgO = parcelRequire("csLgO");

var $soOXK = parcelRequire("soOXK");

var $7xFdb = parcelRequire("7xFdb");
const $4949b32bbf913e83$export$85dad8e9886563f6 = (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $iZnNg.coreProjectLayout), (0, $csLgO.serviceProjectLayout), (0, $soOXK.softwareProjectLayout), (0, $7xFdb.userBoardLayout));

});
parcelRegister("iZnNg", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $de69fcae9527d9e6$export$3c06ced9943ca671);

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
const $de69fcae9527d9e6$export$3c06ced9943ca671 = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));

});
parcelRegister("8QAGR", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $07993258fcc80491$export$204149bac601d20c);

var $7rh0R = parcelRequire("7rh0R");

var $i49Tf = parcelRequire("i49Tf");

var $isbb2 = parcelRequire("isbb2");

var $9dASl = parcelRequire("9dASl");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07993258fcc80491$var$withAnyProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $07993258fcc80491$var$ProjectTrackers = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("aTBTM")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $07993258fcc80491$var$ProjectFavicon = ()=>{
    (0, $9dASl.useProjectFavicon)();
    return null;
};
const $07993258fcc80491$var$rightSidebars = ()=>[];
const $07993258fcc80491$var$globalComponents = [
    $07993258fcc80491$var$withAnyProjectContext($07993258fcc80491$var$ProjectFavicon),
    $07993258fcc80491$var$withAnyProjectContext($07993258fcc80491$var$ProjectTrackers),
    $07993258fcc80491$var$withAnyProjectContext((0, $i49Tf.ProjectRouteListener))
];
const $07993258fcc80491$export$204149bac601d20c = (0, $isbb2.createLayout)({
    globalComponents: $07993258fcc80491$var$globalComponents,
    rightSidebars: $07993258fcc80491$var$rightSidebars()
});

});
parcelRegister("i49Tf", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $badefa8fb2c95856$export$159f09d701320911);

var $eUqFw = parcelRequire("eUqFw");

var $h5RgW = parcelRequire("h5RgW");

var $ixwgj = parcelRequire("ixwgj");

var $c7H0g = parcelRequire("c7H0g");

var $77Wva = parcelRequire("77Wva");
const $badefa8fb2c95856$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $c7H0g.useIsAdmin)();
    const { data: data, loading: loading } = (0, $h5RgW.useResource)((0, $ixwgj.projectContextResource));
    (0, $eUqFw.useEffect)(()=>{
        if (isSiteAdmin) (0, $77Wva.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $77Wva.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $77Wva.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eUqFw.useEffect)(()=>()=>(0, $77Wva.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("c7H0g", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $b4b4ffdc2519fb85$export$99a5e4bc80d231ca);

var $gd0Sp = parcelRequire("gd0Sp");
const $b4b4ffdc2519fb85$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});


parcelRegister("9dASl", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $ccc7b3b9e5ce6616$export$32abcb1f939de016);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");

var $cPEpP = parcelRequire("cPEpP");
const $ccc7b3b9e5ce6616$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $cPEpP.useProject)();
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eUqFw.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $eUqFw.useMemo)(()=>(0, $6rW04.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $eUqFw.useEffect)(()=>{
        const favicon = project ? project.avatarUrl : defaultFavicon;
        if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
        // Switch back to default favicon
        return ()=>{
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
        };
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("aTBTM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("f2iFO")
]).then(()=>parcelRequire('hbMGV'));

});



parcelRegister("csLgO", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $89d8cdf72602f901$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $89d8cdf72602f901$export$820f9bb834280408);

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $dVvIP = parcelRequire("dVvIP");

var $fBmd6 = parcelRequire("fBmd6");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");

var $2QkFp = parcelRequire("2QkFp");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89d8cdf72602f901$var$withServiceProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$ProjectBuilder = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("h3jf5")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("db9gl")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7nvXe")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/index.tsx"
});
const $89d8cdf72602f901$export$e321cb31c875d1ba = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout), {
    globalComponents: [
        $89d8cdf72602f901$var$withServiceProjectContext($89d8cdf72602f901$var$Onboarding),
        ...(0, $2QkFp.serviceProjectFirstImpressionsLayout).globalComponents.map($89d8cdf72602f901$var$withServiceProjectContext),
        $89d8cdf72602f901$var$withServiceProjectContext((0, $fBmd6.AsyncJsmCustomDomainChangeBoardingFlag)),
        $89d8cdf72602f901$var$ProjectBuilder
    ],
    rightSidebars: [
        $89d8cdf72602f901$var$withServiceProjectContext($89d8cdf72602f901$var$RightSidebars),
        ...(0, $2QkFp.serviceProjectFirstImpressionsLayout).rightSidebars.map($89d8cdf72602f901$var$withServiceProjectContext)
    ]
});
const $89d8cdf72602f901$export$820f9bb834280408 = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), {
    rightSidebars: [
        $89d8cdf72602f901$var$RightSidebars
    ]
});

});
parcelRegister("fBmd6", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $2c9f26ce5a28ec28$export$b1ef5e3da6e1959d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c9f26ce5a28ec28$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $7rh0R.lazy)(()=>(parcelRequire("jmlc0")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $2c9f26ce5a28ec28$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c9f26ce5a28ec28$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("jmlc0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("d3MCA")
]).then(()=>parcelRequire('j5Ut0'));

});


parcelRegister("2QkFp", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $28742565404e52e1$export$2562b2d784eadc10);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1WU96 = parcelRequire("1WU96");

var $isbb2 = parcelRequire("isbb2");
const $28742565404e52e1$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WU96.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null));
    const name = (0, $isbb2.coalesce)(Component.displayName) ?? (0, $isbb2.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $28742565404e52e1$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3BWqk")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $28742565404e52e1$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("jBrek")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/index.tsx"
});
const $28742565404e52e1$export$2562b2d784eadc10 = (0, $isbb2.createLayout)({
    globalComponents: [
        $28742565404e52e1$var$withServiceProjectAccess($28742565404e52e1$var$Onboarding)
    ],
    rightSidebars: [
        $28742565404e52e1$var$withServiceProjectAccess($28742565404e52e1$var$RightSidebars)
    ]
});

});
parcelRegister("1WU96", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8966d75f9e18f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $3ndxD = parcelRequire("3ndxD");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4f8966d75f9e18f8$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $3ndxD.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
$4f8966d75f9e18f8$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4f8966d75f9e18f8$export$2e2bcd8739ae039 = $4f8966d75f9e18f8$var$AppPermissionsCheck;

});
parcelRegister("3ndxD", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $4cb60d7dfaed0e5c$export$48e5fb80244b95c5);
const $4cb60d7dfaed0e5c$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("3BWqk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("lSjLj")
]).then(()=>parcelRequire('fopgZ'));

});

parcelRegister("jBrek", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("6HOXP")
]).then(()=>parcelRequire('9iDpZ'));

});


parcelRegister("h3jf5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("12gwi").then(()=>parcelRequire('UsO9m'));

});

parcelRegister("db9gl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hIGOt")
]).then(()=>parcelRequire('jAlsY'));

});

parcelRegister("7nvXe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("1xZoV")
]).then(()=>parcelRequire('lFtmC'));

});


parcelRegister("soOXK", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $da080439a4ecc697$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $da080439a4ecc697$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $da080439a4ecc697$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $da080439a4ecc697$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $da080439a4ecc697$export$ab7e607e8441dc61);

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $da080439a4ecc697$var$withAnySoftwareProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6cHWe")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$OnboardingCode = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5oyQY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fAh5r")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$RightSidebarsCode = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bVdx0")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/index.tsx"
});
const $da080439a4ecc697$var$SoftWareOnboarding = $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$Onboarding);
const $da080439a4ecc697$var$SoftWareOnboardingCode = $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$OnboardingCode);
const $da080439a4ecc697$var$nonSettingsRightSidebars = [
    $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$RightSidebars)
];
const $da080439a4ecc697$var$nonSettingsRightSidebarsCode = [
    $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$RightSidebarsCode)
];
const $da080439a4ecc697$var$sharedSoftwareProjectLayout = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout), {});
const $da080439a4ecc697$export$3791efdd32024063 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebars,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboarding
    ]
});
const $da080439a4ecc697$export$9a918616afa3328c = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebars,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboarding
    ]
});
const $da080439a4ecc697$export$ada52b1309832862 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout);
const $da080439a4ecc697$export$6c1958653c44ba37 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout);
const $da080439a4ecc697$export$ab7e607e8441dc61 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("6cHWe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("2QXYY")
]).then(()=>parcelRequire('5nRWZ'));

});

parcelRegister("5oyQY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("4FTjM")
]).then(()=>parcelRequire('1KEra'));

});

parcelRegister("fAh5r", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hsl5M")
]).then(()=>parcelRequire('epLsj'));

});

parcelRegister("bVdx0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("9LoaN")
]).then(()=>parcelRequire('ddLdL'));

});


parcelRegister("7xFdb", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $104be0934152e131$export$7092b4ee86ae0b71);

var $isbb2 = parcelRequire("isbb2");
const $104be0934152e131$export$7092b4ee86ae0b71 = (0, $isbb2.createLayout)();

});


const $afb3b9e0346cd1fd$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $afb3b9e0346cd1fd$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("5w4hM", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $541e179b5fa9e509$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $541e179b5fa9e509$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $541e179b5fa9e509$export$844d342b575ead35);

var $497qU = parcelRequire("497qU");

var $buaC1 = parcelRequire("buaC1");

var $hUM03 = parcelRequire("hUM03");

var $bt7QT = parcelRequire("bt7QT");

var $iOOlt = parcelRequire("iOOlt");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $8rBPw = parcelRequire("8rBPw");
const $541e179b5fa9e509$export$d88d2d25355bc89a = [
    (0, $buaC1.default),
    (0, $iOOlt.default),
    (0, $iTYGl.default),
    (0, $2Fzrk.default),
    (0, $8rBPw.default)
];
const $541e179b5fa9e509$export$c04daf123cec1f1e = [
    (0, $2Fzrk.default),
    (0, $8rBPw.default)
];
const $541e179b5fa9e509$export$844d342b575ead35 = [
    ...$541e179b5fa9e509$export$d88d2d25355bc89a,
    (0, $497qU.default),
    (0, $hUM03.default),
    (0, $bt7QT.default)
];

});
parcelRegister("497qU", function(module, exports) {

$parcel$export(module.exports, "default", () => $113f60a6a5bc48c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $113f60a6a5bc48c3$var$LazyConnectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("hv5Pz")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $113f60a6a5bc48c3$var$ConnectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($113f60a6a5bc48c3$var$LazyConnectSidebar, null)));
$113f60a6a5bc48c3$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $113f60a6a5bc48c3$export$2e2bcd8739ae039 = $113f60a6a5bc48c3$var$ConnectSidebar;

});
parcelRegister("hv5Pz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("8ciKp")
]).then(()=>parcelRequire('jSzUd'));

});


parcelRegister("buaC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c2ed1c1661f63$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $c95c2ed1c1661f63$var$LazyCoreProjectSidebar = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("4NU3b")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/index.tsx"
});
const $c95c2ed1c1661f63$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c95c2ed1c1661f63$var$LazyCoreProjectSidebar, null));
var $c95c2ed1c1661f63$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c95c2ed1c1661f63$var$CoreProjectSidebar);

});
parcelRegister("4NU3b", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aj3eE")
]).then(()=>parcelRequire('N0fDW'));

});


parcelRegister("bt7QT", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a98b92e63b4efb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("4Owgd")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar, null)));
$93a98b92e63b4efb$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $93a98b92e63b4efb$export$2e2bcd8739ae039 = $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar;

});
parcelRegister("4Owgd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("SBVRB")
]).then(()=>parcelRequire('l15zb'));

});


parcelRegister("iOOlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9c5b483f80318f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("13gCT")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9c5b483f80318f8$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar, null)));
$a9c5b483f80318f8$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
var $a9c5b483f80318f8$export$2e2bcd8739ae039 = $a9c5b483f80318f8$var$SoftwareProjectSidebar;

});
parcelRegister("13gCT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bqmoa")
]).then(()=>parcelRequire('dSgKD'));

});


parcelRegister("iTYGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f67fc1f904f75a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $2f67fc1f904f75a4$export$5b9febabdab63fba = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("7yITH")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $2f67fc1f904f75a4$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f67fc1f904f75a4$export$5b9febabdab63fba, null)));
$2f67fc1f904f75a4$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
var $2f67fc1f904f75a4$export$2e2bcd8739ae039 = $2f67fc1f904f75a4$var$ServicedeskSidebar;

});
parcelRegister("7yITH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("4673m")
]).then(()=>parcelRequire('2osKk'));

});


parcelRegister("2Fzrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bc2c6e90de3714$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("61AEn")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar, null)));
$d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
var $d9bc2c6e90de3714$export$2e2bcd8739ae039 = $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("61AEn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iN4Tu")
]).then(()=>parcelRequire('7bWFF'));

});


parcelRegister("8rBPw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50106f0c2df90e8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $d50106f0c2df90e8$var$LazyUserSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("28wYA")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d50106f0c2df90e8$var$UserSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d50106f0c2df90e8$var$LazyUserSidebar, null)));
$d50106f0c2df90e8$var$UserSidebar.displayName = 'UserSidebar';
var $d50106f0c2df90e8$export$2e2bcd8739ae039 = $d50106f0c2df90e8$var$UserSidebar;

});
parcelRegister("28wYA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kmOrn")
]).then(()=>parcelRequire('fPz94'));

});



parcelRegister("4qvmP", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $539284efb9551a13$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $539284efb9551a13$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $539284efb9551a13$export$21c5527b459d56fe);

var $fD1Hq = parcelRequire("fD1Hq");

var $kMmsu = parcelRequire("kMmsu");

var $f26dB = parcelRequire("f26dB");

var $fIi7o = parcelRequire("fIi7o");

var $fzymf = parcelRequire("fzymf");

var $aeIT6 = parcelRequire("aeIT6");

var $91fCW = parcelRequire("91fCW");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");
const $539284efb9551a13$var$commonResources = [
    (0, $2JncP.projectCreatePermissionsResource),
    (0, $f26dB.navigationResource)
];
const $539284efb9551a13$export$20e8c2951e444b08 = ()=>[
        ...$539284efb9551a13$var$commonResources,
        (0, $aeIT6.projectDetailsResource),
        (0, $91fCW.storageDetailsResource),
        (0, $fIi7o.navigationItemsResourceWithCondition),
        (0, $fIi7o.navigationItemsResourceOldWithCondition)
    ];
const $539284efb9551a13$export$46471673e66df5c1 = ()=>[
        ...$539284efb9551a13$var$commonResources,
        (0, $fzymf.overviewDetailsResource)
    ];
const $539284efb9551a13$export$fcbe882e18ee4a35 = ()=>[
        ...$539284efb9551a13$export$20e8c2951e444b08(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];
const $539284efb9551a13$export$21c5527b459d56fe = ()=>[
        ...$539284efb9551a13$export$46471673e66df5c1(),
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];

});
parcelRegister("fD1Hq", function(module, exports) {

$parcel$export(module.exports, "configurationResource", () => $b3265d3008765031$export$5c4ad441346dc154);
$parcel$export(module.exports, "useRankField", () => $b3265d3008765031$export$fffa1172af8de100);
$parcel$export(module.exports, "useStartDateField", () => $b3265d3008765031$export$bf78b0881400efef);
$parcel$export(module.exports, "useIsLinkingEnabled", () => $b3265d3008765031$export$76fc5a1eecec5a35);
$parcel$export(module.exports, "useIsSubtasksEnabled", () => $b3265d3008765031$export$dca58a051cb58f03);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $7WqaN = parcelRequire("7WqaN");
const $b3265d3008765031$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
const $b3265d3008765031$export$5c4ad441346dc154 = (0, $6xFTe.createResource)({
    type: $b3265d3008765031$var$RESOURCE_KEY,
    getKey: ()=>$b3265d3008765031$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $7WqaN.fetchConfiguration)(cloudId),
    maxAge: Infinity
});
const $b3265d3008765031$export$b629b793d58e3884 = ()=>(0, $h5RgW.useResource)($b3265d3008765031$export$5c4ad441346dc154);
const $b3265d3008765031$export$fffa1172af8de100 = ()=>{
    const { data: data, loading: loading, error: error } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        data: data?.rankField ?? null,
        loading: loading,
        error: error
    };
};
const $b3265d3008765031$export$bf78b0881400efef = ()=>{
    const { data: data, loading: loading, error: error } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        data: data?.startDateField ?? null,
        loading: loading,
        error: error
    };
};
const $b3265d3008765031$export$76fc5a1eecec5a35 = ()=>{
    const { data: data } = $b3265d3008765031$export$b629b793d58e3884();
    return data?.isLinkingEnabled ?? false;
};
const $b3265d3008765031$export$dca58a051cb58f03 = ()=>{
    const { data: data } = $b3265d3008765031$export$b629b793d58e3884();
    return data?.isSubtasksEnabled ?? false;
};

});
parcelRegister("7WqaN", function(module, exports) {

$parcel$export(module.exports, "fetchConfiguration", () => $6d233c0f1331d9ce$export$9911e92fcb5c83c0);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");


var $6xUhC = parcelRequire("6xUhC");
const $6d233c0f1331d9ce$export$9911e92fcb5c83c0 = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
            body: JSON.stringify({
                query: (0, $4e521ecd804aed88$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            })
        });
        if (response.data == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return (0, $6xUhC.transformData)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'configurationResource',
                packageName: 'jiraRouterResourcesBusinessConfiguration',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});
parcelRegister("dlVOn", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $c8c10c82db3c32ef$export$89c202e66b2de2b6);

var $hbMki = parcelRequire("hbMki");

var $1c8hB = parcelRequire("1c8hB");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $c8c10c82db3c32ef$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $c8c10c82db3c32ef$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(graphQLErrors) : [];
        this.message = $c8c10c82db3c32ef$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("hbMki", function(module, exports) {

var $1c8hB = parcelRequire("1c8hB");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $c838f35dc30c870d$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $1c8hB(value) ? value : [
        value
    ];
}
module.exports = $c838f35dc30c870d$var$castArray;

});


const $4e521ecd804aed88$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
  }
}
`;

parcelRegister("6xUhC", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $14956d34a7bd03ca$export$3ceb62baab058c6b);
const $14956d34a7bd03ca$export$3ceb62baab058c6b = (response)=>{
    let rankField = null;
    const rankFieldNode = response.data?.jira?.rankField;
    if (rankFieldNode != null) rankField = {
        id: rankFieldNode.fieldId,
        name: rankFieldNode.name
    };
    let startDateField = null;
    const startDateFieldNode = response.data?.jira?.startDateField;
    if (startDateFieldNode != null) startDateField = {
        id: startDateFieldNode.fieldId,
        name: startDateFieldNode.name
    };
    const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
    const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
    return {
        rankField: rankField,
        startDateField: startDateField,
        isLinkingEnabled: isLinkingEnabled,
        isSubtasksEnabled: isSubtasksEnabled
    };
};

});



parcelRegister("kMmsu", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $1a45b925639aee3d$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $1a45b925639aee3d$export$c0cd85886917fe89);

var $dlVOn = parcelRequire("dlVOn");

var $huI7r = parcelRequire("huI7r");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $9zYls = parcelRequire("9zYls");

var $eKlti = parcelRequire("eKlti");


var $3hBy0 = parcelRequire("3hBy0");
const $1a45b925639aee3d$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a45b925639aee3d$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    return (0, $3hBy0.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a45b925639aee3d$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    return (0, $3hBy0.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $1a45b925639aee3d$export$8bca6c1954ae9308 = (0, $6xFTe.createResource)({
    type: $1a45b925639aee3d$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$1a45b925639aee3d$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$1a45b925639aee3d$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $eKlti.fetchFields)((0, $26aeff854ea788a9$export$c378ca4a0e2c9fec), $1a45b925639aee3d$var$handleOverviewResponse, {
            overviewAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project-overview',
                resourceId: match.params.overviewId,
                activationId: activationId
            })
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $eKlti.fetchFields)((0, $26aeff854ea788a9$export$4d41378da3f70f0f), $1a45b925639aee3d$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $1a45b925639aee3d$export$c0cd85886917fe89 = ()=>(0, $h5RgW.useResource)($1a45b925639aee3d$export$8bca6c1954ae9308);

});
parcelRegister("huI7r", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $c148d923211ffae9$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $c148d923211ffae9$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $c148d923211ffae9$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $c148d923211ffae9$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $c148d923211ffae9$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $c148d923211ffae9$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $c148d923211ffae9$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $c148d923211ffae9$export$8e68286aef4c3a8b = (ari)=>$c148d923211ffae9$var$ARI_REG_EXP.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $c148d923211ffae9$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $c148d923211ffae9$export$24b47820a324e614 = (ari)=>{
    if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $c148d923211ffae9$export$e2789192113e8b07 = (ari, defaultValue = '')=>$c148d923211ffae9$export$24b47820a324e614(ari) ?? defaultValue;
const $c148d923211ffae9$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) {
        const parts = $c148d923211ffae9$var$ARI_REG_EXP.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $c148d923211ffae9$export$3d8d7031a11613fd = (ari)=>{
    const config = $c148d923211ffae9$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("eKlti", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $7876ddb9df2017cc$export$f3ddd735c360919);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $7876ddb9df2017cc$var$PAGE_SIZE = 100;
const $7876ddb9df2017cc$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $7876ddb9df2017cc$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

const $26aeff854ea788a9$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $26aeff854ea788a9$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("3hBy0", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e766e365dbeb1f01$export$3ceb62baab058c6b);
const $e766e365dbeb1f01$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("f26dB", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $2dec1e8aa31afb0b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $2dec1e8aa31afb0b$export$c17011c09e042a31);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $2dec1e8aa31afb0b$export$90749419e9042370);
$parcel$export(module.exports, "useTriggerOverviewChangeboarding", () => $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8);

var $8blac = parcelRequire("8blac");

var $huI7r = parcelRequire("huI7r");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $9zYls = parcelRequire("9zYls");

var $gQNVa = parcelRequire("gQNVa");


const $2dec1e8aa31afb0b$export$62940941ee574cdc = (0, $6xFTe.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectId)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            })
        });
        return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $2dec1e8aa31afb0b$export$c17011c09e042a31 = ()=>(0, $h5RgW.useResource)($2dec1e8aa31afb0b$export$62940941ee574cdc);
const $2dec1e8aa31afb0b$export$90749419e9042370 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.isPremiumUserSeat);
};
const $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.showPlansOnboarding);
};

});
parcelRegister("gQNVa", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $83fda10f52c953b2$export$1fc5fff73d9a570c);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");


var $2Y7Cf = parcelRequire("2Y7Cf");
const $83fda10f52c953b2$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    showPlansOnboarding: false,
    shouldHideOverviews: false
};
const $83fda10f52c953b2$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $02a4cc31089f6443$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $2Y7Cf.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $83fda10f52c953b2$var$EMPTY_RESPONSE;
};

});
const $02a4cc31089f6443$export$3349219a88ac77cd = 10;
const $02a4cc31089f6443$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("2Y7Cf", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e5db137f9c283ecc$export$3ceb62baab058c6b);

var $kar7l = parcelRequire("kar7l");


var $vsTb8 = parcelRequire("vsTb8");
const $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $e5db137f9c283ecc$var$PREMIUM = 'PREMIUM';
const $e5db137f9c283ecc$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $e5db137f9c283ecc$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
    });
const $e5db137f9c283ecc$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $02a4cc31089f6443$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $e5db137f9c283ecc$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $vsTb8.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$e5db137f9c283ecc$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
    const shouldHideOverviews = areOverviewsGone && !showPlansOnboarding;
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        showPlansOnboarding: showPlansOnboarding,
        shouldHideOverviews: shouldHideOverviews
    };
};

});
parcelRegister("kar7l", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $15099970f99feec5$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $15099970f99feec5$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $15099970f99feec5$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $15099970f99feec5$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $15099970f99feec5$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $15099970f99feec5$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $15099970f99feec5$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $15099970f99feec5$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $15099970f99feec5$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $15099970f99feec5$export$34373eced7ee212e);
$parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", () => $15099970f99feec5$export$5ddfadab7b1e12c1);
$parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$349e5dbeac874253);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$242b2d2213fedf27);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $15099970f99feec5$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $15099970f99feec5$export$cab9d853866386f2);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $15099970f99feec5$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $15099970f99feec5$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $15099970f99feec5$export$8e357501548afe78);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $15099970f99feec5$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $15099970f99feec5$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $15099970f99feec5$export$1c0b806722927549);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $15099970f99feec5$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $15099970f99feec5$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");


var $aYtGv = parcelRequire("aYtGv");
const $15099970f99feec5$export$b8b9d90f9e5bd72b = 'jiraBusinessThemeConstants';
const $15099970f99feec5$export$9e0962e0cb41695d = '#FFAB00';
const $15099970f99feec5$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--jwm-backdrop-filter',
    COLOR_BACKGROUND_BRAND_BOLD: '--jwm-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--jwm-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--jwm-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--jwm-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--jwm-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--jwm-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--jwm-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--jwm-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--jwm-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--jwm-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--jwm-background-selected',
    COLOR_BORDER: '--jwm-color-border',
    COLOR_BORDER_INPUT: '--jwm-color-border-input',
    COLOR_BORDER_INVERSE: '--jwm-color-border-inverse',
    COLOR_BORDER_SELECTED: '--jwm-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--jwm-color-elevation-surface',
    COLOR_ICON_DANGER: '--jwm-color-icon-danger',
    COLOR_ICON_INFORMATION: '--jwm-color-icon-information',
    COLOR_ICON_SUCCESS: '--jwm-color-icon-success',
    COLOR_ICON_WARNING: '--jwm-color-icon-warning',
    COLOR_LINK: '--jwm-color-link',
    COLOR_LINK_PRESSED: '--jwm-color-link-pressed',
    COLOR_SKELETON: '--jwm-skeleton',
    COLOR_TEXT: '--jwm-color-text',
    COLOR_TEXT_DISABLED: '--jwm-color-text-disabled',
    COLOR_TEXT_INVERSE: '--jwm-color-text-inverse',
    COLOR_TEXT_SELECTED: '--jwm-color-text-selected',
    COLOR_TEXT_SUBTLE: '--jwm-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--jwm-color-text-subtlest',
    CONTENT_HEIGHT: '--jwm-content-height',
    CONTENT_WIDTH: '--jwm-content-width',
    ELEVATION_SURFACE: '--jwm-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--jwm-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--jwm-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--jwm-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--jwm-wrapper-border-radius',
    WRAPPER_HEIGHT: '--jwm-wrapper-height',
    WRAPPER_PADDING: '--jwm-wrapper-padding',
    WRAPPER_WIDTH: '--jwm-wrapper-width'
};
const $15099970f99feec5$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--jwm-backdrop-filter)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--jwm-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--jwm-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--jwm-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--jwm-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--jwm-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--jwm-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--jwm-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--jwm-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--jwm-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--jwm-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--jwm-background-selected)',
    COLOR_BORDER: 'var(--jwm-color-border)',
    COLOR_BORDER_INPUT: 'var(--jwm-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--jwm-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--jwm-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--jwm-color-elevation-surface)',
    COLOR_ICON_DANGER: 'var(--jwm-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--jwm-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--jwm-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--jwm-color-icon-warning)',
    COLOR_LINK: 'var(--jwm-color-link)',
    COLOR_LINK_PRESSED: 'var(--jwm-color-link-pressed)',
    COLOR_SKELETON: 'var(--jwm-skeleton)',
    COLOR_TEXT: 'var(--jwm-color-text)',
    COLOR_TEXT_DISABLED: 'var(--jwm-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--jwm-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--jwm-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--jwm-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--jwm-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--jwm-content-height)',
    CONTENT_WIDTH: 'var(--jwm-content-width)',
    ELEVATION_SURFACE: 'var(--jwm-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--jwm-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--jwm-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--jwm-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--jwm-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--jwm-wrapper-height)',
    WRAPPER_PADDING: 'var(--jwm-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--jwm-wrapper-width)'
};
const $15099970f99feec5$export$8a6e9b3370a0f87a = {
    'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.background.neutral': `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N30A})`,
    'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$exports).N40A})`,
    'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$exports).N50A})`,
    'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$exports).N40A})`,
    'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$exports).N50A})`,
    'color.background.selected': `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    'color.elevation.surface': `var(--ds-surface, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.border': `var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40A})`,
    'color.border.input': "var(--ds-border-input, #091E4224)",
    'color.border.inverse': `var(--ds-border-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.border.selected': `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    'color.icon.danger': `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    'color.icon.information': `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    'color.icon.success': `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    'color.icon.warning': `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    'color.link': "var(--ds-link, #0c66e4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
    'color.skeleton': `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20A})`,
    'color.text': `var(--ds-text, ${(0, $73a5c9d720aa66e1$exports).N800})`,
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    'color.text.selected': `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    'color.text.subtle': `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $15099970f99feec5$export$f286efa6bd1e8f9d = {
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
};
const $15099970f99feec5$export$97cb21c6432e07e8 = {
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.danger': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.information': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.success': (0, $73a5c9d720aa66e1$exports).N0,
    'color.icon.warning': (0, $73a5c9d720aa66e1$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $73a5c9d720aa66e1$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $15099970f99feec5$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $15099970f99feec5$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $73a5c9d720aa66e1$exports).N0})`
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $73a5c9d720aa66e1$exports).N0,
            'color.icon.information': (0, $73a5c9d720aa66e1$exports).N0,
            'color.icon.success': (0, $73a5c9d720aa66e1$exports).N0,
            'color.icon.warning': (0, $73a5c9d720aa66e1$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
            'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $73a5c9d720aa66e1$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #1D2125)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
        }
    }
};
// Old Colors
const $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $15099970f99feec5$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $15099970f99feec5$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $15099970f99feec5$export$8a6e9b3370a0f87a,
        dark: $15099970f99feec5$export$8a6e9b3370a0f87a
    }
};
// Gradients
const $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $15099970f99feec5$export$34373eced7ee212e = [
    $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARK_BACKGROUND_CONFIG,
    $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$5ddfadab7b1e12c1 = [
    $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$349e5dbeac874253 = [
    ...$15099970f99feec5$export$5ddfadab7b1e12c1,
    $15099970f99feec5$export$4c351ec1dc290344
];
const $15099970f99feec5$export$242b2d2213fedf27 = [
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META
];
const $15099970f99feec5$export$8f118a95a310853a = [
    ...$15099970f99feec5$export$242b2d2213fedf27,
    ...$15099970f99feec5$export$349e5dbeac874253
];
const $15099970f99feec5$export$fe05a238062e2c3d = {
    white: $15099970f99feec5$export$4c351ec1dc290344,
    'light-purple': $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $15099970f99feec5$export$cab9d853866386f2 = $15099970f99feec5$export$4c351ec1dc290344;
const $15099970f99feec5$export$ed7cc0d417ee89e = '--jwm-banner-height';
const $15099970f99feec5$export$7009ab5fba189797 = `var(${$15099970f99feec5$export$ed7cc0d417ee89e}, 0px)`;
const $15099970f99feec5$export$baaf8255c30ea280 = 95;
const $15099970f99feec5$export$8e357501548afe78 = 24;
const $15099970f99feec5$export$d9035bc768f8226d = `calc(${$15099970f99feec5$export$baaf8255c30ea280}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
const $15099970f99feec5$export$4810531e30462f89 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d})`;
const $15099970f99feec5$export$1c0b806722927549 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
const $15099970f99feec5$export$77cdace62a821419 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)}) !important`;
const $15099970f99feec5$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px) !important`;

});
parcelRegister("aYtGv", function(module, exports) {

$parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", () => $479507d87baa6502$export$d60454526e2281af);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");
const $479507d87baa6502$export$d60454526e2281af = `(${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} + ${(0, $ho1Ek.BANNER_HEIGHT)})`;

});


parcelRegister("vsTb8", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $8f89cb3175071b7f$export$ddf2fc82885279d);
const $8f89cb3175071b7f$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $8f89cb3175071b7f$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $8f89cb3175071b7f$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});



const $dac6815921c324c6$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $dac6815921c324c6$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $dac6815921c324c6$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $dac6815921c324c6$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $dac6815921c324c6$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $dac6815921c324c6$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;


parcelRegister("fIi7o", function(module, exports) {

$parcel$export(module.exports, "navigationItemsResource", () => $e864d999bb4bb8a0$export$8446b129b5aba359);
$parcel$export(module.exports, "navigationItemsResourceWithCondition", () => $e864d999bb4bb8a0$export$17f8a240e5c44011);
$parcel$export(module.exports, "navigationItemsResourceOld", () => $e864d999bb4bb8a0$export$38c041bf3215c084);
$parcel$export(module.exports, "navigationItemsResourceOldWithCondition", () => $e864d999bb4bb8a0$export$a9f4e775f4662be7);
// eslint-disable-next-line jira/import-whitelist

var $8npnf = parcelRequire("8npnf");

var $eI5EY = parcelRequire("eI5EY");

var $com8B = parcelRequire("com8B");

var $buJlM = parcelRequire("buJlM");

var $c8y7O = parcelRequire("c8y7O");

var $ixDFg = parcelRequire("ixDFg");

var $9zYls = parcelRequire("9zYls");
var $jwzNs = parcelRequire("jwzNs");
const $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $e864d999bb4bb8a0$export$8446b129b5aba359 = (0, $buJlM.createRelayResource)({
    type: $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = projectId ? (0, $8npnf.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        return {
            parameters: (0, $c8y7O.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $com8B.NAVIGATION_ITEMS_PAGE_SIZE),
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: (0, $eI5EY.fg)('custom_project_navigation_m2'),
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $e864d999bb4bb8a0$export$17f8a240e5c44011 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('business_project_navigation_relay'), $e864d999bb4bb8a0$export$8446b129b5aba359);
const $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY_OLD = 'RESOURCE_TYPE_BUSINESS_NAVIGATION_ITEMS';
const $e864d999bb4bb8a0$export$38c041bf3215c084 = (0, $buJlM.createRelayResource)({
    type: $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY_OLD,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = projectId ? (0, $8npnf.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : null;
        return {
            parameters: (0, $ixDFg.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $com8B.NAVIGATION_ITEMS_PAGE_SIZE),
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: (0, $eI5EY.fg)('custom_project_navigation_m2')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $e864d999bb4bb8a0$export$a9f4e775f4662be7 = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $eI5EY.fg)('business_project_navigation_relay'), $e864d999bb4bb8a0$export$38c041bf3215c084);

});
parcelRegister("c8y7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7232ceddc504ece4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ffd4525189cde640f4bbf2304a5a8ed>>
 * @relayHash 90aa4766778162aaa1f07507b1a474b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc66dced586cb3b2ae52b3cc9fb1e611aac659d7f3cbe578af5b089555107240
const $7232ceddc504ece4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useContainerNavigation"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v10 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v12 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "FragmentSpread",
        "name": "projectBoardHeader_horizontalNavHeader"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = {
        "args": [
            v8 /*: any*/ 
        ],
        "concreteType": "JiraWorkManagementLicensing",
        "kind": "LinkedField",
        "name": "jwmLicensing",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
            }
        ]
    }, v17 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v18 = [
        v8 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "label"
    }, v22 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v24 = {
        "kind": "ScalarField",
        "name": "url"
    }, v25 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v26 = {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraNavigationItem"
            },
            v21 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "canRemove"
            },
            {
                "kind": "ScalarField",
                "name": "canSetAsDefault"
            },
            v22 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraAppSection",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                            v21 /*: any*/ ,
                            {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                    v21 /*: any*/ ,
                                    v23 /*: any*/ ,
                                    v24 /*: any*/ ,
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v24 /*: any*/ ,
                    v23 /*: any*/ ,
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "appType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "envLabel"
                    }
                ],
                "type": "JiraAppNavigationItem"
            }
        ]
    }, v27 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v19 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v28 = {
        "concreteType": "QueryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v27 /*: any*/ 
    }, v29 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v30 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v31 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectTypeName"
        },
        {
            "kind": "ScalarField",
            "name": "webUrl"
        },
        {
            "alias": "editPermission",
            "args": v29 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v30 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        v22 /*: any*/ ,
        {
            "alias": "canEditProjectConfig",
            "args": v29 /*: any*/ ,
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v30 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v30 /*: any*/ ,
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v11 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v11 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v16 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "navigationItems",
                                    "args": v18 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmSavedViewsByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "navigationItems",
                                    "args": v18 /*: any*/ ,
                                    "filters": [
                                        "cloudId",
                                        "projectIdOrKey"
                                    ],
                                    "handle": "connection",
                                    "key": "tabs_jiraNavigation__navigationItems",
                                    "kind": "LinkedHandle",
                                    "name": "jwmSavedViewsByProject"
                                }
                            ]
                        },
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "input",
                                            "variableName": "containerNavigationInput"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEdit"
                                                },
                                                {
                                                    "args": [
                                                        v17 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNavigationItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v27 /*: any*/ ,
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v31 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v31 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bc66dced586cb3b2ae52b3cc9fb1e611aac659d7f3cbe578af5b089555107240",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7232ceddc504ece4$var$node.hash = "f4b30a3daeb5ce6644248fe254ee32bf";
var $7232ceddc504ece4$export$2e2bcd8739ae039 = $7232ceddc504ece4$var$node;

});

parcelRegister("ixDFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9d8cf06b39c2f6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<21280681520ad51af42864c3e891d07a>>
 * @relayHash e025b16c0cc9af81f0b5779a9f9934a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5f919839b0f62d989c306b70e15ca4a38e749c08ae5853d6de19eadc12edfcb
const $c9d8cf06b39c2f6f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useContainerNavigation"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "projectIdOrKey",
        "variableName": "projectIdOrKey"
    }, v7 = {
        "kind": "FragmentSpread",
        "name": "ui_navigationKitTabList_TabList_tabsFragment"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "message"
    }, v12 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v13 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v12 /*: any*/ 
        ]
    }, v14 = {
        "concreteType": "QueryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v15 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v16 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "containerNavigationInput"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v19 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v20 = [
        v19 /*: any*/ 
    ], v21 = [
        v5 /*: any*/ ,
        v19 /*: any*/ ,
        v6 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "label"
    }, v23 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v24 = {
        "kind": "ScalarField",
        "name": "url"
    }, v25 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v26 = {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraNavigationItem"
            },
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "canRemove"
            },
            {
                "kind": "ScalarField",
                "name": "canSetAsDefault"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraAppSection",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                            v22 /*: any*/ ,
                            {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v23 /*: any*/ ,
                                    v24 /*: any*/ ,
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v24 /*: any*/ ,
                    v23 /*: any*/ ,
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "appType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "envLabel"
                    }
                ],
                "type": "JiraAppNavigationItem"
            }
        ]
    }, v27 = [
        v11 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                v12 /*: any*/ 
            ]
        }
    ], v28 = {
        "concreteType": "QueryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v27 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "tabsOld_jwmNavigationItemsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "alias": "navigationItems",
                                            "args": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "__tabs_jiraNavigation__navigationItems_connection",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": v10 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.navigationItems"
                                    }
                                ]
                            },
                            {
                                "condition": "useContainerNavigation",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v16 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "containerNavigation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitTabList_TabList_containerFragment"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_navigationKitAddTab_AddTab"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v17 /*: any*/ ,
                                                    v18 /*: any*/ ,
                                                    {
                                                        "args": v20 /*: any*/ ,
                                                        "concreteType": "JiraNavigationItemConnection",
                                                        "kind": "LinkedField",
                                                        "name": "navigationItems",
                                                        "plural": false,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraNavigationItemEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": v10 /*: any*/ 
                                                            },
                                                            v14 /*: any*/ 
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraContainerNavigation"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v8 /*: any*/ ,
                                                    v11 /*: any*/ ,
                                                    v13 /*: any*/ 
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "tabsOld_jwmNavigationItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "navigationItems",
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmSavedViewsByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "navigationItems",
                                    "args": v21 /*: any*/ ,
                                    "filters": [
                                        "cloudId",
                                        "projectIdOrKey"
                                    ],
                                    "handle": "connection",
                                    "key": "tabs_jiraNavigation__navigationItems",
                                    "kind": "LinkedHandle",
                                    "name": "jwmSavedViewsByProject"
                                }
                            ]
                        },
                        {
                            "condition": "useContainerNavigation",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v16 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "args": v20 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNavigationItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v27 /*: any*/ ,
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a5f919839b0f62d989c306b70e15ca4a38e749c08ae5853d6de19eadc12edfcb",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "navigationItems"
                        ]
                    }
                ]
            },
            "name": "tabsOld_jwmNavigationItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9d8cf06b39c2f6f$var$node.hash = "82693ed8472b4c7ec4f39c4b415f54b7";
var $c9d8cf06b39c2f6f$export$2e2bcd8739ae039 = $c9d8cf06b39c2f6f$var$node;

});


parcelRegister("fzymf", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $a5200a1419c8dbcb$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $a5200a1419c8dbcb$export$626541a5c6f2cfa1);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $wLx84 = parcelRequire("wLx84");
const $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $a5200a1419c8dbcb$export$cd57aa046b167312 = (0, $6xFTe.createResource)({
    type: $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $wLx84.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $a5200a1419c8dbcb$export$626541a5c6f2cfa1 = ()=>(0, $h5RgW.useResource)($a5200a1419c8dbcb$export$cd57aa046b167312);

});
parcelRegister("wLx84", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $218a2f4d5429f49f$export$f0395142dbdd6c61);

var $hhcsA = parcelRequire("hhcsA");

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $huI7r = parcelRequire("huI7r");

var $3UEL2 = parcelRequire("3UEL2");

const $218a2f4d5429f49f$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $3UEL2.QUERY),
                variables: {
                    id: (0, $huI7r.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project-overview',
                        resourceId: overviewId,
                        activationId: activationId
                    })
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $555b6ab3251d313a$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $hhcsA.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $dlVOn.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $guiFP.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("hhcsA", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc15f4b08a142f23$export$e79bf238de33eabb);
const $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc15f4b08a142f23$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc15f4b08a142f23$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc15f4b08a142f23$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("3UEL2", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $286b893702b0066e$export$2b91517d6d5b4365);

const $286b893702b0066e$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $fd066e0e866fe0bc$export$6f4bda7ea1dcf892)}
`;

});
const $fd066e0e866fe0bc$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $555b6ab3251d313a$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';



parcelRegister("aeIT6", function(module, exports) {

$parcel$export(module.exports, "projectDetailsResource", () => $d8cccda868228b81$export$e541d9eb202b4972);
$parcel$export(module.exports, "useProject", () => $d8cccda868228b81$export$51b1383ef8844a7);
$parcel$export(module.exports, "useMediaConfiguration", () => $d8cccda868228b81$export$ab5cf8327e07f046);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $9zYls = parcelRequire("9zYls");

var $Qqb3l = parcelRequire("Qqb3l");
const $d8cccda868228b81$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $d8cccda868228b81$export$e541d9eb202b4972 = (0, $6xFTe.createResource)({
    type: $d8cccda868228b81$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$d8cccda868228b81$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $Qqb3l.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $d8cccda868228b81$export$51b1383ef8844a7 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $h5RgW.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};
const $d8cccda868228b81$export$ab5cf8327e07f046 = ()=>{
    const { data: data } = (0, $h5RgW.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
    return data?.media ?? null;
};

});
parcelRegister("Qqb3l", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $b6d7f500e2b72f80$export$78aa221476efa1c6);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $huI7r = parcelRequire("huI7r");


var $9RmFy = parcelRequire("9RmFy");
const $b6d7f500e2b72f80$var$EMPTY_VALUE = {
    themeSetting: null,
    media: null
};
const $b6d7f500e2b72f80$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $561d2537991d9a5d$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $huI7r.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project',
                        resourceId: projectId
                    }) : ''
                }
            })
        });
        return (0, $9RmFy.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $guiFP.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $b6d7f500e2b72f80$var$EMPTY_VALUE;
};

});
const $561d2537991d9a5d$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $561d2537991d9a5d$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$561d2537991d9a5d$var$PROJECT_FRAGMENT}
`;

parcelRegister("9RmFy", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $402e94b0015519f9$export$3ceb62baab058c6b);
const $402e94b0015519f9$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        status: node.status,
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            deleteIssues: node.deleteIssues.canPerform,
            editIssues: node.editIssues.canPerform,
            linkIssues: node.linkIssues.canPerform,
            scheduleIssues: node.scheduleIssues.canPerform,
            transitionIssues: node.transitionIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $402e94b0015519f9$var$parseThemeSetting = (data)=>{
    const theme = data?.jwmSidebar?.theme;
    if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.colorValue
    };
    if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.gradientValue
    };
    if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
        const { customBackground: customBackground } = theme;
        const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'image',
            value: 'image',
            id: id,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            sourceType: sourceType,
            sourceIdentifier: sourceIdentifier,
            altText: altText
        };
    }
    return null;
};
const $402e94b0015519f9$var$parseMediaConfiguration = (data)=>{
    const clientId = data?.jira?.mediaClientId;
    const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
    if (clientId == null || externalEndpointUrl == null) return null;
    return {
        clientId: clientId,
        externalEndpointUrl: externalEndpointUrl
    };
};
const $402e94b0015519f9$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        themeSetting: $402e94b0015519f9$var$parseThemeSetting(data),
        currentProject: $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey,
        media: $402e94b0015519f9$var$parseMediaConfiguration(data)
    });

});



parcelRegister("91fCW", function(module, exports) {

$parcel$export(module.exports, "storageDetailsResource", () => $24b210595251f2b8$export$76c871115d0c70a1);
$parcel$export(module.exports, "useStorageDetails", () => $24b210595251f2b8$export$8c295c187914aac1);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $gs6RW = parcelRequire("gs6RW");
const $24b210595251f2b8$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
const $24b210595251f2b8$export$76c871115d0c70a1 = (0, $6xFTe.createResource)({
    type: $24b210595251f2b8$var$RESOURCE_TYPE_KEY,
    getKey: ()=>$24b210595251f2b8$var$RESOURCE_TYPE_KEY,
    getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, $gs6RW.fetchStorageDetails)(appEditions),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $24b210595251f2b8$export$8c295c187914aac1 = ()=>(0, $h5RgW.useResource)($24b210595251f2b8$export$76c871115d0c70a1);

});
parcelRegister("gs6RW", function(module, exports) {

$parcel$export(module.exports, "fetchStorageDetails", () => $f8699ff0bc3b5274$export$576d1c3de6af9760);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6WXNs = parcelRequire("6WXNs");

const $f8699ff0bc3b5274$export$576d1c3de6af9760 = async (appEditions)=>{
    try {
        if (appEditions?.core !== (0, $6WXNs.FREE_EDITION)) return null;
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/latest?query', {
            body: JSON.stringify({
                query: (0, $c9625ef7268a5b88$export$2b91517d6d5b4365),
                variables: {
                    productKey: 'jira-core'
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        if (response.errors != null) {
            const error = response.errors?.[0];
            const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
            if (!isClientError) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        }
        const usageLimit = response?.data?.attachmentStorage;
        if (usageLimit && usageLimit?.allowed) {
            const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
            return percentageUsed;
        }
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
        (0, $guiFP.default)({
            meta: {
                id: 'getStorageAmountService',
                packageName: 'jiraRouterResourcesBusinessStorageDetails',
                teamName: 'jira-warepil'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $c9625ef7268a5b88$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;



parcelRegister("2JncP", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $76240f0f6e8ab8e1$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $76240f0f6e8ab8e1$export$2bd0d3b374549a68);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


const $76240f0f6e8ab8e1$var$getDataLoader = ()=>(parcelRequire("iHpyh"));
const $76240f0f6e8ab8e1$export$f6c05eaea53ab4ae = (0, $6xFTe.createResource)({
    type: (0, $3eff975f98a7cc60$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $76240f0f6e8ab8e1$var$getDataLoader,
    maxAge: Infinity
});
const $76240f0f6e8ab8e1$export$2bd0d3b374549a68 = ()=>(0, $h5RgW.useResource)($76240f0f6e8ab8e1$export$f6c05eaea53ab4ae);

});
const $3eff975f98a7cc60$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("iHpyh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8avE4").then(()=>parcelRequire('45aM7'));

});



parcelRegister("aup9J", function(module, exports) {

$parcel$export(module.exports, "legacyAllReportsRoute", () => $33543376dd3501cc$export$549d32fceee24980);

var $exb0h = parcelRequire("exb0h");
const $33543376dd3501cc$export$549d32fceee24980 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_ALL_REPORTS),
    path: '/projects/:projectKey',
    query: [
        'selectedItem=(.*report-page.*)'
    ]
};

});

parcelRegister("aTgp4", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $80c4fbf1cb53cfaf$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $80c4fbf1cb53cfaf$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $80c4fbf1cb53cfaf$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("GuBa2", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $3644fec504a7091d$export$5910307042ab3f6f);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $ElVpH = parcelRequire("ElVpH");

var $b1r4M = parcelRequire("b1r4M");
const $3644fec504a7091d$export$5910307042ab3f6f = (0, $6xFTe.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $b1r4M.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("b1r4M", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $35f5e30d07c84550$export$a93a577d6971da2c);

var $lRmyA = parcelRequire("lRmyA");
const $35f5e30d07c84550$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("5fOZm", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $be1b037470026e68$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $be1b037470026e68$export$e9adc6103e9ed514);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


const $be1b037470026e68$export$96cb0eae1b3413f4 = (0, $6xFTe.createResource)({
    type: (0, $c1b3a83229b530dd$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("h06en")),
    maxAge: 60000
});
const $be1b037470026e68$export$e9adc6103e9ed514 = ()=>(0, $h5RgW.useResource)($be1b037470026e68$export$96cb0eae1b3413f4);

});
const $c1b3a83229b530dd$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $c1b3a83229b530dd$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $c1b3a83229b530dd$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("h06en", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fvJyP").then(()=>parcelRequire('kQVpx'));

});




parcelRegister("fc79W", function(module, exports) {

$parcel$export(module.exports, "legacyBacklogRouteEntry", () => $7f34c43d4fb36994$export$e64dbc2432a0bfba);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $bCmyq = parcelRequire("bCmyq");

var $iYF7d = parcelRequire("iYF7d");

var $bEe6y = parcelRequire("bEe6y");
const $7f34c43d4fb36994$export$e64dbc2432a0bfba = (0, $bMm60.createEntry)((0, $iYF7d.legacyBacklogRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    component: (0, $bCmyq.LegacyPage),
    resources: (0, $hHrVM.getNavigationSidebarProjectResource)()
});

});
parcelRegister("iYF7d", function(module, exports) {

$parcel$export(module.exports, "legacyBacklogRoute", () => $a650331b94c62142$export$c51fda014ab27b5d);

var $exb0h = parcelRequire("exb0h");
const $a650331b94c62142$export$c51fda014ab27b5d = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_BACKLOG),
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(.*planning.*)'
    ]
};

});

parcelRegister("bEe6y", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", () => $1f8792707b4b0d16$export$128d5d79815580ca);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("em36L")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
});
const $1f8792707b4b0d16$export$128d5d79815580ca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-software-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav, null));

});
parcelRegister("em36L", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bnyRr")
]).then(()=>parcelRequire('kUyw6'));

});



parcelRegister("7C31q", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRouteEntry", () => $d9a8843a1492190e$export$e3d172b0d9fd0d47);
$parcel$export(module.exports, "legacyBoard1RouteEntry", () => $d9a8843a1492190e$export$fa18d34686878114);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $bCmyq = parcelRequire("bCmyq");

var $2DBwq = parcelRequire("2DBwq");

var $bEe6y = parcelRequire("bEe6y");
const $d9a8843a1492190e$export$e3d172b0d9fd0d47 = (0, $bMm60.createEntry)((0, $2DBwq.legacyBoardRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    component: (0, $bCmyq.LegacyPage),
    resources: (0, $hHrVM.getNavigationSidebarProjectResource)()
});
const $d9a8843a1492190e$export$fa18d34686878114 = (0, $bMm60.createEntry)((0, $2DBwq.legacyBoard1Route), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    component: (0, $bCmyq.LegacyPage),
    resources: (0, $hHrVM.getNavigationSidebarProjectResource)()
});

});
parcelRegister("2DBwq", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRoute", () => $0b7f1a3284064c50$export$9259d0f05fc27139);
$parcel$export(module.exports, "legacyBoard1Route", () => $0b7f1a3284064c50$export$be72991932610f35);

var $exb0h = parcelRequire("exb0h");
const $0b7f1a3284064c50$export$9259d0f05fc27139 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_BOARD),
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ]
};
const $0b7f1a3284064c50$export$be72991932610f35 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_BOARD),
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("eIO5Y", function(module, exports) {

$parcel$export(module.exports, "legacyConnectGeneralRouteEntry", () => $198e16ac9ae48869$export$5f816cf76ff922b8);

var $l90Gp = parcelRequire("l90Gp");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $isbb2 = parcelRequire("isbb2");

var $aoOGZ = parcelRequire("aoOGZ");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $1SWSD = parcelRequire("1SWSD");
const $198e16ac9ae48869$export$5f816cf76ff922b8 = (0, $bMm60.createEntry)((0, $1SWSD.legacyConnectGeneralRoute), {
    layout: (0, $isbb2.createLayout)(),
    navigation: {
        sidebar: (0, $5w4hM.genericConnectSidebars)
    },
    resources: [
        (0, $aoOGZ.connectGeneralResources),
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("aoOGZ", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $64e1806c7cddf26f$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $64e1806c7cddf26f$export$53479840ec6d4024);

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");


const $64e1806c7cddf26f$export$f34ab0d904621847 = (0, $6xFTe.createResource)({
    type: (0, $4bb561a7936efe46$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("kw0Ar"))
});
const $64e1806c7cddf26f$export$53479840ec6d4024 = ()=>(0, $h5RgW.useResource)($64e1806c7cddf26f$export$f34ab0d904621847);

});
const $4bb561a7936efe46$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("kw0Ar", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5H5no").then(()=>parcelRequire('aSOAb'));

});


parcelRegister("1SWSD", function(module, exports) {

$parcel$export(module.exports, "legacyConnectGeneralRoute", () => $0fe5e10d62f4b013$export$837edad42702a8e5);

var $exb0h = parcelRequire("exb0h");
const $0fe5e10d62f4b013$export$837edad42702a8e5 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
    path: '/plugins/servlet/ac/:addonKey/:moduleKey'
};

});


parcelRegister("iYEeU", function(module, exports) {

$parcel$export(module.exports, "legacyConnectProjectRouteEntry", () => $1b1a1860833cc314$export$c7f411b1904e5c2a);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $bzNVg = parcelRequire("bzNVg");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $iGM5r = parcelRequire("iGM5r");
const $1b1a1860833cc314$export$c7f411b1904e5c2a = (0, $bMm60.createEntry)((0, $iGM5r.legacyConnectProjectRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        (0, $bzNVg.connectProjectResources),
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $kbHFR.getServiceDeskSharedNavigationSingleResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("bzNVg", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $6b6ae9e1cac63317$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $2fEPO = parcelRequire("2fEPO");

var $kXWpU = parcelRequire("kXWpU");

var $6xFTe = parcelRequire("6xFTe");


const $6b6ae9e1cac63317$export$7d2d082a4b91a6c7 = (0, $6xFTe.createResource)({
    type: (0, $0ac1940034966a81$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $2fEPO.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $kXWpU.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("kRMxB"))
});

});
parcelRegister("2fEPO", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $4720f3e3fd1eb764$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $4720f3e3fd1eb764$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $4720f3e3fd1eb764$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $4720f3e3fd1eb764$export$752ef5ab3d7ab15f);

var $gUUjF = parcelRequire("gUUjF");

var $9T0Tw = parcelRequire("9T0Tw");

var $eWsAG = parcelRequire("eWsAG");
const $4720f3e3fd1eb764$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        const structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $gUUjF.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4720f3e3fd1eb764$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $4720f3e3fd1eb764$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $4720f3e3fd1eb764$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $eWsAG.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $9T0Tw.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $4720f3e3fd1eb764$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $4720f3e3fd1eb764$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $4720f3e3fd1eb764$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("9T0Tw", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $1203c12364555614$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $1203c12364555614$export$67db9e2d1b6ed865);
const $1203c12364555614$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $1203c12364555614$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $0ac1940034966a81$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("kRMxB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4OWud").then(()=>parcelRequire('eps5Q'));

});


parcelRegister("kbHFR", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $d0dacb3ad4515336$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $d0dacb3ad4515336$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $d0dacb3ad4515336$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $d0dacb3ad4515336$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $d0dacb3ad4515336$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $d0dacb3ad4515336$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $d0dacb3ad4515336$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $d0dacb3ad4515336$export$9e0cf1fab0581096);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $l90Gp = parcelRequire("l90Gp");
var $7wRIc = parcelRequire("7wRIc");
var $kKeF6 = parcelRequire("kKeF6");
var $2R6ft = parcelRequire("2R6ft");

var $bbvOQ = parcelRequire("bbvOQ");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $kJ81T = parcelRequire("kJ81T");

var $ct0sQ = parcelRequire("ct0sQ");

var $6bQqb = parcelRequire("6bQqb");

var $eryLo = parcelRequire("eryLo");

var $hRe6W = parcelRequire("hRe6W");

var $gxqFh = parcelRequire("gxqFh");

var $k1AKH = parcelRequire("k1AKH");

var $jwzNs = parcelRequire("jwzNs");

var $cV47S = parcelRequire("cV47S");
const $d0dacb3ad4515336$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...$d0dacb3ad4515336$export$41a9145ddbba28e5()
    ];
const $d0dacb3ad4515336$export$41a9145ddbba28e5 = ()=>[
        ...$d0dacb3ad4515336$export$9c1c5e389bd00e56(),
        ...$d0dacb3ad4515336$export$2c543d6accc1eb9b()
    ];
const $d0dacb3ad4515336$export$9c1c5e389bd00e56 = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsm.queues.sectional.healing'), (0, $hRe6W.priorityGroupResource)),
        (0, $k1AKH.featuresResource),
        (0, $2R6ft.staticSidebarJsmReportsResource)
    ];
const $d0dacb3ad4515336$export$2c543d6accc1eb9b = ()=>[
        (0, $hRe6W.queuesNavigationItems),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('ssr_nav4_queues_sidebar'), (0, $eryLo.requiredProjectProperties)),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('ssr_nav4_queues_sidebar'), (0, $eryLo.requiredFrontendProperties)),
        (0, $l90Gp.forgeServiceDeskQueueModuleResource),
        (0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d0dacb3ad4515336$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $6bQqb.servicedeskPracticesResource),
        (0, $ct0sQ.serviceDeskContextResource),
        (0, $kJ81T.serviceDeskAnalyticsContextResource),
        (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gxqFh.virtualAgentOnboardingResource))
    ];
const $d0dacb3ad4515336$export$a8b852f03a310dc0 = ()=>[
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $ct0sQ.serviceDeskContextResource),
        (0, $kJ81T.serviceDeskAnalyticsContextResource)
    ];
const $d0dacb3ad4515336$export$70b97995f4d5ef9f = ()=>[
        ...$d0dacb3ad4515336$export$a8b852f03a310dc0(),
        ...$d0dacb3ad4515336$export$bc0bd65e6da57c1f(),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, $6bQqb.servicedeskPracticesResource))
    ];
const $d0dacb3ad4515336$export$ed87d3b71544c4ef = ()=>[
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $d0dacb3ad4515336$export$9e0cf1fab0581096 = ()=>[
        (0, $cV47S.workspaceResource)
    ];

});
parcelRegister("2R6ft", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $2e9be7a412e29907$export$ec28065a31cce4ce);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $e3vCY = parcelRequire("e3vCY");
const $2e9be7a412e29907$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $2e9be7a412e29907$export$ec28065a31cce4ce = (0, $6xFTe.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$2e9be7a412e29907$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $2e9be7a412e29907$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $e3vCY.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("e3vCY", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $069786dfe22ba4b1$export$c1dd51127051647d);

var $lRmyA = parcelRequire("lRmyA");
const $069786dfe22ba4b1$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("bbvOQ", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $e70a415f97febed5$export$8b58be1423986d17);

var $6xFTe = parcelRequire("6xFTe");


const $e70a415f97febed5$var$getDataLoader = ()=>(parcelRequire("bvuQU"));
const $e70a415f97febed5$export$8b58be1423986d17 = (0, $6xFTe.createResource)({
    type: (0, $fa79a46718d41206$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $e70a415f97febed5$var$getDataLoader,
    maxAge: Infinity
});

});
const $fa79a46718d41206$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("bvuQU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cNb0V").then(()=>parcelRequire('2H0aU'));

});


parcelRegister("kJ81T", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $f5a87dd3d6d3f919$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $f5a87dd3d6d3f919$export$bc2de1c42df30b10);

var $eUqFw = parcelRequire("eUqFw");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $8hg3R = parcelRequire("8hg3R");


const $f5a87dd3d6d3f919$var$getDataLoader = ()=>(parcelRequire("jmi1c"));
const $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS = 86400000;
const $f5a87dd3d6d3f919$export$d6f4f0483916919f = (0, $6xFTe.createResource)({
    type: (0, $76d1e4a47c4d6ee4$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $f5a87dd3d6d3f919$var$getDataLoader,
    maxAge: $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS
});
const $f5a87dd3d6d3f919$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $h5RgW.useResource)($f5a87dd3d6d3f919$export$d6f4f0483916919f);
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $76d1e4a47c4d6ee4$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("jmi1c", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6G5Ft").then(()=>parcelRequire('eUv3W'));

});


parcelRegister("ct0sQ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $21cb155d8c71cb90$export$5eaaf465969a9171);

var $6xFTe = parcelRequire("6xFTe");

var $8hg3R = parcelRequire("8hg3R");


const $21cb155d8c71cb90$var$getDataLoader = ()=>(parcelRequire("g2zrL"));
const $21cb155d8c71cb90$export$5eaaf465969a9171 = (0, $6xFTe.createResource)({
    type: (0, $826e69ec760c3796$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $8hg3R.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $21cb155d8c71cb90$var$getDataLoader,
    maxAge: Infinity
});

});
const $826e69ec760c3796$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("g2zrL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jNeZh").then(()=>parcelRequire('kuXhx'));

});


parcelRegister("6bQqb", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $b386ee585ab532da$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $b386ee585ab532da$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $b386ee585ab532da$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $b386ee585ab532da$export$4d46346ef0bdc6b9);

var $eUqFw = parcelRequire("eUqFw");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $8hg3R = parcelRequire("8hg3R");

var $f1lMr = parcelRequire("f1lMr");


const $b386ee585ab532da$var$getDataLoader = ()=>(parcelRequire("8Ro9w"));
const $b386ee585ab532da$var$ONE_DAY_IN_MILLIS = 86400000;
const $b386ee585ab532da$export$2ae319305481e7de = (0, $6xFTe.createResource)({
    type: (0, $73bf87f5cdbfcccc$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $b386ee585ab532da$var$getDataLoader,
    maxAge: $b386ee585ab532da$var$ONE_DAY_IN_MILLIS
});
const $b386ee585ab532da$var$queuesOrder = [
    (0, $f1lMr.SERVICE_REQUEST),
    (0, $f1lMr.INCIDENTS),
    (0, $f1lMr.PROBLEMS),
    (0, $f1lMr.CHANGES),
    (0, $f1lMr.POST_INCIDENT_REVIEWS)
];
const $b386ee585ab532da$var$workCategoryOrder = [
    ...$b386ee585ab532da$var$queuesOrder,
    (0, $f1lMr.DEVELOPER_ESCALATION)
];
const $b386ee585ab532da$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $b386ee585ab532da$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $b386ee585ab532da$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $b386ee585ab532da$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $b386ee585ab532da$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $h5RgW.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $b386ee585ab532da$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $h5RgW.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $b386ee585ab532da$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $h5RgW.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
const $73bf87f5cdbfcccc$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("8Ro9w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hVKSK").then(()=>parcelRequire('j7FZq'));

});


parcelRegister("eryLo", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $c75493deb6c23e7e$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $c75493deb6c23e7e$export$47241956725e3029);

var $illlw = parcelRequire("illlw");

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");

var $KBxlk = parcelRequire("KBxlk");

const $c75493deb6c23e7e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("ckpix"));
const $c75493deb6c23e7e$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0];
const $c75493deb6c23e7e$export$fbeae45a65f4a5a6 = (0, $6xFTe.createResource)({
    type: (0, $KBxlk.RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES),
    getKey: $c75493deb6c23e7e$var$getKey,
    getDataLoader: $c75493deb6c23e7e$var$getRequiredProjectPropertiesDataLoader,
    maxAge: (0, $KBxlk.ONE_DAY_IN_MILLIS)
});

const $c75493deb6c23e7e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("loJkn"));
const $c75493deb6c23e7e$export$47241956725e3029 = (0, $6xFTe.createResource)({
    type: (0, $KBxlk.RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES),
    getKey: $c75493deb6c23e7e$var$getKey,
    getDataLoader: $c75493deb6c23e7e$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: (0, $KBxlk.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("KBxlk", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES", () => $2d2ef8b18765c6ae$export$54b53cba12671494);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES", () => $2d2ef8b18765c6ae$export$7d9318d6cfb0a4df);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $2d2ef8b18765c6ae$export$5a00268156ea5027);
const $2d2ef8b18765c6ae$export$54b53cba12671494 = 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';
const $2d2ef8b18765c6ae$export$7d9318d6cfb0a4df = 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES';
const $2d2ef8b18765c6ae$export$5a00268156ea5027 = 86400000;

});

parcelRegister("ckpix", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6OKTx").then(()=>parcelRequire('8GFpN'));

});

parcelRegister("loJkn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aFepX").then(()=>parcelRequire('8Y0ba'));

});


parcelRegister("hRe6W", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $e1c5e34342843ed0$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $e1c5e34342843ed0$export$1f9ab301771fe42e);

var $illlw = parcelRequire("illlw");

var $9zYls = parcelRequire("9zYls");

var $lB25E = parcelRequire("lB25E");

var $2Vm6a = parcelRequire("2Vm6a");

const $e1c5e34342843ed0$var$getDataLoader = ()=>(parcelRequire("ebN6x"));

const $e1c5e34342843ed0$var$getPriorityGroupDataLoader = ()=>(parcelRequire("egdVl"));

const $e1c5e34342843ed0$var$fetchIssueListDataLoader = ()=>(parcelRequire("9BNnQ"));
const $e1c5e34342843ed0$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.queueId', '')}`;
const $e1c5e34342843ed0$export$4fed8be571897bef = (0, $lB25E.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $e1c5e34342843ed0$var$getDataLoader,
    maxAge: (0, $2Vm6a.ONE_DAY_IN_MILLIS)
});
const $e1c5e34342843ed0$export$1f9ab301771fe42e = (0, $lB25E.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $e1c5e34342843ed0$var$getPriorityGroupDataLoader,
    maxAge: (0, $2Vm6a.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true
});
const $e1c5e34342843ed0$export$3d03cbaac8581e65 = (0, $lB25E.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $e1c5e34342843ed0$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $e1c5e34342843ed0$var$fetchIssueListDataLoader,
    maxAge: 0
});

});
parcelRegister("2Vm6a", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $447a57e3617be5c6$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $447a57e3617be5c6$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $447a57e3617be5c6$export$2733615da5b906f0);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $447a57e3617be5c6$export$5a00268156ea5027);
const $447a57e3617be5c6$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $447a57e3617be5c6$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $447a57e3617be5c6$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $447a57e3617be5c6$export$5a00268156ea5027 = 86400000;

});

parcelRegister("ebN6x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("886YZ").then(()=>parcelRequire('hgRsr'));

});

parcelRegister("egdVl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d9Mq1").then(()=>parcelRequire('ioDaq'));

});

parcelRegister("9BNnQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gtAlU").then(()=>parcelRequire('c2gbR'));

});


parcelRegister("gxqFh", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $32eefe0f93fd5c41$export$d39827c053fda3aa);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $kiMrZ = parcelRequire("kiMrZ");
const $32eefe0f93fd5c41$export$d39827c053fda3aa = (0, $buJlM.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kiMrZ.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
            }
        })
});

});
parcelRegister("kiMrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d9f012bfa52f22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcf50e775b221024fd1c30e27bbb62f2>>
 * @relayHash 9459c0218f4aabda777b263e43d6af57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda
const $28d9f012bfa52f22$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $28d9f012bfa52f22$export$2e2bcd8739ae039 = $28d9f012bfa52f22$var$node;

});


parcelRegister("k1AKH", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $fc9160f01d8d9975$export$16f81cc9da2c6c47);

var $illlw = parcelRequire("illlw");

var $6xFTe = parcelRequire("6xFTe");

var $9zYls = parcelRequire("9zYls");


const $fc9160f01d8d9975$var$getDataLoader = ()=>(parcelRequire("8UQqh"));
const $fc9160f01d8d9975$var$ONE_DAY_IN_MILLIS = 86400000;
const $fc9160f01d8d9975$export$16f81cc9da2c6c47 = (0, $6xFTe.createResource)({
    type: (0, $ab0f134d1db7b683$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $fc9160f01d8d9975$var$getDataLoader,
    maxAge: $fc9160f01d8d9975$var$ONE_DAY_IN_MILLIS
});

});
const $ab0f134d1db7b683$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("8UQqh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4Oonc").then(()=>parcelRequire('4Kk02'));

});


parcelRegister("cV47S", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $dac86f6ff29c4c91$export$2f02c3f971168d17);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $6xFTe = parcelRequire("6xFTe");

var $aeCba = parcelRequire("aeCba");
const $dac86f6ff29c4c91$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $dac86f6ff29c4c91$export$2f02c3f971168d17 = (0, $6xFTe.createResource)({
    type: $dac86f6ff29c4c91$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $aeCba.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("aeCba", function(module, exports) {

$parcel$export(module.exports, "isPremiumInstance", () => $5d91810a3f6a3a0a$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $5d91810a3f6a3a0a$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $5d91810a3f6a3a0a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $8PehF = parcelRequire("8PehF");

var $aSJew = parcelRequire("aSJew");

var $6WXNs = parcelRequire("6WXNs");
const $5d91810a3f6a3a0a$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
const $5d91810a3f6a3a0a$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $6WXNs.PREMIUM_EDITION);
    return isPremium;
};
const $5d91810a3f6a3a0a$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $5d91810a3f6a3a0a$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $5d91810a3f6a3a0a$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $aSJew.toWorkspaceId)(ids[0].id) : null;
};
const $5d91810a3f6a3a0a$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    if ($5d91810a3f6a3a0a$export$d7b4c32773b1c643(tenantContext) === false || !(0, $8PehF.isCMDBEnabledInEnvironment)()) return null;
    return (0, $lRmyA.performGetRequest)($5d91810a3f6a3a0a$export$530f260cc76f04ff(baseUrl)).then($5d91810a3f6a3a0a$var$transformResponse).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $5d91810a3f6a3a0a$export$2e2bcd8739ae039 = $5d91810a3f6a3a0a$export$e1d718dfe6dad973;

});
parcelRegister("8PehF", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $65623e3f6693c25d$export$6dbfb62369f79a64);

var $dfBCt = parcelRequire("dfBCt");
const $65623e3f6693c25d$export$6dbfb62369f79a64 = ()=>!(0, $dfBCt.isFedRamp)();

});

parcelRegister("aSJew", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $53b5a9a3e106b32f$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $53b5a9a3e106b32f$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $53b5a9a3e106b32f$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $53b5a9a3e106b32f$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $53b5a9a3e106b32f$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toAttributeId", () => $53b5a9a3e106b32f$export$753b5cb76981c41d);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $53b5a9a3e106b32f$export$cfd92c18cee8add7);
const $53b5a9a3e106b32f$export$d577b7f3b832f656 = (id)=>id;
const $53b5a9a3e106b32f$export$1ba342595bc7be13 = (id)=>id;
const $53b5a9a3e106b32f$export$b46e25afa2bab6a = (id)=>id;
const $53b5a9a3e106b32f$export$ece2917434bb0a8c = (id)=>id;
const $53b5a9a3e106b32f$export$d002b8d7821b6b59 = (id)=>id;
const $53b5a9a3e106b32f$export$753b5cb76981c41d = (id)=>id;
const $53b5a9a3e106b32f$export$cfd92c18cee8add7 = (id)=>id;

});




parcelRegister("iGM5r", function(module, exports) {

$parcel$export(module.exports, "legacyConnectProjectRoute", () => $c42fb808b79f869c$export$dfdf98c5b58cfa04);

var $exb0h = parcelRequire("exb0h");
const $c42fb808b79f869c$export$dfdf98c5b58cfa04 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
    path: '/projects/:projectKey',
    query: [
        'selectedItem'
    ]
};

});


parcelRegister("1xUfI", function(module, exports) {

$parcel$export(module.exports, "legacyCustomReportRouteEntry", () => $5d0c8cea1b5ae921$export$12938ba85bf5fe54);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $eJopP = parcelRequire("eJopP");

var $bEe6y = parcelRequire("bEe6y");

var $9ZbpC = parcelRequire("9ZbpC");
const $5d0c8cea1b5ae921$export$12938ba85bf5fe54 = (0, $bMm60.createEntry)((0, $eJopP.legacyCustomReportRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $9ZbpC.getReportsCommonResource)()
    ]
});

});
parcelRegister("eJopP", function(module, exports) {

$parcel$export(module.exports, "legacyCustomReportRoute", () => $72c983dd2518f6dc$export$6f4b8901e7772b05);

var $exb0h = parcelRequire("exb0h");
const $72c983dd2518f6dc$export$6f4b8901e7772b05 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_CUSTOM_REPORT),
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("9ZbpC", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $4ac264e5a4e412bd$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $4ac264e5a4e412bd$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $4ac264e5a4e412bd$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("8WSCP", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsAddRouteEntry", () => $b5060d6b299d5bea$export$6cc9527a3f96c0a5);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $hgZA6 = parcelRequire("hgZA6");
const $b5060d6b299d5bea$export$6cc9527a3f96c0a5 = (0, $bMm60.createEntry)((0, $hgZA6.legacyDashboardsAddRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    }
});

});
parcelRegister("hgZA6", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsAddRoute", () => $619ca1481695c4cb$export$1e88394d2d12a4bc);
const $619ca1481695c4cb$var$secure = '(/secure/|/)';
const $619ca1481695c4cb$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $619ca1481695c4cb$export$1e88394d2d12a4bc = {
    name: 'legacy-dashboards-add',
    path: `${$619ca1481695c4cb$var$secure}AddPortalPage${$619ca1481695c4cb$var$defaultSuffix}.jspa`
};

});


parcelRegister("iVzDY", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsConfigureRouteEntry", () => $5190aa77340e080c$export$18ff609f147595cc);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $dqhVj = parcelRequire("dqhVj");
const $5190aa77340e080c$export$18ff609f147595cc = (0, $bMm60.createEntry)((0, $dqhVj.legacyDashboardsConfigureRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    }
});

});
parcelRegister("dqhVj", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsConfigureRoute", () => $7b2b6325c75231b3$export$549a0bcc3a0017a7);
const $7b2b6325c75231b3$var$secure = '(/secure/|/)';
const $7b2b6325c75231b3$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $7b2b6325c75231b3$export$549a0bcc3a0017a7 = {
    name: 'legacy-dashboards-configure',
    path: `${$7b2b6325c75231b3$var$secure}ConfigurePortalPages${$7b2b6325c75231b3$var$defaultSuffix}.jspa`
};

});


parcelRegister("9t1Bs", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsDeleteRouteEntry", () => $efcc03936ad2e182$export$4f59d0a9276c0c9b);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $3egEf = parcelRequire("3egEf");
const $efcc03936ad2e182$export$4f59d0a9276c0c9b = (0, $bMm60.createEntry)((0, $3egEf.legacyDashboardsDeleteRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    }
});

});
parcelRegister("3egEf", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsDeleteRoute", () => $83a34e3c44295c4d$export$dfa5dcc35e497330);
const $83a34e3c44295c4d$var$secure = '(/secure/|/)';
const $83a34e3c44295c4d$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $83a34e3c44295c4d$export$dfa5dcc35e497330 = {
    name: 'legacy-dashboards-delete',
    path: `${$83a34e3c44295c4d$var$secure}DeletePortalPage${$83a34e3c44295c4d$var$defaultSuffix}.jspa`
};

});


parcelRegister("17XRP", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $7dc3147ae2fb9e2f$export$748e329bd0c282a);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $1bNgp = parcelRequire("1bNgp");
const $7dc3147ae2fb9e2f$export$748e329bd0c282a = (0, $bMm60.createEntry)((0, $1bNgp.dashboardsDirectoryRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    }
});

});
parcelRegister("1bNgp", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $61449b6945ffb8f1$export$41bba408475cab16);

var $exb0h = parcelRequire("exb0h");
const $61449b6945ffb8f1$export$41bba408475cab16 = {
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    path: '/jira/dashboards'
};

});


parcelRegister("qNMoW", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsEditRouteEntry", () => $2891e5e18364db1e$export$60414c63c9cd3646);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $aq1du = parcelRequire("aq1du");
const $2891e5e18364db1e$export$60414c63c9cd3646 = (0, $bMm60.createEntry)((0, $aq1du.legacyDashboardsEditRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    }
});

});
parcelRegister("aq1du", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsEditRoute", () => $643e2d8ecbbfffa0$export$4f028eb17334a195);
const $643e2d8ecbbfffa0$var$secure = '(/secure/|/)';
const $643e2d8ecbbfffa0$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $643e2d8ecbbfffa0$export$4f028eb17334a195 = {
    name: 'legacy-dashboards-edit',
    path: `${$643e2d8ecbbfffa0$var$secure}EditPortalPage${$643e2d8ecbbfffa0$var$defaultSuffix}.jspa`
};

});


parcelRegister("5fmBg", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsRestoreRouteEntry", () => $3da75dd6a5c41344$export$4bf748e39cc28644);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9rrnD = parcelRequire("9rrnD");
const $3da75dd6a5c41344$export$4bf748e39cc28644 = (0, $bMm60.createEntry)((0, $9rrnD.legacyDashboardsRestoreRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    }
});

});
parcelRegister("9rrnD", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsRestoreRoute", () => $01609c2188db1691$export$110af57b4332630d);
const $01609c2188db1691$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $01609c2188db1691$export$110af57b4332630d = {
    name: 'legacy-dashboards-restore',
    path: `/secure/RestoreDefaultDashboard${$01609c2188db1691$var$defaultSuffix}.jspa`
};

});


parcelRegister("gIjnZ", function(module, exports) {

$parcel$export(module.exports, "legacyFallbackRouteEntry", () => $be1d6e072285c088$export$1af0a6dff57e40e7);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $eFlcQ = parcelRequire("eFlcQ");
const $be1d6e072285c088$export$1af0a6dff57e40e7 = (0, $bMm60.createEntry)((0, $eFlcQ.legacyFallbackRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("eFlcQ", function(module, exports) {

$parcel$export(module.exports, "legacyFallbackRoute", () => $45b587a93608a40a$export$27cd5ba2ad569682);

var $exb0h = parcelRequire("exb0h");
const $45b587a93608a40a$export$27cd5ba2ad569682 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_FALLBACK),
    path: '/:any'
};

});


parcelRegister("1JV9H", function(module, exports) {

$parcel$export(module.exports, "legacyGinActionRouteEntry", () => $98cac17a0752c973$export$8d542f975e38405d);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $fxlTA = parcelRequire("fxlTA");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kURmE = parcelRequire("kURmE");
const $98cac17a0752c973$export$8d542f975e38405d = (0, $bMm60.createEntry)((0, $kURmE.legacyGinActionRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("fxlTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0c9af883eccf10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $2b0c9af883eccf10$export$1af88ebe65f50e73);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

// Legacy GIN Sidebar
const $2b0c9af883eccf10$var$LazySidebarFiltersLegacy = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("gMUZw")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2b0c9af883eccf10$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b0c9af883eccf10$var$LazySidebarFiltersLegacy, null)));
var $2b0c9af883eccf10$export$2e2bcd8739ae039 = $2b0c9af883eccf10$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $2b0c9af883eccf10$var$LazySidebarFiltersGlobal = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("aadxz")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $2b0c9af883eccf10$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b0c9af883eccf10$var$LazySidebarFiltersGlobal, null)));

});
parcelRegister("gMUZw", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("jaWtQ")
]).then(()=>parcelRequire('lS5FJ'));

});

parcelRegister("aadxz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("g3Or4")
]).then(()=>parcelRequire('j1wPf'));

});


parcelRegister("kURmE", function(module, exports) {

$parcel$export(module.exports, "legacyGinActionRoute", () => $f3f1e2da39bd68c4$export$796a8e79b017f80d);
const $f3f1e2da39bd68c4$export$796a8e79b017f80d = {
    name: 'legacy-gin-action',
    path: '/secure/IssueNavAction!default.jspa',
    query: [
        'filter|jql|issueKey'
    ]
};

});


parcelRegister("qswpl", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkRouteEntry", () => $137b77f22824efdb$export$fa36e59125fc7266);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $4H8OC = parcelRequire("4H8OC");
const $137b77f22824efdb$export$fa36e59125fc7266 = (0, $bMm60.createEntry)((0, $4H8OC.legacyGinBulkRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("4H8OC", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkRoute", () => $0960ed1df1b6c0fd$export$73e4833202a78627);
const $0960ed1df1b6c0fd$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $0960ed1df1b6c0fd$export$73e4833202a78627 = {
    name: 'legacy-gin-bulk',
    path: `/secure/Bulk(\\w+)${$0960ed1df1b6c0fd$var$defaultSuffix}.jspa`
};

});


parcelRegister("4K2n4", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkeditRouteEntry", () => $1a7b2e1e36b59cc7$export$f591688aa6cd2d3);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $eMqoK = parcelRequire("eMqoK");
const $1a7b2e1e36b59cc7$export$f591688aa6cd2d3 = (0, $bMm60.createEntry)((0, $eMqoK.legacyGinBulkeditRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("eMqoK", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkeditRoute", () => $4c8d61dae7e908b5$export$7c8f48fad7f31e42);
const $4c8d61dae7e908b5$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $4c8d61dae7e908b5$export$7c8f48fad7f31e42 = {
    name: 'legacy-gin-bulkedit',
    path: `/(secure/views|issue)/bulkedit/Bulk(\\w+)${$4c8d61dae7e908b5$var$defaultSuffix}.jspa`
};

});


parcelRegister("eLXBs", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueAssignRouteEntry", () => $4980eb4e17e3f515$export$b7bc71c8e27d96);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $efiCO = parcelRequire("efiCO");
const $4980eb4e17e3f515$export$b7bc71c8e27d96 = (0, $bMm60.createEntry)((0, $efiCO.legacyGinIssueAssignRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("efiCO", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueAssignRoute", () => $13c889a05aa1d02b$export$6cc1fcd71b2e06ad);
const $13c889a05aa1d02b$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $13c889a05aa1d02b$export$6cc1fcd71b2e06ad = {
    name: 'legacy-gin-issue-assign',
    path: `/secure/(\\w*)AssignIssue${$13c889a05aa1d02b$var$defaultSuffix}.jspa`
};

});


parcelRegister("LHKQV", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCloneRouteEntry", () => $4cf5597c0babca91$export$b54f23b666808992);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $jxbbp = parcelRequire("jxbbp");
const $4cf5597c0babca91$export$b54f23b666808992 = (0, $bMm60.createEntry)((0, $jxbbp.legacyGinIssueCloneRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("jxbbp", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCloneRoute", () => $dffff21085b95b6e$export$55ba9c8834c09ade);
const $dffff21085b95b6e$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $dffff21085b95b6e$export$55ba9c8834c09ade = {
    name: 'legacy-gin-issue-clone',
    path: `/(secure|issue)/CloneIssue(\\w*)${$dffff21085b95b6e$var$defaultSuffix}.jspa`
};

});


parcelRegister("1FmVb", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueConvertRouteEntry", () => $c2e29c0c82e4d8d2$export$45f0108fe367a800);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $8xfoZ = parcelRequire("8xfoZ");
const $c2e29c0c82e4d8d2$export$45f0108fe367a800 = (0, $bMm60.createEntry)((0, $8xfoZ.legacyGinIssueConvertRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("8xfoZ", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueConvertRoute", () => $823fd85e7b1b7679$export$338f229cb5c21a79);
const $823fd85e7b1b7679$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $823fd85e7b1b7679$export$338f229cb5c21a79 = {
    name: 'legacy-gin-issue-convert',
    path: `/secure/ConvertIssue(\\w*)${$823fd85e7b1b7679$var$defaultSuffix}.jspa`
};

});


parcelRegister("gAZCg", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCreateRouteEntry", () => $9e68597fcf2b686b$export$86ab2339e662875a);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $9GgbV = parcelRequire("9GgbV");
const $9e68597fcf2b686b$export$86ab2339e662875a = (0, $bMm60.createEntry)((0, $9GgbV.legacyGinIssueCreateRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("9GgbV", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCreateRoute", () => $ababcc21e2d0bdeb$export$f27db894d3724085);
const $ababcc21e2d0bdeb$var$secure = '(/secure/|/)';
const $ababcc21e2d0bdeb$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $ababcc21e2d0bdeb$export$f27db894d3724085 = {
    name: 'legacy-gin-issue-create',
    path: `${$ababcc21e2d0bdeb$var$secure}CreateIssue(\\w*)${$ababcc21e2d0bdeb$var$defaultSuffix}.jspa`
};

});


parcelRegister("5HwSM", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueEditRouteEntry", () => $69d355ccfaf17b26$export$944b36cf4b5cef62);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $9tc0z = parcelRequire("9tc0z");
const $69d355ccfaf17b26$export$944b36cf4b5cef62 = (0, $bMm60.createEntry)((0, $9tc0z.legacyGinIssueEditRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("9tc0z", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueEditRoute", () => $81d8443a246e0bc0$export$5286735392e527fb);
const $81d8443a246e0bc0$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $81d8443a246e0bc0$export$5286735392e527fb = {
    name: 'legacy-gin-issue-edit',
    path: `/secure/EditIssue${$81d8443a246e0bc0$var$defaultSuffix}.jspaa`
};

});


parcelRegister("3lAhy", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueMoveRouteEntry", () => $fbc19f793d3be39d$export$9c2ab973bb46413b);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $1JA4r = parcelRequire("1JA4r");
const $fbc19f793d3be39d$export$9c2ab973bb46413b = (0, $bMm60.createEntry)((0, $1JA4r.legacyGinIssueMoveRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("1JA4r", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueMoveRoute", () => $fd2da44ffcc906bd$export$338e257c93d678f9);
const $fd2da44ffcc906bd$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $fd2da44ffcc906bd$export$338e257c93d678f9 = {
    name: 'legacy-gin-issue-move',
    path: `/secure/MoveIssue(\\w*)${$fd2da44ffcc906bd$var$defaultSuffix}.jspa`
};

});


parcelRegister("aMVCY", function(module, exports) {

$parcel$export(module.exports, "legacyGinManageRouteEntry", () => $a286802b84d095af$export$2b56a5623615dd47);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $fxlTA = parcelRequire("fxlTA");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9qtKG = parcelRequire("9qtKG");
const $a286802b84d095af$export$2b56a5623615dd47 = (0, $bMm60.createEntry)((0, $9qtKG.legacyGinManageRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9qtKG", function(module, exports) {

$parcel$export(module.exports, "legacyGinManageRoute", () => $3c1471983e36c6ea$export$e6c509778313a0c1);
const $3c1471983e36c6ea$var$secure = '(/secure/|/)';
const $3c1471983e36c6ea$export$e6c509778313a0c1 = {
    name: 'legacy-gin-manage',
    path: `${$3c1471983e36c6ea$var$secure}ManageFilters.jspa`
};

});


parcelRegister("1l6lw", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionEditRouteEntry", () => $3091b8512587fa6f$export$5255243cc56f26c3);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $fxlTA = parcelRequire("fxlTA");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $in8dg = parcelRequire("in8dg");
const $3091b8512587fa6f$export$5255243cc56f26c3 = (0, $bMm60.createEntry)((0, $in8dg.legacyGinSubscriptionEditRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("in8dg", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionEditRoute", () => $79944b514f4616dc$export$20e6c550a55cf8f4);
const $79944b514f4616dc$var$secure = '(/secure/|/)';
const $79944b514f4616dc$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $79944b514f4616dc$export$20e6c550a55cf8f4 = {
    name: 'legacy-gin-subscription-edit',
    path: `${$79944b514f4616dc$var$secure}EditSubscription${$79944b514f4616dc$var$defaultSuffix}.jspa`
};

});


parcelRegister("hfhaB", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionsRouteEntry", () => $67a0881cec64ff53$export$e739dd8af3aee54a);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $fxlTA = parcelRequire("fxlTA");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $7aIUk = parcelRequire("7aIUk");
const $67a0881cec64ff53$export$e739dd8af3aee54a = (0, $bMm60.createEntry)((0, $7aIUk.legacyGinSubscriptionsRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("7aIUk", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionsRoute", () => $4f0c64891ac1f78b$export$cbcaf00bd4f92b0);

var $exb0h = parcelRequire("exb0h");
const $4f0c64891ac1f78b$var$secure = '(/secure/|/)';
const $4f0c64891ac1f78b$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $4f0c64891ac1f78b$export$cbcaf00bd4f92b0 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS),
    path: `${$4f0c64891ac1f78b$var$secure}ViewSubscriptions${$4f0c64891ac1f78b$var$defaultSuffix}.jspa`
};

});


parcelRegister("7WDKx", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubtaskActionRouteEntry", () => $0d01ac41779f17e8$export$31f29cb95c5903fc);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $cestB = parcelRequire("cestB");
const $0d01ac41779f17e8$export$31f29cb95c5903fc = (0, $bMm60.createEntry)((0, $cestB.legacyGinSubtaskActionRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("cestB", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubtaskActionRoute", () => $5f89423161e176bf$export$d9c87b9b27d73f7c);
const $5f89423161e176bf$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $5f89423161e176bf$export$d9c87b9b27d73f7c = {
    name: 'legacy-gin-subtask-action',
    path: `/secure/(Move|Convert)SubTask(\\w*)${$5f89423161e176bf$var$defaultSuffix}.jspa`
};

});


parcelRegister("4glRX", function(module, exports) {

$parcel$export(module.exports, "legacyGinWatchersIssueRouteEntry", () => $495d626e0738d944$export$97a124d7b834ca82);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $8gDZ4 = parcelRequire("8gDZ4");
const $495d626e0738d944$export$97a124d7b834ca82 = (0, $bMm60.createEntry)((0, $8gDZ4.legacyGinWatchersIssueRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("8gDZ4", function(module, exports) {

$parcel$export(module.exports, "legacyGinWatchersIssueRoute", () => $30bab2f5f7a2954f$export$b3198e66bf5d49ae);
const $30bab2f5f7a2954f$export$b3198e66bf5d49ae = {
    name: 'legacy-gin-watchers-issue',
    path: '/secure/ManageWatchers!default.jspa'
};

});


parcelRegister("cUfSr", function(module, exports) {

$parcel$export(module.exports, "globalAutomationRouteEntry", () => $1d4cb466e0feb11c$export$652cb0c5f80823c0);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $hBaUk = parcelRequire("hBaUk");
const $1d4cb466e0feb11c$export$652cb0c5f80823c0 = (0, $bMm60.createEntry)((0, $hBaUk.globalAutomationRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("hBaUk", function(module, exports) {

$parcel$export(module.exports, "globalAutomationRoute", () => $20de263a12279983$export$5276d514cac1db59);
const $20de263a12279983$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $20de263a12279983$export$5276d514cac1db59 = {
    name: 'global-automation',
    path: `/secure/Automation${$20de263a12279983$var$defaultSuffix}.jspa`
};

});


parcelRegister("1NXii", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRouteEntry", () => $b5556ac8e1eacdf6$export$690b5fd7062ce607);
$parcel$export(module.exports, "globalIssueNavigatorBrowseRouteEntry", () => $b5556ac8e1eacdf6$export$b1b791616cdb9491);
$parcel$export(module.exports, "globalIssueNavigatorRedirectRouteEntry", () => $b5556ac8e1eacdf6$export$8cbe781346b8b4a2);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $fxlTA = parcelRequire("fxlTA");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $bCmyq = parcelRequire("bCmyq");

var $LSeRk = parcelRequire("LSeRk");

var $1ciVT = parcelRequire("1ciVT");
const $b5556ac8e1eacdf6$export$690b5fd7062ce607 = (0, $bMm60.createEntry)((0, $LSeRk.globalIssueNavigatorRoute), {
    canTransitionIn: ()=>false,
    component: (0, $1ciVT.LegacyPageWithTeamProfileCardView),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});
const $b5556ac8e1eacdf6$export$b1b791616cdb9491 = (0, $bMm60.createEntry)((0, $LSeRk.globalIssueNavigatorBrowseRoute), {
    canTransitionIn: ()=>false,
    component: (0, $bCmyq.LegacyPage),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});
const $b5556ac8e1eacdf6$export$8cbe781346b8b4a2 = (0, $bMm60.createEntry)((0, $LSeRk.globalIssueNavigatorRedirectRoute), {
    canTransitionIn: ()=>false,
    component: (0, $bCmyq.LegacyPage),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        sidebar: (0, $fxlTA.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("LSeRk", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $02ff176d6c4428e4$export$f4c8e8bc55cd2008);
$parcel$export(module.exports, "globalIssueNavigatorBrowseRoute", () => $02ff176d6c4428e4$export$c1b37e392499fccf);
$parcel$export(module.exports, "globalIssueNavigatorRedirectRoute", () => $02ff176d6c4428e4$export$b2cd2888fd62d62e);

var $exb0h = parcelRequire("exb0h");
const $02ff176d6c4428e4$export$f4c8e8bc55cd2008 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN),
    path: '/issues/:issueKey(.*)?',
    apdexIgnoreParams: [
        'issueKey'
    ]
};
const $02ff176d6c4428e4$export$c1b37e392499fccf = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_ISSUE),
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};
const $02ff176d6c4428e4$export$b2cd2888fd62d62e = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH),
    path: '/secure/QuickSearch.jspa',
    query: [
        'searchString'
    ]
};

});

parcelRegister("1ciVT", function(module, exports) {

$parcel$export(module.exports, "LegacyPageWithTeamProfileCardView", () => $c41c462c084fefb9$export$bc3f01ea4ac19d59);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $iVQ7s = parcelRequire("iVQ7s");

var $6cmEg = parcelRequire("6cmEg");

var $bCmyq = parcelRequire("bCmyq");

var $gd0Sp = parcelRequire("gd0Sp");
const $c41c462c084fefb9$export$bc3f01ea4ac19d59 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCmyq.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVQ7s.default), null), (0, $1ybV0.ff)('ptc.enabled.legacy-profile.card') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cmEg.default), {
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber)
    }) : null);

});
parcelRegister("iVQ7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af258ecb27f0ff2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3af258ecb27f0ff2$var$OpenHelpPanelLinkThroughEventListener = (0, $7rh0R.lazy)(()=>(parcelRequire("lzPCj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $3af258ecb27f0ff2$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af258ecb27f0ff2$var$OpenHelpPanelLinkThroughEventListener, null)));
var $3af258ecb27f0ff2$export$2e2bcd8739ae039 = $3af258ecb27f0ff2$export$9b28d5c0f56030a7;

});
parcelRegister("lzPCj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("4Cea4")
]).then(()=>parcelRequire('743zr'));

});


parcelRegister("6cmEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeb127311408e35b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aeb127311408e35b$var$LegacyTeamProfileCard = (0, $7rh0R.lazy)(()=>(parcelRequire("efzdD")), {
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard-legacy/index.tsx"
});
const $aeb127311408e35b$export$c8a3662e461b7707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "legacy-team-profile-card",
        packageName: "profilecard-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-legacy-team-profile-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aeb127311408e35b$var$LegacyTeamProfileCard, props)));
var $aeb127311408e35b$export$2e2bcd8739ae039 = $aeb127311408e35b$export$c8a3662e461b7707;

});
parcelRegister("efzdD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bqkBT")
]).then(()=>parcelRequire('3TT68'));

});




parcelRegister("imUKj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsAddonsOauthRouteEntry", () => $6efdfe054524521e$export$b674e2feb3ded4d1);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $aYCw0 = parcelRequire("aYCw0");
const $6efdfe054524521e$export$b674e2feb3ded4d1 = (0, $bMm60.createEntry)((0, $aYCw0.globalSettingsAddonsOauthRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        sidebar: (0, $hUM03.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)()
    ]
});

});
parcelRegister("aYCw0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsAddonsOauthRoute", () => $8b8cb44523a5c834$export$13884c00b567e541);
const $8b8cb44523a5c834$export$13884c00b567e541 = {
    name: 'global-settings-addons-oauth',
    path: '/secure/oauth-credentials'
};

});


parcelRegister("bkOwc", function(module, exports) {

$parcel$export(module.exports, "emceeAppRouteEntry", () => $43760d8bf4308747$export$881c7d683ab02802);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $bCmyq = parcelRequire("bCmyq");

var $bKRo5 = parcelRequire("bKRo5");
const $43760d8bf4308747$export$881c7d683ab02802 = (0, $bMm60.createEntry)((0, $bKRo5.emceeAppRoute), {
    canTransitionIn: ()=>false,
    component: (0, $bCmyq.LegacyPage),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)()
    ]
});

});
parcelRegister("bKRo5", function(module, exports) {

$parcel$export(module.exports, "emceeAppRoute", () => $d35d370905e3d2b9$export$5149e7851c6c4f53);
$parcel$export(module.exports, "manageAppsRoute", () => $d35d370905e3d2b9$export$d5409be3b4016aab);

var $exb0h = parcelRequire("exb0h");
const $d35d370905e3d2b9$export$5149e7851c6c4f53 = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE),
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
};
const $d35d370905e3d2b9$export$d5409be3b4016aab = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_MANAGE_APPS),
    path: '/plugins/servlet/upm'
};

});


parcelRegister("43CRR", function(module, exports) {

$parcel$export(module.exports, "manageAppsRouteEntry", () => $13a29f3f489ce4cb$export$4ce557e11b5e9d68);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $bCmyq = parcelRequire("bCmyq");

var $bKRo5 = parcelRequire("bKRo5");
const $13a29f3f489ce4cb$export$4ce557e11b5e9d68 = (0, $bMm60.createEntry)((0, $bKRo5.manageAppsRoute), {
    canTransitionIn: ()=>false,
    component: (0, $bCmyq.LegacyPage),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)()
    ]
});

});

parcelRegister("hgTPZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $e5fc200332a79e15$export$d83c2e469d070766);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $iyUIE = parcelRequire("iyUIE");
const $e5fc200332a79e15$export$d83c2e469d070766 = (0, $bMm60.createEntry)((0, $iyUIE.globalSettingsCustomFieldsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("4JtEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc85345805b2b6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $bdc85345805b2b6b$var$LazyGlobalIssuesSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("dlPK6")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdc85345805b2b6b$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc85345805b2b6b$var$LazyGlobalIssuesSettingsSidebar, null)));
var $bdc85345805b2b6b$export$2e2bcd8739ae039 = $bdc85345805b2b6b$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("dlPK6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fSMvu").then(()=>parcelRequire('bSHNx'));

});


parcelRegister("iyUIE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $5869fb273f197a5d$export$45e7d93edcc9507f);

var $exb0h = parcelRequire("exb0h");
const $5869fb273f197a5d$export$45e7d93edcc9507f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
    path: '/secure/admin/ViewCustomFields.jspa'
};

});


parcelRegister("g4Nub", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRouteEntry", () => $1ffa608e638449db$export$c493b601f2512cdb);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $byLfJ = parcelRequire("byLfJ");
const $1ffa608e638449db$export$c493b601f2512cdb = (0, $bMm60.createEntry)((0, $byLfJ.globalSettingsFieldLayoutSchemesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("byLfJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRoute", () => $f3a6d5c07ed237b3$export$6e04f01d8f54ad08);

var $exb0h = parcelRequire("exb0h");
const $f3a6d5c07ed237b3$export$6e04f01d8f54ad08 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES),
    path: '/secure/admin/ViewFieldLayoutSchemes.jspa'
};

});


parcelRegister("cHfoX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutsRouteEntry", () => $aeb8dc9d10347bf0$export$9988358457e7d230);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $bkfIo = parcelRequire("bkfIo");
const $aeb8dc9d10347bf0$export$9988358457e7d230 = (0, $bMm60.createEntry)((0, $bkfIo.globalSettingsFieldLayoutsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("bkfIo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutsRoute", () => $4e8b57ba61dbabb2$export$ead41dd3ea1da5b3);

var $exb0h = parcelRequire("exb0h");
const $4e8b57ba61dbabb2$export$ead41dd3ea1da5b3 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS),
    path: '/secure/admin/ViewFieldLayouts.jspa'
};

});


parcelRegister("l76Vj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueSubtasksRouteEntry", () => $53bf3307f75c861b$export$625e23490e28fdb5);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $jJ1Du = parcelRequire("jJ1Du");
const $53bf3307f75c861b$export$625e23490e28fdb5 = (0, $bMm60.createEntry)((0, $jJ1Du.globalSettingsIssueSubtasksRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("jJ1Du", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueSubtasksRoute", () => $63aa994f4e385bd4$export$1327adfb7eea6607);

var $exb0h = parcelRequire("exb0h");
const $63aa994f4e385bd4$export$1327adfb7eea6607 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS),
    path: '/secure/admin/subtasks/ManageSubTasks.jspa'
};

});


parcelRegister("5xWEa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRouteEntry", () => $182fb49693e1d275$export$ad6c1602c9fe5020);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $3hcwM = parcelRequire("3hcwM");
const $182fb49693e1d275$export$ad6c1602c9fe5020 = (0, $bMm60.createEntry)((0, $3hcwM.globalSettingsIssueTimeTrackingRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("3hcwM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRoute", () => $8866d145b02d15b9$export$8596beec8543d958);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $8866d145b02d15b9$var$defaultSuffix = '([!%]?[\\w]*)';
const $8866d145b02d15b9$export$8596beec8543d958 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING),
    path: `/secure/admin/TimeTrackingAdmin${$8866d145b02d15b9$var$defaultSuffix}.jspa`
};

});


parcelRegister("gIH1C", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowRouteEntry", () => $ce758191e0c2a751$export$460b4d1709d73a2e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $8hKOH = parcelRequire("8hKOH");
const $ce758191e0c2a751$export$460b4d1709d73a2e = (0, $bMm60.createEntry)((0, $8hKOH.globalSettingsIssueWorkflowRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("8hKOH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowRoute", () => $9909846c22990c73$export$83c76a9f38e044d2);

var $exb0h = parcelRequire("exb0h");
const $9909846c22990c73$export$83c76a9f38e044d2 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
    path: '/secure/admin/workflows/:page'
};

});


parcelRegister("iE7ZG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRouteEntry", () => $47fb3f157450af39$export$cfc4572fe7838d46);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5ZXqZ = parcelRequire("5ZXqZ");
const $47fb3f157450af39$export$cfc4572fe7838d46 = (0, $bMm60.createEntry)((0, $5ZXqZ.globalSettingsIssueWorkflowSchemesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5ZXqZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRoute", () => $1e4fb2819f2023dc$export$fabaf6e717c3f1b6);

var $exb0h = parcelRequire("exb0h");
const $1e4fb2819f2023dc$export$fabaf6e717c3f1b6 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES),
    path: '/secure/admin/ViewWorkflowSchemes.jspa'
};

});


parcelRegister("1Aau6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRouteEntry", () => $3e74544d6952ace1$export$580990afd7fb8505);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $lRQup = parcelRequire("lRQup");
const $3e74544d6952ace1$export$580990afd7fb8505 = (0, $bMm60.createEntry)((0, $lRQup.globalSettingsIssuesCustomFieldsAssociateRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("lRQup", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRoute", () => $f3474f662b9f88c4$export$4e17e29838928fe7);

var $exb0h = parcelRequire("exb0h");
const $f3474f662b9f88c4$export$4e17e29838928fe7 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE),
    path: '/secure/admin/AssociateFieldToScreens!default.jspa'
};

});


parcelRegister("iVrTt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRouteEntry", () => $48bfcb393907c8d0$export$f2078b26bfdef553);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $h8x1a = parcelRequire("h8x1a");
const $48bfcb393907c8d0$export$f2078b26bfdef553 = (0, $bMm60.createEntry)((0, $h8x1a.globalSettingsIssuesCustomFieldsConfigRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("h8x1a", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRoute", () => $f2c7f6ffdd9e61b1$export$db330236178a2eb2);

var $exb0h = parcelRequire("exb0h");
const $f2c7f6ffdd9e61b1$export$db330236178a2eb2 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE),
    path: '/secure/admin/ConfigureCustomField!default.jspa'
};

});


parcelRegister("2VpKv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRouteEntry", () => $6c2e105068230501$export$504c6fb2862492a1);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $javJs = parcelRequire("javJs");
const $6c2e105068230501$export$504c6fb2862492a1 = (0, $bMm60.createEntry)((0, $javJs.globalSettingsIssuesCustomFieldsDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("javJs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRoute", () => $9d9478ad6c94c457$export$36f7f639e35c6980);

var $exb0h = parcelRequire("exb0h");
const $9d9478ad6c94c457$export$36f7f639e35c6980 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE),
    path: '/secure/admin/DeleteCustomField!default.jspa'
};

});


parcelRegister("c9ioI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRouteEntry", () => $093ccb7097ad47eb$export$68ff9a44323b27ca);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $7wmdf = parcelRequire("7wmdf");
const $093ccb7097ad47eb$export$68ff9a44323b27ca = (0, $bMm60.createEntry)((0, $7wmdf.globalSettingsIssuesCustomFieldsEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("7wmdf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRoute", () => $7da2a727535d7c47$export$ca7a3fa1760c59bf);

var $exb0h = parcelRequire("exb0h");
const $7da2a727535d7c47$export$ca7a3fa1760c59bf = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT),
    path: '/secure/admin/EditCustomField(\\w*)!default.jspa'
};

});


parcelRegister("9xKXn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRouteEntry", () => $2b8217043681db1e$export$12970e70b4c77f98);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $836lu = parcelRequire("836lu");
const $2b8217043681db1e$export$12970e70b4c77f98 = (0, $bMm60.createEntry)((0, $836lu.globalSettingsIssuesCustomFieldsManageRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("836lu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRoute", () => $bca2caea3c199c84$export$441ab7e26eb9710);

var $exb0h = parcelRequire("exb0h");
const $bca2caea3c199c84$export$441ab7e26eb9710 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE),
    path: '/secure/admin/ManageConfigurationScheme!default.jspa'
};

});


parcelRegister("c8sjC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRouteEntry", () => $f4c0bca5b0e34cc5$export$df186d4a4dcc70d6);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $54RoB = parcelRequire("54RoB");
const $f4c0bca5b0e34cc5$export$df186d4a4dcc70d6 = (0, $bMm60.createEntry)((0, $54RoB.globalSettingsIssuesCustomFieldsTranslateRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("54RoB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRoute", () => $1c415cf3cdf135a6$export$13f985d12cff8c13);

var $exb0h = parcelRequire("exb0h");
const $1c415cf3cdf135a6$export$13f985d12cff8c13 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE),
    path: '/secure/admin/TranslateCustomField!default.jspa'
};

});


parcelRegister("gFF3Y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldAddRouteEntry", () => $bf5b8a41768aca2c$export$a0f9d2aa72494978);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $jMVqw = parcelRequire("jMVqw");
const $bf5b8a41768aca2c$export$a0f9d2aa72494978 = (0, $bMm60.createEntry)((0, $jMVqw.globalSettingsIssuesFieldAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("jMVqw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldAddRoute", () => $87bd4d47303c5d35$export$7bb3a869061a8016);
const $87bd4d47303c5d35$export$7bb3a869061a8016 = {
    name: 'global-settings-issues-field-add',
    path: '/secure/admin/AddNewFieldScreen.jspa'
};

});


parcelRegister("iMiUN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRouteEntry", () => $a0f27766f041535f$export$26b162cdb704f0a0);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cpFlj = parcelRequire("cpFlj");
const $a0f27766f041535f$export$26b162cdb704f0a0 = (0, $bMm60.createEntry)((0, $cpFlj.globalSettingsIssuesFieldConfigureEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("cpFlj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRoute", () => $86b316e8a66e645a$export$37908ebd0fc6f94c);

var $exb0h = parcelRequire("exb0h");
const $86b316e8a66e645a$export$37908ebd0fc6f94c = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT),
    path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa'
};

});


parcelRegister("j2fHk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRouteEntry", () => $66e2299d63310623$export$ce20a01bf6cc22e8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $lNap8 = parcelRequire("lNap8");
const $66e2299d63310623$export$ce20a01bf6cc22e8 = (0, $bMm60.createEntry)((0, $lNap8.globalSettingsIssuesFieldConfigureRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("lNap8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRoute", () => $fc75651e69132f61$export$47585e3c198123be);

var $exb0h = parcelRequire("exb0h");
const $fc75651e69132f61$export$47585e3c198123be = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE),
    path: '/secure/admin/ConfigureFieldScreen.jspa'
};

});


parcelRegister("dJWjd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRouteEntry", () => $db4de3141796b5f4$export$4d899a20474ade0);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $57WK8 = parcelRequire("57WK8");
const $db4de3141796b5f4$export$4d899a20474ade0 = (0, $bMm60.createEntry)((0, $57WK8.globalSettingsIssuesFieldCopyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("57WK8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRoute", () => $fbde721881065056$export$ec5bbfc3593b01b7);

var $exb0h = parcelRequire("exb0h");
const $fbde721881065056$export$ec5bbfc3593b01b7 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY),
    path: '/secure/admin/ViewCopyFieldScreen.jspa'
};

});


parcelRegister("jGH4y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRouteEntry", () => $4600ddd5c0321885$export$9170e2ce6999793e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $04teB = parcelRequire("04teB");
const $4600ddd5c0321885$export$9170e2ce6999793e = (0, $bMm60.createEntry)((0, $04teB.globalSettingsIssuesFieldDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("04teB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRoute", () => $5280eaf76f2c5b50$export$9a0bc2a1c24ad312);

var $exb0h = parcelRequire("exb0h");
const $5280eaf76f2c5b50$export$9a0bc2a1c24ad312 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE),
    path: '/secure/admin/ViewDeleteFieldScreen.jspa'
};

});


parcelRegister("7FDXH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldEditRouteEntry", () => $a396720c1e10a492$export$4f6f7197ee5fbd88);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $bKmFY = parcelRequire("bKmFY");
const $a396720c1e10a492$export$4f6f7197ee5fbd88 = (0, $bMm60.createEntry)((0, $bKmFY.globalSettingsIssuesFieldEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("bKmFY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldEditRoute", () => $c64d036b0c8a407f$export$e41329d1f04b5b51);

var $exb0h = parcelRequire("exb0h");
const $c64d036b0c8a407f$export$e41329d1f04b5b51 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT),
    path: '/secure/admin/EditFieldScreen!default.jspa'
};

});


parcelRegister("7nirz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRouteEntry", () => $baf605eef78ab061$export$3a842eb59e795637);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $lcLPH = parcelRequire("lcLPH");
const $baf605eef78ab061$export$3a842eb59e795637 = (0, $bMm60.createEntry)((0, $lcLPH.globalSettingsIssuesFieldSchemesAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("lcLPH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRoute", () => $eabf65fbb6d762d5$export$8b20e975ade5b676);

var $exb0h = parcelRequire("exb0h");
const $eabf65fbb6d762d5$export$8b20e975ade5b676 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD),
    path: '/secure/admin/AddFieldConfigurationScheme!default.jspa'
};

});


parcelRegister("7QX3x", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRouteEntry", () => $7b441c4c00b8e1b6$export$5f5a8b65a56acfea);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $bOj4a = parcelRequire("bOj4a");
const $7b441c4c00b8e1b6$export$5f5a8b65a56acfea = (0, $bMm60.createEntry)((0, $bOj4a.globalSettingsIssuesFieldSchemesConfigureRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("bOj4a", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRoute", () => $2f92ed8a69111e25$export$6401bf37dfa17226);

var $exb0h = parcelRequire("exb0h");
const $2f92ed8a69111e25$export$6401bf37dfa17226 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE),
    path: '/secure/admin/ConfigureFieldScreenScheme.jspa'
};

});


parcelRegister("iZ26w", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRouteEntry", () => $e7da089a676f9401$export$4c126f203951bdce);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $gmdQi = parcelRequire("gmdQi");
const $e7da089a676f9401$export$4c126f203951bdce = (0, $bMm60.createEntry)((0, $gmdQi.globalSettingsIssuesFieldSchemesCopyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("gmdQi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRoute", () => $99a2caaaaa952d5e$export$195423dd1ef4cf0a);

var $exb0h = parcelRequire("exb0h");
const $99a2caaaaa952d5e$export$195423dd1ef4cf0a = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY),
    path: '/secure/admin/ViewCopyFieldScreenScheme.jspa'
};

});


parcelRegister("2W2q2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRouteEntry", () => $c965f64829ac141c$export$a4609f789aeed81f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9zKN5 = parcelRequire("9zKN5");
const $c965f64829ac141c$export$a4609f789aeed81f = (0, $bMm60.createEntry)((0, $9zKN5.globalSettingsIssuesFieldSchemesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9zKN5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRoute", () => $88af1c73aee743bc$export$998546ee0d8d0995);

var $exb0h = parcelRequire("exb0h");
const $88af1c73aee743bc$export$998546ee0d8d0995 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE),
    path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa'
};

});


parcelRegister("l9tXd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRouteEntry", () => $4cd79098d1f1f77d$export$aabed4f53fb4f921);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cuPEu = parcelRequire("cuPEu");
const $4cd79098d1f1f77d$export$aabed4f53fb4f921 = (0, $bMm60.createEntry)((0, $cuPEu.globalSettingsIssuesFieldSchemesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cuPEu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRoute", () => $12e3c4c477db5f4b$export$c7b713e1fe2e026f);

var $exb0h = parcelRequire("exb0h");
const $12e3c4c477db5f4b$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $12e3c4c477db5f4b$export$c7b713e1fe2e026f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT),
    path: `/secure/admin/EditFieldScreenScheme${$12e3c4c477db5f4b$var$defaultSuffix}.jspa`
};

});


parcelRegister("cJJgM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRouteEntry", () => $93f3204ee3f4bde9$export$e38b78ff4a960db6);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $eswIR = parcelRequire("eswIR");
const $93f3204ee3f4bde9$export$e38b78ff4a960db6 = (0, $bMm60.createEntry)((0, $eswIR.globalSettingsIssuesFieldSchemesEditItemRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("eswIR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRoute", () => $8f12105ef2fd77a3$export$4606c3f78e4ec3db);

var $exb0h = parcelRequire("exb0h");
const $8f12105ef2fd77a3$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $8f12105ef2fd77a3$export$4606c3f78e4ec3db = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM),
    path: `/secure/admin/EditFieldScreenSchemeItem${$8f12105ef2fd77a3$var$defaultSuffix}.jspa`
};

});


parcelRegister("eB8ua", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldViewRouteEntry", () => $275a826bbfa9500f$export$25331ec7b1b8ebfb);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9tiBf = parcelRequire("9tiBf");
const $275a826bbfa9500f$export$25331ec7b1b8ebfb = (0, $bMm60.createEntry)((0, $9tiBf.globalSettingsIssuesFieldViewRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9tiBf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldViewRoute", () => $882b99069787b997$export$1a32944e52a128e5);
const $882b99069787b997$export$1a32944e52a128e5 = {
    name: 'global-settings-issues-field-view',
    path: '/secure/admin/ViewFieldsScreen.jspa'
};

});


parcelRegister("dRIVd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRouteEntry", () => $48d47c544ffa3cbf$export$8946e190202a15c7);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $Yz99W = parcelRequire("Yz99W");
const $48d47c544ffa3cbf$export$8946e190202a15c7 = (0, $bMm60.createEntry)((0, $Yz99W.globalSettingsIssuesFieldlayoutsConfigRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("Yz99W", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRoute", () => $dbdd17e264b300b2$export$b469488e0c133a32);

var $exb0h = parcelRequire("exb0h");
const $dbdd17e264b300b2$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $dbdd17e264b300b2$export$b469488e0c133a32 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW),
    path: `/secure/admin/ConfigureFieldLayout${$dbdd17e264b300b2$var$defaultSuffix}.jspa`
};

});


parcelRegister("hPp3X", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRouteEntry", () => $588624d2b9654465$export$c4d25de70db36bde);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $8oiQS = parcelRequire("8oiQS");
const $588624d2b9654465$export$c4d25de70db36bde = (0, $bMm60.createEntry)((0, $8oiQS.globalSettingsIssuesFieldlayoutsCopyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("8oiQS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRoute", () => $752e827ae6428589$export$3a9552d4b0f71408);

var $exb0h = parcelRequire("exb0h");
const $752e827ae6428589$export$3a9552d4b0f71408 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY),
    path: '/secure/admin/CopyFieldLayout!default.jspa'
};

});


parcelRegister("heAU9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRouteEntry", () => $71202cd9083166a6$export$f2dfb8808ab4e2f2);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $bW9k9 = parcelRequire("bW9k9");
const $71202cd9083166a6$export$f2dfb8808ab4e2f2 = (0, $bMm60.createEntry)((0, $bW9k9.globalSettingsIssuesFieldlayoutsDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("bW9k9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRoute", () => $645e25d174ac667c$export$3ef4c145c5aa96b6);
const $645e25d174ac667c$export$3ef4c145c5aa96b6 = {
    name: 'global-settings-issues-fieldlayouts-delete',
    path: '/secure/admin/DeleteFieldLayout!default.jspa'
};

});


parcelRegister("cIx9g", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRouteEntry", () => $512784ebc68024c6$export$10710e2f7971e271);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $aUygK = parcelRequire("aUygK");
const $512784ebc68024c6$export$10710e2f7971e271 = (0, $bMm60.createEntry)((0, $aUygK.globalSettingsIssuesFieldlayoutsEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("aUygK", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRoute", () => $abffbdc568d2c569$export$3a0534b35ee08e33);
const $abffbdc568d2c569$export$3a0534b35ee08e33 = {
    name: 'global-settings-issues-fieldlayouts-edit',
    path: '/secure/admin/EditFieldLayout!default.jspa'
};

});


parcelRegister("7Q4s7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry", () => $6621c89002781150$export$5b791b0a90dab069);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $eTgrj = parcelRequire("eTgrj");
const $6621c89002781150$export$5b791b0a90dab069 = (0, $bMm60.createEntry)((0, $eTgrj.globalSettingsIssuesFieldlayoutsSchemesConfigRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("eTgrj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRoute", () => $bbbdaba2705b4b53$export$97921be5feed3adf);

var $exb0h = parcelRequire("exb0h");
const $bbbdaba2705b4b53$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $bbbdaba2705b4b53$export$97921be5feed3adf = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE),
    path: `/secure/admin/ConfigureFieldLayoutScheme${$bbbdaba2705b4b53$var$defaultSuffix}.jspa`
};

});


parcelRegister("10wJP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry", () => $4ec9a329950c4ed3$export$e5d2e7b8b7eb3bf5);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9n7ts = parcelRequire("9n7ts");
const $4ec9a329950c4ed3$export$e5d2e7b8b7eb3bf5 = (0, $bMm60.createEntry)((0, $9n7ts.globalSettingsIssuesFieldlayoutsSchemesCopyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9n7ts", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRoute", () => $42f1df748f30ec86$export$71563f57601b0e2);

var $exb0h = parcelRequire("exb0h");
const $42f1df748f30ec86$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $42f1df748f30ec86$export$71563f57601b0e2 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY),
    path: `/secure/admin/CopyFieldLayoutScheme${$42f1df748f30ec86$var$defaultSuffix}.jspa`
};

});


parcelRegister("baY1v", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry", () => $4790f59ab1d95c7b$export$c1e57f90dca7eb4c);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $i5kVN = parcelRequire("i5kVN");
const $4790f59ab1d95c7b$export$c1e57f90dca7eb4c = (0, $bMm60.createEntry)((0, $i5kVN.globalSettingsIssuesFieldlayoutsSchemesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("i5kVN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRoute", () => $5773c9ae0d815523$export$e1a49cd1071690c4);

var $exb0h = parcelRequire("exb0h");
const $5773c9ae0d815523$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $5773c9ae0d815523$export$e1a49cd1071690c4 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE),
    path: `/secure/admin/DeleteFieldLayoutScheme${$5773c9ae0d815523$var$defaultSuffix}.jspa`
};

});


parcelRegister("afFye", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry", () => $e720cbe2035babf2$export$99138c4ced2f05f7);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cpHQZ = parcelRequire("cpHQZ");
const $e720cbe2035babf2$export$99138c4ced2f05f7 = (0, $bMm60.createEntry)((0, $cpHQZ.globalSettingsIssuesFieldlayoutsSchemesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cpHQZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRoute", () => $f237dec5c129d3c4$export$a14fc516b4846e63);

var $exb0h = parcelRequire("exb0h");
const $f237dec5c129d3c4$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $f237dec5c129d3c4$export$a14fc516b4846e63 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT),
    path: `/secure/admin/EditFieldLayoutScheme${$f237dec5c129d3c4$var$defaultSuffix}.jspa`
};

});


parcelRegister("6I50K", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry", () => $9cafa87f610e5e90$export$a860d5fef4b2c724);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $avMas = parcelRequire("avMas");
const $9cafa87f610e5e90$export$a860d5fef4b2c724 = (0, $bMm60.createEntry)((0, $avMas.globalSettingsIssuesFieldlayoutsSchemesEntityRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("avMas", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRoute", () => $31833d7a64bbd2af$export$54dfcbcea4cc773c);

var $exb0h = parcelRequire("exb0h");
const $31833d7a64bbd2af$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $31833d7a64bbd2af$export$54dfcbcea4cc773c = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY),
    path: `/secure/admin/ViewEditFieldLayoutSchemeEntity${$31833d7a64bbd2af$var$defaultSuffix}.jspa`
};

});


parcelRegister("eSPGm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldviewRouteEntry", () => $d4d5e83b66dfb2ba$export$1258f6b3b3168b6a);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9v0C0 = parcelRequire("9v0C0");
const $d4d5e83b66dfb2ba$export$1258f6b3b3168b6a = (0, $bMm60.createEntry)((0, $9v0C0.globalSettingsIssuesFieldviewRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9v0C0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldviewRoute", () => $8af9ebd691c4b066$export$4e15d6f42067a40d);

var $exb0h = parcelRequire("exb0h");
const $8af9ebd691c4b066$export$4e15d6f42067a40d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE),
    path: '/secure/admin/ViewIssueFields.jspa'
};

});


parcelRegister("6cuLl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRouteEntry", () => $84872db2441254ec$export$611de8afc4baaba5);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $dQHbN = parcelRequire("dQHbN");
const $84872db2441254ec$export$611de8afc4baaba5 = (0, $bMm60.createEntry)((0, $dQHbN.globalSettingsIssuesGeneralTranslationsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("dQHbN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRoute", () => $d1b572c3edd7fbc6$export$82d4e60692b6b82);
const $d1b572c3edd7fbc6$export$82d4e60692b6b82 = {
    name: 'global-settings-issues-general-translations',
    path: '/secure/admin/ViewTranslations!default.jspa'
};

});


parcelRegister("6MVKx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRouteEntry", () => $ae96f3366ff30bdc$export$a96d582e6ce3db7f);
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRouteEntry", () => $ae96f3366ff30bdc$export$a7de28edcb387644);
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRouteEntry", () => $ae96f3366ff30bdc$export$bcae6091ca248a97);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9SDl1 = parcelRequire("9SDl1");
const $ae96f3366ff30bdc$export$a96d582e6ce3db7f = (0, $bMm60.createEntry)((0, $9SDl1.globalSettingsIssuesLinkTypesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});
const $ae96f3366ff30bdc$export$a7de28edcb387644 = (0, $bMm60.createEntry)((0, $9SDl1.globalSettingsIssuesLinkTypesActivateRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});
const $ae96f3366ff30bdc$export$bcae6091ca248a97 = (0, $bMm60.createEntry)((0, $9SDl1.globalSettingsIssuesLinkTypesDeactivateRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("9SDl1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRoute", () => $15ee37731833be0e$export$ee4b5d966d77c912);
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRoute", () => $15ee37731833be0e$export$3669b743a852443d);
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRoute", () => $15ee37731833be0e$export$3b168b9635205cc2);

var $exb0h = parcelRequire("exb0h");
const $15ee37731833be0e$export$ee4b5d966d77c912 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES),
    path: '/secure/admin/ViewLinkTypes!default.jspa'
};
const $15ee37731833be0e$export$3669b743a852443d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE),
    path: '/secure/admin/IssueLinkingActivate.jspa'
};
const $15ee37731833be0e$export$3b168b9635205cc2 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE),
    path: '/secure/admin/IssueLinkingDeActivate.jspa'
};

});


parcelRegister("adgc5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRouteEntry", () => $bb686a0e6be8508d$export$5fed41168399db0a);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $hTN9P = parcelRequire("hTN9P");
const $bb686a0e6be8508d$export$5fed41168399db0a = (0, $bMm60.createEntry)((0, $hTN9P.globalSettingsIssuesLinktypesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("hTN9P", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRoute", () => $7f5739e83d3e7d65$export$da95e063618de37b);

var $exb0h = parcelRequire("exb0h");
const $7f5739e83d3e7d65$export$da95e063618de37b = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE),
    path: '/secure/admin/DeleteLinkType!default.jspa'
};

});


parcelRegister("1v7mq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRouteEntry", () => $d6154a492a716831$export$58d36c7fbe66c9af);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $d7z2k = parcelRequire("d7z2k");
const $d6154a492a716831$export$58d36c7fbe66c9af = (0, $bMm60.createEntry)((0, $d7z2k.globalSettingsIssuesLinktypesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("d7z2k", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRoute", () => $5388163023fd69c8$export$670f7372491286fd);

var $exb0h = parcelRequire("exb0h");
const $5388163023fd69c8$export$670f7372491286fd = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT),
    path: '/secure/admin/EditLinkType!default.jspa'
};

});


parcelRegister("faeuP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRouteEntry", () => $49ef00e4a52f4ef5$export$d52d95e2669ccb14);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5FJC1 = parcelRequire("5FJC1");
const $49ef00e4a52f4ef5$export$d52d95e2669ccb14 = (0, $bMm60.createEntry)((0, $5FJC1.globalSettingsIssuesNotificationAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5FJC1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRoute", () => $4f1c3a370360ae56$export$493378d37b4f830);

var $exb0h = parcelRequire("exb0h");
const $4f1c3a370360ae56$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $4f1c3a370360ae56$export$493378d37b4f830 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD),
    path: `/secure/admin/AddNotification${$4f1c3a370360ae56$var$defaultSuffix}.jspa`
};

});


parcelRegister("5WBnz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRouteEntry", () => $a3c16aed7ba122e2$export$e3ff68e9ac0a92e2);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $hcYqa = parcelRequire("hcYqa");
const $a3c16aed7ba122e2$export$e3ff68e9ac0a92e2 = (0, $bMm60.createEntry)((0, $hcYqa.globalSettingsIssuesNotificationDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("hcYqa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRoute", () => $94de50d6d8f2df5d$export$7497920ead69d08f);

var $exb0h = parcelRequire("exb0h");
const $94de50d6d8f2df5d$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $94de50d6d8f2df5d$export$7497920ead69d08f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE),
    path: `/secure/admin/DeleteNotification${$94de50d6d8f2df5d$var$defaultSuffix}.jspa`
};

});


parcelRegister("furTl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRouteEntry", () => $1b0b73ad733149f6$export$256c34b63a2221ee);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $k8O14 = parcelRequire("k8O14");
const $1b0b73ad733149f6$export$256c34b63a2221ee = (0, $bMm60.createEntry)((0, $k8O14.globalSettingsIssuesNotificationEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("k8O14", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRoute", () => $d6e15a60e35f0caf$export$715522cf2d547eaf);

var $exb0h = parcelRequire("exb0h");
const $d6e15a60e35f0caf$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $d6e15a60e35f0caf$export$715522cf2d547eaf = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT),
    path: `/secure/admin/EditNotifications${$d6e15a60e35f0caf$var$defaultSuffix}.jspa`
};

});


parcelRegister("9BiW1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRouteEntry", () => $44624e67ae9ba759$export$f1f02571fc623886);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $87kfv = parcelRequire("87kfv");
const $44624e67ae9ba759$export$f1f02571fc623886 = (0, $bMm60.createEntry)((0, $87kfv.globalSettingsIssuesNotificationSchemeAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("87kfv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRoute", () => $52e6a9de92486b06$export$629ba048f31d2c0f);

var $exb0h = parcelRequire("exb0h");
const $52e6a9de92486b06$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $52e6a9de92486b06$export$629ba048f31d2c0f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD),
    path: `/secure/admin/AddNotificationScheme${$52e6a9de92486b06$var$defaultSuffix}.jspa`
};

});


parcelRegister("97mkw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRouteEntry", () => $e6931e1f6b097d23$export$40145c5de888865f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $6jGzL = parcelRequire("6jGzL");
const $e6931e1f6b097d23$export$40145c5de888865f = (0, $bMm60.createEntry)((0, $6jGzL.globalSettingsIssuesNotificationSchemeDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("6jGzL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRoute", () => $573c89c28093bad9$export$64a190266a30ffd6);

var $exb0h = parcelRequire("exb0h");
const $573c89c28093bad9$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $573c89c28093bad9$export$64a190266a30ffd6 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE),
    path: `/secure/admin/DeleteNotificationScheme${$573c89c28093bad9$var$defaultSuffix}.jspa`
};

});


parcelRegister("v9XgX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRouteEntry", () => $58af7399fc76cc8d$export$856d15be55b1a791);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $vjyyJ = parcelRequire("vjyyJ");
const $58af7399fc76cc8d$export$856d15be55b1a791 = (0, $bMm60.createEntry)((0, $vjyyJ.globalSettingsIssuesNotificationSchemeEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("vjyyJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRoute", () => $2fbcd091f65196ec$export$a7f8c6170a6db933);

var $exb0h = parcelRequire("exb0h");
const $2fbcd091f65196ec$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $2fbcd091f65196ec$export$a7f8c6170a6db933 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT),
    path: `/secure/admin/EditNotificationScheme${$2fbcd091f65196ec$var$defaultSuffix}.jspa`
};

});


parcelRegister("lspYz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRouteEntry", () => $291b040c75d86a3e$export$45dd8c9548b0054e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $jv1Wg = parcelRequire("jv1Wg");
const $291b040c75d86a3e$export$45dd8c9548b0054e = (0, $bMm60.createEntry)((0, $jv1Wg.globalSettingsIssuesNotificationViewRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("jv1Wg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRoute", () => $dacf79d3080eaf6d$export$bc2109e7325d1a16);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $dacf79d3080eaf6d$var$defaultSuffix = '([!%]?[\\w]*)';
const $dacf79d3080eaf6d$export$bc2109e7325d1a16 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW),
    path: `/secure/admin/ViewNotificationSchemes${$dacf79d3080eaf6d$var$defaultSuffix}.jspa`
};

});


parcelRegister("LvsCP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRouteEntry", () => $c9da26834f669e96$export$f49580b73c3ba83);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $co24e = parcelRequire("co24e");

var $4qraf = parcelRequire("4qraf");
const $c9da26834f669e96$export$f49580b73c3ba83 = (0, $bMm60.createEntry)((0, $co24e.globalSettingsIssuesPermissionsEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    component: (0, $4qraf.LegacyEditPermissionsPage),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("co24e", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRoute", () => $4dc4fc338018deae$export$c7d87b3baf9e9a67);
const $4dc4fc338018deae$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $4dc4fc338018deae$export$c7d87b3baf9e9a67 = {
    name: 'global-settings-issues-permissions-edit',
    path: `/secure/admin/EditPermissions${$4dc4fc338018deae$var$defaultSuffix}.jspa`
};

});

parcelRegister("4qraf", function(module, exports) {

$parcel$export(module.exports, "LegacyEditPermissionsPage", () => $d55980ccbe4880c1$export$fb0bf0e5f8e439b9);

var $eUqFw = parcelRequire("eUqFw");

var $bCmyq = parcelRequire("bCmyq");
const $d55980ccbe4880c1$export$fb0bf0e5f8e439b9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCmyq.LegacyPage), props));
var $d55980ccbe4880c1$export$2e2bcd8739ae039 = $d55980ccbe4880c1$export$fb0bf0e5f8e439b9;

});


parcelRegister("gzOIA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRouteEntry", () => $578d0959f78ac119$export$d475751e96368b33);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $bZTlC = parcelRequire("bZTlC");
const $578d0959f78ac119$export$d475751e96368b33 = (0, $bMm60.createEntry)((0, $bZTlC.globalSettingsIssuesPermissionsSchemesAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("bZTlC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRoute", () => $c60013f286239ba9$export$f9c900df1268958);

var $exb0h = parcelRequire("exb0h");
const $c60013f286239ba9$export$f9c900df1268958 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD),
    path: '/secure/admin/AddPermissionScheme!default.jspa'
};

});


parcelRegister("3Fjff", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRouteEntry", () => $99d6013fce9a82ad$export$af3ca420f50b74f8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $a8mJL = parcelRequire("a8mJL");
const $99d6013fce9a82ad$export$af3ca420f50b74f8 = (0, $bMm60.createEntry)((0, $a8mJL.globalSettingsIssuesPermissionsSchemesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("a8mJL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRoute", () => $69c809ee529b3b36$export$9cbf97d551da6de6);

var $exb0h = parcelRequire("exb0h");
const $69c809ee529b3b36$export$9cbf97d551da6de6 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE),
    path: '/secure/admin/DeletePermissionScheme!default.jspa'
};

});


parcelRegister("jkJhv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRouteEntry", () => $a9c985951c832934$export$a1aace45fc58c0c0);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $11BeP = parcelRequire("11BeP");
const $a9c985951c832934$export$a1aace45fc58c0c0 = (0, $bMm60.createEntry)((0, $11BeP.globalSettingsIssuesPermissionsSchemesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("11BeP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRoute", () => $45cbe042760c33d4$export$baed669ce740350d);

var $exb0h = parcelRequire("exb0h");
const $45cbe042760c33d4$export$baed669ce740350d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT),
    path: '/secure/admin/EditPermissionScheme!default.jspa'
};

});


parcelRegister("8Zyn4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRouteEntry", () => $b2eda14a96226617$export$92306855354418dd);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $1HLt2 = parcelRequire("1HLt2");
const $b2eda14a96226617$export$92306855354418dd = (0, $bMm60.createEntry)((0, $1HLt2.globalSettingsIssuesPermissionsSchemesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("1HLt2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRoute", () => $1eda208aa13bd015$export$152abbb6f806c87);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $1eda208aa13bd015$var$defaultSuffix = '([!%]?[\\w]*)';
const $1eda208aa13bd015$export$152abbb6f806c87 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES),
    path: `/secure/admin/ViewPermissionSchemes${$1eda208aa13bd015$var$defaultSuffix}.jspa`
};

});


parcelRegister("je2Fi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRouteEntry", () => $1237b1636acdd56c$export$79f7bd4999f40475);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $1nJo8 = parcelRequire("1nJo8");
const $1237b1636acdd56c$export$79f7bd4999f40475 = (0, $bMm60.createEntry)((0, $1nJo8.globalSettingsIssuesPermissionsSchemesProjectRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("1nJo8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRoute", () => $ffc62f133103dd6f$export$c29ffdea8ba3226d);

var $exb0h = parcelRequire("exb0h");
const $ffc62f133103dd6f$export$c29ffdea8ba3226d = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE),
    path: '/secure/project/SelectProjectPermissionScheme!default.jspa'
};

});


parcelRegister("jMPjG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRouteEntry", () => $31a5f82e356c3ff7$export$88a39202914c5905);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cuTBE = parcelRequire("cuTBE");
const $31a5f82e356c3ff7$export$88a39202914c5905 = (0, $bMm60.createEntry)((0, $cuTBE.globalSettingsIssuesPrioritiesDefaultRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cuTBE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRoute", () => $6a0d67c940c016f2$export$83a29d1cc0270f5a);
const $6a0d67c940c016f2$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $6a0d67c940c016f2$export$83a29d1cc0270f5a = {
    name: 'global-settings-issues-priorities-default',
    path: `/secure/admin/MakeDefaultPriority${$6a0d67c940c016f2$var$defaultSuffix}.jspa`
};

});


parcelRegister("4s7Hu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRouteEntry", () => $957d43f6d2496c50$export$e13fff0f49e2648b);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5njN4 = parcelRequire("5njN4");
const $957d43f6d2496c50$export$e13fff0f49e2648b = (0, $bMm60.createEntry)((0, $5njN4.globalSettingsIssuesPrioritiesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5njN4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRoute", () => $68aa5c583c707e1b$export$1092268c69e42aa4);

var $exb0h = parcelRequire("exb0h");
const $68aa5c583c707e1b$export$1092268c69e42aa4 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE),
    path: '/secure/admin/DeletePriority!default.jspa'
};

});


parcelRegister("iE4io", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRouteEntry", () => $80dd3716c04ff435$export$cd447ff81bd82138);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $eiZMZ = parcelRequire("eiZMZ");
const $80dd3716c04ff435$export$cd447ff81bd82138 = (0, $bMm60.createEntry)((0, $eiZMZ.globalSettingsIssuesPrioritiesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("eiZMZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRoute", () => $ef4243004213ac3a$export$c0f633caf37ba40d);

var $exb0h = parcelRequire("exb0h");
const $ef4243004213ac3a$export$c0f633caf37ba40d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT),
    path: '/secure/admin/EditPriority!default.jspa'
};

});


parcelRegister("hwhdw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $f2eb783d515c1e03$export$63a56a096ab0d260);

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $jBc70 = parcelRequire("jBc70");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $df2ju = parcelRequire("df2ju");
const $f2eb783d515c1e03$export$63a56a096ab0d260 = (0, $bMm60.createEntry)((0, $df2ju.globalSettingsIssuesPrioritiesRoute), {
    layout: (0, $jBc70.priorityMappingGlobalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("jBc70", function(module, exports) {

$parcel$export(module.exports, "priorityMappingGlobalSettingsLayout", () => $059e6d5ccd9c842a$export$233c4c28b2b79294);

var $7rh0R = parcelRequire("7rh0R");

var $efFTI = parcelRequire("efFTI");

var $isbb2 = parcelRequire("isbb2");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $059e6d5ccd9c842a$var$LegacyAsyncModals = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("4dYKN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-priorities-mapping-global-settings-layout/src/ui/legacy-async-modals/index.tsx"
});
const $059e6d5ccd9c842a$export$4219cc7dcaa1716c = [
    $059e6d5ccd9c842a$var$LegacyAsyncModals
];
const $059e6d5ccd9c842a$export$233c4c28b2b79294 = (0, $isbb2.composeLayouts)((0, $efFTI.globalSettingsLayout), {
    globalComponents: $059e6d5ccd9c842a$export$4219cc7dcaa1716c
});

});
parcelRegister("4dYKN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hTXBi")
]).then(()=>parcelRequire('iboSx'));

});


parcelRegister("df2ju", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $94a02e1f8441b50b$export$518516cdf6b7cd83);

var $exb0h = parcelRequire("exb0h");
const $94a02e1f8441b50b$export$518516cdf6b7cd83 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
    path: '/secure/admin/ViewPriorities.jspa'
};

});


parcelRegister("eMbz6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRouteEntry", () => $4fa31076184428f4$export$3dd9e223f9189ad8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $i97iv = parcelRequire("i97iv");
const $4fa31076184428f4$export$3dd9e223f9189ad8 = (0, $bMm60.createEntry)((0, $i97iv.globalSettingsIssuesPrioritiesTranslationsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("i97iv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRoute", () => $81c97b4698ff8ab2$export$ac50c32d38c2abe0);

var $exb0h = parcelRequire("exb0h");
const $81c97b4698ff8ab2$export$ac50c32d38c2abe0 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE),
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=priority'
    ]
};

});


parcelRegister("91zkM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRouteEntry", () => $be953f8f421014dd$export$48a6536027e4aff8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $hpgGB = parcelRequire("hpgGB");
const $be953f8f421014dd$export$48a6536027e4aff8 = (0, $bMm60.createEntry)((0, $hpgGB.globalSettingsIssuesResolutionsDefaultRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("hpgGB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRoute", () => $041c4ff18e1807e5$export$3069447d64064849);

var $exb0h = parcelRequire("exb0h");
const $041c4ff18e1807e5$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $041c4ff18e1807e5$export$3069447d64064849 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT),
    path: `/secure/admin/MakeDefaultResolution${$041c4ff18e1807e5$var$defaultSuffix}.jspa`
};

});


parcelRegister("gVBaq", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRouteEntry", () => $af4ca9de4a917f18$export$e4f8ecf8d9862ad4);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $ekgSO = parcelRequire("ekgSO");
const $af4ca9de4a917f18$export$e4f8ecf8d9862ad4 = (0, $bMm60.createEntry)((0, $ekgSO.globalSettingsIssuesResolutionsDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("ekgSO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRoute", () => $a4c4e3a27f5233fe$export$cef4d5289f287690);

var $exb0h = parcelRequire("exb0h");
const $a4c4e3a27f5233fe$export$cef4d5289f287690 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE),
    path: '/secure/admin/DeleteResolution!default.jspa'
};

});


parcelRegister("ciIlo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRouteEntry", () => $f9c74b9514c8d6f9$export$abc7d0979f67b53f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $ZEFHY = parcelRequire("ZEFHY");
const $f9c74b9514c8d6f9$export$abc7d0979f67b53f = (0, $bMm60.createEntry)((0, $ZEFHY.globalSettingsIssuesResolutionsEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("ZEFHY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRoute", () => $900253b232686f25$export$92b7f2cef28676);

var $exb0h = parcelRequire("exb0h");
const $900253b232686f25$export$92b7f2cef28676 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT),
    path: '/secure/admin/EditResolution!default.jspa'
};

});


parcelRegister("1blIf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsRouteEntry", () => $d57998550e713e06$export$2fc29b05ae7ea40);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $c8smC = parcelRequire("c8smC");
const $d57998550e713e06$export$2fc29b05ae7ea40 = (0, $bMm60.createEntry)((0, $c8smC.globalSettingsIssuesResolutionsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("c8smC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsRoute", () => $4379bc07332e2fdd$export$7ad0e4697ed2a3ec);

var $exb0h = parcelRequire("exb0h");
const $4379bc07332e2fdd$export$7ad0e4697ed2a3ec = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS),
    path: '/secure/admin/ViewResolutions.jspa'
};

});


parcelRegister("2SdI5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRouteEntry", () => $e3ee251f2af8ecec$export$93bb5b2fc4a9a739);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9NWT7 = parcelRequire("9NWT7");
const $e3ee251f2af8ecec$export$93bb5b2fc4a9a739 = (0, $bMm60.createEntry)((0, $9NWT7.globalSettingsIssuesResolutionsTranslationsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9NWT7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRoute", () => $142f876b9354eeeb$export$c84118fcbe41734c);

var $exb0h = parcelRequire("exb0h");
const $142f876b9354eeeb$export$c84118fcbe41734c = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE),
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=resolution'
    ]
};

});


parcelRegister("iBYQH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRouteEntry", () => $cc5e42c2a8aa6877$export$fe5197eff63a479c);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $aey03 = parcelRequire("aey03");
const $cc5e42c2a8aa6877$export$fe5197eff63a479c = (0, $bMm60.createEntry)((0, $aey03.globalSettingsIssuesSecurityEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("aey03", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRoute", () => $68bb4ae8d68b2f5a$export$5f1d8fd298c25945);

var $exb0h = parcelRequire("exb0h");
const $68bb4ae8d68b2f5a$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $68bb4ae8d68b2f5a$export$5f1d8fd298c25945 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT),
    path: `/secure/admin/EditIssueSecurities${$68bb4ae8d68b2f5a$var$defaultSuffix}.jspa`
};

});


parcelRegister("iubtQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRouteEntry", () => $218deceed1fc0244$export$32a0f47c80094c8a);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $f25A1 = parcelRequire("f25A1");
const $218deceed1fc0244$export$32a0f47c80094c8a = (0, $bMm60.createEntry)((0, $f25A1.globalSettingsIssuesSecurityLevelAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("f25A1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRoute", () => $cbc9a3cfb45366aa$export$27fd05d5eac2b88);

var $exb0h = parcelRequire("exb0h");
const $cbc9a3cfb45366aa$export$27fd05d5eac2b88 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD),
    path: '/secure/admin/AddIssueSecurity!default.jspa'
};

});


parcelRegister("acwwS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRouteEntry", () => $447587dac20ae91f$export$566f3107971a2203);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kCIt8 = parcelRequire("kCIt8");
const $447587dac20ae91f$export$566f3107971a2203 = (0, $bMm60.createEntry)((0, $kCIt8.globalSettingsIssuesSecurityLevelDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("kCIt8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRoute", () => $3ce3fcc951499c5c$export$9d60d6418ce002aa);

var $exb0h = parcelRequire("exb0h");
const $3ce3fcc951499c5c$export$9d60d6418ce002aa = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE),
    path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa'
};

});


parcelRegister("aaRBu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRouteEntry", () => $9ac9421e047fe41f$export$d5da255e04fa662f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kA1CP = parcelRequire("kA1CP");
const $9ac9421e047fe41f$export$d5da255e04fa662f = (0, $bMm60.createEntry)((0, $kA1CP.globalSettingsIssuesSecurityLevelEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("kA1CP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRoute", () => $49067f59683abae7$export$882588e58b7b7aa4);

var $exb0h = parcelRequire("exb0h");
const $49067f59683abae7$export$882588e58b7b7aa4 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT),
    path: '/secure/admin/EditSecurityLevel!default.jspa'
};

});


parcelRegister("aA2zo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRouteEntry", () => $0040580c49dd28b4$export$a0157f60ff5930b1);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $gM9y8 = parcelRequire("gM9y8");
const $0040580c49dd28b4$export$a0157f60ff5930b1 = (0, $bMm60.createEntry)((0, $gM9y8.globalSettingsIssuesSecuritySchemesAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("gM9y8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRoute", () => $ab0b55fedc245d08$export$1f38848b5541a84a);

var $exb0h = parcelRequire("exb0h");
const $ab0b55fedc245d08$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $ab0b55fedc245d08$export$1f38848b5541a84a = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD),
    path: `/secure/admin/AddIssueSecurityScheme${$ab0b55fedc245d08$var$defaultSuffix}.jspa`
};

});


parcelRegister("21PQj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRouteEntry", () => $ff4a5148126ea60a$export$9a262260e12c79c8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $eawVW = parcelRequire("eawVW");
const $ff4a5148126ea60a$export$9a262260e12c79c8 = (0, $bMm60.createEntry)((0, $eawVW.globalSettingsIssuesSecuritySchemesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("eawVW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRoute", () => $67411b3afa463c65$export$c653091a64df0f25);

var $exb0h = parcelRequire("exb0h");
const $67411b3afa463c65$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $67411b3afa463c65$export$c653091a64df0f25 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE),
    path: `/secure/admin/DeleteIssueSecurityScheme${$67411b3afa463c65$var$defaultSuffix}.jspa`
};

});


parcelRegister("jCLVV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRouteEntry", () => $cb2403e921aeb623$export$fd9e3acdd660a584);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $8SsUH = parcelRequire("8SsUH");
const $cb2403e921aeb623$export$fd9e3acdd660a584 = (0, $bMm60.createEntry)((0, $8SsUH.globalSettingsIssuesSecuritySchemesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("8SsUH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRoute", () => $2bbb9a51c03055bf$export$bea68ab25bef976c);

var $exb0h = parcelRequire("exb0h");
const $2bbb9a51c03055bf$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $2bbb9a51c03055bf$export$bea68ab25bef976c = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT),
    path: `/secure/admin/EditIssueSecurityScheme${$2bbb9a51c03055bf$var$defaultSuffix}.jspa`
};

});


parcelRegister("djSBu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRouteEntry", () => $4590584ae471266f$export$97cc0de5c7b8411a);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kazd4 = parcelRequire("kazd4");
const $4590584ae471266f$export$97cc0de5c7b8411a = (0, $bMm60.createEntry)((0, $kazd4.globalSettingsIssuesSecuritySchemesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("kazd4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRoute", () => $5432975438e6ab1d$export$35f866ec59eb6111);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $5432975438e6ab1d$var$defaultSuffix = '([!%]?[\\w]*)';
const $5432975438e6ab1d$export$35f866ec59eb6111 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES),
    path: `/secure/admin/ViewIssueSecuritySchemes${$5432975438e6ab1d$var$defaultSuffix}.jspa`
};

});


parcelRegister("7Wy95", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesRouteEntry", () => $22f2e8cb8c23516a$export$f736a667e7868236);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $8dA7Z = parcelRequire("8dA7Z");
const $22f2e8cb8c23516a$export$f736a667e7868236 = (0, $bMm60.createEntry)((0, $8dA7Z.globalSettingsIssuesStatusesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("8dA7Z", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesRoute", () => $a0705d4b3427d6cd$export$4f249f1de6014aa8);

var $exb0h = parcelRequire("exb0h");
const $a0705d4b3427d6cd$export$4f249f1de6014aa8 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES),
    path: '/secure/admin/ViewStatuses.jspa'
};

});


parcelRegister("dx9b1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRouteEntry", () => $220a19b2e29949bb$export$6ae705ef4b0a0174);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kwR1q = parcelRequire("kwR1q");
const $220a19b2e29949bb$export$6ae705ef4b0a0174 = (0, $bMm60.createEntry)((0, $kwR1q.globalSettingsIssuesStatusesTranslationsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("kwR1q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRoute", () => $60beaef89de881ab$export$1766642f43dd1413);

var $exb0h = parcelRequire("exb0h");
const $60beaef89de881ab$export$1766642f43dd1413 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE),
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=status'
    ]
};

});


parcelRegister("lkbNT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRouteEntry", () => $2a03ae8a751a49f8$export$62334310a9f11802);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $frytG = parcelRequire("frytG");
const $2a03ae8a751a49f8$export$62334310a9f11802 = (0, $bMm60.createEntry)((0, $frytG.globalSettingsIssuesSubtasksDisableRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("frytG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRoute", () => $909e7eb87b75f84a$export$d2a6ab37bbab7a2d);

var $exb0h = parcelRequire("exb0h");
const $909e7eb87b75f84a$export$d2a6ab37bbab7a2d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE),
    path: '/secure/admin/subtasks/DisableSubTasks!default.jspa'
};

});


parcelRegister("eU1h2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRouteEntry", () => $6aebf8d538589536$export$ffc845bbb3fd5a36);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kmC25 = parcelRequire("kmC25");
const $6aebf8d538589536$export$ffc845bbb3fd5a36 = (0, $bMm60.createEntry)((0, $kmC25.globalSettingsIssuesSubtasksEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("kmC25", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRoute", () => $e6efc3fea37963ab$export$6ab3581cc7d5f524);

var $exb0h = parcelRequire("exb0h");
const $e6efc3fea37963ab$export$6ab3581cc7d5f524 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT),
    path: '/secure/admin/subtasks/EditSubTaskIssueTypes!default.jspa'
};

});


parcelRegister("6FExv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRouteEntry", () => $1feabe23996c1d88$export$e03cf52d50503939);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5mlmZ = parcelRequire("5mlmZ");
const $1feabe23996c1d88$export$e03cf52d50503939 = (0, $bMm60.createEntry)((0, $5mlmZ.globalSettingsIssuesSubtasksTranlationsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5mlmZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRoute", () => $95272f1ef68b0098$export$5ebaadfa47e727e6);

var $exb0h = parcelRequire("exb0h");
const $95272f1ef68b0098$export$5ebaadfa47e727e6 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE),
    path: '/secure/admin/subtasks/ViewTranslations!default.jspa'
};

});


parcelRegister("6v0cp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRouteEntry", () => $f533425f01be8800$export$5d0300325c3e456c);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9zrns = parcelRequire("9zrns");
const $f533425f01be8800$export$5d0300325c3e456c = (0, $bMm60.createEntry)((0, $9zrns.globalSettingsIssuesTypesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9zrns", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRoute", () => $961dc8641b0f9f11$export$53c2f4353355a41b);

var $exb0h = parcelRequire("exb0h");
const $961dc8641b0f9f11$export$53c2f4353355a41b = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE),
    path: '/secure/admin/DeleteIssueType!default.jspa'
};

});


parcelRegister("1QVRV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesEditRouteEntry", () => $494109b0968063a3$export$7e3e6487b18f13dd);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $b1HKj = parcelRequire("b1HKj");
const $494109b0968063a3$export$7e3e6487b18f13dd = (0, $bMm60.createEntry)((0, $b1HKj.globalSettingsIssuesTypesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("b1HKj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesEditRoute", () => $0d1d8ffcd9760992$export$26b7c50d91022a7);

var $exb0h = parcelRequire("exb0h");
const $0d1d8ffcd9760992$export$26b7c50d91022a7 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT),
    path: '/secure/admin/EditIssueType!default.jspa'
};

});


parcelRegister("21OTx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRouteEntry", () => $34e1473951317d3d$export$5d1defdba7aabb03);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $j2rnO = parcelRequire("j2rnO");
const $34e1473951317d3d$export$5d1defdba7aabb03 = (0, $bMm60.createEntry)((0, $j2rnO.globalSettingsIssuesTypesMigrateRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("j2rnO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRoute", () => $2aec55587884f1d0$export$6f6923c45a7c3d7d);
const $2aec55587884f1d0$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $2aec55587884f1d0$export$6f6923c45a7c3d7d = {
    name: 'global-settings-issues-types-migrate',
    path: `/secure/admin/MigrateIssueTypes${$2aec55587884f1d0$var$defaultSuffix}.jspa`
};

});


parcelRegister("7e1il", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry", () => $2e93a769d0ab9613$export$7c04fddca02bf5e5);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $k7rE0 = parcelRequire("k7rE0");
const $2e93a769d0ab9613$export$7c04fddca02bf5e5 = (0, $bMm60.createEntry)((0, $k7rE0.globalSettingsIssuesTypesSchemesAssociateDefaultRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("k7rE0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRoute", () => $15722e9485a60157$export$ce555a4492eeb41);

var $exb0h = parcelRequire("exb0h");
const $15722e9485a60157$export$ce555a4492eeb41 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE),
    path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa'
};

});


parcelRegister("7JniE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRouteEntry", () => $3e30614102a16356$export$a4322d0977a716ec);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $61zcw = parcelRequire("61zcw");
const $3e30614102a16356$export$a4322d0977a716ec = (0, $bMm60.createEntry)((0, $61zcw.globalSettingsIssuesTypesSchemesAssociateRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("61zcw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRoute", () => $9e39ddf605cc1d01$export$695947f4bf787b08);
const $9e39ddf605cc1d01$export$695947f4bf787b08 = {
    name: 'global-settings-issues-types-schemes-associate',
    path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa'
};

});


parcelRegister("fKLft", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry", () => $cfad87a308f1c3a7$export$2486d5cbf90be36f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cZU99 = parcelRequire("cZU99");
const $cfad87a308f1c3a7$export$2486d5cbf90be36f = (0, $bMm60.createEntry)((0, $cZU99.globalSettingsIssuesTypesSchemesOptionDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cZU99", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRoute", () => $de5f34ee809a2d50$export$c6dca032125109f7);

var $exb0h = parcelRequire("exb0h");
const $de5f34ee809a2d50$export$c6dca032125109f7 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE),
    path: '/secure/admin/DeleteOptionScheme!default.jspa'
};

});


parcelRegister("7GAkN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRouteEntry", () => $9ad6755b7288ff73$export$c604bf31fc1ec79f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $3O8Aj = parcelRequire("3O8Aj");
const $9ad6755b7288ff73$export$c604bf31fc1ec79f = (0, $bMm60.createEntry)((0, $3O8Aj.globalSettingsIssuesTypesSchemesOptionRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("3O8Aj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRoute", () => $6c5d82fe5f41d40b$export$e77dd31f52063355);

var $exb0h = parcelRequire("exb0h");
const $6c5d82fe5f41d40b$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $6c5d82fe5f41d40b$export$e77dd31f52063355 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY),
    path: `/secure/admin/ConfigureOptionSchemes${$6c5d82fe5f41d40b$var$defaultSuffix}.jspa`
};

});


parcelRegister("871XI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry", () => $6ff204035ba9f92e$export$953b618d4334efe8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $lDQPR = parcelRequire("lDQPR");
const $6ff204035ba9f92e$export$953b618d4334efe8 = (0, $bMm60.createEntry)((0, $lDQPR.globalSettingsIssuesTypesScreenSchemesConfigureRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("lDQPR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRoute", () => $193888da6cf54ab8$export$35a08f15e9b959ee);

var $exb0h = parcelRequire("exb0h");
const $193888da6cf54ab8$export$35a08f15e9b959ee = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE),
    path: '/secure/admin/ConfigureIssueTypeScreenScheme.jspa'
};

});


parcelRegister("17G3z", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRouteEntry", () => $614104f0a1c04c8a$export$7f2d678246700c2);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $58IbH = parcelRequire("58IbH");
const $614104f0a1c04c8a$export$7f2d678246700c2 = (0, $bMm60.createEntry)((0, $58IbH.globalSettingsIssuesTypesScreenSchemesCopyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("58IbH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRoute", () => $830e8e1c50822791$export$56cacc1b264d8eec);

var $exb0h = parcelRequire("exb0h");
const $830e8e1c50822791$export$56cacc1b264d8eec = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY),
    path: '/secure/admin/ViewCopyIssueTypeScreenScheme.jspa'
};

});


parcelRegister("99kzs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry", () => $93bb0ddcbd91ce46$export$5776296a4d01ebfc);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $c2jIB = parcelRequire("c2jIB");
const $93bb0ddcbd91ce46$export$5776296a4d01ebfc = (0, $bMm60.createEntry)((0, $c2jIB.globalSettingsIssuesTypesScreenSchemesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("c2jIB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRoute", () => $9e8cf1d6538d285a$export$3e0cfa858e2af787);

var $exb0h = parcelRequire("exb0h");
const $9e8cf1d6538d285a$export$3e0cfa858e2af787 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE),
    path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa'
};

});


parcelRegister("19kmi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRouteEntry", () => $56c3524da60844ed$export$c4d5ef3d480983a7);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $46G3m = parcelRequire("46G3m");
const $56c3524da60844ed$export$c4d5ef3d480983a7 = (0, $bMm60.createEntry)((0, $46G3m.globalSettingsIssuesTypesScreenSchemesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("46G3m", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRoute", () => $52da5a531eda06f9$export$1ddbfff8d0b6f652);

var $exb0h = parcelRequire("exb0h");
const $52da5a531eda06f9$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $52da5a531eda06f9$export$1ddbfff8d0b6f652 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT),
    path: `/secure/admin/EditIssueTypeScreenScheme${$52da5a531eda06f9$var$defaultSuffix}.jspa`
};

});


parcelRegister("2aAoE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRouteEntry", () => $38aa07ccf1859cf3$export$13bfbf88a9e3596d);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cLgdW = parcelRequire("cLgdW");
const $38aa07ccf1859cf3$export$13bfbf88a9e3596d = (0, $bMm60.createEntry)((0, $cLgdW.globalSettingsIssuesTypesScreenSchemesEntityRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cLgdW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRoute", () => $f08bb9c8173333fe$export$dbd4ba90dd0ca938);

var $exb0h = parcelRequire("exb0h");
const $f08bb9c8173333fe$export$dbd4ba90dd0ca938 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY),
    path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa'
};

});


parcelRegister("7brDo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRouteEntry", () => $675b063ab5aa55c4$export$4f9686f0681ca4ae);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cDxhM = parcelRequire("cDxhM");
const $675b063ab5aa55c4$export$4f9686f0681ca4ae = (0, $bMm60.createEntry)((0, $cDxhM.globalSettingsIssuesTypesTranslationsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cDxhM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRoute", () => $ca8343dd80e0fb26$export$58b39a591d56ebd2);

var $exb0h = parcelRequire("exb0h");
const $ca8343dd80e0fb26$export$58b39a591d56ebd2 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE),
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=issuetype'
    ]
};

});


parcelRegister("6iqEO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRouteEntry", () => $c13276800eb3240d$export$fc7a930108b9d172);
$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry", () => $c13276800eb3240d$export$bf03c0c6f11d43ea);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $2hwyz = parcelRequire("2hwyz");
const $c13276800eb3240d$export$fc7a930108b9d172 = (0, $bMm60.createEntry)((0, $2hwyz.globalSettingsIssuesWorkflowTransitionRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});
const $c13276800eb3240d$export$bf03c0c6f11d43ea = (0, $bMm60.createEntry)((0, $2hwyz.globalSettingsIssuesWorkflowTransitionMetaAttributesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
    }
});

});
parcelRegister("2hwyz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRoute", () => $840f2d66ba98c032$export$1579038a55dade21);
$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRoute", () => $840f2d66ba98c032$export$bc1d4dae621df0c5);

var $exb0h = parcelRequire("exb0h");
const $840f2d66ba98c032$export$1579038a55dade21 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION),
    path: '/secure/admin/ViewWorkflowTransition.jspa'
};
const $840f2d66ba98c032$export$bc1d4dae621df0c5 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES),
    path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa'
};

});


parcelRegister("isiO0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRouteEntry", () => $6a4da88ba594d531$export$3c5fdd60ca22958d);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5I5jh = parcelRequire("5I5jh");
const $6a4da88ba594d531$export$3c5fdd60ca22958d = (0, $bMm60.createEntry)((0, $5I5jh.globalSettingsIssuesWorkflowsImportRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5I5jh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRoute", () => $7adda048f5ec46a9$export$81f075f719f41037);
const $7adda048f5ec46a9$export$81f075f719f41037 = {
    name: 'global-settings-issues-workflows-import',
    path: '/plugins/servlet/wfshare-(import|export)'
};

});


parcelRegister("8cvs0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRouteEntry", () => $59e3057ded4b9618$export$22172eb9e4a9e4ae);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $dHK26 = parcelRequire("dHK26");
const $59e3057ded4b9618$export$22172eb9e4a9e4ae = (0, $bMm60.createEntry)((0, $dHK26.globalSettingsIssuesWorkflowsSchemesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("dHK26", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRoute", () => $bc9c6fbabe391c91$export$51a0d34ef3d00da8);

var $exb0h = parcelRequire("exb0h");
const $bc9c6fbabe391c91$export$51a0d34ef3d00da8 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT),
    path: '/secure/admin/EditWorkflowScheme.jspa'
};

});


parcelRegister("aKebc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAccessRouteEntry", () => $0630c1f151dca7a4$export$1a764e0ec9764809);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $2m4s8 = parcelRequire("2m4s8");
const $0630c1f151dca7a4$export$1a764e0ec9764809 = (0, $bMm60.createEntry)((0, $2m4s8.globalSettingsProductsAccessRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("7okz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0717b3ae49c7e5d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $f0717b3ae49c7e5d$var$LazyGlobalProductsSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("digTg")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0717b3ae49c7e5d$var$LazyGlobalProductsSettingsSidebar, null)));
$f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $f0717b3ae49c7e5d$export$2e2bcd8739ae039 = $f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar;

});
parcelRegister("digTg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("2YKQC")
]).then(()=>parcelRequire('gla7s'));

});


parcelRegister("2m4s8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAccessRoute", () => $7e88e7ea9703e63c$export$622d63534e0526a7);
const $7e88e7ea9703e63c$export$622d63534e0526a7 = {
    name: 'global-settings-products-access',
    path: '/secure/admin/ApplicationAccess.jspa'
};

});


parcelRegister("1L0xa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry", () => $6a4b54244caf61ff$export$c3b9f18ebde289c);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $1Nuxy = parcelRequire("1Nuxy");
const $6a4b54244caf61ff$export$c3b9f18ebde289c = (0, $bMm60.createEntry)((0, $1Nuxy.globalSettingsProductsAdvancedRoadmapsHierarchyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("1Nuxy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRoute", () => $107c32c9f33b87b5$export$40d4fd2626eca72c);
const $107c32c9f33b87b5$export$40d4fd2626eca72c = {
    name: 'global-settings-products-advanced-roadmaps-hierarchy',
    path: '/secure/PortfolioHierarchy.jspa'
};

});


parcelRegister("3NLRG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsApplinksRouteEntry", () => $580a3b4803941641$export$3dcc4ef9452eebbe);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $4tIVp = parcelRequire("4tIVp");
const $580a3b4803941641$export$3dcc4ef9452eebbe = (0, $bMm60.createEntry)((0, $4tIVp.globalSettingsProductsApplinksRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("4tIVp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsApplinksRoute", () => $b6fd80babcf0d2f1$export$8ff9863beab5519d);

var $exb0h = parcelRequire("exb0h");
const $b6fd80babcf0d2f1$export$8ff9863beab5519d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS),
    path: '/plugins/servlet/applinks/listApplicationLinks'
};

});


parcelRegister("4avaK", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRouteEntry", () => $6949462068f938af$export$8d7fb911e3ad15ce);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $865go = parcelRequire("865go");
const $6949462068f938af$export$8d7fb911e3ad15ce = (0, $bMm60.createEntry)((0, $865go.globalSettingsProductsDvcsBitbucketRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        // NOTE: the sidebar is rendered for this in Nav V2 too, but there's no corresponding sidebar item?
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("865go", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRoute", () => $20214f271d703ce8$export$463d647a53bdebee);
const $20214f271d703ce8$export$463d647a53bdebee = {
    name: 'global-settings-products-dvcs-bitbucket',
    path: '/secure/BitbucketPostInstallApprovalAction.jspa'
};

});


parcelRegister("2h3lO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsRouteEntry", () => $3e376ad052fdfac4$export$7970dfc3b824c864);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $7nZxL = parcelRequire("7nZxL");
const $3e376ad052fdfac4$export$7970dfc3b824c864 = (0, $bMm60.createEntry)((0, $7nZxL.globalSettingsProductsDvcsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("7nZxL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsRoute", () => $df0bd2f2bc866a7f$export$75d086bb3dd16edc);

var $exb0h = parcelRequire("exb0h");
const $df0bd2f2bc866a7f$export$75d086bb3dd16edc = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS),
    path: '/secure/admin/ConfigureDvcsOrganizations!default.jspa'
};

});


parcelRegister("4fquI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsJsdStatusRouteEntry", () => $c78ac7979c0d5626$export$5f4b9c737cade2ac);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $3CORd = parcelRequire("3CORd");
const $c78ac7979c0d5626$export$5f4b9c737cade2ac = (0, $bMm60.createEntry)((0, $3CORd.globalSettingsProductsJsdStatusRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("3CORd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsJsdStatusRoute", () => $b0004c30acdb682c$export$a0292a772bf703a0);

var $exb0h = parcelRequire("exb0h");
const $b0004c30acdb682c$export$a0292a772bf703a0 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE),
    path: '/plugins/servlet/ac/jsd-status-page'
};

});


parcelRegister("2DXVI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdconfigRouteEntry", () => $69a25acd1e3dfc8a$export$cb6362a400fffb25);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $cXHEi = parcelRequire("cXHEi");
const $69a25acd1e3dfc8a$export$cb6362a400fffb25 = (0, $bMm60.createEntry)((0, $cXHEi.globalSettingsProductsSdconfigRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("cXHEi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdconfigRoute", () => $8b5f29d1042b18da$export$846e5cd0d5151fde);
const $8b5f29d1042b18da$export$846e5cd0d5151fde = {
    name: 'global-settings-products-sdconfig',
    path: '/secure/admin/SDConfiguration.jspa'
};

});


parcelRegister("ijvcE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdmailRouteEntry", () => $54c2cf607639c8ce$export$e296aae86525a621);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $3SxCr = parcelRequire("3SxCr");
const $54c2cf607639c8ce$export$e296aae86525a621 = (0, $bMm60.createEntry)((0, $3SxCr.globalSettingsProductsSdmailRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("3SxCr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdmailRoute", () => $2db64480de16e605$export$e35c6c6fbfbb5111);

var $exb0h = parcelRequire("exb0h");
const $2db64480de16e605$export$e35c6c6fbfbb5111 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL),
    path: '/secure/admin/SDMailInfo.jspa'
};

});


parcelRegister("50RHu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRouteEntry", () => $c5ad4f9efb32b904$export$3e9459c1e240d138);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $d3SCE = parcelRequire("d3SCE");
const $c5ad4f9efb32b904$export$3e9459c1e240d138 = (0, $bMm60.createEntry)((0, $d3SCE.globalSettingsProductsSoftwareConfigRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: (0, $hHrVM.getNavigationSidebarProductsSettingResource)()
});

});
parcelRegister("d3SCE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRoute", () => $d606710feac5080d$export$5b270f25cf4ae11c);
const $d606710feac5080d$export$5b270f25cf4ae11c = {
    name: 'global-settings-products-software-config',
    path: '/secure/SoftwareConfig.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("lXIqH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRouteEntry", () => $9b280370a7c27ae1$export$ecfb2cc5a7593980);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $1vpkN = parcelRequire("1vpkN");
const $9b280370a7c27ae1$export$ecfb2cc5a7593980 = (0, $bMm60.createEntry)((0, $1vpkN.globalSettingsProjectsCategoriesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("7hF3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $707f9bf31c05907b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $707f9bf31c05907b$var$LazyGlobalProjectsSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("cp7ZQ")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $707f9bf31c05907b$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($707f9bf31c05907b$var$LazyGlobalProjectsSettingsSidebar, null)));
$707f9bf31c05907b$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $707f9bf31c05907b$export$2e2bcd8739ae039 = $707f9bf31c05907b$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("cp7ZQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("kWP1Y")
]).then(()=>parcelRequire('a6QRE'));

});


parcelRegister("1vpkN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRoute", () => $af64378cd0804a1e$export$f155c76657570a56);

var $exb0h = parcelRequire("exb0h");
const $af64378cd0804a1e$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $af64378cd0804a1e$export$f155c76657570a56 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE),
    path: `/secure/admin/projectcategories/DeleteProjectCategory${$af64378cd0804a1e$var$defaultSuffix}.jspa`
};

});


parcelRegister("bPjBv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRouteEntry", () => $e97bb4b577b662a0$export$8364dd961ae6c494);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $jXXom = parcelRequire("jXXom");
const $e97bb4b577b662a0$export$8364dd961ae6c494 = (0, $bMm60.createEntry)((0, $jXXom.globalSettingsProjectsCategoriesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("jXXom", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRoute", () => $e4c2d6facd359652$export$53d7a3e6e69ec873);

var $exb0h = parcelRequire("exb0h");
const $e4c2d6facd359652$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $e4c2d6facd359652$export$53d7a3e6e69ec873 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT),
    path: `/secure/admin/projectcategories/EditProjectCategory${$e4c2d6facd359652$var$defaultSuffix}.jspa`
};

});


parcelRegister("hLzqF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRouteEntry", () => $267480d80cd6ec2a$export$f53b9ac05cdf2fe8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $foJ4k = parcelRequire("foJ4k");
const $267480d80cd6ec2a$export$f53b9ac05cdf2fe8 = (0, $bMm60.createEntry)((0, $foJ4k.globalSettingsProjectsCategoriesViewRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("foJ4k", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRoute", () => $7946eae9515ca0c8$export$17ada00b0bde9ebc);

var $exb0h = parcelRequire("exb0h");
const $7946eae9515ca0c8$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $7946eae9515ca0c8$export$17ada00b0bde9ebc = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW),
    path: `/secure/admin/projectcategories/ViewProjectCategories${$7946eae9515ca0c8$var$defaultSuffix}.jspa`
};

});


parcelRegister("fzE9V", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRouteEntry", () => $acdee1a5fcc80170$export$48579ce5caedb688);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9gp0H = parcelRequire("9gp0H");
const $acdee1a5fcc80170$export$48579ce5caedb688 = (0, $bMm60.createEntry)((0, $9gp0H.globalSettingsSystemApplicationAdvancedRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9gp0H", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRoute", () => $efb4bdf02f4f1d1b$export$e79dd086a8ca16b7);

var $exb0h = parcelRequire("exb0h");
const $efb4bdf02f4f1d1b$export$e79dd086a8ca16b7 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS),
    path: '/secure/admin/AdvancedApplicationProperties.jspa'
};

});


parcelRegister("7KIKV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationEditRouteEntry", () => $94dfed468820d899$export$cb756194922d59f5);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $lpZ5y = parcelRequire("lpZ5y");
const $94dfed468820d899$export$cb756194922d59f5 = (0, $bMm60.createEntry)((0, $lpZ5y.globalSettingsSystemApplicationEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("lpZ5y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationEditRoute", () => $bf175395fb396487$export$3cfb7004aee9915c);

var $exb0h = parcelRequire("exb0h");
const $bf175395fb396487$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $bf175395fb396487$export$3cfb7004aee9915c = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS),
    path: `/secure/admin/EditApplicationProperties${$bf175395fb396487$var$defaultSuffix}.jspa`
};

});


parcelRegister("jbNtl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationViewRouteEntry", () => $7188ad827c849b66$export$c97a0463677004d2);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $1iLVf = parcelRequire("1iLVf");
const $7188ad827c849b66$export$c97a0463677004d2 = (0, $bMm60.createEntry)((0, $1iLVf.globalSettingsSystemApplicationViewRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("1iLVf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationViewRoute", () => $98d1fc7213ea229e$export$5ddf1dd9c57a9326);
const $98d1fc7213ea229e$export$5ddf1dd9c57a9326 = {
    name: 'global-settings-system-application-view',
    path: '/secure/admin/ViewApplicationProperties.jspa'
};

});


parcelRegister("gmZ4K", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAttachmentsRouteEntry", () => $6de00ec6da7b6d0f$export$a692196c89a01817);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $k3czj = parcelRequire("k3czj");
const $6de00ec6da7b6d0f$export$a692196c89a01817 = (0, $bMm60.createEntry)((0, $k3czj.globalSettingsSystemAttachmentsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("k3czj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAttachmentsRoute", () => $a2197e5e2f139629$export$717d7ab74cb9ce91);

var $exb0h = parcelRequire("exb0h");
const $a2197e5e2f139629$export$717d7ab74cb9ce91 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS),
    path: '/secure/admin/ViewAttachmentSettings.jspa'
};

});


parcelRegister("1koE7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAuditingRouteEntry", () => $1e0e3edb6df00760$export$7484cb4db3cfbf3f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $gdvR4 = parcelRequire("gdvR4");
const $1e0e3edb6df00760$export$7484cb4db3cfbf3f = (0, $bMm60.createEntry)((0, $gdvR4.globalSettingsSystemAuditingRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("gdvR4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAuditingRoute", () => $a82350861e8626f3$export$b8241cf6a8335186);

var $exb0h = parcelRequire("exb0h");
const $a82350861e8626f3$export$b8241cf6a8335186 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG),
    path: '/auditing/:page'
};

});


parcelRegister("6DgC6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemCollectorsRouteEntry", () => $445a6b7bc607a89a$export$a46b2c4865857bde);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $ci0L5 = parcelRequire("ci0L5");
const $445a6b7bc607a89a$export$a46b2c4865857bde = (0, $bMm60.createEntry)((0, $ci0L5.globalSettingsSystemCollectorsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("ci0L5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemCollectorsRoute", () => $a1b0e4f974a1f486$export$69ef22f1d54c39dc);

var $exb0h = parcelRequire("exb0h");
const $a1b0e4f974a1f486$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $a1b0e4f974a1f486$export$69ef22f1d54c39dc = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS),
    path: `/secure/admin/ViewGlobalCollectors${$a1b0e4f974a1f486$var$defaultSuffix}.jspa`
};

});


parcelRegister("8PAza", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRouteEntry", () => $baece59ac9303be0$export$3ba7ed3247e0da7);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5PM9C = parcelRequire("5PM9C");
const $baece59ac9303be0$export$3ba7ed3247e0da7 = (0, $bMm60.createEntry)((0, $5PM9C.globalSettingsSystemDefaultSettingsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5PM9C", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRoute", () => $4787a9125454d18c$export$d8f4254e5ee116aa);

var $exb0h = parcelRequire("exb0h");
const $4787a9125454d18c$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $4787a9125454d18c$export$d8f4254e5ee116aa = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS),
    path: `/secure/admin/ViewUserDefaultSettings${$4787a9125454d18c$var$defaultSuffix}.jspa`
};

});


parcelRegister("jfWNm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsRouteEntry", () => $28c72830e5baa7af$export$431e68e0ed553cca);
$parcel$export(module.exports, "globalSettingsSystemEventsAddRouteEntry", () => $28c72830e5baa7af$export$18dc7c450d001255);
$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRouteEntry", () => $28c72830e5baa7af$export$82ec56d45583ff5a);
$parcel$export(module.exports, "globalSettingsSystemEventsEditRouteEntry", () => $28c72830e5baa7af$export$5700f7202370e9c4);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5R7xI = parcelRequire("5R7xI");
const $28c72830e5baa7af$export$431e68e0ed553cca = (0, $bMm60.createEntry)((0, $5R7xI.globalSettingsSystemEventsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});
const $28c72830e5baa7af$export$18dc7c450d001255 = (0, $bMm60.createEntry)((0, $5R7xI.globalSettingsSystemEventsAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});
const $28c72830e5baa7af$export$82ec56d45583ff5a = (0, $bMm60.createEntry)((0, $5R7xI.globalSettingsSystemEventsDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});
const $28c72830e5baa7af$export$5700f7202370e9c4 = (0, $bMm60.createEntry)((0, $5R7xI.globalSettingsSystemEventsEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("5R7xI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsRoute", () => $515d8870a3d89cf4$export$c294ba50eb736e7b);
$parcel$export(module.exports, "globalSettingsSystemEventsAddRoute", () => $515d8870a3d89cf4$export$3bafc84a5f76a507);
$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRoute", () => $515d8870a3d89cf4$export$cf0c62e05603f7e1);
$parcel$export(module.exports, "globalSettingsSystemEventsEditRoute", () => $515d8870a3d89cf4$export$9bf98baef9abe3eb);

var $exb0h = parcelRequire("exb0h");
const $515d8870a3d89cf4$export$c294ba50eb736e7b = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS),
    path: '/secure/admin/ListEventTypes.jspa'
};
const $515d8870a3d89cf4$export$3bafc84a5f76a507 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD),
    path: '/secure/admin/AddEventType.jspa'
};
const $515d8870a3d89cf4$export$cf0c62e05603f7e1 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE),
    path: '/secure/admin/DeleteEventType.jspa'
};
const $515d8870a3d89cf4$export$9bf98baef9abe3eb = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT),
    path: '/secure/admin/EditEventType.jspa'
};

});


parcelRegister("cBVsd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemExportRouteEntry", () => $f72b2468ec3c44b6$export$78effb39671690ca);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $7xlVJ = parcelRequire("7xlVJ");
const $f72b2468ec3c44b6$export$78effb39671690ca = (0, $bMm60.createEntry)((0, $7xlVJ.globalSettingsSystemExportRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("7xlVJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemExportRoute", () => $0662433f7b0ec4ae$export$e398684ea718a2e7);

var $exb0h = parcelRequire("exb0h");
const $0662433f7b0ec4ae$export$e398684ea718a2e7 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER),
    path: '/secure/admin/CloudExport.jspa'
};

});


parcelRegister("4LAO4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRouteEntry", () => $b7add36510986c63$export$ebb311f9ff3b5efb);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5vxUz = parcelRequire("5vxUz");
const $b7add36510986c63$export$ebb311f9ff3b5efb = (0, $bMm60.createEntry)((0, $5vxUz.globalSettingsSystemGlobalPermissionsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("5vxUz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRoute", () => $fbe46971979c6715$export$38ac3717b046eb26);

var $exb0h = parcelRequire("exb0h");
const $fbe46971979c6715$export$38ac3717b046eb26 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS),
    path: '/secure/admin/jira/GlobalPermissions!default.jspa'
};

});


parcelRegister("dSBp6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRouteEntry", () => $f37e1228081c0f8a$export$e2befb3c6371d2f2);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $adGtk = parcelRequire("adGtk");
const $f37e1228081c0f8a$export$e2befb3c6371d2f2 = (0, $bMm60.createEntry)((0, $adGtk.globalSettingsSystemHelperNotificationRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("adGtk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRoute", () => $e928b45f53b70e14$export$7dab38c28c574395);

var $exb0h = parcelRequire("exb0h");
const $e928b45f53b70e14$export$7dab38c28c574395 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER),
    path: '/secure/admin/NotificationHelperAdmin.jspa'
};

});


parcelRegister("2Njzs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRouteEntry", () => $f266c261f87754ac$export$b7f8ebfe77163756);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $baoQ2 = parcelRequire("baoQ2");
const $f266c261f87754ac$export$b7f8ebfe77163756 = (0, $bMm60.createEntry)((0, $baoQ2.globalSettingsSystemHelperPermissionRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("baoQ2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRoute", () => $c44c5d47dd90a653$export$5c1770f1a1797fa5);

var $exb0h = parcelRequire("exb0h");
const $c44c5d47dd90a653$export$5c1770f1a1797fa5 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER),
    path: '/secure/admin/PermissionHelperAdmin.jspa'
};

});


parcelRegister("4SOuU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportBulkRouteEntry", () => $666438870fe0062e$export$dd20078389577d29);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5ZUa9 = parcelRequire("5ZUa9");
const $666438870fe0062e$export$dd20078389577d29 = (0, $bMm60.createEntry)((0, $5ZUa9.globalSettingsSystemImportBulkRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5ZUa9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportBulkRoute", () => $f5645485ec252ee4$export$9de82cbc931fb7d0);
const $f5645485ec252ee4$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $f5645485ec252ee4$export$9de82cbc931fb7d0 = {
    name: 'global-settings-system-import-bulk',
    path: `/secure/admin/BulkCreate(\\w+)${$f5645485ec252ee4$var$defaultSuffix}.jspa`
};

});


parcelRegister("1j0Bt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCloudRouteEntry", () => $03f89f2f9adb939d$export$9d598c957e5bddde);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $2L15b = parcelRequire("2L15b");
const $03f89f2f9adb939d$export$9d598c957e5bddde = (0, $bMm60.createEntry)((0, $2L15b.globalSettingsSystemImportCloudRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("2L15b", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCloudRoute", () => $1a51c2d92a1b8535$export$9953342c4b995f8);

var $exb0h = parcelRequire("exb0h");
const $1a51c2d92a1b8535$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $1a51c2d92a1b8535$export$9953342c4b995f8 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT),
    path: `/secure/admin/CloudImport${$1a51c2d92a1b8535$var$defaultSuffix}.jspa`
};

});


parcelRegister("l6Ck7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCsvRouteEntry", () => $2f476a2f78e3340a$export$9e23dd51b331426c);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $3BwSb = parcelRequire("3BwSb");
const $2f476a2f78e3340a$export$9e23dd51b331426c = (0, $bMm60.createEntry)((0, $3BwSb.globalSettingsSystemImportCsvRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("3BwSb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCsvRoute", () => $12f4a08cefbe8ff8$export$49f0cc3d88107d6b);

var $exb0h = parcelRequire("exb0h");
const $12f4a08cefbe8ff8$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $12f4a08cefbe8ff8$export$49f0cc3d88107d6b = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV),
    path: `/(secure|secure/admin)/Csv(\\w+)Page${$12f4a08cefbe8ff8$var$defaultSuffix}.jspa`
};

});


parcelRegister("3YyaO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalRouteEntry", () => $e8b48631e7776142$export$bf4a85badc8c82c9);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kACg7 = parcelRequire("kACg7");
const $e8b48631e7776142$export$bf4a85badc8c82c9 = (0, $bMm60.createEntry)((0, $kACg7.globalSettingsSystemImportExternalRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("kACg7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalRoute", () => $13cfbf02daaead3e$export$afcc884cbc873f9f);

var $exb0h = parcelRequire("exb0h");
const $13cfbf02daaead3e$export$afcc884cbc873f9f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT),
    path: '/secure/admin/ExternalImport1.jspa'
};

});


parcelRegister("bNJbU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRouteEntry", () => $0447b08bb8809c9e$export$7ca884816be2470a);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $26NoT = parcelRequire("26NoT");
const $0447b08bb8809c9e$export$7ca884816be2470a = (0, $bMm60.createEntry)((0, $26NoT.globalSettingsSystemImportExternalPagesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("26NoT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRoute", () => $49b6d1f5f453d17a$export$dffab00ceab69eb2);
const $49b6d1f5f453d17a$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $49b6d1f5f453d17a$export$dffab00ceab69eb2 = {
    name: 'global-settings-system-import-external-pages',
    path: `/secure/admin/Importer(\\w+)Page${$49b6d1f5f453d17a$var$defaultSuffix}.jspa`
};

});


parcelRegister("k2nqy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportJsonRouteEntry", () => $549f9673180e7285$export$fbac3139112fe654);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $39ZGm = parcelRequire("39ZGm");
const $549f9673180e7285$export$fbac3139112fe654 = (0, $bMm60.createEntry)((0, $39ZGm.globalSettingsSystemImportJsonRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("39ZGm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportJsonRoute", () => $dbfad4983ab56254$export$169bd8bcabed089d);

var $exb0h = parcelRequire("exb0h");
const $dbfad4983ab56254$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $dbfad4983ab56254$export$169bd8bcabed089d = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON),
    path: `/secure/admin/Json(\\w+)Page${$dbfad4983ab56254$var$defaultSuffix}.jspa`
};

});


parcelRegister("7vRFW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportTrelloRouteEntry", () => $e868ef5787ef910d$export$19f57ac143eecd95);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $4cron = parcelRequire("4cron");
const $e868ef5787ef910d$export$19f57ac143eecd95 = (0, $bMm60.createEntry)((0, $4cron.globalSettingsSystemImportTrelloRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("4cron", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportTrelloRoute", () => $9f04f5a2519c3016$export$b6753e755954098b);

var $exb0h = parcelRequire("exb0h");
const $9f04f5a2519c3016$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $9f04f5a2519c3016$export$b6753e755954098b = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO),
    path: `/secure/admin/Trello(\\w+)Page${$9f04f5a2519c3016$var$defaultSuffix}.jspa`
};

});


parcelRegister("1mBGD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLexorankRouteEntry", () => $aa5ff6b8c347379b$export$5163204c27a4b60f);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $6ed6Q = parcelRequire("6ed6Q");
const $aa5ff6b8c347379b$export$5163204c27a4b60f = (0, $bMm60.createEntry)((0, $6ed6Q.globalSettingsSystemLexorankRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("6ed6Q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLexorankRoute", () => $2ea7b9e29b2a76fa$export$d4ce3155385fd8cf);

var $exb0h = parcelRequire("exb0h");
const $2ea7b9e29b2a76fa$export$d4ce3155385fd8cf = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT),
    path: '/secure/GHLexoRankManage.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("e1Lm3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLookRouteEntry", () => $beb0077284aa59aa$export$bf366af006cda74e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9INED = parcelRequire("9INED");
const $beb0077284aa59aa$export$bf366af006cda74e = (0, $bMm60.createEntry)((0, $9INED.globalSettingsSystemLookRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9INED", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLookRoute", () => $4b99fbc503b1d8c4$export$61f7b12ec2ac6aa1);

var $exb0h = parcelRequire("exb0h");
const $4b99fbc503b1d8c4$export$61f7b12ec2ac6aa1 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL),
    path: '/secure/admin/LookAndFeel!default.jspa'
};

});


parcelRegister("eh53C", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailAddRouteEntry", () => $8b4d1051eda2ad75$export$c48daf66fa2bb3e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $h65A7 = parcelRequire("h65A7");
const $8b4d1051eda2ad75$export$c48daf66fa2bb3e = (0, $bMm60.createEntry)((0, $h65A7.globalSettingsSystemMailAddRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("h65A7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailAddRoute", () => $fa280cedb46afdb0$export$2874a3735d7cb330);
const $fa280cedb46afdb0$export$2874a3735d7cb330 = {
    name: 'global-settings-system-mail-add',
    path: '/secure/admin/(Add|Update)PopMailServer!default.jspa'
};

});


parcelRegister("k3GOY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailIncomingRouteEntry", () => $3bc908e6d29acd09$export$3ae66df5766592ef);
$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRouteEntry", () => $3bc908e6d29acd09$export$a14468794f1b5c83);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $b3GcD = parcelRequire("b3GcD");
const $3bc908e6d29acd09$export$3ae66df5766592ef = (0, $bMm60.createEntry)((0, $b3GcD.globalSettingsSystemMailIncomingRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});
const $3bc908e6d29acd09$export$a14468794f1b5c83 = (0, $bMm60.createEntry)((0, $b3GcD.globalSettingsSystemMailDeleteMailHandlerRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("b3GcD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailIncomingRoute", () => $3195ac3a674c8f3d$export$90c9c127e433d888);
$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRoute", () => $3195ac3a674c8f3d$export$140403398c884f90);

var $exb0h = parcelRequire("exb0h");
const $3195ac3a674c8f3d$export$90c9c127e433d888 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL),
    path: '/secure/admin/IncomingMailServers.jspa'
};
const $3195ac3a674c8f3d$export$140403398c884f90 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER),
    path: '/secure/admin/DeleteMailHandler.jspa'
};

});


parcelRegister("d7vUv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRouteEntry", () => $b7036fa9b8b771c0$export$cb267b8986031cb7);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $hqkSa = parcelRequire("hqkSa");
const $b7036fa9b8b771c0$export$cb267b8986031cb7 = (0, $bMm60.createEntry)((0, $hqkSa.globalSettingsSystemMailOutgoingRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("hqkSa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRoute", () => $f59c5997eb6c3a63$export$6da120a8b84a7872);

var $exb0h = parcelRequire("exb0h");
const $f59c5997eb6c3a63$export$6da120a8b84a7872 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL),
    path: '/secure/admin/OutgoingMailServers.jspa'
};

});


parcelRegister("2QuGp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSendRouteEntry", () => $527f0a53aab201a4$export$bff9c3c6b0aba389);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cVbh3 = parcelRequire("cVbh3");
const $527f0a53aab201a4$export$bff9c3c6b0aba389 = (0, $bMm60.createEntry)((0, $cVbh3.globalSettingsSystemMailSendRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cVbh3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSendRoute", () => $dcd84f4766026ed8$export$a2ae5fa2accd6e5f);

var $exb0h = parcelRequire("exb0h");
const $dcd84f4766026ed8$export$a2ae5fa2accd6e5f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL),
    path: '/secure/admin/SendBulkMail!default.jspa'
};

});


parcelRegister("iSe8w", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSettingsRouteEntry", () => $2c31589f2b0e0bff$export$3c0d52a24b499e7c);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $inL0C = parcelRequire("inL0C");
const $2c31589f2b0e0bff$export$3c0d52a24b499e7c = (0, $bMm60.createEntry)((0, $inL0C.globalSettingsSystemMailSettingsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("inL0C", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSettingsRoute", () => $b56719cd77028b38$export$8423ad7a1177552);
const $b56719cd77028b38$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $b56719cd77028b38$export$8423ad7a1177552 = {
    name: 'global-settings-system-mail-settings',
    path: `/secure/admin/GlobalMailSettings${$b56719cd77028b38$var$defaultSuffix}.jspa`
};

});


parcelRegister("8Gz9v", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailVerifyRouteEntry", () => $88ad60f14ae472fb$export$2fd491752a9501a2);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $iBNZH = parcelRequire("iBNZH");
const $88ad60f14ae472fb$export$2fd491752a9501a2 = (0, $bMm60.createEntry)((0, $iBNZH.globalSettingsSystemMailVerifyRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("iBNZH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailVerifyRoute", () => $dfee30843fa18243$export$51b4ff8214b9fd7f);
const $dfee30843fa18243$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $dfee30843fa18243$export$51b4ff8214b9fd7f = {
    name: 'global-settings-system-mail-verify',
    path: `/secure/admin/VerifyPopServerConnection${$dfee30843fa18243$var$defaultSuffix}.jspa`
};

});


parcelRegister("ksQFL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemPermissionsRouteEntry", () => $24d12cdfdd213338$export$9fe6a3bc70d75bae);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $8BJ94 = parcelRequire("8BJ94");
const $24d12cdfdd213338$export$9fe6a3bc70d75bae = (0, $bMm60.createEntry)((0, $8BJ94.globalSettingsSystemPermissionsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("8BJ94", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemPermissionsRoute", () => $28979584f5d1353c$export$1382458fd6826787);

var $exb0h = parcelRequire("exb0h");
const $28979584f5d1353c$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $28979584f5d1353c$export$1382458fd6826787 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD),
    path: `/secure/admin/GlobalPermissions${$28979584f5d1353c$var$defaultSuffix}.jspa`
};

});


parcelRegister("2NoVw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRouteEntry", () => $221961b4e5995687$export$b78eddbedd30951d);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $An5HT = parcelRequire("An5HT");
const $221961b4e5995687$export$b78eddbedd30951d = (0, $bMm60.createEntry)((0, $An5HT.globalSettingsSystemProjectAssignSecurityRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("An5HT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRoute", () => $cdb4c37a6700b573$export$f53750f3a4fc2fde);
const $cdb4c37a6700b573$export$f53750f3a4fc2fde = {
    name: 'global-settings-system-project-assign-security',
    path: '/secure/project/AssignIssueSecuritySchemeProgress.jspa'
};

});


parcelRegister("jn1UR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRouteEntry", () => $8834358f063ee19b$export$849f3666529d049e);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $1GNUn = parcelRequire("1GNUn");
const $8834358f063ee19b$export$849f3666529d049e = (0, $bMm60.createEntry)((0, $1GNUn.globalSettingsSystemProjectDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("1GNUn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRoute", () => $7d03ebb40ce2f51b$export$f31d8748a56aa638);
const $7d03ebb40ce2f51b$export$f31d8748a56aa638 = {
    name: 'global-settings-system-project-delete',
    path: '/secure/project/DeleteProject.jspa'
};

});


parcelRegister("223x6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectSelectRouteEntry", () => $9b3b20c92f8cbf3c$export$a1869de90837dac8);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $acvvu = parcelRequire("acvvu");
const $9b3b20c92f8cbf3c$export$a1869de90837dac8 = (0, $bMm60.createEntry)((0, $acvvu.globalSettingsSystemProjectSelectRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("acvvu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectSelectRoute", () => $dc71985a77a2d3d0$export$8f44b9e5553dccec);
const $dc71985a77a2d3d0$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $dc71985a77a2d3d0$export$8f44b9e5553dccec = {
    name: 'global-settings-system-project-select',
    path: `/secure/project/SelectProject(\\w*)${$dc71985a77a2d3d0$var$defaultSuffix}.jspa`
};

});


parcelRegister("jnAuY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsRouteEntry", () => $ab575d0ab4d816e4$export$7dc567ad40905890);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kT8jf = parcelRequire("kT8jf");
const $ab575d0ab4d816e4$export$7dc567ad40905890 = (0, $bMm60.createEntry)((0, $kT8jf.globalSettingsSystemRolesActorsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("kT8jf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsRoute", () => $a442a7f8968e0425$export$3dca5fcf3b98db1e);

var $exb0h = parcelRequire("exb0h");
const $a442a7f8968e0425$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $a442a7f8968e0425$export$3dca5fcf3b98db1e = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS),
    path: `/secure/project/ViewDefaultProjectRoleActors${$a442a7f8968e0425$var$defaultSuffix}.jspa`
};

});


parcelRegister("7Wws4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRouteEntry", () => $13888b5744e876b5$export$ac1028baf6d1bd60);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $iUoPW = parcelRequire("iUoPW");
const $13888b5744e876b5$export$ac1028baf6d1bd60 = (0, $bMm60.createEntry)((0, $iUoPW.globalSettingsSystemRolesActorsGroupsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("iUoPW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRoute", () => $7913a109e53ca87e$export$836f3cdea3e238a4);

var $exb0h = parcelRequire("exb0h");
const $7913a109e53ca87e$export$836f3cdea3e238a4 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS),
    path: '/secure/project/GroupRoleActorAction.jspa'
};

});


parcelRegister("hylPE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRouteEntry", () => $da16b7354fdaf006$export$3186176f09045f35);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $6UpHI = parcelRequire("6UpHI");
const $da16b7354fdaf006$export$3186176f09045f35 = (0, $bMm60.createEntry)((0, $6UpHI.globalSettingsSystemRolesActorsUsersRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("6UpHI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRoute", () => $f1bc675020b25cf6$export$119e823548eefd4f);

var $exb0h = parcelRequire("exb0h");
const $f1bc675020b25cf6$export$119e823548eefd4f = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS),
    path: '/secure/project/UserRoleActorAction.jspa'
};

});


parcelRegister("aIPqS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRouteEntry", () => $6ab527cd6d1642db$export$4f2756ef0230f213);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $kkJzm = parcelRequire("kkJzm");
const $6ab527cd6d1642db$export$4f2756ef0230f213 = (0, $bMm60.createEntry)((0, $kkJzm.globalSettingsSystemRolesDeleteRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("kkJzm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRoute", () => $3d4f2116776fa278$export$c4b2dba31a4a29c8);

var $exb0h = parcelRequire("exb0h");
const $3d4f2116776fa278$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $3d4f2116776fa278$export$c4b2dba31a4a29c8 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE),
    path: `/secure/project/DeleteProjectRole${$3d4f2116776fa278$var$defaultSuffix}.jspa`
};

});


parcelRegister("5U2vN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesEditRouteEntry", () => $3b3ab25f53f810fc$export$18cfabcb0c0c21e5);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9rpBw = parcelRequire("9rpBw");
const $3b3ab25f53f810fc$export$18cfabcb0c0c21e5 = (0, $bMm60.createEntry)((0, $9rpBw.globalSettingsSystemRolesEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("9rpBw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesEditRoute", () => $1b982f60a4b3c881$export$88917fe447558e55);

var $exb0h = parcelRequire("exb0h");
const $1b982f60a4b3c881$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $1b982f60a4b3c881$export$88917fe447558e55 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT),
    path: `/secure/project/EditProjectRole${$1b982f60a4b3c881$var$defaultSuffix}.jspa`
};

});


parcelRegister("j8GQH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesUsageRouteEntry", () => $1b1f2f1eb8d3aa3c$export$d9f7c60572f36835);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $aNUP5 = parcelRequire("aNUP5");
const $1b1f2f1eb8d3aa3c$export$d9f7c60572f36835 = (0, $bMm60.createEntry)((0, $aNUP5.globalSettingsSystemRolesUsageRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("aNUP5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesUsageRoute", () => $14fafb641d684e41$export$91305e5cb99eb005);

var $exb0h = parcelRequire("exb0h");
const $14fafb641d684e41$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $14fafb641d684e41$export$91305e5cb99eb005 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE),
    path: `/secure/project/ViewProjectRoleUsage${$14fafb641d684e41$var$defaultSuffix}.jspa`
};

});


parcelRegister("leBgO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesViewRouteEntry", () => $80d116d3f8f03297$export$47efc3b9a4cedfba);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5H9Me = parcelRequire("5H9Me");
const $80d116d3f8f03297$export$47efc3b9a4cedfba = (0, $bMm60.createEntry)((0, $5H9Me.globalSettingsSystemRolesViewRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("5H9Me", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesViewRoute", () => $b5fac8943624c914$export$81d6a9112f47a229);

var $exb0h = parcelRequire("exb0h");
const $b5fac8943624c914$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $b5fac8943624c914$export$81d6a9112f47a229 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES),
    path: `/secure/project/ViewProjectRoles${$b5fac8943624c914$var$defaultSuffix}.jspa`
};

});


parcelRegister("dg8kv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemServicesRouteEntry", () => $3653f2489d57b82e$export$f08661656eef7ad1);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $cn2L8 = parcelRequire("cn2L8");
const $3653f2489d57b82e$export$f08661656eef7ad1 = (0, $bMm60.createEntry)((0, $cn2L8.globalSettingsSystemServicesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("cn2L8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemServicesRoute", () => $cb354af7150c6f2e$export$a176af71f8d6d872);

var $exb0h = parcelRequire("exb0h");
const $cb354af7150c6f2e$export$a176af71f8d6d872 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES),
    path: '/secure/admin/ViewServices!default.jspa'
};

});


parcelRegister("8rQkD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRouteEntry", () => $dd6e7d1d3e4cf6bb$export$48cce4d971c37598);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $3XeIr = parcelRequire("3XeIr");
const $dd6e7d1d3e4cf6bb$export$48cce4d971c37598 = (0, $bMm60.createEntry)((0, $3XeIr.globalSettingsSystemSharedDashboardsRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("3XeIr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRoute", () => $470306db5e558752$export$64739c332d5146ba);

var $exb0h = parcelRequire("exb0h");
const $470306db5e558752$export$64739c332d5146ba = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS),
    path: '/secure/admin/dashboards/ViewSharedDashboards.jspa'
};

});


parcelRegister("atOQk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRouteEntry", () => $1a4eeaf8e29515a0$export$6777672075f7d618);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $2rYhs = parcelRequire("2rYhs");
const $1a4eeaf8e29515a0$export$6777672075f7d618 = (0, $bMm60.createEntry)((0, $2rYhs.globalSettingsSystemSharedFiltersRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("2rYhs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRoute", () => $651bcb9d323d1dfa$export$684d93e5438fcd69);

var $exb0h = parcelRequire("exb0h");
const $651bcb9d323d1dfa$export$684d93e5438fcd69 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS),
    path: '/secure/admin/filters/ViewSharedFilters.jspa'
};

});


parcelRegister("1Fjfc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRouteEntry", () => $511d48ce4ea3e0d3$export$dbe314c372e965d4);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $9fVZQ = parcelRequire("9fVZQ");
const $511d48ce4ea3e0d3$export$dbe314c372e965d4 = (0, $bMm60.createEntry)((0, $9fVZQ.globalSettingsSystemUserInterfaceDashboardEditRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("9fVZQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRoute", () => $fc9ebfdcf4c112ff$export$78c9a0475c2f9cd0);

var $exb0h = parcelRequire("exb0h");
const $fc9ebfdcf4c112ff$export$78c9a0475c2f9cd0 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT),
    path: '/secure/admin/jira/EditApplicationProperties!default.jspa'
};

});


parcelRegister("egQ89", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRouteEntry", () => $5e95ba7bd6a69509$export$7025983c5e996386);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $5NV1l = parcelRequire("5NV1l");
const $5e95ba7bd6a69509$export$7025983c5e996386 = (0, $bMm60.createEntry)((0, $5NV1l.globalSettingsSystemUserInterfacePreferencesRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
    }
});

});
parcelRegister("5NV1l", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRoute", () => $836b95254a8dfe0d$export$6f46032e4fc13ea0);

var $exb0h = parcelRequire("exb0h");
const $836b95254a8dfe0d$export$6f46032e4fc13ea0 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY),
    path: '/secure/admin/SetGlobalEmailPreference!default.jspa'
};

});


parcelRegister("12Uvs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemWebhooksRouteEntry", () => $0318aec058392196$export$aff2563c719af2aa);

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $bMm60 = parcelRequire("bMm60");

var $9CFDS = parcelRequire("9CFDS");

var $eG40e = parcelRequire("eG40e");
const $0318aec058392196$export$aff2563c719af2aa = (0, $bMm60.createEntry)((0, $eG40e.globalSettingsSystemWebhooksRoute), {
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        (0, $9CFDS.navigationSidebarGlobalResource)
    ]
});

});
parcelRegister("eG40e", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemWebhooksRoute", () => $45d26a681ef081fb$export$2c20f3aef4ea16aa);

var $exb0h = parcelRequire("exb0h");
const $45d26a681ef081fb$export$2c20f3aef4ea16aa = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS),
    path: '/plugins/servlet/webhooks'
};

});


parcelRegister("4FxfK", function(module, exports) {

$parcel$export(module.exports, "legacyIssueRouteEntry", () => $b4edec1ad6e44328$export$e8ba55056b4fde20);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $gF5SK = parcelRequire("gF5SK");

var $hRe6W = parcelRequire("hRe6W");

var $ji2y4 = parcelRequire("ji2y4");

var $gvg03 = parcelRequire("gvg03");
const $b4edec1ad6e44328$export$e8ba55056b4fde20 = (0, $bMm60.createEntry)((0, $ji2y4.legacyIssueRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    component: (0, $gvg03.LegacyIssueView),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $hRe6W.queuesNavigationItems),
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("ji2y4", function(module, exports) {

$parcel$export(module.exports, "legacyIssueRoute", () => $4ce4fea81ffea237$export$71da6fcc13745fba);
const $4ce4fea81ffea237$export$71da6fcc13745fba = {
    name: 'legacy-issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)',
    query: [
        'jql!=(.+)',
        'filter!=(.+)'
    ]
};

});

parcelRegister("gvg03", function(module, exports) {

$parcel$export(module.exports, "LegacyIssueView", () => $a40ed7210cfb6e51$export$34dc6596952b042c);

var $eUqFw = parcelRequire("eUqFw");

var $bCmyq = parcelRequire("bCmyq");
const $a40ed7210cfb6e51$export$34dc6596952b042c = (props)=>{
    const { route: route } = props;
    if (!route) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCmyq.LegacyPage), props));
};

});


parcelRegister("2VVMG", function(module, exports) {

$parcel$export(module.exports, "legacyJsdCustomersRouteEntry", () => $b8f902b86ed57cfe$export$f458747db287136e);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $2jxxp = parcelRequire("2jxxp");

var $csLgO = parcelRequire("csLgO");
const $b8f902b86ed57cfe$export$f458747db287136e = (0, $bMm60.createEntry)((0, $2jxxp.legacyJsdCustomersRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("2jxxp", function(module, exports) {

$parcel$export(module.exports, "legacyJsdCustomersRoute", () => $41936fc4288b3bb5$export$3af39e70a286821c);

var $exb0h = parcelRequire("exb0h");
const $41936fc4288b3bb5$export$3af39e70a286821c = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_CUSTOMERS),
    path: '/projects/:projectKey/customers'
};

});


parcelRegister("e3g9n", function(module, exports) {

$parcel$export(module.exports, "legacyJsdGettingStartedRouteEntry", () => $d651373cee8be460$export$3c4b4abb062b10e3);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $dEQR5 = parcelRequire("dEQR5");

var $csLgO = parcelRequire("csLgO");
const $d651373cee8be460$export$3c4b4abb062b10e3 = (0, $bMm60.createEntry)((0, $dEQR5.legacyJsdGettingStartedRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("dEQR5", function(module, exports) {

$parcel$export(module.exports, "legacyJsdGettingStartedRoute", () => $fc54b6a83c4fea1c$export$71b946ee427d710);

var $exb0h = parcelRequire("exb0h");
const $fc54b6a83c4fea1c$export$71b946ee427d710 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED),
    path: '/projects/:projectKey/getting-started'
};

});


parcelRegister("8HL4y", function(module, exports) {

$parcel$export(module.exports, "legacyJsdJiraAutomationRouteEntry", () => $94a967fff0f649c7$export$d2d1cb3e56d9ba93);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $idIgm = parcelRequire("idIgm");

var $csLgO = parcelRequire("csLgO");
const $94a967fff0f649c7$export$d2d1cb3e56d9ba93 = (0, $bMm60.createEntry)((0, $idIgm.legacyJsdJiraAutomationRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("idIgm", function(module, exports) {

$parcel$export(module.exports, "legacyJsdJiraAutomationRoute", () => $8557f87338b262e8$export$7d38596d701d5776);

var $exb0h = parcelRequire("exb0h");
const $8557f87338b262e8$export$7d38596d701d5776 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION),
    path: '/servicedesk/admin/:projectKey/automation'
};

});


parcelRegister("3Cfrh", function(module, exports) {

$parcel$export(module.exports, "legacyJsdKnowledgeRouteEntry", () => $787170110ddf1034$export$352579e39711e17);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $lPIpa = parcelRequire("lPIpa");

var $csLgO = parcelRequire("csLgO");
const $787170110ddf1034$export$352579e39711e17 = (0, $bMm60.createEntry)((0, $lPIpa.legacyJsdKnowledgeRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("lPIpa", function(module, exports) {

$parcel$export(module.exports, "legacyJsdKnowledgeRoute", () => $62c870583e150e1b$export$7c7fc282c0c143d);

var $exb0h = parcelRequire("exb0h");
const $62c870583e150e1b$export$7c7fc282c0c143d = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE),
    path: '/projects/:projectKey/knowledge/:page?'
};

});


parcelRegister("1hpYM", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesRouteEntry", () => $56703f7f826e9feb$export$7c006e8310e2641a);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9mvq9 = parcelRequire("9mvq9");

var $csLgO = parcelRequire("csLgO");
const $56703f7f826e9feb$export$7c006e8310e2641a = (0, $bMm60.createEntry)((0, $9mvq9.legacyJsdQueuesRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("9mvq9", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesRoute", () => $de9bc3beead0fd3d$export$2d08dc2a8c573cf3);

var $exb0h = parcelRequire("exb0h");
const $de9bc3beead0fd3d$export$2d08dc2a8c573cf3 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_QUEUES),
    path: '/projects/:projectKey/queues/:custom(custom)?/:id?'
};

});


parcelRegister("3cLCI", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesManageRouteEntry", () => $1fb023e957ea0ec1$export$cdabf798cd8727fd);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $13CxO = parcelRequire("13CxO");

var $csLgO = parcelRequire("csLgO");
const $1fb023e957ea0ec1$export$cdabf798cd8727fd = (0, $bMm60.createEntry)((0, $13CxO.legacyJsdQueuesManageRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("13CxO", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesManageRoute", () => $a04940d1aea4cbc4$export$af365e550fae80);

var $exb0h = parcelRequire("exb0h");
const $a04940d1aea4cbc4$export$af365e550fae80 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE),
    path: '/projects/:projectKey/queues/manage'
};

});


parcelRegister("3mqtu", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsCustomRouteEntry", () => $616032d2ddc070b0$export$e133645c1a4bdfe7);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $fYOQZ = parcelRequire("fYOQZ");

var $csLgO = parcelRequire("csLgO");
const $616032d2ddc070b0$export$e133645c1a4bdfe7 = (0, $bMm60.createEntry)((0, $fYOQZ.legacyJsdReportsCustomRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("fYOQZ", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsCustomRoute", () => $84737e03c4ba085c$export$e5d83d06029b0f71);

var $exb0h = parcelRequire("exb0h");
const $84737e03c4ba085c$export$e5d83d06029b0f71 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM),
    path: '/projects/:projectKey/reports/custom/:id?'
};

});


parcelRegister("4kGtK", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsRouteEntry", () => $4d26595ead13f596$export$893692ad278d4aa2);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $iLJau = parcelRequire("iLJau");

var $csLgO = parcelRequire("csLgO");
const $4d26595ead13f596$export$893692ad278d4aa2 = (0, $bMm60.createEntry)((0, $iLJau.legacyJsdReportsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("iLJau", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsRoute", () => $8fbb7f08c331da5c$export$253418b9005ff89e);

var $exb0h = parcelRequire("exb0h");
const $8fbb7f08c331da5c$export$253418b9005ff89e = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_REPORTS),
    path: '/projects/:projectKey/reports/:reportType'
};

});


parcelRegister("lzxba", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsFallbackRouteEntry", () => $db7a3ad35511a410$export$f0bcff1cea783147);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $1Qwst = parcelRequire("1Qwst");

var $csLgO = parcelRequire("csLgO");
const $db7a3ad35511a410$export$f0bcff1cea783147 = (0, $bMm60.createEntry)((0, $1Qwst.legacyJsdSettingsFallbackRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("1Qwst", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsFallbackRoute", () => $4a8836839b778bc2$export$831971c91fbdcd5b);

var $exb0h = parcelRequire("exb0h");
const $4a8836839b778bc2$export$831971c91fbdcd5b = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK),
    path: '/servicedesk/admin/:projectKey/:adminOption'
};

});


parcelRegister("ejqSg", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguageRouteEntry", () => $a4aa7fe88a49764d$export$d9063e63677bfd5d);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $6bzap = parcelRequire("6bzap");

var $csLgO = parcelRequire("csLgO");
const $a4aa7fe88a49764d$export$d9063e63677bfd5d = (0, $bMm60.createEntry)((0, $6bzap.legacyJsdSettingsLanguageRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("6bzap", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguageRoute", () => $a66f88f59d08903e$export$453ac1bfce2eb20e);

var $exb0h = parcelRequire("exb0h");
const $a66f88f59d08903e$export$453ac1bfce2eb20e = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE),
    path: '/servicedesk/admin/:projectKey/language',
    exact: true
};

});


parcelRegister("C0pKf", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRouteEntry", () => $b5ca1bcdfdf7c30a$export$492207df7adc0823);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9m1hB = parcelRequire("9m1hB");

var $csLgO = parcelRequire("csLgO");
const $b5ca1bcdfdf7c30a$export$492207df7adc0823 = (0, $bMm60.createEntry)((0, $9m1hB.legacyJsdSettingsLanguagePagesRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("9m1hB", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRoute", () => $d0931f5f67aa1ff8$export$2fd783c1d45b1a9f);

var $exb0h = parcelRequire("exb0h");
const $d0931f5f67aa1ff8$export$2fd783c1d45b1a9f = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES),
    path: '/servicedesk/admin/:projectKey/language/:languageKey/:sidebarItemKey?'
};

});


parcelRegister("9bf2e", function(module, exports) {

$parcel$export(module.exports, "legacyJsdWidgetsRouteEntry", () => $3027233bd8f3518d$export$8b6c493f34b243fb);

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $bMm60 = parcelRequire("bMm60");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $5HIvu = parcelRequire("5HIvu");

var $csLgO = parcelRequire("csLgO");
const $3027233bd8f3518d$export$8b6c493f34b243fb = (0, $bMm60.createEntry)((0, $5HIvu.legacyJsdWidgetsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("5HIvu", function(module, exports) {

$parcel$export(module.exports, "legacyJsdWidgetsRoute", () => $a7daf73350a119e0$export$ecfee0d843d9f28a);

var $exb0h = parcelRequire("exb0h");
const $a7daf73350a119e0$export$ecfee0d843d9f28a = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_JSD_WIDGETS),
    path: '/servicedesk/admin/:projectKey/addon/:addonName',
    exact: true
};

});


parcelRegister("lnL58", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRouteEntry", () => $4e97dad482ab199d$export$30ce3fd3c9377561);

var $dVvIP = parcelRequire("dVvIP");

var $bMm60 = parcelRequire("bMm60");

var $lRJ0o = parcelRequire("lRJ0o");
const $4e97dad482ab199d$export$30ce3fd3c9377561 = (0, $bMm60.createEntry)((0, $lRJ0o.legacyPersonalSettingsAccessTokensRoute), {
    layout: (0, $dVvIP.globalLayout)
});

});
parcelRegister("lRJ0o", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRoute", () => $1b8c59ac6fac1704$export$49a90c7c39db3dd3);
const $1b8c59ac6fac1704$export$49a90c7c39db3dd3 = {
    name: 'legacy-personal-settings-access-tokens',
    path: '/plugins/servlet/oauth/users/access-tokens'
};

});


parcelRegister("kOwA2", function(module, exports) {

$parcel$export(module.exports, "legacyPinRouteEntry", () => $578080d9d7c30029$export$2311541dfc64683c);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $bWXWL = parcelRequire("bWXWL");
const $578080d9d7c30029$export$2311541dfc64683c = (0, $bMm60.createEntry)((0, $bWXWL.legacyPinRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("bWXWL", function(module, exports) {

$parcel$export(module.exports, "legacyPinRoute", () => $366bc5869625b0ce$export$5600fbce403620b6);

var $exb0h = parcelRequire("exb0h");
const $366bc5869625b0ce$export$5600fbce403620b6 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PIN),
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("hnGKO", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioPagesRouteEntry", () => $3cea68b1416b95fc$export$200d6f7de97d1e96);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $dSZRi = parcelRequire("dSZRi");
const $3cea68b1416b95fc$export$200d6f7de97d1e96 = (0, $bMm60.createEntry)((0, $dSZRi.legacyPortfolioPagesRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    }
});

});
parcelRegister("dSZRi", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioPagesRoute", () => $25849b12ad2d7596$export$c8591b40ac25c22d);
const $25849b12ad2d7596$export$c8591b40ac25c22d = {
    name: 'legacy-portfolio-pages',
    path: '/secure/PortfolioPlan(\\w+).jspa'
};

});


parcelRegister("eMyWM", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioTeamRouteEntry", () => $d5353213e86a4a32$export$67d1a57e72c969e);

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $bMm60 = parcelRequire("bMm60");

var $bYjLD = parcelRequire("bYjLD");
const $d5353213e86a4a32$export$67d1a57e72c969e = (0, $bMm60.createEntry)((0, $bYjLD.legacyPortfolioTeamRoute), {
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    }
});

});
parcelRegister("bYjLD", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioTeamRoute", () => $44ac43132e0b264e$export$b61cebfbe2ae0da2);
const $44ac43132e0b264e$export$b61cebfbe2ae0da2 = {
    name: 'legacy-portfolio-team',
    path: '/secure/TeamManagement.jspa'
};

});


parcelRegister("fwIzJ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesBambooRouteEntry", () => $6c73d78e221c11d9$export$929a483dcf3c101d);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ba89i = parcelRequire("ba89i");
const $6c73d78e221c11d9$export$929a483dcf3c101d = (0, $bMm60.createEntry)((0, $ba89i.legacyProjectReleasesBambooRoute), {
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    layout: (0, $d1szd.genericProjectLayout),
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("ba89i", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesBambooRoute", () => $93d4fb091abb3c29$export$df7f0213f2f22fc8);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $93d4fb091abb3c29$var$defaultSuffix = '([!%]?[\\w]*)';
const $93d4fb091abb3c29$export$df7f0213f2f22fc8 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO),
    path: `/secure/ConfigureBambooRelease${$93d4fb091abb3c29$var$defaultSuffix}.jspa`
};

});


parcelRegister("f6ROO", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesRouteEntry", () => $ff8724bbdd183c4b$export$5d0e55986ed5e2c9);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $i1u3J = parcelRequire("i1u3J");
const $ff8724bbdd183c4b$export$5d0e55986ed5e2c9 = (0, $bMm60.createEntry)((0, $i1u3J.legacyProjectReleasesRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("i1u3J", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesRoute", () => $c8af0719152a9af8$export$577b2cf03e294477);

var $exb0h = parcelRequire("exb0h");
const $c8af0719152a9af8$export$577b2cf03e294477 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_RELEASES),
    path: '/projects/:projectKey/versions/:id?'
};

});


parcelRegister("bvVvS", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $3ee9f9772a732937$export$836428e7b33b6c6c);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $a2Mbc = parcelRequire("a2Mbc");
const $3ee9f9772a732937$export$836428e7b33b6c6c = (0, $bMm60.createEntry)((0, $a2Mbc.legacyProjectReleasesNoteConfigRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("a2Mbc", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $8497a95f7932d244$export$a9509017cabb1e30);

var $exb0h = parcelRequire("exb0h");
const $8497a95f7932d244$export$a9509017cabb1e30 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG),
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("8cNTF", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $a5e0a9ebc317e415$export$781dd53d465d270d);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ey6eO = parcelRequire("ey6eO");
const $a5e0a9ebc317e415$export$781dd53d465d270d = (0, $bMm60.createEntry)((0, $ey6eO.legacyProjectReleasesNoteRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("ey6eO", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $6c876a2d72661c34$export$6ef734887b6da0c8);

var $exb0h = parcelRequire("exb0h");
const $6c876a2d72661c34$export$6ef734887b6da0c8 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE),
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("9lIwg", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRouteEntry", () => $fe8f359995aa3c68$export$256375c5bbf6166a);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $4t8bK = parcelRequire("4t8bK");
const $fe8f359995aa3c68$export$256375c5bbf6166a = (0, $bMm60.createEntry)((0, $4t8bK.legacyProjectSettingsCollectorsAddRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("4t8bK", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRoute", () => $9f6f5af84b2064e9$export$a3909b9ad3f61ae6);

var $exb0h = parcelRequire("exb0h");
const $9f6f5af84b2064e9$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $9f6f5af84b2064e9$export$a3909b9ad3f61ae6 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD),
    path: `/secure/AddCollector${$9f6f5af84b2064e9$var$defaultSuffix}.jspa`,
    query: [
        'projectKey'
    ]
};

});


parcelRegister("hvKIU", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsRouteEntry", () => $9dcc2ad88e367fc3$export$e3a7328abebdc329);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $92lza = parcelRequire("92lza");
const $9dcc2ad88e367fc3$export$e3a7328abebdc329 = (0, $bMm60.createEntry)((0, $92lza.legacyProjectSettingsCollectorsRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("92lza", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsRoute", () => $4ea7caa463c6923a$export$956a041d0b6694e3);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $4ea7caa463c6923a$var$defaultSuffix = '([!%]?[\\w]*)';
const $4ea7caa463c6923a$export$956a041d0b6694e3 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS),
    path: `/secure/ViewCollectors${$4ea7caa463c6923a$var$defaultSuffix}.jspa`,
    query: [
        'projectKey'
    ]
};

});


parcelRegister("9NqLg", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRouteEntry", () => $a75c59db1d55953d$export$10edcec0926752a6);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $6VS9S = parcelRequire("6VS9S");
const $a75c59db1d55953d$export$10edcec0926752a6 = (0, $bMm60.createEntry)((0, $6VS9S.legacyProjectSettingsCollectorsHelpRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("6VS9S", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRoute", () => $16bdf1251b897e08$export$7433cef5cafafb17);

var $exb0h = parcelRequire("exb0h");
const $16bdf1251b897e08$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $16bdf1251b897e08$export$7433cef5cafafb17 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP),
    path: `/secure/InsertCollectorHelp${$16bdf1251b897e08$var$defaultSuffix}.jspa`,
    query: [
        'projectKey'
    ]
};

});


parcelRegister("8nnEW", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRouteEntry", () => $95371a2133181030$export$7b10472641e87ea);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $d8EQ0 = parcelRequire("d8EQ0");
const $95371a2133181030$export$7b10472641e87ea = (0, $bMm60.createEntry)((0, $d8EQ0.legacyProjectSettingsCollectorsViewRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("d8EQ0", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRoute", () => $b8efc083d2633cbc$export$c3f8831257e68c5a);

var $exb0h = parcelRequire("exb0h");
const $b8efc083d2633cbc$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $b8efc083d2633cbc$export$c3f8831257e68c5a = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW),
    path: `/secure/ViewCollector${$b8efc083d2633cbc$var$defaultSuffix}.jspa`,
    query: [
        'projectKey'
    ]
};

});


parcelRegister("1knqj", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsConfigRouteEntry", () => $6067306fc852e4fa$export$3c4ea5135028082);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $eanaU = parcelRequire("eanaU");
const $6067306fc852e4fa$export$3c4ea5135028082 = (0, $bMm60.createEntry)((0, $eanaU.legacyProjectSettingsConfigRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("eanaU", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsConfigRoute", () => $cfc6596238101f7e$export$3403c95bb82037b2);

var $exb0h = parcelRequire("exb0h");
const $cfc6596238101f7e$export$3403c95bb82037b2 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG),
    path: '/plugins/servlet/project-config/:projectKey/:adminOption'
};

});


parcelRegister("70v59", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDeleteRouteEntry", () => $be41549fea800f71$export$f5fadab402705bc4);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $b1Xsd = parcelRequire("b1Xsd");
const $be41549fea800f71$export$f5fadab402705bc4 = (0, $bMm60.createEntry)((0, $b1Xsd.legacyProjectSettingsDeleteRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("b1Xsd", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDeleteRoute", () => $1f3c3a567f8fea4c$export$4e8f3a153f80bfa1);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $1f3c3a567f8fea4c$var$secure = '(/secure/|/)';
const $1f3c3a567f8fea4c$var$defaultSuffix = '([!%]?[\\w]*)';
const $1f3c3a567f8fea4c$export$4e8f3a153f80bfa1 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE),
    path: `${$1f3c3a567f8fea4c$var$secure}project/DeleteProject${$1f3c3a567f8fea4c$var$defaultSuffix}.jspa`,
    query: [
        'pid'
    ]
};

});


parcelRegister("4EwNb", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDevRouteEntry", () => $7a98ad58393e41c5$export$bb5131b6203b8f3a);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $7SspY = parcelRequire("7SspY");
const $7a98ad58393e41c5$export$bb5131b6203b8f3a = (0, $bMm60.createEntry)((0, $7SspY.legacyProjectSettingsDevRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("7SspY", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDevRoute", () => $265adb54c46b8d1e$export$d3fca8ea951ff47f);

var $exb0h = parcelRequire("exb0h");
const $265adb54c46b8d1e$export$d3fca8ea951ff47f = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV),
    path: '/secure/ConfigureDevStatus.jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("b4PHH", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsEditRouteEntry", () => $4eb66e875b57b640$export$1b930b1155c7c95d);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $cbDJX = parcelRequire("cbDJX");
const $4eb66e875b57b640$export$1b930b1155c7c95d = (0, $bMm60.createEntry)((0, $cbDJX.legacyProjectSettingsEditRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("cbDJX", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsEditRoute", () => $484aee577d4e2fb0$export$69813bfb3aa0feb9);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $484aee577d4e2fb0$var$secure = '(/secure/|/)';
const $484aee577d4e2fb0$var$defaultSuffix = '([!%]?[\\w]*)';
const $484aee577d4e2fb0$export$69813bfb3aa0feb9 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT),
    path: `${$484aee577d4e2fb0$var$secure}project/EditProject${$484aee577d4e2fb0$var$defaultSuffix}.jspa`,
    query: [
        'pid'
    ]
};

});


parcelRegister("f6hR4", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsRouteEntry", () => $4390e33746298a5e$export$cf5230efac88ec18);
$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRouteEntry", () => $4390e33746298a5e$export$c7cd1115d3e90593);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $eYZlP = parcelRequire("eYZlP");
const $4390e33746298a5e$export$cf5230efac88ec18 = (0, $bMm60.createEntry)((0, $eYZlP.legacyProjectSettingsFieldsRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $4390e33746298a5e$export$c7cd1115d3e90593 = (0, $bMm60.createEntry)((0, $eYZlP.legacyProjectSettingsFieldsAssociateRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("eYZlP", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsRoute", () => $ec579b46db6c4b5c$export$f8d801c531c09b6e);
$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRoute", () => $ec579b46db6c4b5c$export$b45ad52ceda09b54);

var $exb0h = parcelRequire("exb0h");
const $ec579b46db6c4b5c$export$f8d801c531c09b6e = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
    path: '/plugins/servlet/project-config/:projectKey/fields'
};
const $ec579b46db6c4b5c$export$b45ad52ceda09b54 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE),
    path: '/secure/admin/SelectFieldLayoutScheme!default.jspa'
};

});


parcelRegister("lJ4T7", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRouteEntry", () => $68e0f5fd44d782df$export$ba112336170e9374);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $30FfU = parcelRequire("30FfU");
const $68e0f5fd44d782df$export$ba112336170e9374 = (0, $bMm60.createEntry)((0, $30FfU.legacyProjectSettingsIssueLayoutRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("30FfU", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRoute", () => $1caa37954d396a56$export$b9490f2a02690c81);

var $exb0h = parcelRequire("exb0h");
const $1caa37954d396a56$export$b9490f2a02690c81 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT),
    path: '/plugins/servlet/project-config/:projectKey/issuelayout'
};

});


parcelRegister("bX7PX", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRouteEntry", () => $51919a1046981f9c$export$50c072825de9f7ec);
$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRouteEntry", () => $51919a1046981f9c$export$31f276ec8affeb65);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $7WQZX = parcelRequire("7WQZX");
const $51919a1046981f9c$export$50c072825de9f7ec = (0, $bMm60.createEntry)((0, $7WQZX.legacyProjectSettingsIssueSecurityRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $51919a1046981f9c$export$31f276ec8affeb65 = (0, $bMm60.createEntry)((0, $7WQZX.legacyProjectSettingsIssueSecurityAssociateRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("7WQZX", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRoute", () => $2b55d4d7eb786b07$export$71aa1b769739b378);
$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRoute", () => $2b55d4d7eb786b07$export$8fb428d7ca4ce850);

var $exb0h = parcelRequire("exb0h");
const $2b55d4d7eb786b07$export$71aa1b769739b378 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
    path: '/plugins/servlet/project-config/:projectKey/issuesecurity'
};
const $2b55d4d7eb786b07$var$defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
const $2b55d4d7eb786b07$export$8fb428d7ca4ce850 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE),
    path: `/secure/project/SelectProjectIssueSecurityScheme${$2b55d4d7eb786b07$var$defaultSuffix}.jspa`
};

});


parcelRegister("19Ry0", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRouteEntry", () => $3c1d9e873eee1eb1$export$664d9bccf509eab1);
$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRouteEntry", () => $3c1d9e873eee1eb1$export$997736bd2e54a14b);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $e2pRZ = parcelRequire("e2pRZ");
const $3c1d9e873eee1eb1$export$664d9bccf509eab1 = (0, $bMm60.createEntry)((0, $e2pRZ.legacyProjectSettingsIssueTypesRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $3c1d9e873eee1eb1$export$997736bd2e54a14b = (0, $bMm60.createEntry)((0, $e2pRZ.legacyProjectSettingsIssueTypesAssociateRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("e2pRZ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRoute", () => $35a6244fd28f14de$export$f22d4a1fbe6ce2d);
$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRoute", () => $35a6244fd28f14de$export$64a3a3a4a9e32ab2);

var $exb0h = parcelRequire("exb0h");
const $35a6244fd28f14de$export$f22d4a1fbe6ce2d = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
    path: '/plugins/servlet/project-config/:projectKey/issuetypes'
};
const $35a6244fd28f14de$export$64a3a3a4a9e32ab2 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE),
    path: '/secure/admin/SelectIssueTypeSchemeForProject!default.jspa'
};

});


parcelRegister("axsmw", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsRouteEntry", () => $3badf948f3cf9405$export$ec9c71381b367931);
$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRouteEntry", () => $3badf948f3cf9405$export$756ebd18bdb87829);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $gI48O = parcelRequire("gI48O");
const $3badf948f3cf9405$export$ec9c71381b367931 = (0, $bMm60.createEntry)((0, $gI48O.legacyProjectSettingsNotificationsRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $3badf948f3cf9405$export$756ebd18bdb87829 = (0, $bMm60.createEntry)((0, $gI48O.legacyProjectSettingsNotificationsAssociateRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("gI48O", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsRoute", () => $20b6885cf23c495b$export$3053634181f5a1e4);
$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRoute", () => $20b6885cf23c495b$export$c3b586e70bfcdfe);

var $exb0h = parcelRequire("exb0h");
const $20b6885cf23c495b$export$3053634181f5a1e4 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
    path: '/plugins/servlet/project-config/:projectKey/notifications'
};
const $20b6885cf23c495b$export$c3b586e70bfcdfe = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE),
    path: '/secure/project/SelectProjectScheme!default.jspa'
};

});


parcelRegister("klGsW", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRouteEntry", () => $278e9740fe9c283c$export$a0ee66fa0f02ab9a);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $7YzEu = parcelRequire("7YzEu");
const $278e9740fe9c283c$export$a0ee66fa0f02ab9a = (0, $bMm60.createEntry)((0, $7YzEu.legacyProjectSettingsOpsgenieRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("7YzEu", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRoute", () => $a70fcfdf0225eea2$export$9bc923c0dc9a3144);

var $exb0h = parcelRequire("exb0h");
const $a70fcfdf0225eea2$export$9bc923c0dc9a3144 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE),
    path: '/plugins/servlet/project-config/:projectKey/opsgenie'
};

});


parcelRegister("bo5BL", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPeopleRouteEntry", () => $a21e0f6e8c048da0$export$a3355a805216689d);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $bCmyq = parcelRequire("bCmyq");

var $eHv6O = parcelRequire("eHv6O");
const $a21e0f6e8c048da0$export$a3355a805216689d = (0, $bMm60.createEntry)((0, $eHv6O.legacyProjectSettingsPeopleRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    component: (0, $bCmyq.LegacyPage),
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("eHv6O", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPeopleRoute", () => $8b676e1d514366fb$export$69b69c5831576686);

var $exb0h = parcelRequire("exb0h");
const $8b676e1d514366fb$export$69b69c5831576686 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
    path: '/plugins/servlet/project-config/:projectKey/people'
};

});


parcelRegister("2WzSD", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPermissionsRouteEntry", () => $a684ec7e8108318f$export$f941d7668bb5b4b9);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $bCmyq = parcelRequire("bCmyq");

var $lWUk8 = parcelRequire("lWUk8");
const $a684ec7e8108318f$export$f941d7668bb5b4b9 = (0, $bMm60.createEntry)((0, $lWUk8.legacyProjectSettingsPermissionsRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    component: (0, $bCmyq.LegacyPage),
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("lWUk8", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPermissionsRoute", () => $798d9c0d496e58a9$export$e5e3b10fbd5b967);

var $exb0h = parcelRequire("exb0h");
const $798d9c0d496e58a9$export$e5e3b10fbd5b967 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
    path: '/plugins/servlet/project-config/:projectKey/permissions'
};

});


parcelRegister("8ouYC", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensRouteEntry", () => $e587b7d76d549de1$export$f0c4185be35123a4);
$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRouteEntry", () => $e587b7d76d549de1$export$c4a7c46acad95724);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $lpoNX = parcelRequire("lpoNX");
const $e587b7d76d549de1$export$f0c4185be35123a4 = (0, $bMm60.createEntry)((0, $lpoNX.legacyProjectSettingsScreensRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $e587b7d76d549de1$export$c4a7c46acad95724 = (0, $bMm60.createEntry)((0, $lpoNX.legacyProjectSettingsScreensAssociateRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("lpoNX", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensRoute", () => $431c50c1d5d5ae62$export$a132d85f94cbc75c);
$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRoute", () => $431c50c1d5d5ae62$export$e97df9c9d8af2495);

var $exb0h = parcelRequire("exb0h");
const $431c50c1d5d5ae62$export$a132d85f94cbc75c = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
    path: '/plugins/servlet/project-config/:projectKey/screens'
};
const $431c50c1d5d5ae62$export$e97df9c9d8af2495 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE),
    path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa'
};

});


parcelRegister("eZ0Ne", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsSummaryRouteEntry", () => $8518f445d1a0722e$export$b79434e4cc24dab2);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $7ajVP = parcelRequire("7ajVP");
const $8518f445d1a0722e$export$b79434e4cc24dab2 = (0, $bMm60.createEntry)((0, $7ajVP.legacyProjectSettingsSummaryRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("7ajVP", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsSummaryRoute", () => $e9bb13b668d1a621$export$2c4b88224ff6b238);

var $exb0h = parcelRequire("exb0h");
const $e9bb13b668d1a621$export$2c4b88224ff6b238 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY),
    path: '/plugins/servlet/project-config/:projectKey/summary'
};

});


parcelRegister("hScXQ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRouteEntry", () => $854faf6b0df2a486$export$a69fefbe6504422d);
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRouteEntry", () => $854faf6b0df2a486$export$496170aba3d2c90a);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $4jwB8 = parcelRequire("4jwB8");
const $854faf6b0df2a486$export$a69fefbe6504422d = (0, $bMm60.createEntry)((0, $4jwB8.legacyProjectSettingsWorkflowsRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});
const $854faf6b0df2a486$export$496170aba3d2c90a = (0, $bMm60.createEntry)((0, $4jwB8.legacyProjectSettingsWorkflowsAssociateRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        horizontal: (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        sidebarId: (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("4jwB8", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $9e36619d2743d769$export$b03606cedffdadf6);
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRoute", () => $9e36619d2743d769$export$c70512e2d6fd53d);

var $exb0h = parcelRequire("exb0h");
const $9e36619d2743d769$export$b03606cedffdadf6 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};
const $9e36619d2743d769$export$c70512e2d6fd53d = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
    path: '/secure/project/SelectProjectWorkflowScheme!default.jspa'
};

});


parcelRegister("dwp5N", function(module, exports) {

$parcel$export(module.exports, "legacyReportsAverageAgeRouteEntry", () => $49dca3d1f99d8460$export$dae04c73273ef29a);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $3tI8K = parcelRequire("3tI8K");

var $77gHI = parcelRequire("77gHI");
const $49dca3d1f99d8460$export$dae04c73273ef29a = (0, $bMm60.createEntry)((0, $3tI8K.legacyReportsAverageAgeRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $77gHI.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("3tI8K", function(module, exports) {

$parcel$export(module.exports, "legacyReportsAverageAgeRoute", () => $3313e428e040ed35$export$b40e93dd1042f869);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $3313e428e040ed35$var$defaultSuffix = '([!%]?[\\w]*)';
const $3313e428e040ed35$export$b40e93dd1042f869 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE),
    path: `/secure/ConfigureReport${$3313e428e040ed35$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:averageage-report'
    ]
};

});

parcelRegister("77gHI", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $d5dec71111ee8902$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $d5dec71111ee8902$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d5dec71111ee8902$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("jKTLS", function(module, exports) {

$parcel$export(module.exports, "legacyReportsConfigRouteEntry", () => $6c2d7d25ed601ccf$export$6dee3bbbe4ff04f);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $jsKrh = parcelRequire("jsKrh");

var $lVwvD = parcelRequire("lVwvD");
const $6c2d7d25ed601ccf$export$6dee3bbbe4ff04f = (0, $bMm60.createEntry)((0, $jsKrh.legacyReportsConfigRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $lVwvD.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("jsKrh", function(module, exports) {

$parcel$export(module.exports, "legacyReportsConfigRoute", () => $609b06137e46164a$export$b2ef61435fecef69);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $609b06137e46164a$var$defaultSuffix = '([!%]?[\\w]*)';
const $609b06137e46164a$export$b2ef61435fecef69 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_CONFIG),
    path: `/secure/ConfigureReport${$609b06137e46164a$var$defaultSuffix}.jspa`,
    query: [
        'reportKey'
    ]
};

});

parcelRegister("lVwvD", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $b4e3448651b8e202$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $b4e3448651b8e202$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $b4e3448651b8e202$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("bpapD", function(module, exports) {

$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRouteEntry", () => $41aca0e170a385fa$export$b2ed165752bdb8e5);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $k1Axx = parcelRequire("k1Axx");

var $aFGRw = parcelRequire("aFGRw");
const $41aca0e170a385fa$export$b2ed165752bdb8e5 = (0, $bMm60.createEntry)((0, $k1Axx.legacyReportsCreatedVsResolvedRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $aFGRw.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("k1Axx", function(module, exports) {

$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRoute", () => $4f36f46ca3cc3379$export$832846047e142646);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $4f36f46ca3cc3379$var$defaultSuffix = '([!%]?[\\w]*)';
const $4f36f46ca3cc3379$export$832846047e142646 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED),
    path: `/secure/ConfigureReport${$4f36f46ca3cc3379$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report'
    ]
};

});

parcelRegister("aFGRw", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $1ef25842fc260fe3$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $1ef25842fc260fe3$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $1ef25842fc260fe3$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("dyqXz", function(module, exports) {

$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRouteEntry", () => $764541c456106863$export$29e29cddbc430ebe);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $hYK3V = parcelRequire("hYK3V");

var $kXWJR = parcelRequire("kXWJR");
const $764541c456106863$export$29e29cddbc430ebe = (0, $bMm60.createEntry)((0, $hYK3V.legacyReportsDeveloperWorkloadRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $kXWJR.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("hYK3V", function(module, exports) {

$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRoute", () => $48abdbcaf1e61d8f$export$a64e86bcf65b3432);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $48abdbcaf1e61d8f$var$defaultSuffix = '([!%]?[\\w]*)';
const $48abdbcaf1e61d8f$export$a64e86bcf65b3432 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD),
    path: `/secure/ConfigureReport${$48abdbcaf1e61d8f$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:developer-workload'
    ]
};

});

parcelRegister("kXWJR", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $85e69ad3e006938f$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $85e69ad3e006938f$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $85e69ad3e006938f$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("aXK8E", function(module, exports) {

$parcel$export(module.exports, "legacyReportsPieRouteEntry", () => $71a34ee7b4f05e86$export$fd3a1495328fefba);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $dJI8I = parcelRequire("dJI8I");

var $denDZ = parcelRequire("denDZ");
const $71a34ee7b4f05e86$export$fd3a1495328fefba = (0, $bMm60.createEntry)((0, $dJI8I.legacyReportsPieRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $denDZ.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("dJI8I", function(module, exports) {

$parcel$export(module.exports, "legacyReportsPieRoute", () => $1965382436c6f476$export$327da6ce208593c2);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $1965382436c6f476$var$defaultSuffix = '([!%]?[\\w]*)';
const $1965382436c6f476$export$327da6ce208593c2 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_PIE),
    path: `/secure/ConfigureReport${$1965382436c6f476$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:pie-report'
    ]
};

});

parcelRegister("denDZ", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $39213eb6d135d44e$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $39213eb6d135d44e$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $39213eb6d135d44e$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("dqn9u", function(module, exports) {

$parcel$export(module.exports, "legacyReportsRecentlyCreatedRouteEntry", () => $c452c79dc5021a90$export$666b8efa07780ffb);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $3BhAp = parcelRequire("3BhAp");

var $9ITlz = parcelRequire("9ITlz");
const $c452c79dc5021a90$export$666b8efa07780ffb = (0, $bMm60.createEntry)((0, $3BhAp.legacyReportsRecentlyCreatedRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $9ITlz.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("3BhAp", function(module, exports) {

$parcel$export(module.exports, "legacyReportsRecentlyCreatedRoute", () => $4e2416917b3956a4$export$f81f42a6de9ebb5a);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $4e2416917b3956a4$var$defaultSuffix = '([!%]?[\\w]*)';
const $4e2416917b3956a4$export$f81f42a6de9ebb5a = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED),
    path: `/secure/ConfigureReport${$4e2416917b3956a4$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'
    ]
};

});

parcelRegister("9ITlz", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $1b92a083ee9d029b$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $1b92a083ee9d029b$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $1b92a083ee9d029b$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("iyauW", function(module, exports) {

$parcel$export(module.exports, "legacyReportsResolutionTimeRouteEntry", () => $c3e22a722c5d115f$export$53c5b89c8f6f5d76);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $3IvA9 = parcelRequire("3IvA9");

var $kH5JI = parcelRequire("kH5JI");
const $c3e22a722c5d115f$export$53c5b89c8f6f5d76 = (0, $bMm60.createEntry)((0, $3IvA9.legacyReportsResolutionTimeRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $kH5JI.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("3IvA9", function(module, exports) {

$parcel$export(module.exports, "legacyReportsResolutionTimeRoute", () => $e963b37adfd30fea$export$c27dcd4a756d7860);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $e963b37adfd30fea$var$defaultSuffix = '([!%]?[\\w]*)';
const $e963b37adfd30fea$export$c27dcd4a756d7860 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME),
    path: `/secure/ConfigureReport${$e963b37adfd30fea$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report'
    ]
};

});

parcelRegister("kH5JI", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $2c36629be08d49dd$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $2c36629be08d49dd$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $2c36629be08d49dd$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("04owV", function(module, exports) {

$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRouteEntry", () => $dcd579a12fbb8c66$export$80cd34d8b30c9fff);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $1auKk = parcelRequire("1auKk");

var $9ijo9 = parcelRequire("9ijo9");
const $dcd579a12fbb8c66$export$80cd34d8b30c9fff = (0, $bMm60.createEntry)((0, $1auKk.legacyReportsSingleLevelGroupByRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $9ijo9.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("1auKk", function(module, exports) {

$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRoute", () => $c9e3b7f7e3a50a06$export$4b7de6966d0318ae);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $c9e3b7f7e3a50a06$var$defaultSuffix = '([!%]?[\\w]*)';
const $c9e3b7f7e3a50a06$export$4b7de6966d0318ae = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY),
    path: `/secure/ConfigureReport${$c9e3b7f7e3a50a06$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby'
    ]
};

});

parcelRegister("9ijo9", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $ca11ab5f0f4310a8$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $ca11ab5f0f4310a8$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $ca11ab5f0f4310a8$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("9p0FM", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeSinceRouteEntry", () => $d114b78d7fe6159c$export$c0837717e37bba3b);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $l3V8F = parcelRequire("l3V8F");

var $70opO = parcelRequire("70opO");
const $d114b78d7fe6159c$export$c0837717e37bba3b = (0, $bMm60.createEntry)((0, $l3V8F.legacyReportsTimeSinceRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $70opO.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("l3V8F", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeSinceRoute", () => $d1a5eaa7cb2d5652$export$e9d8f7977a3e63a8);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $d1a5eaa7cb2d5652$var$defaultSuffix = '([!%]?[\\w]*)';
const $d1a5eaa7cb2d5652$export$e9d8f7977a3e63a8 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE),
    path: `/secure/ConfigureReport${$d1a5eaa7cb2d5652$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:timesince-report'
    ]
};

});

parcelRegister("70opO", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $7f6090ae537ef499$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $7f6090ae537ef499$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $7f6090ae537ef499$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("gcyh1", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeTrackingReportRouteEntry", () => $7243106548543aa9$export$d911abc03d9aac0e);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $eDpJE = parcelRequire("eDpJE");

var $2VAa4 = parcelRequire("2VAa4");
const $7243106548543aa9$export$d911abc03d9aac0e = (0, $bMm60.createEntry)((0, $eDpJE.legacyReportsTimeTrackingReportRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $2VAa4.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("eDpJE", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeTrackingReportRoute", () => $107659b2aaa4a790$export$5c05df6c5a65a436);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $107659b2aaa4a790$var$defaultSuffix = '([!%]?[\\w]*)';
const $107659b2aaa4a790$export$5c05df6c5a65a436 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT),
    path: `/secure/ConfigureReport${$107659b2aaa4a790$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:time-tracking'
    ]
};

});

parcelRegister("2VAa4", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $10dcc718c102e7a9$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $10dcc718c102e7a9$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $10dcc718c102e7a9$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("2NNzt", function(module, exports) {

$parcel$export(module.exports, "legacyReportsVersionWorkloadRouteEntry", () => $083c904fe7a2744f$export$225a265884367582);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $I3qZA = parcelRequire("I3qZA");

var $2pYEg = parcelRequire("2pYEg");
const $083c904fe7a2744f$export$225a265884367582 = (0, $bMm60.createEntry)((0, $I3qZA.legacyReportsVersionWorkloadRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $2pYEg.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("I3qZA", function(module, exports) {

$parcel$export(module.exports, "legacyReportsVersionWorkloadRoute", () => $09a52e05c25ed6e0$export$b7a951738ffd54ac);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $09a52e05c25ed6e0$var$defaultSuffix = '([!%]?[\\w]*)';
const $09a52e05c25ed6e0$export$b7a951738ffd54ac = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD),
    path: `/secure/ConfigureReport${$09a52e05c25ed6e0$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'
    ]
};

});

parcelRegister("2pYEg", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $687670038ac5656a$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $687670038ac5656a$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $687670038ac5656a$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("iWHQ4", function(module, exports) {

$parcel$export(module.exports, "legacyReportsWorkloadPieRouteEntry", () => $e16c6151b4733c88$export$371af7520206fe98);

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $bMm60 = parcelRequire("bMm60");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $29N2l = parcelRequire("29N2l");

var $k3LYt = parcelRequire("k3LYt");
const $e16c6151b4733c88$export$371af7520206fe98 = (0, $bMm60.createEntry)((0, $29N2l.legacyReportsWorkloadPieRoute), {
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $k3LYt.getReportsCommonResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});

});
parcelRegister("29N2l", function(module, exports) {

$parcel$export(module.exports, "legacyReportsWorkloadPieRoute", () => $e1c2327d61f90c0a$export$e8a2e4a5ccbbeff6);
// like !default / !edit / %21viewLogs

var $exb0h = parcelRequire("exb0h");
const $e1c2327d61f90c0a$var$defaultSuffix = '([!%]?[\\w]*)';
const $e1c2327d61f90c0a$export$e8a2e4a5ccbbeff6 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE),
    path: `/secure/ConfigureReport${$e1c2327d61f90c0a$var$defaultSuffix}.jspa`,
    query: [
        'reportKey=com.atlassian.jira.ext.charting:workloadpie-report'
    ]
};

});

parcelRegister("k3LYt", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $4a0f6e545a70e2ea$export$8cb713295e6b7204);

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $4a0f6e545a70e2ea$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $4a0f6e545a70e2ea$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("19aSV", function(module, exports) {

$parcel$export(module.exports, "workflowDesignerRouteEntry", () => $b67ef914adf99df2$export$5863c71049541219);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $4JtEo = parcelRequire("4JtEo");

var $bMm60 = parcelRequire("bMm60");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $bCmyq = parcelRequire("bCmyq");

var $3NgHf = parcelRequire("3NgHf");

var $jQbsE = parcelRequire("jQbsE");
const $b67ef914adf99df2$export$5863c71049541219 = (0, $bMm60.createEntry)((0, $3NgHf.workflowDesignerRoute), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsm-new-workflow-editor-preference') && (0, $1ybV0.ff)('pce.helix.admin-pages.edit-workflow-page'), (0, $jQbsE.LegacyWorkflowDesigner), (0, $bCmyq.LegacyPage)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebarId: (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)()
    ]
});

});
parcelRegister("9zysr", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $cbf8ee3071697856$export$6e8ea24b15199873);

var $eUqFw = parcelRequire("eUqFw");
function $cbf8ee3071697856$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("3NgHf", function(module, exports) {

$parcel$export(module.exports, "workflowDesignerRoute", () => $058552c8cc3e8c0a$export$7cd61529f5fa5e43);

var $exb0h = parcelRequire("exb0h");
const $058552c8cc3e8c0a$export$7cd61529f5fa5e43 = {
    name: (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
    path: '/secure/admin/(workflows/|)(WorkflowDesigner|ViewWorkflowSteps).jspa'
};

});

parcelRegister("jQbsE", function(module, exports) {

$parcel$export(module.exports, "LegacyWorkflowDesigner", () => $cbd09863a253defd$export$c264c6032a3fa865);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $0cdA8 = parcelRequire("0cdA8");

var $bKxX9 = parcelRequire("bKxX9");

var $bCmyq = parcelRequire("bCmyq");

var $gL6Dw = parcelRequire("gL6Dw");
const $cbd09863a253defd$export$c264c6032a3fa865 = (props)=>{
    const elm = document.getElementById('workflow-editor-preference-dropdown');
    const workflowId = elm?.getAttribute('data-workflow-id') ?? '';
    const workflowName = elm?.getAttribute('data-workflow-name') ?? '';
    const editMode = elm?.getAttribute('data-edit-mode') ?? undefined;
    if ((0, $bKxX9.ff)('jsm-error-boundary-default-workflow-editor-dialog_aq32n')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jsm-dropdown-error-boundary",
        packageName: "jiraRouterRoutesLegacyWorkflowDesignerEntries",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCmyq.LegacyPage), props), elm && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gL6Dw.WorkflowEditorPreferenceDropdown), {
        workflowId: workflowId,
        workflowName: workflowName,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        editMode: editMode
    }), elm));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCmyq.LegacyPage), props), elm && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gL6Dw.WorkflowEditorPreferenceDropdown), {
        workflowId: workflowId,
        workflowName: workflowName,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        editMode: editMode
    }), elm));
};

});
parcelRegister("gL6Dw", function(module, exports) {

$parcel$export(module.exports, "WorkflowEditorPreferenceDropdown", () => $c7f7db36dea48a4b$export$7194565c2a06a25d);
$parcel$export(module.exports, "DefaultWorkflowEditorDialog", () => (parcelRequire("2Zc3E")).DefaultWorkflowEditorDialog);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hu4Cz = parcelRequire("hu4Cz");

var $576pI = parcelRequire("576pI");

var $jJKsA = parcelRequire("jJKsA");

var $2Zc3E = parcelRequire("2Zc3E");

var $bURS7 = parcelRequire("bURS7");
const $c7f7db36dea48a4b$export$7194565c2a06a25d = ({ workflowId: workflowId, workflowName: workflowName, editMode: editMode })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showDialog, setShowDialog] = (0, $eUqFw.useState)(false);
    const openDialog = ()=>setShowDialog(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Show flag when show old editor flag is true in session storage
    (0, $jJKsA.useChangeToOldEditorSuccessFlag)({
        openDefaultEditorDialog: openDialog
    });
    const fireTrackEvent = (0, $eUqFw.useCallback)((mode)=>{
        const dropdownItemClickEvent = createAnalyticsEvent({
            action: 'click',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(dropdownItemClickEvent, 'workflowEditorToolbarNewEditorLink', {
            workflowLegacyEditMode: mode === 'draft' ? 'Draft' : 'Live'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "workflow-editor-preference-settings.ui.dropdown-menu",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7f7db36dea48a4b$var$LegacyButtonText, null, formatMessage((0, $bURS7.default).switchEditorButton)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        href: (0, $hu4Cz.getNewEditorLink)(workflowId),
        onClick: ()=>fireTrackEvent(editMode),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $bURS7.default).openInNewEditor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: openDialog
    }, formatMessage((0, $bURS7.default).changeDefaultEditor)))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Zc3E.DefaultWorkflowEditorDialog), {
        workflowName: workflowName,
        workflowId: workflowId,
        workflowPublicationStatus: editMode === 'draft' ? (0, $576pI.WorkflowPublicationStatus).Draft : (0, $576pI.WorkflowPublicationStatus).Live,
        onClose: ()=>setShowDialog(false),
        onOpenDefaultEditorDialog: openDialog
    }));
};
const $c7f7db36dea48a4b$var$LegacyButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("hu4Cz", function(module, exports) {

$parcel$export(module.exports, "isRuleTypeConstrainedByProductOrScope", () => $30ba659eedf20c82$export$b5fede90e3f809d6);
$parcel$export(module.exports, "isRuleTypeConstrainedByTransition", () => $30ba659eedf20c82$export$5a818ed7c804c8f1);
$parcel$export(module.exports, "isRuleTypeConstrainedByAnotherRule", () => $30ba659eedf20c82$export$5ddc27f97380bfae);
$parcel$export(module.exports, "orderStatusesByCategoryAndName", () => $30ba659eedf20c82$export$2068d124b6d003c3);
$parcel$export(module.exports, "getLegacyEditorLink", () => $30ba659eedf20c82$export$ff5bc033c9b0efb4);
$parcel$export(module.exports, "getNewEditorLink", () => $30ba659eedf20c82$export$540456165b615498);
$parcel$export(module.exports, "openLegacyEditor", () => $30ba659eedf20c82$export$766368a57fd33bad);
$parcel$export(module.exports, "buildEditWorkflowJSPUrl", () => $30ba659eedf20c82$export$2e17b62c233ea33b);
$parcel$export(module.exports, "conditionallyNarrowType", () => $30ba659eedf20c82$export$1a907429044213b9);

var $3G3gn = parcelRequire("3G3gn");

var $53ciZ = parcelRequire("53ciZ");

var $5zSUY = parcelRequire("5zSUY");

var $8T7GM = parcelRequire("8T7GM");
const $30ba659eedf20c82$export$b5fede90e3f809d6 = (ruleType, projectType, appEdition, scope)=>{
    if (scope === (0, $8T7GM.SCOPE_GLOBAL)) return !ruleType.constraints.scope.includes(scope);
    // @ts-expect-error - TS2345 - Argument of type '"PROJECT" | undefined' is not assignable to parameter of type 'WorkflowScope'.
    if (!ruleType.constraints.scope.includes(scope)) return true;
    const compatibleProductConstraint = ruleType.constraints.compatibleProducts.find((product)=>product.type === projectType);
    // If compatibleProductConstraint is not found, the rule type will be constrained
    return compatibleProductConstraint ? !compatibleProductConstraint.editions.includes(appEdition) : true;
};
const $30ba659eedf20c82$export$5a818ed7c804c8f1 = (ruleType, transition)=>transition ? !ruleType.constraints.availableForInitial && transition.type === (0, $8T7GM.transitionType).INITIAL : false;
const $30ba659eedf20c82$export$5ddc27f97380bfae = (ruleType, rules)=>rules.some((rule)=>ruleType.constraints.incompatibleRules.some((constraint)=>rule.ruleKey === constraint.qualifiedKey));
const $30ba659eedf20c82$export$2068d124b6d003c3 = (statuses)=>(0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(statuses, [
        (status)=>(0, $8T7GM.STATUS_CATEGORY_WEIGHTS)[status.statusCategory],
        'name'
    ]);
const $30ba659eedf20c82$export$ff5bc033c9b0efb4 = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?workflowMode=live&wfName=${encodeURIComponent(workflowName)}`;
const $30ba659eedf20c82$export$540456165b615498 = (workflowId)=>`/jira/settings/issues/workflows/${workflowId}`;
const $30ba659eedf20c82$export$766368a57fd33bad = (workflowName)=>{
    const url = $30ba659eedf20c82$export$ff5bc033c9b0efb4(workflowName);
    window.location.href = url;
};
const $30ba659eedf20c82$export$2e17b62c233ea33b = (workflowName)=>`/secure/admin/workflows/EditWorkflowDispatcher.jspa?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        atl_token: (0, $5zSUY.default)(),
        wfName: workflowName
    })}`;
const $30ba659eedf20c82$export$1a907429044213b9 = (value, condition)=>condition;

});
parcelRegister("8T7GM", function(module, exports) {

$parcel$export(module.exports, "START_NODE_ID", () => $70b075ae0428a910$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $70b075ae0428a910$export$331d6399b2e33350);
$parcel$export(module.exports, "transitionIcon", () => $70b075ae0428a910$export$bb55b5bf71d8edff);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $70b075ae0428a910$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $70b075ae0428a910$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $70b075ae0428a910$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $70b075ae0428a910$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $70b075ae0428a910$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $70b075ae0428a910$export$927c560a42a52ce0);

var $8Qd0L = parcelRequire("8Qd0L");
const $70b075ae0428a910$export$e117396b0784c7cc = 'START';
const $70b075ae0428a910$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $70b075ae0428a910$export$bb55b5bf71d8edff = {
    BOLT: 'bolt',
    ERROR: 'error',
    CHECK: 'check',
    CHECK_INACTIVE: 'check_inactive',
    CROSS: 'cross',
    CROSS_INACTIVE: 'cross_inactive'
};
const $70b075ae0428a910$export$9bb188cec3fcc43d = 'GLOBAL';
const $70b075ae0428a910$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $70b075ae0428a910$export$d3dc8e33b7258fc5 = 'ALL';
const $70b075ae0428a910$export$8fc40e3c53b7f30e = {
    [(0, $8Qd0L.TODO)]: 1,
    [(0, $8Qd0L.IN_PROGRESS)]: 2,
    [(0, $8Qd0L.DONE)]: 3,
    [(0, $8Qd0L.UNDEFINED)]: 4
};
const $70b075ae0428a910$export$804f62993e553350 = 'ANY';
const $70b075ae0428a910$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};

});
parcelRegister("8Qd0L", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e7c4cf297fb3917f$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e7c4cf297fb3917f$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e7c4cf297fb3917f$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e7c4cf297fb3917f$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e7c4cf297fb3917f$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e7c4cf297fb3917f$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e7c4cf297fb3917f$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e7c4cf297fb3917f$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e7c4cf297fb3917f$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e7c4cf297fb3917f$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e7c4cf297fb3917f$export$d928f247c903643a);
const $e7c4cf297fb3917f$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e7c4cf297fb3917f$export$aa456a5030160740 = 'TODO';
const $e7c4cf297fb3917f$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e7c4cf297fb3917f$export$71efb3495f6084f2 = 'DONE';
const $e7c4cf297fb3917f$export$d9119300f9d9a815 = [
    $e7c4cf297fb3917f$export$6db089fe7b26f5b6,
    $e7c4cf297fb3917f$export$aa456a5030160740,
    $e7c4cf297fb3917f$export$5a9ac66c2785cc13,
    $e7c4cf297fb3917f$export$71efb3495f6084f2
];
const $e7c4cf297fb3917f$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e7c4cf297fb3917f$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e7c4cf297fb3917f$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e7c4cf297fb3917f$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e7c4cf297fb3917f$export$71efb3495f6084f2
    }
];
const $e7c4cf297fb3917f$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e7c4cf297fb3917f$export$3f42f49c284d5b58 = Object.freeze({
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.NEW]: 2,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.DONE]: 3,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e7c4cf297fb3917f$export$f3f919dc0f56d9eb = Object.values($e7c4cf297fb3917f$export$5d42a08d46cffe7);
const $e7c4cf297fb3917f$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e7c4cf297fb3917f$export$6db089fe7b26f5b6;
};
const $e7c4cf297fb3917f$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e7c4cf297fb3917f$export$d928f247c903643a = (key)=>$e7c4cf297fb3917f$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});



parcelRegister("576pI", function(module, exports) {

$parcel$export(module.exports, "NEW_EDITOR", () => $f9518c8299434e98$export$83282786ca4b04f);
$parcel$export(module.exports, "LEGACY_EDITOR", () => $f9518c8299434e98$export$e2f196e116d3fca2);
$parcel$export(module.exports, "WorkflowPublicationStatus", () => $f9518c8299434e98$export$8b8b078375514ab6);
const $f9518c8299434e98$export$83282786ca4b04f = 'NEW';
const $f9518c8299434e98$export$e2f196e116d3fca2 = 'LEGACY';
var $f9518c8299434e98$export$8b8b078375514ab6;
(function(WorkflowPublicationStatus) {
    WorkflowPublicationStatus[WorkflowPublicationStatus["None"] = 0] = "None";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Dirty"] = 1] = "Dirty";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Draft"] = 2] = "Draft";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Live"] = 3] = "Live";
})($f9518c8299434e98$export$8b8b078375514ab6 || ($f9518c8299434e98$export$8b8b078375514ab6 = {}));

});

parcelRegister("jJKsA", function(module, exports) {

$parcel$export(module.exports, "useChangeToOldEditorSuccessFlag", () => $ba99cb36781b525c$export$4a8a957b814cf4be);

var $eUqFw = parcelRequire("eUqFw");

var $gfrke = parcelRequire("gfrke");

var $33ywq = parcelRequire("33ywq");
const $ba99cb36781b525c$export$4a8a957b814cf4be = ({ openDefaultEditorDialog: openDefaultEditorDialog })=>{
    const { showOldEditorSuccessFlag: showOldEditorSuccessFlag } = (0, $33ywq.useChangePreferenceFlag)();
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $gfrke.getShouldShowOldEditorSucccessFlag)()) {
            (0, $gfrke.clearShowOldEditorSucccessFlag)();
            showOldEditorSuccessFlag(openDefaultEditorDialog);
        }
    }, [
        openDefaultEditorDialog,
        showOldEditorSuccessFlag
    ]);
    return {
        showOldEditorSuccessFlag: showOldEditorSuccessFlag
    };
};

});
parcelRegister("gfrke", function(module, exports) {

$parcel$export(module.exports, "getShouldShowNewEditorSucccessFlag", () => $790f351f67bf7aa2$export$b33dd94e7d4068a9);
$parcel$export(module.exports, "setShowNewEditorSuccessFlag", () => $790f351f67bf7aa2$export$38de37b600fe15c7);
$parcel$export(module.exports, "clearShowNewEditorSucccessFlag", () => $790f351f67bf7aa2$export$10794e9068b437c1);
$parcel$export(module.exports, "getShouldShowOldEditorSucccessFlag", () => $790f351f67bf7aa2$export$b07da7bcc8c25b1a);
$parcel$export(module.exports, "clearShowOldEditorSucccessFlag", () => $790f351f67bf7aa2$export$385473acd3052995);
$parcel$export(module.exports, "setShowOldEditorSuccessFlag", () => $790f351f67bf7aa2$export$baea524121407210);
const $790f351f67bf7aa2$var$SHOW_NEW_EDITOR_SUCCESS_FLAG = 'SHOW_NEW_EDITOR_SUCCESS_FLAG';
const $790f351f67bf7aa2$var$SHOW_OLD_EDITOR_ERROR_FLAG = 'SHOW_OLD_EDITOR_SUCCESS_FLAG';
// New editor success flag
const $790f351f67bf7aa2$var$updateShowNewEditorSucccessFlag = (value)=>{
    sessionStorage.setItem($790f351f67bf7aa2$var$SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString());
};
const $790f351f67bf7aa2$export$b33dd94e7d4068a9 = ()=>Boolean(sessionStorage.getItem($790f351f67bf7aa2$var$SHOW_NEW_EDITOR_SUCCESS_FLAG));
const $790f351f67bf7aa2$export$38de37b600fe15c7 = ()=>{
    $790f351f67bf7aa2$var$updateShowNewEditorSucccessFlag(true);
};
const $790f351f67bf7aa2$export$10794e9068b437c1 = ()=>{
    sessionStorage.removeItem($790f351f67bf7aa2$var$SHOW_NEW_EDITOR_SUCCESS_FLAG);
};
// Old editor success flag
const $790f351f67bf7aa2$var$updateShowOldEditorSucccessFlag = (value)=>{
    sessionStorage.setItem($790f351f67bf7aa2$var$SHOW_OLD_EDITOR_ERROR_FLAG, value.toString());
};
const $790f351f67bf7aa2$export$b07da7bcc8c25b1a = ()=>Boolean(sessionStorage.getItem($790f351f67bf7aa2$var$SHOW_OLD_EDITOR_ERROR_FLAG));
const $790f351f67bf7aa2$export$385473acd3052995 = ()=>{
    sessionStorage.removeItem($790f351f67bf7aa2$var$SHOW_OLD_EDITOR_ERROR_FLAG);
};
const $790f351f67bf7aa2$export$baea524121407210 = ()=>{
    $790f351f67bf7aa2$var$updateShowOldEditorSucccessFlag(true);
};

});

parcelRegister("33ywq", function(module, exports) {

$parcel$export(module.exports, "useChangePreferenceFlag", () => $03fe887a6cc12c68$export$cb7da29550cd2317);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $k8Qyf = parcelRequire("k8Qyf");

var $k6a7g = parcelRequire("k6a7g");
const $03fe887a6cc12c68$var$NEW_EDITOR_SUCCESS_FLAG = 'new-editor-success-flag';
const $03fe887a6cc12c68$var$learnMoreLinkNewEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
const $03fe887a6cc12c68$var$learnMoreLinkOldEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/changing-your-default-workflow-editor/';
const $03fe887a6cc12c68$export$cb7da29550cd2317 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onClickLearnMoreOldEditor = ()=>{
        window.open($03fe887a6cc12c68$var$learnMoreLinkOldEditor, '_blank');
    };
    const onClickLearnMoreNewEditor = ()=>{
        window.open($03fe887a6cc12c68$var$learnMoreLinkNewEditor, '_blank');
    };
    const showNewEditorSuccessFlag = (0, $eUqFw.useCallback)(()=>showFlag({
            id: $03fe887a6cc12c68$var$NEW_EDITOR_SUCCESS_FLAG,
            testId: 'workflow-editor-preference-settings.ui.success-flag',
            type: 'success',
            title: (0, $k6a7g.default).changeToNewEditorTitle,
            description: (0, $k6a7g.default).changeToNewEditorDescription,
            actions: [
                {
                    content: (0, $k6a7g.default).learnMore,
                    onClick: onClickLearnMoreNewEditor
                },
                {
                    content: (0, $k6a7g.default).ok,
                    onClick: ()=>dismissFlag($03fe887a6cc12c68$var$NEW_EDITOR_SUCCESS_FLAG)
                }
            ]
        }), [
        dismissFlag,
        showFlag
    ]);
    const showOldEditorSuccessFlag = (0, $eUqFw.useCallback)((openDefaultEditorDialog = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))))=>showFlag({
            type: 'success',
            title: (0, $k6a7g.default).changeToOldEditorTitle,
            description: (0, $k6a7g.default).changeToOldEditorDescription,
            actions: [
                {
                    content: (0, $k6a7g.default).learnMore,
                    onClick: onClickLearnMoreOldEditor
                },
                {
                    content: (0, $k6a7g.default).switchToNewEditor,
                    onClick: openDefaultEditorDialog
                }
            ]
        }), [
        showFlag
    ]);
    const showErrorFlag = (0, $eUqFw.useCallback)(()=>showFlag({
            type: 'error',
            title: (0, $k6a7g.default).updatePreferenceErrorFlagTitle,
            description: (0, $k6a7g.default).updatePreferenceErrorFlagDescription
        }), [
        showFlag
    ]);
    return {
        showNewEditorSuccessFlag: showNewEditorSuccessFlag,
        showOldEditorSuccessFlag: showOldEditorSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});
parcelRegister("k6a7g", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f665c8488c83f5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $90f665c8488c83f5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeToOldEditorTitle: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-title",
        "defaultMessage": "You've changed the default editor"
    },
    changeToOldEditorDescription: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-description",
        "defaultMessage": "You can use the old editor as needed while we continue building the new editor."
    },
    learnMore: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.learn-more",
        "defaultMessage": "Learn more"
    },
    switchToNewEditor: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.switch-to-new-editor",
        "defaultMessage": "Switch to new editor"
    },
    changeToNewEditorTitle: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-title",
        "defaultMessage": "Welcome to the new workflow editor"
    },
    changeToNewEditorDescription: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-description",
        "defaultMessage": "Enjoy a faster, cleaner, more intuitive experience while creating and editing your workflows."
    },
    ok: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.ok",
        "defaultMessage": "Ok"
    },
    updatePreferenceErrorFlagTitle: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-title",
        "defaultMessage": "We couldn't update your default editor"
    },
    updatePreferenceErrorFlagDescription: {
        "id": "workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-description",
        "defaultMessage": "Select Confirm to try again."
    }
});

});



parcelRegister("2Zc3E", function(module, exports) {

$parcel$export(module.exports, "DefaultWorkflowEditorDialog", () => $2eaba03fa70d66d1$export$6e60a479812ee7d6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5YsMl = parcelRequire("5YsMl");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $hnuwz = parcelRequire("hnuwz");


var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $0cdA8 = parcelRequire("0cdA8");

var $bKxX9 = parcelRequire("bKxX9");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hu4Cz = parcelRequire("hu4Cz");

var $lB25E = parcelRequire("lB25E");

var $576pI = parcelRequire("576pI");

var $33ywq = parcelRequire("33ywq");
var $bR5j7 = parcelRequire("bR5j7");
var $jffUq = parcelRequire("jffUq");

var $jljjx = parcelRequire("jljjx");

var $gfrke = parcelRequire("gfrke");

var $eISIy = parcelRequire("eISIy");

var $jjrX7 = parcelRequire("jjrX7");

var $6d5Wr = parcelRequire("6d5Wr");
var $2eaba03fa70d66d1$export$759a75979ec109e2;
(function(WarningType) {
    WarningType[WarningType["None"] = 0] = "None";
    WarningType[WarningType["Dirty"] = 1] = "Dirty";
    WarningType[WarningType["Draft"] = 2] = "Draft";
})($2eaba03fa70d66d1$export$759a75979ec109e2 || ($2eaba03fa70d66d1$export$759a75979ec109e2 = {}));
const $2eaba03fa70d66d1$var$DefaultWorkflowEditorDialogInner = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, workflowPublicationStatus: workflowPublicationStatus = (0, $576pI.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [selectedWorkflowEditor, setSelectedWorkflowEditor] = (0, $eUqFw.useState)(null);
    const [{ route: route }] = (0, $lB25E.useRouter)();
    const { userPreference: userPreference } = (0, $bR5j7.useNewWorkflowEditorPreference)();
    const { showNewEditorSuccessFlag: showNewEditorSuccessFlag, showOldEditorSuccessFlag: showOldEditorSuccessFlag, showErrorFlag: showErrorFlag } = (0, $33ywq.useChangePreferenceFlag)();
    (0, $eUqFw.useEffect)(()=>{
        setSelectedWorkflowEditor(userPreference);
    }, [
        userPreference,
        setSelectedWorkflowEditor
    ]);
    const redirectToLegacyEditorAndShowSuccessFlag = (0, $eUqFw.useCallback)(()=>{
        if (route?.name === (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW)) showOldEditorSuccessFlag(onOpenDefaultEditorDialog);
        else {
            // set flag to show success flag in session storage when user is redirected to legacy editor
            (0, $gfrke.setShowOldEditorSuccessFlag)();
            window.location.assign(shouldRedirectToDraftMode ? (0, $hu4Cz.buildEditWorkflowJSPUrl)(workflowName) : (0, $hu4Cz.getLegacyEditorLink)(workflowName));
        }
    }, [
        route?.name,
        shouldRedirectToDraftMode,
        showOldEditorSuccessFlag,
        workflowName,
        onOpenDefaultEditorDialog
    ]);
    const redirectToNewEditorAndShowSuccessFlag = (0, $eUqFw.useCallback)(()=>{
        if (route?.name === (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT)) showNewEditorSuccessFlag();
        else {
            // set flag to show success flag in session storage when user is redirected to new editor
            (0, $gfrke.setShowNewEditorSuccessFlag)();
            route?.name !== (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT) && workflowId && window.location.assign((0, $hu4Cz.getNewEditorLink)(workflowId));
        }
    }, [
        route?.name,
        showNewEditorSuccessFlag,
        workflowId
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $jffUq.useOptOutFeedbackDialog)({
        projectType: projectType,
        onClose: redirectToLegacyEditorAndShowSuccessFlag
    });
    const onSelectNew = ()=>setSelectedWorkflowEditor((0, $576pI.NEW_EDITOR));
    const onSelectOld = ()=>setSelectedWorkflowEditor((0, $576pI.LEGACY_EDITOR));
    const onConfirmButtonClicked = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (_, analyticsEvent)=>{
        try {
            if (selectedWorkflowEditor === (0, $576pI.LEGACY_EDITOR)) {
                await (0, $jljjx.changeDefaultWorkflowEditorToLegacy)(analyticsEvent, workflowPublicationStatus);
                renderFeedbackDialog();
            }
            if (selectedWorkflowEditor === (0, $576pI.NEW_EDITOR)) {
                await (0, $jljjx.changeDefaultWorkflowEditorToNew)(analyticsEvent, workflowPublicationStatus);
                redirectToNewEditorAndShowSuccessFlag();
            }
            onClose();
        } catch (error) {
            showErrorFlag();
        }
    }, [
        selectedWorkflowEditor,
        onClose,
        renderFeedbackDialog,
        redirectToNewEditorAndShowSuccessFlag,
        showErrorFlag,
        workflowPublicationStatus
    ]);
    const link = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
    const learnMoreLink = formatMessage((0, $6d5Wr.default).learnMoreLink, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: link,
                target: "_blank"
            }, chunks)
    });
    const shouldShowWarningMessage = workflowPublicationStatus === (0, $576pI.WorkflowPublicationStatus).Draft || workflowPublicationStatus === (0, $576pI.WorkflowPublicationStatus).Dirty;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: "medium",
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.title"
    }, formatMessage((0, $6d5Wr.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6d5Wr.default).body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$Info, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, learnMoreLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$Instruction, null, formatMessage((0, $6d5Wr.default).instruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2eaba03fa70d66d1$var$boxStyles,
        onClick: onSelectNew,
        backgroundColor: selectedWorkflowEditor === (0, $576pI.NEW_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.new-editor-radio"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
        isChecked: selectedWorkflowEditor === (0, $576pI.NEW_EDITOR),
        ariaLabel: "New editor radio"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eISIy))),
        alt: "new editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6d5Wr.default).newWorkflowEditor))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2eaba03fa70d66d1$var$boxStyles,
        onClick: onSelectOld,
        padding: "space.200",
        backgroundColor: selectedWorkflowEditor === (0, $576pI.LEGACY_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
        isChecked: selectedWorkflowEditor === (0, $576pI.LEGACY_EDITOR),
        ariaLabel: "Old editor radio"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jjrX7))),
        alt: "old editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6d5Wr.default).oldWorkflowEditor)))), shouldShowWarningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$WarningContainer, {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        size: "medium",
        label: "Warning",
        primaryColor: `var(--ds-text-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$WarningText, null, workflowPublicationStatus === (0, $576pI.WorkflowPublicationStatus).Draft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6d5Wr.default).draftUnpublishedWarning), workflowPublicationStatus === (0, $576pI.WorkflowPublicationStatus).Dirty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $6d5Wr.default).dirtyLossWarning,
        values: {
            workflowName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, workflowName),
            update: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("i", null, formatMessage((0, $6d5Wr.default).updateButton)),
            cancel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("i", null, formatMessage((0, $6d5Wr.default).cancelButton))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage((0, $6d5Wr.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onConfirmButtonClicked,
        isDisabled: userPreference === selectedWorkflowEditor,
        appearance: "primary",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.confirm-button"
    }, formatMessage((0, $6d5Wr.default).confirmButton)))));
};
const $2eaba03fa70d66d1$export$6e60a479812ee7d6 = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, workflowPublicationStatus: workflowPublicationStatus = (0, $576pI.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    if ((0, $bKxX9.ff)('jsm-error-boundary-default-workflow-editor-dialog_aq32n')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jsm-error-boundary-default-workflow-editor-dialog",
        packageName: "workflow-editor-preference-settings",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$DefaultWorkflowEditorDialogInner, {
        workflowName: workflowName,
        projectType: projectType,
        onClose: onClose,
        onOpenDefaultEditorDialog: onOpenDefaultEditorDialog,
        workflowId: workflowId,
        workflowPublicationStatus: workflowPublicationStatus,
        shouldRedirectToDraftMode: shouldRedirectToDraftMode
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2eaba03fa70d66d1$var$DefaultWorkflowEditorDialogInner, {
        workflowName: workflowName,
        projectType: projectType,
        onClose: onClose,
        onOpenDefaultEditorDialog: onOpenDefaultEditorDialog,
        workflowId: workflowId,
        workflowPublicationStatus: workflowPublicationStatus,
        shouldRedirectToDraftMode: shouldRedirectToDraftMode
    });
};
const $2eaba03fa70d66d1$var$boxStyles = (0, $1ZAYh.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    paddingLeft: 'space.050',
    paddingRight: 'space.500',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2eaba03fa70d66d1$var$Info = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _11c8qk37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2eaba03fa70d66d1$var$RadioIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1epz _u5f3pxbi _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2eaba03fa70d66d1$var$Instruction = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _n3tdu2gc _syaz1rc1 _1wybutpp _vwz4pxbi _k48pbfng",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2eaba03fa70d66d1$var$WarningContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41bpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2eaba03fa70d66d1$var$WarningText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _16jlkb7n _syaz1w44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

const $306a59ce4e6b6146$var$packageName = "platform-pkg";
const $306a59ce4e6b6146$var$packageVersion = "0.0.0-use.local";
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});

parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("bR5j7", function(module, exports) {

$parcel$export(module.exports, "useNewWorkflowEditorPreference", () => $324aa0c79d089b7b$export$b59c27df71e5edcf);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $576pI = parcelRequire("576pI");

var $hgAMV = parcelRequire("hgAMV");
const $324aa0c79d089b7b$var$useNewWorkflowEditorPreferenceNew = ()=>{
    const [editorType, setEditorType] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $hgAMV.getUserWorkflowEditorPreference)().then((pref)=>{
            setEditorType(pref);
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getDefaultWorkflowEditorPreferance success');
        }).catch((error)=>{
            setEditorType(null);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('workflow-Editor.preference', 'Unable to fetch workflow editor user preference', error);
            (0, $guiFP.default)({
                meta: {
                    id: 'getDefaultWorkflowEditorPreference',
                    packageName: 'jiraWorkflowEditorPreferenceSettings'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                attributes: {
                    isClientFetchError: (0, $1ybV0.ff)('workflow-editor-preference-improve-analytics-client-error_kbu7l') ? (0, $JRB5w.isClientFetchError)(error) : undefined
                }
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    const shouldUseNewWorkFlowEditor = (0, $eUqFw.useMemo)(()=>{
        const isJsmNewWorkflowPreferenceEnabled = (0, $1ybV0.ff)('jsm-new-workflow-editor-preference');
        const isDefaultUserWorkflowEnabled = (0, $1ybV0.ff)('workflow-editor-default-user-preference_go979');
        if (!isJsmNewWorkflowPreferenceEnabled) return isDefaultUserWorkflowEnabled;
        if (editorType) return editorType === (0, $576pI.NEW_EDITOR);
        return isDefaultUserWorkflowEnabled;
    }, [
        editorType
    ]);
    return {
        shouldUseNewWorkFlowEditor: shouldUseNewWorkFlowEditor,
        userPreference: editorType
    };
};
const $324aa0c79d089b7b$export$b59c27df71e5edcf = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('pce.helix.admin-pages.edit-workflow-page'), $324aa0c79d089b7b$var$useNewWorkflowEditorPreferenceNew, ()=>({
        shouldUseNewWorkFlowEditor: false,
        userPreference: null
    }));

});
parcelRegister("hgAMV", function(module, exports) {

$parcel$export(module.exports, "getUserWorkflowEditorPreference", () => $5fe32dae63c97c6d$export$d9664e16e2fb1f27);

var $lRmyA = parcelRequire("lRmyA");
const $5fe32dae63c97c6d$var$workflowEditorPreferenceKey = 'jira.user.workflow.editor.global.scope.enrolment';
const $5fe32dae63c97c6d$var$WORKFLOW_EDITOR_PREFERENCE_QUERY = `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [
        "${$5fe32dae63c97c6d$var$workflowEditorPreferenceKey}"
    ])
}
`;
const $5fe32dae63c97c6d$export$d9664e16e2fb1f27 = async ()=>{
    const apiResult = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $5fe32dae63c97c6d$var$WORKFLOW_EDITOR_PREFERENCE_QUERY
        })
    });
    const preferences = apiResult?.data?.myPreferences;
    if (preferences) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return preferences[`${$5fe32dae63c97c6d$var$workflowEditorPreferenceKey}`];
    const errorResponse = apiResult?.errors;
    if (errorResponse) throw new Error(`Error getting user preference: ${$5fe32dae63c97c6d$var$workflowEditorPreferenceKey}`, {
        cause: apiResult?.errors?.[0] ?? 'unknown'
    });
    return null;
};

});


parcelRegister("jffUq", function(module, exports) {

$parcel$export(module.exports, "useOptOutFeedbackDialog", () => $f169a26bc99a4445$export$f692fac382bec058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $9Anw5 = parcelRequire("9Anw5");

var $gd0Sp = parcelRequire("gd0Sp");

var $d40uv = parcelRequire("d40uv");
const $f169a26bc99a4445$var$unknownAttributeValue = 'unknown';
const $f169a26bc99a4445$var$FEEDBACK_GROUP_ID = 'workflow-editor-opt-out'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f169a26bc99a4445$export$e4c3d9ebed5d4509 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $f169a26bc99a4445$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, projectType: projectType, cloudId: cloudId })=>[
        {
            id: (0, $1c02D.EntryKeys).LOCATION,
            value: (0, $9Anw5.default)(window.location.href)
        },
        {
            id: (0, $1c02D.EntryKeys).REFERER,
            value: document.referrer ? (0, $9Anw5.default)(document.referrer) : ''
        },
        {
            id: (0, $1c02D.EntryKeys).USER_AGENT,
            value: navigator.userAgent
        },
        {
            id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
            value: `${window.screen.width} x ${window.screen.height}`
        },
        {
            id: (0, $1c02D.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $1c02D.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $f169a26bc99a4445$export$f692fac382bec058 = ({ onClose: onClose = ()=>undefined, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const routeName = route.name ?? $f169a26bc99a4445$var$unknownAttributeValue;
    const renderFeedbackDialog = (0, $eUqFw.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: $f169a26bc99a4445$var$FEEDBACK_GROUP_ID,
            onClose: onClose,
            feedbackContext: $f169a26bc99a4445$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeName: routeName,
                projectType: projectType || $f169a26bc99a4445$var$unknownAttributeValue
            }),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $d40uv.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $d40uv.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $d40uv.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $d40uv.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $d40uv.default).reasonComment)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $d40uv.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $d40uv.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $d40uv.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $d40uv.default).reasonQuestion)
                }
            },
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f169a26bc99a4445$export$e4c3d9ebed5d4509, null, formatMessage((0, $d40uv.default).feedbackTitleDetails)),
            selectLabel: formatMessage((0, $d40uv.default).feedbackTitleDetailsQuestion),
            cancelButtonLabel: formatMessage((0, $d40uv.default).feedbackCancelButton)
        });
    }, [
        formatMessage,
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeName,
        projectType
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};

});
parcelRegister("1c02D", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ccbba0a7f0f3304b$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ccbba0a7f0f3304b$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ccbba0a7f0f3304b$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ccbba0a7f0f3304b$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ccbba0a7f0f3304b$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $ccbba0a7f0f3304b$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ccbba0a7f0f3304b$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ccbba0a7f0f3304b$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $ccbba0a7f0f3304b$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "EntryKeys", () => $ccbba0a7f0f3304b$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ccbba0a7f0f3304b$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ccbba0a7f0f3304b$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment'
});

});

parcelRegister("irg9D", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $8d3d8a971c5329dd$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8d3d8a971c5329dd$export$c35dbf16ebe9df04);

var $WBLbN = parcelRequire("WBLbN");
const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $8d3d8a971c5329dd$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8d3d8a971c5329dd$var$Store = (0, $WBLbN.createStore)({
    name: 'feedback-collector',
    initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
    actions: $8d3d8a971c5329dd$export$e324594224ef24da
});
const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $WBLbN.createHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $WBLbN.createActionsHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $WBLbN.createSubscriber)($8d3d8a971c5329dd$var$Store, {
    selector: null
});

});

parcelRegister("d40uv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9eda32579d6dc54$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a9eda32579d6dc54$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reasonPlaceholder: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonQuestion: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-question",
        "defaultMessage": "Missing features"
    },
    reasonBug: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-bug",
        "defaultMessage": "Bugs"
    },
    reasonComment: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-comment",
        "defaultMessage": "Prefer old editor"
    },
    reasonOthers: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-others",
        "defaultMessage": "Other"
    },
    fieldLabel: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.field-label",
        "defaultMessage": "Add details to help us improve the workflow editor for everyone."
    },
    feedbackTitleDetails: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details",
        "defaultMessage": "Help us improve your experience with the new workflow editor."
    },
    feedbackTitleDetailsQuestion: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details-question",
        "defaultMessage": "Let us know why you\u2019re moving to the old editor"
    },
    feedbackCancelButton: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-cancel-button",
        "defaultMessage": "Skip step"
    }
});

});


parcelRegister("jljjx", function(module, exports) {

$parcel$export(module.exports, "changeDefaultWorkflowEditorToLegacy", () => $aa330dddd1e30c8d$export$f16799cd8f24c0e2);
$parcel$export(module.exports, "changeDefaultWorkflowEditorToNew", () => $aa330dddd1e30c8d$export$e03a9424d4619803);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $576pI = parcelRequire("576pI");
const $aa330dddd1e30c8d$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $aa330dddd1e30c8d$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $aa330dddd1e30c8d$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0] ?? 'unknown'
    });
};
const $aa330dddd1e30c8d$export$f16799cd8f24c0e2 = async (analyticsEvent, workflowPublicationStatus)=>{
    try {
        await $aa330dddd1e30c8d$var$setGlobalScopeUserPreference({
            key: 'jira.user.workflow.editor.global.scope.enrolment',
            value: (0, $576pI.LEGACY_EDITOR)
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'legacyWorkflowEditorUserPreference set', {
            workflowPublicationStatus: workflowPublicationStatus === (0, $576pI.WorkflowPublicationStatus).Dirty ? 'Unsaved' // user-friendly term to use instead of Dirty
             : (0, $576pI.WorkflowPublicationStatus)[workflowPublicationStatus]
        });
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'changeDefaultWorkflowEditorToLegacy',
                packageName: 'jiraWorkflowEditorPreferenceSettings'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};
const $aa330dddd1e30c8d$export$e03a9424d4619803 = async (analyticsEvent, workflowPublicationStatus)=>{
    try {
        await $aa330dddd1e30c8d$var$setGlobalScopeUserPreference({
            key: 'jira.user.workflow.editor.global.scope.enrolment',
            value: (0, $576pI.NEW_EDITOR)
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'newWorkflowEditorUserPreference set', {
            workflowPublicationStatus: workflowPublicationStatus === (0, $576pI.WorkflowPublicationStatus).Dirty ? 'Unsaved' // user-friendly term to use instead of Dirty
             : (0, $576pI.WorkflowPublicationStatus)[workflowPublicationStatus]
        });
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'changeDefaultWorkflowEditorToNew',
                packageName: 'jiraWorkflowEditorPreferenceSettings'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};

});

parcelRegister("eISIy", function(module, exports) {
module.exports = new URL("newEditorImage.very-specific-illu.103374a4.png", import.meta.url).toString();

});

parcelRegister("jjrX7", function(module, exports) {
module.exports = new URL("oldEditorImage.very-specific-illu.cd2f1dd1.png", import.meta.url).toString();

});

parcelRegister("6d5Wr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d967d9d7a2c9b962$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d967d9d7a2c9b962$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.title",
        "defaultMessage": "Select a default workflow editor"
    },
    body: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.body",
        "defaultMessage": "While we continue building the new workflow editor, you can switch between editors as needed. When you select a default, we\u2019ll always open your workflows in that editor."
    },
    instruction: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.instruction",
        "defaultMessage": "Select a default workflow editor"
    },
    link: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.link",
        "defaultMessage": "Learn more about editing workflows."
    },
    learnMoreLink: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.learn-more-link",
        "defaultMessage": "<a>Learn more about editing workflows</a>."
    },
    newWorkflowEditor: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.new-workflow-editor",
        "defaultMessage": "New editor"
    },
    oldWorkflowEditor: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.old-workflow-editor",
        "defaultMessage": "Old editor"
    },
    cancelButton: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.cancel-button",
        "defaultMessage": "Cancel"
    },
    confirmButton: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.confirm-button",
        "defaultMessage": "Confirm"
    },
    updateButton: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.update-button",
        "defaultMessage": "Update"
    },
    draftLossWarning: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.draft-loss-warning",
        "defaultMessage": "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then publish your draft workflow before continuing."
    },
    draftUnpublishedWarning: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.draft-unpublished-warning",
        "defaultMessage": "Publish your draft workflow before continuing so that your edits will be visible in the new workflow editor."
    },
    dirtyLossWarning: {
        "id": "workflow-editor-preference-settings.default-workflow-editor-dialog.dirty-loss-warning",
        "defaultMessage": "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then {update} workflow before continuing."
    }
});

});


parcelRegister("bURS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab663716fbbbd61b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ab663716fbbbd61b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    openInNewEditor: {
        "id": "workflow-editor-preference-settings.open-in-new-editor",
        "defaultMessage": "Open workflow in new editor"
    },
    changeDefaultEditor: {
        "id": "workflow-editor-preference-settings.change-default-editor",
        "defaultMessage": "Change default editor"
    },
    switchEditorButton: {
        "id": "workflow-editor-preference-settings.switch-editor-button",
        "defaultMessage": "Switch editor"
    }
});

});





parcelRegister("fGHk2", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa);
const $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("awT4s", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("k21YS")
]).then(()=>parcelRequire('3oPZV'));

});



$parcel$global.rwr("6zNWu", () => { parcelRequire("7QpAw");
parcelRequire("2EvGI");

var $2apnq = parcelRequire("2apnq");

var $nJqTU = parcelRequire("nJqTU");
(0, $nJqTU.default).install();
(0, $2apnq.provideHealthcheck)();
 }, ["eNmuD","dsiAd","hPzOn","2Lfdl","1QYl5","561Jq","i5RRW","92sUi","kWrFZ","bYT2S","h2MrD","bCeK4","2hmUs","akvQ0"]);

$parcel$global.rlb("6zNWu")
//# sourceMappingURL=global-single-fragment.390edcdd.js.map
